import { createContext, useContext, useEffect, useMemo, useRef, useState } from "react";
import { useAuth } from "./AuthContext";
import { apiRequest } from "../utils/api";

const LanguageContext = createContext();

// The languages STRINGS has. Same list the backend accepts (usersController APP_LANGUAGES).
export const APP_LANGUAGES = ["en", "te", "hi", "ta", "kn"];

const STRINGS = {
  "en": {
"rm_of": "{yes} of {n}",
"rm_driverCame": "Same driver as booked",
"rm_carCame": "Same car as booked",
"rm_no": "No",
"rm_yes": "Yes",
"rm_sameDriver": "Did the same driver you booked come?",
"rm_sameCar": "Did the same car you booked come?",
"lg_brand": "Sramika",
"tx_bonus": "Bonus",
"tx_referralBack": "Referral reward taken back",
"tx_referral": "Referral reward",
"tx_welcome": "Welcome offer",
"tx_failed": "Payment failed",
"lc_offer": "Special offer",
"lh_ref": "Ref",
"cv_mpv": "MPV",
"ac_roleOwner": "Driver",
"ac_roleAdmin": "Admin",
"ac_roleSuper": "Super admin",
"ac_roleDriver": "Driver",
"ac_roleAgent": "Field agent",
"ac_ownerCarsLeads": "My cars & leads",
"od_title": "My drivers",
"od_list": "Drivers of your cars",
"od_add": "Add driver",
"od_addTitle": "Add a driver",
"od_name": "Driver's name",
"od_namePh": "e.g. Ramesh Kumar",
"od_licencePh": "e.g. AP09 2024 0012345",
"od_licPhoto": "Photo of the licence",
"od_photo": "Driver's photo",
"od_choose": "Choose a photo",
"od_checkNote": "Sramika checks the licence before the driver is shown.",
"od_errName": "Enter the driver's name.",
"od_errPhone": "Enter a 10-digit mobile number.",
"od_errLicence": "Enter the licence number.",
"od_errLicPhoto": "Add a photo of the licence.",
"od_errPhoto": "Add the driver's photo.",
"od_addFail": "Could not add the driver. Please try again.",
"od_addBtn": "Add this driver",
"od_adding": "Adding…",
"od_loading": "Loading your drivers…",
"od_loadFail": "Could not load your drivers.",
"od_pending": "Waiting for approval",
"od_remove": "Remove",
"od_removeAsk": "Remove this driver from your list?",
"od_removeYes": "Yes, remove",
"od_removeFail": "Could not remove the driver. Please try again.",
"od_emptyTitle": "No drivers yet",
"od_emptyText": "Add the drivers who drive your cars.",
"ea_title": "Change account details",
"ea_note": "These were checked at sign-up. A change is sent to Sramika and shows once it is approved.",
"ea_pendingTitle": "A change is waiting for approval",
"ea_pendingText": "Sramika is checking the change you sent. You can send another once it is done.",
"ea_sentTitle": "Sent for approval",
"ea_sentText": "Your details stay as they are until Sramika approves the change.",
"ea_toAccount": "Go to my account",
"ea_loadFail": "Could not load your account details.",
"ea_sendFail": "Could not send your change. Please try again.",
"ea_phoneLocked": "To change a verified number, call Sramika.",
"ea_blood": "Blood group",
"ea_select": "Choose",
"ea_contact": "Address and emergency contact",
"ea_ap": "Andhra Pradesh",
"ea_tg": "Telangana",
"ea_emName": "Emergency contact name",
"ea_emPhone": "Emergency contact number",
"ea_driving": "Driving",
"ea_aadhaar": "Aadhaar number",
"ea_licence": "Driving licence number",
"ea_bank": "Bank details",
"ea_accName": "Account holder name",
"ea_accNo": "Account number",
"ea_ifsc": "IFSC code",
"ea_send": "Send for approval",
"pe_saved": "Your details are saved.",
"pe_saveFail": "Could not save. Please try again.",
"pe_loading": "Loading your details…",
"pe_loadFail": "Could not load your details.",
"pe_checked": "Checked at sign-up",
"pe_car": "Car",
"pe_lockedText": "To change these, call Sramika - they are checked again first.",
"pe_about": "About you",
"pe_business": "Business name (if you have one)",
"pe_businessHint": "Leave it empty to show your own name.",
"pe_businessPh": "e.g. Sri Sai Travels",
"pe_other": "Other",
"pe_langs": "Languages you speak",
"pe_bio": "A few words about you",
"pe_bioHint": "Tell customers a little about yourself.",
"pe_bioApproval": "Sramika checks new words here before customers see them.",
"pe_bioSent": "Saved. Your new words show once Sramika approves them.",
"pe_bioWaiting": "Saved. Your new words wait - another change of yours is with Sramika.",
"pe_bioPending": "Waiting for approval: “{bio}”",
"pe_bioPh": "e.g. Driving for 8 years, I know the Vijayawada - Hyderabad road well.",
"pe_pincode": "Pincode",
"pe_phonePh": "10-digit mobile number",
"pe_carTrips": "Your car and trips",
"pe_personalText": "Your address, languages, gender and emergency contact are changed in {account} → {edit}. Sramika checks the change first.",
"pe_personalBtn": "Change my details",
"pe_acPerCar": "AC is set on each car, in {myCars}.",
"pe_moreCars": "+{n} more",
"pe_tripKinds": "Trips you take",
"pe_hourly": "Hourly",
"pe_dayRent": "Day rent",
"pe_prices": "Prices",
"pe_week": "Days and hours you work",
"pe_from": "From",
"pe_to": "Until",
"pe_save": "Save changes",
"ld_sentDriver": "Sent to the driver",
"ld_refNoteDriver": "This is the price you were shown. The final price is agreed directly with the driver.",
"ld_callDriver": "Call the driver",
"dp_theDriver": "The driver",
"cv_ownerWord": "The driver",
"hm_nCars": "{n} cars",
"hm_oneCar": "1 car",
"as_title": "Your business account is suspended",
"as_since": "Since {date}",
"as_whatDriver": "Your driver profile is hidden from customers, and you will not get new hire requests.",
"as_whatCars": "Your cars are hidden from customers, and you will not get new leads.",
"as_reason": "Reason given:",
"as_else": "Everything else still works. You can find cabs, call a driver and book a trip as a customer, and your past records stay here.",
"as_lift": "Only our team can lift a suspension.",
"as_liftCall": "Call Sramika and give your registered mobile number.",
"as_call": "Call Sramika · {phone}",
"lc_fee": "Lead fee",
"lc_free": "FREE",
"lc_noCharges": "No lead charges yet",
"lc_andAbove": "{min} and above",
"lc_ladderCar": "Car and cab accounts",
"lc_ladderHire": "Hire driver accounts",
"lc_bandCar": "By the trip fare quoted to the customer",
"lc_bandHire": "By the duty fare quoted to the customer",
"lc_sub": "What one customer enquiry costs you.",
"lc_loading": "Loading the current charges…",
"lc_loadFail": "Could not load the lead prices.",
"lc_freeNow": "Leads are free right now",
"lc_freeText": "Every lead below is free for you today. Nothing is taken from your wallet, and no lead is refused for a low balance.",
"lc_validTill": "Offer valid till {date}.",
"lc_worth": "The prices below are what a lead is worth - shown so there is no surprise on the day charges begin. We will tell you before that day.",
"lc_active": "Lead charges are on",
"lc_activeText": "The fee below is taken from your wallet for each lead you get.",
"lc_tripFare": "Trip fare",
"lc_good": "Good to know",
"lc_g1": "You pay for the lead - the customer’s enquiry - not a commission on the trip. What the customer pays you is yours.",
"lc_g2": "The fee depends on the fare quoted to that customer, so a small trip never costs you a big trip’s fee.",
"lc_g3": "If the same customer calls you again soon, it is not a new lead.",
"lc_g4": "These charges can change. Your lead history always shows what each lead cost you on the day it came.",
"dd_kycTitle": "Complete these to get leads",
"dd_kycBasic": "Basic details",
"dd_kycEmergency": "Emergency contact",
"dd_kycLicence": "Licence",
"dd_kycPhoto": "Photo",
"dd_kycReview": "Your details are being checked",
"dd_kycReviewSub": "Sramika is looking at your profile.",
"dd_rbNew": "New driver - no ratings yet",
"dd_rbNewSub": "Finish trips and ask customers to rate you - good ratings put you higher in the list.",
"dd_rbLine": "Rating {r} · {tier} · {ratings}",
"dd_tSusp": "Paused",
"dd_cSusp": "Paused after customers reported more than once that you did not come.",
"dd_tPriority": "Priority",
"dd_cPriority": "You are shown higher in customer searches.",
"dd_tStandard": "Standard",
"dd_cStandard": "Standard place in customer searches.",
"dd_tWarning": "Warning",
"dd_cWarning": "A warning shows on your profile, and Sramika will look into it.",
"dd_tCritical": "Critical",
"dd_cCritical": "New leads are paused until Sramika reviews your profile.",
"dd_liTotal": "Leads received",
"dd_liMonth": "This month",
"dd_liFees": "Lead fees",
"dd_liConv": "{pct}% became trips · {won} of the {decided} you marked",
"dd_psTitle": "Profile strength",
"dd_psFull": "✅ Complete profile - shown higher in search",
"dd_psGood": "Good profile",
"dd_psLow": "⚠️ Profile not complete - customers see you less",
"dd_psRank": "Rank higher in the Hire Driver list",
"dd_psTip1": "Stay Available. Available drivers are listed first.",
"dd_psTip2": "Reach 100/100. Complete profiles are listed ahead of the rest.",
"dd_psTip3": "Earn 4★ or more. Ask happy customers to rate your trip.",
"dd_psMissing": "Add these to raise your score:",
"dd_fPhoto": "Profile photo",
"dd_fLicence": "Driving licence",
"dd_fBio": "About you",
"dd_fGender": "Gender",
"dd_fAge": "Age",
"dd_fCity": "City",
"dd_fAddress": "Full address",
"dd_fAutomatic": "Automatic car driving",
"dd_fTypes": "Car types you drive",
"dd_fOwnRates": "Your own rates",
"dd_fWeekly": "Weekly availability",
"dd_fRating": "Customer rating 4+",
"dd_avTitle": "Your availability",
"dd_avOffline": "Offline",
"dd_avHintAvail": "Customers can find and call you.",
"dd_avHintBusy": "You stay in the list, marked busy.",
"dd_avHintOff": "You are hidden from new leads.",
"dd_avHintSusp": "Not shown to customers while your account is suspended - this setting applies again once it is lifted.",
"dd_availFail": "Could not change your availability. Please try again.",
"dd_leadFail": "Could not save your answer for this lead. Please try again.",
"dd_rates": "Your rates",
"dd_gBoth": "Local and outstation",
"dd_nightHalt": "Night halt",
"dd_usual": "Usual ₹{n}",
"dd_max": "Max ₹{n}",
"dd_cityStd": "city standard",
"dd_followsCity": "city rate, moves with it",
"dd_above": "above usual",
"dd_below": "below usual",
"dd_nightRides": "Night rides ({from}-{to})",
"dd_yesPct": "Yes, +{pct}%",
"dd_no": "No",
"dd_raiseOnce": "You can lower your prices any time. Raising them is allowed once a day - next after {when}.",
"dd_ratesSaved": "Rates saved.",
"dd_ratesSavedMax": "Rates saved. Some were reduced to your city's maximum.",
"dd_ratesFail": "Could not save your rates. Please try again.",
"dd_pending": "A change is waiting for approval. Your current details stay live until it is checked.",
"dd_pickImage": "Please choose a photo.",
"dd_tooBig": "That photo is too large. Please choose one under 6MB.",
"dd_sentApproval": "Sent for approval.",
"dd_photoFail": "Could not send your photo. Please try again.",
"dd_changePhoto": "Change photo",
"dd_licExpired": "Driving licence expired",
"dd_licToday": "Licence expires today",
"dd_licOneDay": "Licence expires in 1 day",
"dd_licDays": "Licence expires in {n} days",
"dd_licUpdate": "Update your licence to keep getting leads.",
"dd_lowFree": "Wallet below ₹200 (₹{bal})",
"dd_lowFreeText": "Leads are free now - nothing is taken. Add money before lead fees begin.",
"dd_lowPaid": "Low wallet balance (₹{bal})",
"dd_lowPaidText": "Add money to keep getting leads.",
"dd_leadHistory": "Lead history",
"dd_leadHistorySub": "Customers who called you through Sramika",
"dd_noLeads": "No leads yet. When a customer calls you through Sramika, it shows here.",
"dd_pendingVer": "Waiting for verification",
"dd_details": "Details",
"dd_exp": "Experience",
"dd_trips": "Trip types",
"dd_tripsPick": "Pick at least one kind of trip.",
"dd_tripsFail": "Could not save. Please try again.",
"dd_langs": "Languages",
"dd_docs": "Your documents",
"dd_mobileLocked": "Verified · cannot be changed",
"dd_licFront": "Licence - front",
"dd_licBack": "Licence - back",
"dd_notUploaded": "Not uploaded",
"dd_docsNote": "To change your licence or mobile number, call Sramika - these are checked again before they change.",
"dd_editProfile": "Edit profile and documents",
"dd_referrals": "Referrals",
"dd_earned": "Earned",
"dp_pDriving": "Driving skill",
"dp_slabLocal": "Local - up to {n} hrs",
"dp_slabOut": "Outstation - up to {n} hrs",
"dp_nightRide": "Night ride +{pct}%",
"dp_nightHalt": "Night halt × {n}",
"dp_notFound": "Driver not found",
"dp_notFoundText": "This driver is no longer listed.",
"dp_backDrivers": "Back to drivers",
"dp_available": "Available now",
"dp_busy": "Busy now",
"dp_offline": "Not available now",
"dp_canDrive": "Can drive",
"dp_moreTypes": "+{n} more",
"dp_new": "New driver",
"dp_tooLong": "This trip is too long for one driver.",
"dp_price": "Driver's price",
"dp_driverOnly": "Driver's charge only",
"dp_noPrice": "No price for this trip yet - call to ask.",
"dp_callFail": "Could not connect the call. Please try again.",
"dp_trustDirect": "Talk to the driver directly",
"wl_title": "Sramika wallet",
"wl_balance": "Balance",
"wl_recent": "Recent transactions",
"wl_needAmt": "Not enough balance. Recharge ₹{amt} to continue.",
"wl_badAmt": "Enter a valid amount.",
"wl_done": "Recharge done.",
"wl_payFail": "Payment failed: {reason}",
"wl_payStartFail": "Could not start the payment.",
"wl_txnOther": "Wallet entry",
"wl_balAfter": "Balance {amt}",
"wg_lowTitle": "Your free calls are used up",
"wg_lowText": "Each connected call now costs ₹{fee}. It is taken from your wallet only when the call connects.",
"wg_balance": "Wallet balance: ₹{bal}",
"wg_resets": "Free calls come back at {time}",
"wg_pick": "Choose an amount",
"wg_add": "Add ₹{amt}",
"wg_paidTitle": "This call costs ₹{fee}",
"wg_paidText": "Taken from your wallet only if the call connects. Nothing is taken if it does not.",
"wg_paidCall": "Call · ₹{fee}",
"wg_okTitle": "₹{amt} added to your wallet",
"wg_okText": "New balance: ₹{bal}",
"wg_callNow": "Call now",
"wg_done": "Done",
"wg_failTitle": "The payment did not go through",
"wg_failText": "No money was added to your wallet. If money was taken from your bank, it comes back on its own in 5–7 working days.",
"wg_tryAgain": "Try again",
"wg_pendingTitle": "Confirming your payment",
"wg_pendingText": "This can take a minute. Your balance will update on its own - please do not pay again.",
"wg_soonTitle": "Adding money opens soon",
"wg_soonText": "Payments are not switched on yet. Your free calls still work.",
"wg_startFail": "Could not open the payment page. Please check your internet and try again.",
"wg_extraTitle": "Extra call - ₹{fee}",
"wg_extraText": "{n} free calls every {h} hours keep bookings genuine.",
"wg_extraTalk": "Talk to the driver directly on this call.",
"wg_balanceAfter": "Balance ₹{bal} → ₹{after}",
"wg_payWallet": "₹{fee} from wallet · Call",
"wg_payUpi": "Pay ₹{amt} & call",
"wg_freeAfter": "Free after {time}",
"wg_lastTitle": "Your last free call ({n}/{n})",
"wg_lastText": "{n} more free calls after {time}.",
"wg_call": "Call",
"wg_ownTitle": "This is your own car",
"wg_ownProfile": "This is your own profile",
"wg_ownText": "You can't create a lead on your own account.",
"ib_title": "Immediate booking",
"ib_text": "For trips starting within 8 hours, Sramika recommends the car based on availability.",
"ib_seats": "How many people?",
"ib_seat5": "1–4 people",
"ib_seat7": "5–6 people",
"ib_seat12": "7–12 people",
"ib_model": "Car model (optional)",
"ib_modelHint": "e.g. Innova",
"ib_fare": "Fare for this trip: ₹{min} – ₹{max}",
"ib_pickSeats": "Choose the seats",
"ib_book": "Book now",
"ib_finding": "Confirming your car…",
"ib_confirmed": "Booking confirmed",
"ib_callYou": "The driver will call you in 10 minutes.",
"ib_team": "Our team will call you in 10 minutes.",
"ib_error": "Could not book. Please try again.",
"ob_title": "⚡ Urgent trip?",
"ob_sub": "Sramika recommended car in 2–10 min · ₹{min} – ₹{max}",
"ib_textAny": "Sramika recommends the car based on availability.",
"ib_urgentTitle": "⚡ This is an urgent trip",
"ib_urgentText": "Within 8 hours: a Sramika recommended car, usually confirmed in 2–10 minutes. No need to call drivers one by one.",
"ib_urgentBtn": "⚡ Book a car in 2–10 min",
"ib_any": "Any",
"ib_cars": "{n} cars",
"ib_wait": "Usually 2–10 minutes. If no car is confirmed in 10 minutes, our team calls you.",
"ib_callDriver": "📞 Call driver",
"ib_private": "Through the Sramika number - the driver does not see your number",
"ib_calling": "📞 Your phone will ring now - pick up to talk to the driver.",
"tr_wants": "Customer asked for: {what}",
"wl_txnCall": "Call charge",
"wl_minMax": "Add between ₹{min} and ₹{max}.",
"sp_title": "Help",
"sp_callTitle": "Talk to Sramika",
"sp_callText": "For any problem with a call, a price, a car or a driver.",
"sp_callBtn": "Call Sramika",
"sp_faqTitle": "Common questions",
"sp_q1": "How do I find a car?",
"sp_a1": "Set your pickup and drop. Compare the cars and their prices, then tap Call to talk to the driver directly.",
"sp_q2": "Is there a booking fee?",
"sp_a2": "No. Nothing is booked in the app - you agree the trip with the driver and pay them directly.",
"sp_q3": "How do I cancel a trip?",
"sp_a3": "Call the driver and tell them. The trip is arranged between you and them, so there is no booking here to cancel. Your enquiry stays in History either way.",
"sp_q4": "How do I pay?",
"sp_a4": "You pay the driver directly - cash or UPI, as you agree with them.",
"sp_q5": "What is not in the price?",
"sp_a5": "Toll, parking and state tax - pay the driver directly. Extra km or hours cost more.",
"sp_q6": "How do I report a problem?",
"sp_a6": "Call Sramika with the button above. Keep the enquiry from History open, so you can say which trip it is.",
"sp_footer": "Sramika help · support@sramika.com",
"nc_soon": "Coming soon",
"nc_title": "Sramika is coming to {city}",
"nc_titleNoCity": "Sramika is coming to your city soon",
"nc_text": "We're adding cars and drivers in {city}. Leave your number and we'll tell you on WhatsApp when they are ready.",
"nc_textNoCity": "We're adding cars and drivers in your city. Leave your number and we'll tell you on WhatsApp when they are ready.",
"nc_expected": "Expected to start",
"nc_name": "Your name",
"nc_phone": "WhatsApp number (10 digits)",
"nc_join": "Tell me when it starts",
"nc_enterName": "Please enter your name.",
"nc_fail": "Could not save. Please try again.",
"nc_doneTitle": "You're on the list",
"nc_doneText": "We'll tell you on WhatsApp when Sramika starts in {city}.",
"nc_doneTextNoCity": "We'll tell you on WhatsApp when Sramika starts in your city.",
"nt_title": "Notifications",
"nt_emptyTitle": "No notifications yet",
"nt_emptyText": "News about your enquiries and your account will show here.",
"nt_history": "See my enquiries",
"nt_all": "All",
"nt_ride": "Trips",
"nt_approval": "Approvals",
"nt_document": "Documents",
"nt_wallet": "Wallet",
"nt_system": "Updates",
"nt_unread": "New",
"nt_read": "Seen",
"nt_important": "Important",
"nt_noneHere": "Nothing under {name}.",
"nt_showAll": "Show all",
"nt_notification": "Notification",
"st_confirm": "Confirm",
"st_notSignedIn": "You're not logged in",
"st_signInToManage": "Log in to change your profile and settings",
"st_loginSignup": "Log in / Sign up",
"st_partnerLogin": "Driver login",
"st_notEditable": "Cannot be changed",
"st_usernamePh": "Your username",
"st_save": "Save",
"st_notSet": "Not set",
"st_edit": "Edit",
"st_cityPh": "e.g. Vijayawada",
"st_myRating": "My rating",
"st_footer": "Sramika v1.0 · All data secured with encryption",
"st_nameSaved": "Username updated.",
"st_nameFail": "Could not save the username.",
"st_nfTitle": "This page does not exist",
"st_nfText": "The link may be old, or the address may have a typo. Everything is still here - start from the home page.",
"st_nfCar": "Find a car",
"st_nfDriver": "Hire a driver",
"st_suInvalid": "This page opens after you verify your mobile number.",
"st_suToLogin": "Go to login",
"st_suNameTitle": "Set your username",
"st_suNameHint": "Spaces are allowed. It cannot be changed later.",
"st_suNameMissing": "Enter a username to continue.",
"st_suContinue": "Continue",
"st_suPwTitle": "Set your password",
"st_suPwMissing": "Enter a password to continue.",
"st_suPwFail": "Could not set the password.",
"st_suNewPwPh": "Enter a new password",
"pl_brand": "Sramika Business",
"pl_portal": "For drivers",
"pl_stepPhone": "Enter mobile",
"pl_awaiting": "Your account is not active yet. Please contact Sramika.",
"pl_continueFail": "Could not continue. Try again.",
"pl_badPw": "Wrong password. Please try again.",
"pl_hide": "Hide",
"pl_show": "Show",
"pl_checking": "Checking…",
"pl_continue": "Continue →",
"pl_welcomeBack": "Welcome back! Signing in as +91 {phone}",
"pl_otpInstead": "Log in with OTP instead",
"pl_otpLabel": "OTP (one-time password)",
"pl_customerLogin": "← Customer login",
"pl_secs": "{n}s",
"lg_tenDigit": "10-digit number",
"lg_moreDigits": "{n} more digits needed",
"lg_oneMoreDigit": "1 more digit needed",
"lg_startDigit": "Must start with 6, 7, 8 or 9",
"lg_enterMobile": "Enter your mobile number.",
"lg_otpSendFail": "Could not send the OTP. Try again.",
"lg_enterOtp": "Enter the OTP.",
"lg_otpInvalid": "Wrong OTP. Please try again.",
"lg_otpResendFail": "Could not resend the OTP.",
"lg_pwMin": "Password must be at least 8 characters.",
"lg_pwMax": "Password must be 64 characters or fewer.",
"lg_pwRange": "Password must be 8-64 characters.",
"lg_resetFail": "Could not change the password. Try again.",
"lg_resetTitle": "Reset password",
"lg_verifyOtp": "Verify OTP",
"lg_setNewPw": "Set new password",
"lg_forgotIntro": "Enter your registered mobile number. We'll send you a code.",
"lg_mobile": "Mobile number",
"lg_waNotice": "We'll send your OTP and updates about your enquiries to this number on WhatsApp and SMS. To stop updates, reply STOP on WhatsApp.",
"lg_sending": "Sending…",
"lg_sendOtp": "Send OTP",
"lg_otpSentTo": "OTP sent to +91 {phone}. Enter the 6-digit code below.",
"lg_otp6": "6-digit OTP",
"lg_resendIn": "Resend in {n}s",
"lg_resend": "Resend",
"lg_verifying": "Verifying…",
"lg_otpDone": "OTP verified. Set your new password.",
"lg_newPw": "New password",
"lg_pwHint": "8-64 characters",
"lg_saving": "Saving…",
"lg_tagline": "Your trusted cab service",
"lg_logIn": "Log in",
"lg_signUp": "Sign up",
"lg_password": "Password",
"lg_otpLogin": "OTP login",
"lg_userOrMobile": "Username or mobile",
"lg_userOrMobilePh": "Username or mobile number",
"lg_enterPw": "Enter password",
"lg_forgot": "Forgot password?",
"lg_signingIn": "Signing in…",
"lg_signIn": "Sign in",
"lg_codeSentTo": "Enter the 6-digit code sent to +91 {phone}",
"lg_verifySignIn": "Verify & sign in",
"lg_userName": "User name",
"lg_nameTaken": "This username is taken.",
"lg_tryName": "Try: {name}",
"lg_numTaken": "This mobile number is already registered.",
"lg_signInInstead": "Sign in instead →",
"lg_email": "Email",
"lg_fullName": "Full name",
"lg_enterOtp6": "Enter 6-digit OTP",
"lg_setPw": "Set password",
"lg_confirmPw": "Confirm password",
"lg_reenterPw": "Re-enter password",
"lg_accept": "I accept the {terms} and {privacy}, and explicitly consent to the collection of my personal data for platform operations.",
"lg_terms": "Terms & Conditions",
"lg_privacy": "Privacy Policy",
"lg_creating": "Creating account…",
"lg_create": "Create account",
"lg_earn": "Want to earn with Sramika?",
"lg_joinAs": "Join as a driver or an alting driver",
"lg_cabOwner": "Driver",
"lg_hireDriver": "Hire driver",
"lg_enterUsername": "Please enter a username.",
"lg_otherUsername": "Please choose a different username.",
"lg_validMobile": "Enter a valid 10-digit mobile number.",
"lg_hasAccount": "This number already has an account.",
"lg_otpSentShort": "OTP sent to +91 {phone}",
"lg_noAccount": "No account yet - let's create one.",
"lg_autoOtpFail": "Could not send the OTP. Tap Resend.",
"lg_noPwYet": "Your account has no password yet - set it now.",
"lg_enterOtpSent": "Enter the OTP sent to your mobile.",
"lg_enterUserOrMobile": "Enter your username or mobile number.",
"lg_enterPwMsg": "Enter your password.",
"lg_setPwFor": "Please set a password for your mobile number.",
"lg_badLogin": "Wrong username/mobile or password. Please check.",
"lg_otpExpired": "OTP expired. Please resend.",
"lg_pwMismatch": "Passwords do not match.",
"lg_enterEmail": "Please enter an email address.",
"lg_enterFullName": "Please enter your full name.",
"lg_acceptFirst": "Please accept the Terms & Privacy Policy.",
"lg_createFail": "Could not create the account.",
"cv_lExtraOneHr": "Extra 1 hr",
"cv_24h": "24 hours",
"cv_back": "Back",
"cv_share": "Share",
"cv_linkCopied": "Link copied",
"cv_prevPhoto": "Previous photo",
"cv_nextPhoto": "Next photo",
"cv_close": "Close",
"cv_nRatings": "{n} ratings",
"cv_oneRating": "1 rating",
"cv_model": "{year} model",
"cv_manual": "Manual",
"cv_auto": "Automatic",
"cv_male": "Male",
"cv_female": "Female",
"cv_licence": "Licence checked",
"cv_yourTrip": "Your trip",
"cv_change": "Change",
"cv_local": "Local",
"cv_partnerPrice": "Driver's price",
"cv_usualFare": "Usual fare",
"cv_extrasShort": "Toll, parking extra",
"cv_priceDetails": "Price details",
"cv_eta": "{name} is {n} min from {place}",
"cv_seePriceTitle": "See the price for your trip",
"cv_seePriceText": "Set pickup and drop - the price shows here.",
"cv_setTrip": "Set pickup & drop",
"cv_allDay": "Available every day · 24 hours",
"cv_everyDay": "Available every day · {hours}",
"cv_openToday": "Available today · {hours}",
"cv_closedToday": "Not available today",
"cv_daysOpen": "{n} of 7 days",
"cv_week": "Week",
"cv_dayOff": "Off",
"cv_dayBusy": "Busy",
"cv_dayOpen": "Available",
"cv_notConfirmed": "Usual hours - not yet confirmed by the driver",
"cv_rateTitle": "How was your trip with {name}?",
"cv_rateNoName": "How was your trip?",
"cv_rateParts": "Each part - change any, or just send",
"cv_noRatings": "No ratings yet",
"cv_rateAfter": "Travelled with this car? Rate it after your trip.",
"cv_partsFrom": "Parts from {n} of {m} ratings",
"rl_title": "Rate the trip with {name}",
"rl_done": "Thank you! Your rating is saved.",
"rl_gone": "This link has expired. Thank you for your stars!",
"cv_trustDirect": "Talk to the driver directly",
"cv_trustNoFee": "No booking fee",
"cv_trustHelp": "Sramika help if needed",
"cv_help": "Need help? Call Sramika",
"cv_onTripBack": "On a trip · back {when}",
"cv_onTrip": "On a trip right now",
"cv_notFree": "Not free right now",
"cv_notifyMe": "Tell me when free",
"cv_notified": "We'll tell you",
"cv_similar": "Similar cars",
"cv_setByPartner": "Set by the driver · No Sramika commission",
"cv_kmBoth": "{km} km both ways",
"cv_nDays": "{n} days",
"cv_oneDay": "1 day",
"cv_nHrs": "{n} hrs",
"cv_oneHr": "1 hr",
"cv_nNights": "{n} nights",
"cv_oneNight": "1 night",
"cv_nHalfDays": "{n} half-days",
"cv_oneHalfDay": "1 half-day",
"cv_lBase": "Base fare",
"cv_lDrop": "Drop fare",
"cv_lDriver": "Driver allowance ({x})",
"cv_lNight": "Night allowance ({x})",
"cv_lDropUpTo": "One-way drop (up to {km} km)",
"cv_lDropFirst": "One-way drop (first {km} km)",
"cv_lExtraKmRate": "Extra {km} km × ₹{rate}",
"cv_lPackage": "{n}-hour package",
"cv_lExtraHr": "Extra {n} hrs",
"cv_lExtraKm": "Extra {n} km",
"cv_lDayRent": "Day rent ({x})",
"cv_lFuel": "Fuel charge",
"cv_youPay": "You pay the driver",
"cv_notIncl": "Not included",
"cv_notIncl1": "Toll, parking and state tax - pay the driver directly",
"cv_notIncl2": "Extra km or hours cost more",
"cv_calcLink": "Work out extra km / hours",
"cv_calcTitle": "Price calculator",
"cv_calcSub": "Price for more km or hours",
"cv_calcHours": "Trip hours",
"cv_calcKm": "Total km",
"cv_calcBtn": "Work out price",
"cv_calcTotal": "Estimated price",
"cv_calcNote": "Toll, parking and state tax not included",
"cv_loading": "Loading car details…",
"cv_goneTitle": "Car not available",
"cv_goneText": "This car is no longer listed, or the link has expired.",
"cv_backHome": "Back to Home",
"hm_recentEnquiry": "Your recent enquiry",
"hm_nPartners": "{n} partners",
"hm_onePartner": "1 partner",
"hm_resAvailIn": "{items} available in {city}",
"hm_resAvailInCars": "{items} available in {city}",
"hm_changeLang": "Change language",
"hm_changeCity": "Change city",
"hm_helpCall": "Call Sramika for help",
"hm_chooseCity": "Choose your city",
"hm_typeCity": "Type your city",
"hm_useMyLocation": "Use my location",
"hm_finding": "Finding your location…",
"hm_noCities": "No city with this name",
"hm_locNotSupported": "This phone cannot share its location.",
"hm_locMapsOff": "Maps did not load. Please refresh the page.",
"hm_locNotFound": "Could not find your location. Please try again.",
"hm_locNoCity": "We found you, but could not tell the city. Please choose it below.",
"hm_locDenied": "Location permission was not given. Please allow it in your phone settings and try again.",
"hm_locUnavailable": "Location is not available. Please turn on GPS and try again.",
"hm_locTimeout": "Finding your location took too long. Please try again.",
"hm_guestTitle": "Log in to call drivers directly",
"hm_guestSubCars": "Compare fares, then talk to the driver directly - no booking fee.",
"hm_guestSubDrivers": "Free with your mobile number. Call in one tap and see your enquiries in History. No booking fee.",
"hm_guestTitleCars": "Log in to call drivers directly",
"hm_guestSubCarsLogin": "Free with your mobile number. Call in one tap and see your enquiries in History. No booking fee.",
"hm_loginJoin": "Log in / Join",
"hm_recent": "Recent",
"hm_setTrip": "Set trip",
"hm_km": "{km} km",
"hm_searchCars": "Search car, model or area",
"hm_searchDrivers": "Search driver name or language",
"hm_filters": "Filters",
"hm_clearSearch": "Clear search",
"hm_removeFilter": "Remove filter",
"hm_any": "Any",
"hm_sort": "Sort",
"hm_sortRec": "Recommended",
"hm_sortPriceLow": "Lowest price first",
"hm_sortPriceHigh": "Highest price first",
"hm_sortRating": "Best rated first",
"hm_sortEta": "Nearest first",
"hm_sortNewest": "Newest cars first",
"hm_seats": "Seats",
"hm_nSeats": "{n} seats",
"hm_carType": "Car type",
"hm_price": "Price",
"hm_ctHatch": "Hatchback",
"hm_ctSedan": "Sedan",
"hm_ctMiniSuv": "Mini SUV",
"hm_ctSuv": "SUV",
"hm_ctMpv": "7-seater (MPV)",
"hm_ctTempo": "Tempo Traveller",
"hm_ctBus": "Bus",
"hm_fuel": "Fuel",
"hm_fuelPetrol": "Petrol",
"hm_fuelDiesel": "Diesel",
"hm_fuelCng": "CNG",
"hm_fuelEv": "Electric",
"hm_year": "Car year",
"hm_yr2024": "2024 or newer",
"hm_yr2015": "2015 or older",
"hm_budUnder5": "Under ₹5,000",
"hm_budAbove15": "Above ₹15,000",
"hm_sortExp": "Most experienced first",
"hm_sortOnline": "Online now first",
"hm_sortFareLow": "Lowest fare first",
"hm_dBudUnder1": "Under ₹1,000",
"hm_dBudAbove3": "Above ₹3,000",
"hm_priceNeedsTrip": "Set your trip first - the price depends on it.",
"hm_rating": "Rating",
"hm_starsPlus": "{n}+ stars",
"hm_experience": "Driving experience",
"hm_expPlus": "{n}+ yrs driving",
"hm_speaks": "Speaks",
"hm_goodAt": "Customers say",
"hm_tOnTime": "On time",
"hm_tPolite": "Polite",
"hm_tComfort": "Comfortable ride",
"hm_tClean": "Clean car",
"hm_tSafe": "Safe driving",
"hm_driverAge": "Driver's age",
"hm_ageRange": "{range} years",
"hm_grpCar": "The car",
"hm_grpDriver": "The driver",
"hm_grpPrice": "Price",
"hm_grpTrip": "The trip",
"hm_clearAll": "Clear all",
"hm_close": "Close",
"hm_showCars": "Show {n} cars",
"hm_showOneCar": "Show 1 car",
"hm_showNoCars": "No cars match",
"hm_showDrivers": "Show {n} drivers",
"hm_showOneDriver": "Show 1 driver",
"hm_showNoDrivers": "No drivers match",
"hm_tripType": "Trip type",
"hm_ttLocal": "Local",
"hm_ttOut": "Outstation",
"hm_ttDrop": "Dropping",
"hm_availability": "Availability",
"hm_availNow": "Available now",
"hm_nDrivers": "{n} drivers",
"hm_oneDriver": "1 driver",
"hm_resRoute": "{items} for {route}",
"hm_resNear": "{items} near {place}",
"hm_resFound": "Found: {items}",
"hm_showAll": "Show all",
"hm_shareList": "Share list",
"dk_trips": "Trips",
"dk_heroCars": "Cars in {city}",
"dk_subCars": "Compare real prices, then call the driver directly - no booking fee, no advance.",
"dk_heroDrivers": "Hire a driver in {city}",
"dk_subDrivers": "Your car, our driver - see every rate, then call the driver directly.",
"dk_searchCars": "Search cars",
"dk_searchDrivers": "Find drivers",
"dk_when": "When",
"dk_tripType": "Trip",
"dk_filters": "Filters",
"dk_pickWhen": "Pick a date",
"dk_tagline": "Cars and drivers near you - compare prices and call the driver directly.",
"dk_fCustomers": "For customers",
"dk_fJoin": "Join Sramika",
"dk_fAbout": "About",
"dk_fByCity": "By city",
"dk_fCabsByCity": "Cabs by city",
"dk_fDriversByCity": "Hire drivers by city",
"dk_fFareChart": "Taxi fare chart",
"dk_fAirport": "Airport taxi",
"cbk_button": "🙋 Call me back — we book it for you",
"cbk_title": "We'll call you",
"cbk_sub": "Our Sramika team calls you within 10 minutes and books it for you. No login needed.",
"cbk_night": "It's night now - we'll call you at 8 am.",
"cbk_name": "Your name",
"cbk_phone": "Mobile number",
"cbk_trip": "Your trip",
"cbk_note": "Anything else (optional)",
"cbk_notePh": "6 people, 3 bags…",
"cbk_send": "Ask for a call",
"cbk_sending": "Sending…",
"cbk_done": "Got it! You'll get a call within 10 minutes.",
"cbk_doneNight": "Got it! We'll call you at 8 am.",
"cbk_already": "We already have your request - we'll call you soon.",
"cbk_badPhone": "Enter a 10-digit mobile number",
"cbk_noName": "Enter your name",
"cbk_error": "Couldn't send. Please call {n}.",
"cbk_noLogin": "Don't want to log in? We'll call you →",
"lcb_title": "New customer call",
"lcb_accept": "I'll take it",
"lcb_reject": "Not now",
"lcb_ago": "{n} min ago",
"lcb_accepted": "Taken - call the customer from Leads",
"lcb_rejected": "Okay - Sramika will help this customer",
"tr_title": "New trip",
"tr_yourPrice": "Your price",
"tr_accept": "Accept",
"tr_decline": "Decline",
"tr_won": "Trip confirmed",
"tr_taken": "Taken by another driver",
"tr_closed": "This request has closed",
"tr_missedTip": "The first driver to accept gets the trip. Accept quickly next time.",
"tr_declined": "Declined",
"tr_free": "Free for trips today",
"tr_call": "Call the customer",
"tr_calling": "Connecting - your phone rings first",
"tr_over": "The trip has ended",
"tr_callErr": "Could not connect. Try again.",
"tr_people": "{n} people",
"cbk_close": "Close",
"dk_fRegisterCar": "Register your car",
"dk_fJoinDriver": "Join as a driver",
"dk_fTerms": "Terms",
"dk_fPrivacy": "Privacy",
"dk_fRefunds": "Refunds",
"dk_fDelete": "Delete account",
"bl_title": "Please wait before calling another business",
"bl_body": "Drivers can call one business every 6 hours - so the same enquiry does not reach people again and again.",
"bl_next": "You can call another business from {when}",
"bl_urgent": "Urgent? Call Sramika",
"bl_ok": "OK",
"cb_pill": "Call to book",
"cb_barTitle": "Not sure which car? We book it for you",
"cb_hours": "8 am – 9 pm · Telugu, Hindi, English",
"cb_call": "Call",
"cb_or": "Or call us and we book it for you:",
"cb_want": "Want us to book it for you?",
"cb_quiet": "Want to book on a call? We book it for you",
"cb_callUs": "Call us",
"hm_guestCardT": "Log in once - call any driver directly",
"hm_guestCardD": "Free with your mobile number. No booking fee.",
"hm_loginShort": "Log in",
"vc_speak": "Speak",
"vc_listening": "Speak now…",
"vc_langs": "Telugu · Hindi · English - in your own language",
"vc_stop": "Stop",
"vc_errMic": "Allow the microphone to speak",
"vc_errNone": "Didn't hear anything - try again",
"vc_errOther": "Voice is not working now - please type",
"sq_phCars": "Car, place, trip - ask anything",
"sq_phDrivers": "Driver, language, trip - ask anything",
"sq_recent": "Your recent searches",
"sq_clear": "Clear all",
"sq_remove": "Remove",
"sq_try": "You can ask",
"sq_trips": "Popular trips",
"sq_understood": "Understood:",
"sq_goTrip": "See prices for this trip",
"sq_goCars": "Show these cars",
"sq_goDrivers": "Show these drivers",
"sq_speaks": "Speaks {lang}",
"sq_ex1": "7-seater to Tirupati tomorrow",
"sq_ex2": "Airport drop",
"sq_ex3": "7-seater diesel",
"sq_ex4": "Hyderabad and back, day after tomorrow",
"sq_dx1": "Hyderabad and back tomorrow morning",
"sq_dx2": "Airport drop tonight",
"sq_dx3": "Hindi speaking driver tomorrow",
"sq_dx4": "Tirupati tomorrow",
"sq_inDrivers": "No car by this name - {n} found in Drivers ›",
"sq_inCars": "No driver by this name - {n} found in Cars ›",
"vr_titleCars": "How far should your cars be seen?",
"vr_titleDriver": "How far should your profile be seen?",
"vr_sub": "Customers whose pickup is within this distance of you see you.",
"vr_km": "{n} km",
"vr_sramika": "Sramika",
"vr_legCity": "Sramika {n} km",
"vr_legOwn": "Yours {n} km",
"vr_note": "A longer distance brings more enquiries - but you travel to the pickup.",
"vr_save": "Save",
"vr_reset": "Use Sramika's distance ({n} km)",
"vr_saved": "Saved",
"vr_err": "Could not save - try again",
"vr_later": "You can change it later on your dashboard.",
"dk_bizSub": "For drivers.",
"dk_bizCalls": "Calls from customers, directly",
"dk_bizPrices": "Your own prices",
"dk_bizHours": "Your own hours",
"dk_bizJoin": "New here? Join Sramika",
"dk_step1": "Fill the form",
"dk_step2": "Sramika checks it",
"dk_step3": "Customers call you",
"dk_trustCars": "Verified cars",
"dk_trustDrivers": "Verified drivers",
"dk_trustPrice": "Price before you call",
"dk_trustCallOwner": "Call the driver directly",
"dk_trustCallDriver": "Call the driver directly",
"dk_tripReady": "All set - the prices shown are for this trip.",
"dk_tripReadyDrivers": "All set - each driver's price is for this trip.",
"dk_route": "Route",
"dk_group": "Group",
"dk_people": "{n} people",
"dk_person": "1 person",
"dk_bags": "{n} bags",
"dk_bag": "1 bag",
"dk_kmApprox": "~{km} km",
"hm_linkCopied": "Link copied - paste it in WhatsApp",
"hm_setPickup": "Set as pickup",
"hm_goingTo": "Going to {city}?",
"hm_canTake": "{items} from {city} can take you there",
"hm_setDrop": "Set as drop",
"hm_seeBasedIn": "See cars based in {city}",
"hm_bTop": "Top rated",
"hm_bNearby": "Nearby",
"hm_homeReturn": "{city} car · takes you on its way home",
"rc_badge": "Sramika Recommended",
"join_vendor": "Car wash or car inspection business? List your business →",
"rc_checked": "Checked by Sramika: documents, prices, answers calls, no complaints",
"rc_why": "Recommended cars are shown higher to customers nearby.",
"rc_has": "You have it until {date}",
"rc_c_verified": "Verified",
"rc_c_profile": "Set all prices",
"rc_c_answers": "Answer calls",
"rc_c_rated": "Good ratings",
"rc_c_price": "Fair price",
"rc_c_clean": "No complaints",
"hm_bLuxury": "Luxury",
"hm_bFamily": "Family trip",
"hm_bFast": "Quick booking",
"hm_bNew": "New on Sramika",
"hm_online": "Online",
"hm_newTag": "New",
"hm_viewFare": "View fare",
"hm_nReviews": "{n} reviews",
"hm_onTrip": "On a trip",
"hm_repair": "In repair",
"hm_age": "Age {n}",
"hm_yrs": "{yrs} yrs",
"hm_driving": "driving",
"hm_minAway": "{n} min away",
"hm_kmAway": "{km} km away",
"hm_aboutKm": "about {km} km",
"hm_under1km": "under 1 km",
"hm_distFrom": "{dist} from {place}",
"hm_matchedBy": "Matched: {what}",
"hm_mModel": "Car model",
"hm_mBrand": "Brand",
"hm_mDriver": "Driver name",
"hm_mLang": "Language",
"hm_mDetails": "Car details",
"hm_mName": "Name",
"hm_mCity": "City",
"hm_mProfile": "Profile",
"hm_seePrice": "See price",
"hm_saveAmt": "Save ₹{amt}",
"hm_call": "Call",
"hm_viewCar": "View details for {name}",
"hm_photoOf": "Photo {n} of {name}",
"hm_tooLong": "Too far for one driver",
"hm_priceOnReq": "Price on request",
"hm_oneHr": "1 hr",
"hm_busy": "Busy",
"hm_offline": "Offline",
"hm_confirmTitle": "Call {name}?",
"hm_confirmText": "About the {car}. Your trip details go to the driver with the call.",
"hm_thePartner": "the driver",
"hm_cancel": "Cancel",
"hm_callConnecting": "Connecting you to the driver.",
"hm_callFailed": "Could not connect the call. Please try again.",
"hm_partnerBusy": "This driver cannot take calls right now. Please try another car.",
"hm_cantCall": "This account cannot call drivers. Please log in as a customer.",
"hm_findingCars": "Finding cars in {city}…",
"hm_findingDrivers": "Finding drivers in {city}…",
"hm_pickCityCars": "Choose your city to see cars",
"hm_pickCityDrivers": "Choose your city to see drivers",
"hm_networkGrowing": "Sramika is growing",
"hm_noCarsIn": "No cars in {city} yet",
"hm_noCarsText": "We are adding drivers here. Try another city, or join if you own a car.",
"hm_noDriversIn": "No drivers in {city} yet",
"hm_noDriversText": "We are adding drivers here. Try another city, or join if you are a driver.",
"hm_joinPartner": "Join with your car",
"hm_joinDriver": "Join as driver",
"hm_supTitle": "Need help from Sramika?",
"hm_supText": "Call us. We will help you find the right car.",
"hm_ocTitle": "Looking for cars in {city}?",
"hm_ocText": "Your city is set to {current}.",
"hm_switchTo": "Switch to {city}",
"hm_lookingFor": "Looking for “{q}” near {city}…",
"hm_iAccT": "Looking for your account?",
"hm_iAccD": "Your profile and settings are in Account.",
"hm_iAccB": "Open Account",
"hm_iPartT": "Want to add your car to Sramika?",
"hm_iPartD": "Join Sramika as a business - with your car or as a driver - and get calls from customers. No commission.",
"hm_iTripsT": "Looking for your trips?",
"hm_iTripsD": "Your enquiries and trips are in History.",
"hm_iTripsB": "Open History",
"hm_iPriceT": "Checking prices?",
"hm_iPriceD": "Set your trip at the top to see the price of every car.",
"hm_iRouteT": "Going somewhere?",
"hm_iRouteD": "Tap “Pickup location” at the top to set your trip.",
"hm_noFound": "No cars found for “{q}”",
"hm_noDriversFound": "No drivers found for “{q}”",
"hm_noMatchCars": "No cars match your filters",
"hm_noMatchDrivers": "No drivers match your filters",
"hm_tryThese": "Try one of these:",
"hm_clearFilters": "Clear filters",
"hm_hide": "Hide",
"hm_didBookCar": "Did you book the {car}?",
"hm_didBookWith": "Did you book the {car} with {name}?",
"hm_didHire": "Did you hire {name}?",
"hm_thanksSaid": "Thanks - you said “{answer}”.",
"hm_askLater": "Ask me later",
"hm_joinDriverT": "Are you a driver?",
"hm_joinDriverD": "Join Sramika and get calls from customers.",
"hm_join": "Join",
"hm_joinCarT": "Do you own a car?",
"hm_joinCarD": "Add your car to Sramika and get calls from customers. No commission.",
"hm_myRequests": "My hire requests",
"hm_loading": "Loading…",
"hm_reqPending": "Waiting",
"hm_reqAccepted": "Accepted",
"hm_reqRejected": "Declined",
"hm_halfDay": "Half day (4 hrs)",
"hm_fullDay": "Full day (8 hrs)",
"hm_rateThisDriver": "Rate this driver",
"hm_rated": "Rated",
"hm_reqSent": "Request sent",
"hm_reqSentText": "The driver will look at your request and reply soon.",
"hm_ratingSent": "Rating sent",
"hm_ratingThanks": "Thank you. It helps other customers.",
"hm_ok": "OK",
"mc_custRequest": "Customer's request",
"mc_helpLead": "Need help with this lead? Call Sramika",
"ld_stCall": "Call triggered",
"ld_stAccepted": "Accepted",
"ld_stSuccess": "Trip successful",
"ld_stConfirm": "Need to confirm",
"ld_stNotBooked": "Not booked",
"ld_waiting": "Waiting",
"ld_afterTrip": "After the trip",
"ld_chipDone": "Completed",
"ld_chipConfirm": "Needs your answer",
"ld_chipUpcoming": "Upcoming",
"ld_chipSent": "Enquiry sent",
"ld_title": "Enquiry details",
"ld_sub": "See your enquiry and tell us what happened",
"ld_tripEnquiry": "Trip enquiry",
"ld_sentTo": "Sent to {name}",
"ld_sentPartner": "Sent to the driver",
"ld_tripDetails": "Trip details",
"ld_tripDate": "Trip date",
"ld_enquiryDate": "Enquiry date",
"ld_distance": "Distance",
"ld_passengers": "Passengers",
"ld_vehicle": "Vehicle requested",
"ld_driverReq": "Driver requested",
"ld_refFare": "Reference fare",
"ld_refNote": "This is the price you were shown. The final price is agreed directly with the driver.",
"ld_didBook": "Did you book this car?",
"ld_didBookDriver": "Did you hire this driver?",
"ld_didBookSub": "Let us know how this enquiry went.",
"ld_yes": "Yes, booked",
"ld_yesSub": "I went with them",
"ld_no": "No, didn't book",
"ld_noSub": "I didn't go",
"ld_maybe": "Still deciding",
"ld_maybeSub": "Not sure yet",
"ld_beforeTrip": "You can answer after the trip date.",
"ld_rateTitle": "How was your experience?",
"ld_rateSub": "Your stars help other customers choose.",
"ld_ratePh": "Tell us about your experience (optional)",
"ld_rateSend": "Submit rating",
"ld_rateThanks": "Thanks - you rated {n} ★",
"ld_rateErr": "Could not save your rating. Please try again.",
"ld_whyTitle": "If you didn't book, what happened?",
"ld_whySub": "Helps us serve you better (optional)",
"ld_rHigh": "High price",
"ld_rNotAvail": "Car not available",
"ld_rElsewhere": "Booked elsewhere",
"ld_rNoResp": "No response",
"ld_rPlans": "Changed plans",
"ld_rOther": "Other",
"ld_rThanks": "Thanks for telling us.",
"ld_callPartner": "Call the driver",
"ld_callSub": "Talk to the partner directly",
"mc_tabLeads": "Leads",
"mc_tabWallet": "Wallet",
"mc_free": "Leads are free now.",
"mc_freeSub": "Nothing is taken from your wallet.",
"mc_low": "Wallet below ₹{min} - add money to keep getting leads.",
"mc_addMoney": "Add money - call Sramika",
"mc_cars": "Cars",
"mc_available": "Available",
"mc_busy": "Busy",
"mc_inReview": "In review",
"mc_myDrivers": "My drivers",
"mc_limit": "Vehicle limit reached ({n})",
"mc_live": "Live",
"mc_rejected": "Not approved",
"mc_hidden": "Hidden",
"mc_availability": "Availability",
"mc_onTrip": "On trip",
"mc_maint": "Maintenance",
"mc_avHint": "Customers see \"On trip\" or \"Maintenance\" on your car. It goes back to Available after 24 hours.",
"mc_addDriver": "Add driver",
"mc_driver": "Driver",
"mc_chooseDriver": "Choose a driver",
"mc_drvPending": "(waiting for approval)",
"mc_pricesDetails": "Prices & details",
"mc_reviewText": "Sramika is checking this car. We will tell you when it is live.",
"mc_editsPending": "Your latest changes are waiting for approval.",
"mc_rejectedText": "This car was not approved. Call Sramika to know why.",
"mc_hiddenText": "Customers cannot see this car. Call Sramika to show it again.",
"mc_noCars": "No cars yet",
"mc_noCarsSub": "Add your car to start getting calls.",
"mc_regProgress": "Car registration in progress",
"mc_regProgressSub": "Your car is being set up. Call Sramika if this takes more than a day.",
"mc_profileReview": "Profile under review",
"mc_profileReviewSub": "Your documents are being checked. Your cars go live after approval.",
"mc_submitted": "Submitted",
"mc_appId": "Application ID",
"mc_licExpired": "Licence expired",
"mc_licExpiredSub": "Your driving licence has expired. Please renew it and send it again.",
"mc_licAgain": "Licence photo needed again",
"mc_licAgainSub": "Your licence photo was not clear. Please send a clear photo.",
"mc_loading": "Loading your cars…",
"mc_loadErr": "Could not load. Please try again.",
"mc_retry": "Try again",
"mc_relogin": "Log in again",
"mc_moveDriver": "Move {a} to this car? {b} will get the other car.",
"mc_replaceDriver": "Put {a} on this car? {b} will be taken off it.",
"mc_assignErr": "Could not change the driver. Please try again.",
"mc_getMore": "Get more calls",
"mc_getMoreSub": "5 simple steps",
"mc_leadPrices": "Lead prices",
"mc_leadPricesSub": "What a lead costs",
"mc_yourLeads": "Your leads",
"mc_leadsCount": "{n} · newest first",
"mc_noLeads": "No leads yet",
"mc_noLeadsSub": "When customers call you through Sramika, they appear here.",
"mc_new": "New",
"mc_called": "Called",
"mc_booked": "Booked",
"mc_custPrice": "Customer's price",
"mc_showNumber": "Show number",
"mc_revealSoon": "Showing the customer number is coming soon.",
"mc_didHappen": "Did this trip happen?",
"mc_youMarked": "You said: {answer}",
"mc_locked": "Locked",
"mc_changesLeft": "Change your answer - {n} left",
"mc_rateCust": "Rate this customer",
"mc_rated": "Thanks - rated",
"mc_leadDetails": "Lead details",
"mc_leadDetailsSub": "The customer's enquiry and what happened",
"mc_customer": "Customer",
"mc_quoted": "Customer was shown",
"mc_freeLine": "Leads are free now - nothing is taken from this.",
"mc_chargeLine": "Lead fees are taken from this balance.",
"mc_refer": "Refer a business",
"mc_referText": "When the driver you invite is approved, you both get credit for lead fees.",
"mc_txns": "Transactions",
"mc_noTxns": "No transactions yet",
"mc_tip1": "Lead fees come from this wallet",
"mc_tip2": "A low balance can stop new leads",
"mc_tip3": "Add money any time to stay active",
"cd_title": "Vehicle details",
"cd_photosNote": "Number plates are hidden automatically after review.",
"cd_photosMin": "Add at least 3 photos ({n} more needed)",
"cd_photosSent": "Sent for review. The new photos show after approval.",
"cd_addPhoto": "Add photo",
"cd_replace": "Replace",
"cd_remove": "Remove",
"cd_newTag": "New",
"cd_pendingTag": "In review",
"cd_details": "Car details",
"cd_detailsNote": "Changes to photos and details are checked by Sramika before they show.",
"cd_city": "City",
"cd_category": "Price group",
"cd_categoryNote": "Set from your model and seats. Call Sramika if it looks wrong.",
"cd_notSet": "Not set yet",
"cd_acSub": "Does this car have working AC?",
"cd_musicSub": "Does it have working music or Bluetooth?",
"cd_pricesNote": "Saved straight away. An empty box uses the suggested price shown in grey.",
"cd_rule": "You can raise prices once every 24 hours. Lowering is allowed any time.",
"cd_suggestedUsed": "Empty: suggested {v} is used",
"cd_savePrices": "Save my prices",
"cd_saving": "Saving…",
"cd_saved": "Saved",
"cd_savedMsg": "Your prices are saved.",
"cd_saveErr": "Could not save your prices. Please try again.",
"cd_noCat": "This car has no price group yet. Please call Sramika.",
"cd_submit": "Send car details for approval",
"cd_sending": "Sending…",
"cd_sent": "Sent",
"cd_sentMsg": "Sent! Sramika will check and approve your changes.",
"cd_sendErr": "Could not send. Please try again.",
"cd_minPhotosErr": "Please keep at least 3 photos.",
"cd_noChange": "No price changed",
"hl_phNote": "E.g. my car is automatic, I need a driver who speaks Hindi...",
"hl_noteHint": "The driver sees this with your enquiry.",
"hl_yearFirst": "Enter the year first",
"lp_headerSub": "Plan your trip and find the best cars",
"hl_headerSub": "Plan your trip and find the best drivers",
"lp_whenSub": "Select your travel dates and times",
"lp_prefSub": "Tell us a few more details",
"lp_optional": "(Optional)",
"lp_clear": "Clear",
"hl_carTitle": "Car you need the driver for",
"hl_carSub": "Year and model of your car",
"hl_year": "Year",
"hl_model": "Model",
"hl_fuel": "Fuel type",
"hl_phYear": "e.g. 2018",
"hl_phModel": "Search model",
"hl_phFuel": "Filled in from the model",
"hl_car": "Your car",
"hl_farPickup": "{area} is more than 30 km from {city}. Choose a place within 30 km, or change the city.",
"hl_tooFar": "{from} to {to} is {km} km, which is more than the {max} km limit for a single driver. Please choose a destination under {max} km.",
"hl_noPlace": "Could not read a place name from your location - please type your city.",
"navDashboard": "Dashboard",
"ac_language_sub": "Change app language",
"ac_support": "Support",
"ac_support_sub": "Help & FAQs",
"ac_settings": "Settings",
"ac_settings_sub": "Profile & preferences",
"ac_profileInfo": "Profile info",
"ac_profileInfo_sub": "Edit name, email, phone",
"ac_prefCity": "Preferred city",
"ac_prefCity_sub": "Change default city",
"ac_terms": "Terms",
"ac_terms_sub": "Terms & conditions",
"ac_privacy": "Privacy",
"ac_privacy_sub": "Privacy policy",
"ac_history_sub": "Your enquiries and past trips",
"ac_notifications": "Notifications",
"ac_notif_sub_user": "Ride & account updates",
"ac_notif_sub": "Account updates",
"ac_ownerDash": "Driver dashboard",
"ac_ownerDash_sub": "Leads, cars and wallet",
"ac_myCars": "My cars",
"ac_myCars_sub": "Manage your vehicle list",
"ac_addVehicle": "Add a vehicle",
"ac_addVehicle_sub": "Submit another car for approval",
"ac_driverDash": "Driver dashboard",
"ac_driverDash_sub": "Your leads, rates and status",
"ac_menuUser": "My account",
"ac_menuUser_sub": "Manage your trips & account",
"ac_menuOwner": "Driver menu",
"ac_menuOwner_sub": "Vehicles & driver operations",
"ac_menuDriver": "Hire driver menu",
"ac_menuDriver_sub": "Your leads & status",
"ac_menuAgent": "Field agent menu",
"ac_menuAgent_sub": "Your referral code & account",
"ac_menuGeneral": "General options",
"ac_menuGeneral_sub": "Account & app preferences",
"ac_account": "Account",
"ac_editProfile": "Edit profile",
"ac_changePhoto": "Change profile photo",
"ac_verified": "Verified",
"ac_back": "Go back",
"ac_pendingTitle": "Business application pending",
"ac_pendingText": "An admin is reviewing your business application. You will be told once it is approved.",
"ac_strength": "Profile strength",
"ac_strengthDone": "Complete - you're fully set up!",
"ac_strengthGood": "Good standing",
"ac_strengthLow": "Incomplete - finish your profile",
"ac_searchPh": "Search settings, dashboard…",
"ac_clearSearch": "Clear search",
"ac_noMatch": "No matches found",
"ac_tryElse": "Try searching for something else",
"ac_inSection": "in {section}",
"ac_agentCode": "Referral code",
"ac_agentCodeSub": "Give this to the driver you are signing up",
"ac_noCode": "No code yet",
"ac_copy": "Copy",
"ac_copied": "Copied",
"ac_working": "Working…",
"ac_genNew": "Generate a new code",
"ac_gen": "Generate code",
"ac_agentNote": "The driver must enter this while signing up, and it must still be valid when they do. Generating a new code stops the old one being accepted.",
"ac_agentConfirm": "Generate a new code? Your current code stops working immediately, so anyone who has it written down will not be able to use it. Accounts already signed up with it keep their credit.",
"ac_agentErr": "Could not generate a code. Please try again.",
"ac_refer": "Refer & Earn",
"ac_referCustSub": "Invite a driver or alting driver",
"ac_referCustSubR": "Invite a driver or alting driver, get ₹{amt} each",
"ac_referCustText": "Know someone who owns a cab or drives for hire? Share your code. When their account is approved, you get {reward} in your Sramika wallet.",
"ac_aCredit": "a referral credit",
"ac_share": "Share",
"ac_approved": "Approved",
"ac_waiting": "Waiting",
"ac_yourWallet": "Your wallet",
"ac_referBizSub": "Invite another driver or alting driver",
"ac_referBizSubR": "Invite another driver - you both get ₹{amt}",
"ac_referSoon": "Your referral code arrives as soon as your account is approved.",
"ac_referBizText": "Share your code. When their account is approved, you both get {credit} towards lead fees.",
"ac_creditAmt": "₹{amt} credit",
"ac_credit": "credit",
"ac_pickCar": "Pick which car the referral is recorded against.",
"ac_spaces": "Spaces and dashes are ignored - it works however it is typed.",
"ac_oneWallet": "Credit from any of your codes goes to your one wallet balance.",
"ac_car": "Car {id}",
"ac_calcTitle": "Trip odometer & fare calculator",
"ac_calcSub": "Estimate a fare from odometer readings",
"ac_startOdo": "Start reading (km)",
"ac_endOdo": "End reading (km)",
"ac_endLess": "End reading must be greater than start.",
"ac_calcBtn": "Calculate fare",
"ac_calcNone": "No fare for this trip and car in this city yet.",
"ac_pricedAs": "Priced as: {mode}",
"ac_estNote": "An estimate at the city's suggested prices - confirm the final fare with the driver. Tolls, parking and state permits are extra.",
"ac_seats": "{n} seats",
"ac_logout": "Log out",
"ac_loading": "Loading profile…",
"ac_takePhoto": "Take photo",
"ac_gallery": "Choose from gallery",
"ac_removePhoto": "Remove photo",
"ac_cancel": "Cancel",
"ms_title": "More services",
"ms_sub": "All car & travel services in one place",
"ms_towing": "Vehicle towing van",
"ms_towing_sub": "Move your vehicle safely",
"ms_school": "Driving schools",
"ms_school_sub": "Learn from certified instructors",
"ms_lease": "Monthly car lease",
"ms_lease_sub": "Cars with driver, monthly contracts",
"ms_tours": "Tours & packages",
"ms_tours_sub": "Group & individual tour quotes",
"ms_wash": "Home car wash",
"ms_wash_sub": "Doorstep washing, your price",
"ms_mechanic": "Home car mechanic",
"ms_mechanic_sub": "Trusted mechanics at your doorstep",
"ms_accessories": "Accessories fitting",
"ms_accessories_sub": "Accessories delivered & fitted at home",
"ms_soon": "Coming soon",
"ms_noneYet": "No services in your city yet - call us and tell us what you need.",
"ms_soonText": "We are bringing {service} to your city soon. Want it sooner? Call us and tell us what you need.",
"ms_callUs": "Call Sramika",
"ms_close": "Close",
"ms_footer": "More services coming soon · Contact us at {email}",
"navHireDriver": "Drivers",
"hs_title": "History",
"hs_active": "Active",
"hs_past": "Past",
"hs_loading": "Loading your history…",
"hs_emptyTitle": "No activity yet",
"hs_emptyText": "Your car enquiries and trip history will appear here.",
"hs_findCar": "Find a car",
"hs_activeEmpty": "Nothing in progress. Enquiries you make appear here until the trip date passes.",
"hs_pastEmpty": "Nothing here yet.",
"hs_filterAll": "All",
"hs_filterNone": "Nothing matches this filter.",
"hs_signInTitle": "My history",
"hs_signInText": "Sign in to see your enquiries and trips.",
"hs_signIn": "Sign in",
"hs_rateTitle": "How was your last ride?",
"hs_rateTap": "Tap a star to rate",
"hs_rateLow": "We'll work to improve your experience",
"hs_rateMid": "Thanks for the feedback!",
"hs_rateHigh": "Glad you had a great ride!",
"hs_rateSubmit": "Submit rating",
"hs_rateLater": "Later",
"hs_rateHelps": "Your rating helps improve future rides.",
"hs_rateVerified": "Your account is now Sramika Verified!",
"hs_rateDriver": "Rate driver",
"hs_editRating": "Edit rating",
"hs_chatDriver": "Chat with driver",
"hs_paid": "Paid: ₹{amt}",
"hs_stBooked": "Booked",
"hs_stNotBooked": "Not booked",
"hs_stDeciding": "Still deciding",
"hs_stContacted": "Driver contacted",
"hs_stSent": "Enquiry sent",
"hs_oneWay": "One way",
"hs_roundTrip": "Round trip",
"hs_enquiry": "Enquiry",
"hs_callName": "Call {name}",
"hs_callDriver": "Call driver",
"hs_askBooked": "Did you book this trip?",
"hs_yes": "Yes",
"hs_no": "No",
"hs_notYet": "Not yet",
"hs_saveFailedRow": "Could not save that - open the enquiry to try again.",
"hs_saidBooked": "You said you booked this",
"hs_saidNot": "You said you did not book this",
"hs_saidDeciding": "You said you were still deciding",
"hs_details": "Details",
"hs_sheetTitle": "Trip enquiry",
"hs_pickup": "Pickup",
"hs_drop": "Drop",
"hs_tripType": "Trip type",
"hs_distTime": "Distance / time",
"hs_vehicle": "Vehicle",
"hs_partner": "Partner",
"hs_enquiryMade": "Enquiry made",
"hs_timesCalled": "Times called",
"hs_quoted": "You were quoted",
"hs_quotedNote": "The price shown when you enquired. Confirm the final fare with the partner.",
"hs_whatHappened": "What happened",
"hs_tlCreated": "Enquiry created",
"hs_tlViewed": "You viewed {car}",
"hs_tlShared": "Number shared",
"hs_tlSharedNote": "The partner's number was shown to you",
"hs_tlCalled": "You called the partner",
"hs_tlCalls": "{n} calls in total",
"hs_tlAnswered": "You answered",
"hs_youBooked": "You booked this trip",
"hs_youNot": "You did not book this trip",
"hs_youDeciding": "You were still deciding",
"hs_changeAnswer": "Change answer",
"hs_noMoreChanges": "No further changes allowed",
"hs_changesLeft": "Changes left: {n}",
"hs_changeYour": "Change your answer",
"hs_askWhy": "It helps us show you better cabs - and tells the driver their listing worked.",
"hs_ansYes": "Yes, I booked it",
"hs_ansNo": "No, I didn't",
"hs_keep": "Keep my answer",
"hs_saveErr": "Could not save that. Please try again.",
"hs_callAgain": "Call {name} again",
"hs_callPartner": "Call the partner",
"hs_hrs": "{n} hrs",
"hs_close": "Close",
"hs_yourRequest": "Your request",
"hs_passengers": "Passengers: {n}",
"hs_luggage": "Luggage: {n}",
"hs_noLuggage": "No luggage",
"hs_helpEnquiry": "Need help with this enquiry? Call Sramika",
"lp_route": "Pickup & drop",
"lp_lblPickup": "Pickup location",
"lp_lblDrop": "Drop location",
"lp_cityLine": "City: {city}",
"lp_change": "Change",
"lp_sameAsDrivers": "Same trip as on Drivers?",
"lp_sameAsCars": "Same trip as on Cars?",
"lp_sameYes": "Yes, use it",
"lp_sameNo": "No, a new trip",
"lp_swap": "Swap pickup and drop",
"lp_when": "When",
"lp_pickupWhen": "Pickup",
"lp_returnWhen": "Return",
"lp_today": "Today",
"lp_tomorrow": "Tomorrow",
"lp_sameDay": "Same day",
"lp_nextDay": "Next day",
"lp_otherDate": "Other date",
"lp_pickTime": "Pick time",
"lp_distanceLine": "About {km} km · {time}",
"lp_hrMin": "{h} hr {m} min",
"lp_minOnly": "{m} min",
"lp_stillNeeded": "Still needed: {list}",
"lp_noteLabel": "Note for the driver",
"lp_noteHint": "The driver sees this with your enquiry.",
"pricesPerCarNote": "Prices are set for each car. Open your car to see or change them.",
"changeMyPrices": "Change my prices",
"lp_btnAddStop": "+ Add Stop",
"lp_btnDetectLocation": "📍 Detect Location",
"lp_btnDetecting": "Detecting…",
"lp_btnViewCabs": "View Cabs",
"lp_btnViewDrivers": "View Drivers",
"lp_btnViewDrivers": "View Drivers",
"lp_btnCompleteDetails": "Complete Trip Details",
"lp_tabRoundTrip": "Round Trip",
"lp_tabOneWay": "Dropping",
"lp_tripDetails": "Trip Details",
"lp_hireDetails": "Trip Details",
"lp_tripPreferencesOptional": "Trip Preferences (Optional)",
"lp_lblPickupCity": "Pickup City",
"lp_phTypeCity": "Type city",
"lp_lblExactLocation": "Exact Location",
"lp_phPrecisePickup": "Enter precise pickup point",
"lp_lblPickupSchedule": "Pickup Schedule",
"lp_phStop": "Stop {n}",
"lp_lblFinalDestination": "Final Destination",
"lp_phDropLocation": "Enter drop location",
"lp_lblReturnSchedule": "Return Schedule",
"lp_lblDropSchedule": "Drop off by",
"lp_hintOneWayReturnCost": "After dropping you and your vehicle, the driver travels back on their own. That return cost is not part of this fare - please agree it directly with the driver on the call.",
"lp_lblPassengers": "Passengers in your group",
"lp_subLblGroupCab": "Your group books the entire cab",
"lp_lblLuggage": "Luggage",
"lp_lblStops": "Stops",
"lp_errSameLocation": "Pickup and drop cannot be the same location",
"lp_errReturnTooEarly": "{from} to {to} takes about {hours} hours - please pick a later return time",
"lp_backHomeBy": "Back home by",
"lp_errBackTooEarly": "{from} to {to} and back takes about {hours} hours - please pick a later time",
"lp_hintCalculatingRoute": "Calculating route…",
"lp_phNote": "E.g. I need a baby seat, pet friendly cab...",
"lp_promoRoundTrip": "Round trip or multi-stop?",
"lp_promoMoreStops": "Add more stops to plan your perfect journey.",
"lp_toastLocSuccess": "Location detected ✅",
"lp_toastLocDeny": "Please allow location access in your browser to use this feature",
"lp_errMissingFields": "Missing mandatory fields: {list}",
"lp_errCity": "Please select a city.",
"lp_errPickupDt": "Please select pickup date and time.",
"lp_errPickupTimeLimit": "Pickup time must be at least 30 minutes from now.",
"lp_errReturnDt": "Please select return/end date and time.",
"lp_errReturnTimeLimit": "Return time must be after pickup time.",
"lp_errReturnMaxLimit": "Return date must be within 10 days of pickup",
"lp_errPickupLoc": "Please enter your pickup location.",
"lp_errPickupRadius": "Please select a location within {km} km of {city}.",
"lp_errDestLoc": "Please enter your destination.",
"lp_errDestRadius": "Please select a destination within 1000 km of your pickup.",
"lp_errStopValid": "Please select a stop from suggestions.",
"lp_errStopRadius": "Please select a stop within 1000 km of your pickup.",
"awaitingDriverResponse": "Awaiting Driver Response",
"driverConnected": "Driver Connected",
"driverAccepted": "Driver Accepted",
"tripConfirmed": "Trip Confirmed",
"rideStarted": "Ride Started",
"rideCompleted": "Ride Completed",
"connectionFeePaid": "Connection Fee Paid",
"waitingForPickup": "Waiting for Pickup",
"manageTrip": "Manage Trip",
"tripType": "Trip Type",
"createdOn": "Created On",
"currentStatus": "Current Status",
"connectionFee": "Connection Fee",
"estimatedFare": "Estimated Fare",
"tripId": "Trip ID",
"actualDriverName": "Actual Driver Name",
"waitingForDriverAcceptance": "Waiting for Driver Acceptance",
"vehicleName": "Vehicle Name",
"vehicleDetailsAvailableAfter": "Vehicle details will be available after driver confirmation.",
"paidUsingWallet": "Paid using Wallet",
"paidUsingCredit": "Used 1 Free Call Credit",
"finalFareConfirmedDirectly": "Final fare is agreed directly between you and the driver.",
"tripTimeline": "Trip Timeline",
"contactSupport": "Contact Sramika Support",
"needHelp": "Need help?",
"upcomingTrips": "Upcoming",
"previousTrips": "Previous",
"connectingIvrCall": "Connecting your call via Sramika IVR. Please wait for our system to call you.",
"callConnectionFailed": "Could not connect call.",
"callError": "Error initiating call.",
"pickupAddress": "Pickup Address",
"destination": "Destination",
"vehicleNumber": "Vehicle Number",
"callHistory": "Call History",
"callDriverToBook": "Call Driver",
"getDriversNumber": "Get driver's number",
"loadingCalls": "Loading calls...",
"noCallsMade": "No calls made yet.",
    "completeProfile": "Complete your profile",
    "sramikaWallet": "SRAMIKA WALLET",
    "walletBalance": "Wallet Balance",
    "viewWallet": "View Wallet",

    "walletRemaining": "Remaining",
    "walletInfoTitle": "Used only to pay for calls Sramika connects for you.",
    "walletInfo1": "Money added to this wallet cannot be withdrawn.",
    "walletInfo2": "{free} calls are free every {hours} hours. After that, each connected call costs ₹{fee}; nothing is taken if a call does not connect.",
    "walletAddMoney": "Add Money",
    "walletEnterAmount": "Enter amount",
    "walletRecharge": "Recharge Wallet",
    "walletProcessing": "Processing...",
    "walletNoTxns": "No wallet transactions yet.",
    "walletNoTxnsSub": "Money you add and call charges will show here.",
    "walletTxnRecharge": "Recharge",
    "walletTxnServiceFee": "Connection Fee",
    "walletTxnRefund": "Refund",
    "callDriverToBook": "Call Driver To Book","getDriversNumber": "Get driver's number","appName": "SRAMIKA",
    "appSubtitle": "Nearby Car Travels",
    "loginCta": "Login / Join",
    "findTaxiBy": "Find the right taxi by",
    "from": "From",
    "to": "To",
    "nearbyCars": "Nearby best rated cars",
    "accountTitle": "My Profile",
    "bookings": "History",
    "notifications": "Notifications",
    "support": "Support",
    "supportDescription": "Our Sramika Support team is here to assist you.",
    "settings": "Settings",
    "logout": "Logout",
    "loginSignup": "Login / Signup",
    "noBookings": "No bookings yet.",
    "startBooking": "Start booking trusted local cabs",
    "faqTitle": "FAQs",
    "callSupport": "Call Support",
    "language": "Language",
    "fareCalculator": "Fare Calculator",
    "terms": "Terms & Conditions",
    "privacy": "Privacy Policy",
    "manageProfile": "Manage your profile and preferences",
    "mobileNumber": "Mobile Number",
    "username": "Username",
    "preferredCity": "Preferred City",
    "referFriend": "Refer a Friend",
    "comingSoon": "Coming soon",
    "cabOwnerProfile": "Cab Driver Profile",
    "editCabOwnerProfile": "Edit Cab Driver Details",
    "accountActions": "Account Actions",
    "save": "Save Changes",
    "edit": "Edit",
    "verified": "Verified",
    "notEditable": "Not editable",
    "myRating": "My Rating",
    "notSet": "Not set",
    "upcoming": "Upcoming",
    "previous": "Previous",
    "noUpcomingTrips": "No upcoming trips.",
    "noPreviousTrips": "No previous trips.",
    "bookRide": "Book a Ride",
    "signIn": "Sign In",
    "viewBookings": "View Bookings",
    "personalDetails": "Personal Details",
    "location": "Location",
    "emergencyContact": "Emergency Contact",
    "vehicleOptions": "Vehicle Options",
    "tripTypesOffered": "Trip Types Offered",
    "pricing": "Pricing",
    "weeklyAvailability": "Weekly Availability",
    "kycLocked": "KYC Details are locked",
    "kycLockedDesc": "Name, mobile, DL and vehicle details cannot be changed here. Contact support.",
    "verifiedInfo": "Verified Information",
    "gender": "Gender",
    "languagesSpoken": "Languages Spoken",
    "bio": "Short Bio",
    "address": "Address",
    "pincode": "Pincode",
    "contactName": "Contact Name",
    "contactPhone": "Contact Phone",
    "acAvailable": "AC Available",
    "wallet": "Wallet",
    "recentSearches": "Recent Searches",
    "home": "Home",
    "navCars": "Cars",
    "nearbyHireDrivers": "Nearby Hire Drivers",
    "city": "City",
    "onb_skip": "Skip",
    "onb_getStarted": "Get Started",
    "onb_p1_sign": "Nearby cars",
    "onb_p1_title": "Find nearby drivers",
    "onb_p1_sub": "Connect directly with nearby drivers.",
    "onb_p1_badge": "0% Commission for Cab Accounts",
    "onb_p2_sign": "Nearby Hire Driver",
    "onb_p2_title": "Hire nearby drivers",
    "onb_p2_sub": "Connect directly with nearby drivers.",
    "onb_p2_badge": "0% Commission for Drivers",
    "onb_p3_sign": "We connect you with trusted people",
    "onb_p3_title": "Need help choosing?",
    "onb_p3_sub": "Our support team can connect you with the right cab driver.",
    "onb_p3_badge": "0% Commission for Support Assistance",
    "onb_p4_sign1": "Hire Cab",
    "onb_p4_sign2": "Hire Driver",
    "onb_p4_sign3": "More Services",
    "onb_p4_title": "Everything you need in one place",
    "onb_p4_sub": "Hire cabs, hire drivers and discover more travel services.",
    "onb_p4_badge": "0% Commission on More Services",
    "onb_p5_sign": "One app. Many travel services.",
    "onb_p5_title": "Let's get started",
    "onb_p5_sub": "Travel smarter with nearby services.",
    "onb_p5_badge": "Always 0% Commission",
    "onb_lang_title": "In your language, for your convenience",
    "onb_lang_sub": "Content will be shown in your local language.",
    "onb_footer": "Local support. Local language. Better experience.",
    "onb_language": "Language",
    "onb_intentTagline": "Nearby cabs & drivers",
    "onb_intentTitle": "What brings you to Sramika?",
    "onb_intentSub": "Choose an option to continue",
    "onb_intentRide": "Find cabs & drivers",
    "onb_intentRideSub": "Book local or outstation cabs, or hire a driver for your own car.",
    "onb_intentEarn": "Do you want to earn with Sramika?",
    "onb_intentCab": "Join as Cab account",
    "onb_intentCabSub": "Register your cab and get calls from customers directly.",
    "onb_intentDriver": "Join as Alting driver",
    "onb_intentDriverSub": "No car needed. Drive customers' cars, paid by the hour or day.",
    // The /join page for ads (Oct 2026).
    "join_title": "Earn with Sramika",
    "join_subShort": "Customers call you directly.",
    "join_codeLine": "Code {code} · ₹{amount} once approved",
    "join_codeOnly": "Code {code}",
    "join_car": "I have a car",
    "join_carNeed": "Licence, RC, car photos · 15 minutes",
    "join_drv": "I can drive - no car",
    "join_drvNeed": "Licence, photo, your rates · 10 minutes",
    "join_needACar": "Need a car?",
    "join_seeCarsShort": "See cars",
    "onb_skipForNow": "Skip for now",
    "noCabsFoundFor": "No cabs found for",
    "tryDifferentSearch": "Try a different search or use one of these suggestions:",
    "sramikaComingTo": "SRAMIKA is coming to",
    "onboardingDriversIn": "We're onboarding drivers in",
    "beTheFirstToKnow": ". Be the first to know when we launch.",
    "expectedLaunch": "Expected Launch",
    "yourName": "Your name",
    "whatsappNumber": "WhatsApp number (10 digits)",
    "notifyViaWhatsapp": "We'll notify you via WhatsApp when we launch",
    "joining": "Joining...",
    "onTheList": "You're on the list!",
    "goBackHome": "Go Back Home",
    "noDriversIn": "No available drivers in",
    "driverNetworkExpanding": "Our verified driver network is expanding rapidly. Be the first driver partner in this city and start receiving ride requests.",
    "registerAsDriver": "Register as Driver",
    "learnMore": "Learn More",
    "noCabsIn": "No available cabs in",
    "cabNetworkExpanding": "Our premium network is expanding rapidly. Be the first partner to launch our exclusive services in this city and start earning today.",
    "joinAsPartner": "Join as Partner",
    "exploreCities": "Explore Cities",
    "newDriver": "New Driver",
    "startsFrom": "Starts from",
    "contactDriver": "Contact Driver",
    "hireDriverTitle": "Hire Driver",
    "driverWillCome": "Driver will come to your location",
    "date": "Date",
    "time": "Time",
    "duration": "Duration",
    "yourCarType": "Your Car Type",
    "pickupAddress": "Pickup Address",
    "yourPhone": "Your Phone",
    "tripPurpose": "Trip Purpose (optional)",
    "youPayDriverDirectly": "You pay the driver directly. Sramika charges no commission.",
    "rateDriver": "Rate Driver",
    "howWasExperience": "How was your experience?",
    "shortReview": "Short Review (optional)",
    "callDriver": "Call Driver",
    "filter": "Filter",
    "loadingRequests": "Loading Requests...",
    "driverWillReview": "The driver will review your request and respond soon.",
    "dismiss": "Dismiss",
    "thankYouFeedback": "Thank you for your feedback. It helps other customers.",
    "selectCityHire": "Select a city to see hire drivers near you",
    "findingDriversIn": "Finding drivers in",
    "clearAll": "Clear all",
    "areYouDriver": "Are you a driver?",
    "registerAsHireDriver": "Register as a Hire Driver to be listed",
    "join": "Join",
    "fareCalculatorTitle": "Fare Calculator",
    "distanceLabel": "Distance",
    "durationLabel": "Duration",
    "booked": "Booked",
    "estimatedFareLabel": "Estimated Fare",
    "advanceAlreadyPaid": "Advance Already Paid",
    "payToDriverLabel": "Pay to Driver",
    "noTripDetails": "No trip details found.",
    "goHome": "Go Home",
    "earnCommissionBooking": "Earn commission on this booking",
    "customerNameReq": "Customer Name *",
    "customerPhoneReq": "Customer Phone *",
    "yourCab": "Your Cab",
    "paymentSummary": "Payment Summary",
    "cabFare": "Cab Fare",
    "totalTripCost": "Total Trip Cost",
    "payNowLabel": "Pay Now:",
    "advance10Percent": "Advance (10% of Cab Fare)",
    "balanceToDriver": "Balance to Driver",
    "selectPaymentMethod": "Select Payment Method",
    "howItWorks": "How It Works",
    "advanceFullyRefunded": "Advance fully refunded",
    "advanceNonRefundable": "Advance non-refundable",
    "additionalChargesActuals": "Additional charges at actuals",
    "profilePhoto": "Profile Photo",
    "startTrip": "Start Trip",
    "endTrip": "End Trip",
    "finalDistance": "Final Distance",
    "fareBreakdown": "Fare Breakdown",
    "totalDuration": "Total Duration",
    "withdrawalUnlock": "Withdrawal unlock",
    "quickWins": "Quick wins:",
    "yourTrustedCabPartner": "Your trusted cab partner",
    "usernameOrMobile": "Username or Mobile",
    "password": "Password",
    "expired": "Expired",
    "withdrawToUpi": "Withdraw to UPI",
    "minPtsWallet": "Min. 300 pts must stay in wallet",
    "availableToWithdraw": "Available to withdraw",
    "upiId": "UPI ID",
    "amountRupees": "Amount (₹)",
    "bookingId": "Booking ID",
    "lifetimeEarned": "Lifetime Earned",
    "withdrawable": "Withdrawable",
    "useOnRide": "Use on Ride",
    "recentActivity": "Recent Activity",
    "seeAll": "See all",
    "withdrawalLocked": "Withdrawal Locked",
    "transactionHistory": "Transaction History",
    "noTransactionsYet": "No transactions yet",
    "platformDisclaimer": "SRAMIKA is a technology platform. Transport services are provided by independent operators.",
    "topRated": "Top Rated",
    "newPartner": "New on Sramika",
    "nearby": "Nearby",
    "luxury": "Luxury",
    "familyTrip": "Family Trip",
    "fastBooking": "Fast Booking",
    "matched": "Matched",
    "estPrice": "Est Price",
    "baseRateLabel": "Base rate",
    "recentSearchesLabel": "Recent Searches",
    "anyCab": "Any Cab",
    "trip": "trip",
    "trips": "trips",
    "selectCity": "Select City",
    "detecting": "Detecting...",
    "detectLocation": "Detect Location",
    "typeCityName": "Type city name...",
    "filters": "Filters",
    "select": "Select",
    "bioHint": "Tell passengers a little about yourself",
    "searchCity": "Search city...",
    "selectCity2": "Select city",
    "findRightTaxi": "Find the right car",
    "lastBooked": "Last booked:",
    "more": "+ More",
    "hireDriver": "Hire Driver",
    "services": "Services",
    "account": "Account",
    "findRightDriver": "Find the right driver",
    "searchCabPlaceholder": "Search cab, model, area...",
    "searchDriverPlaceholder": "Search driver, area, language, experience...",
    "myHireRequests": "My Hire Requests",
    "driverCanSpeakLanguages": "Driver can speak languages",
    "referenceFare": "Reference Fare",
    "callDriver": "Call Driver",

    "driverDiscountLabel": "Discount",
    "connecting": "Connecting...",

    "mockCallConnecting": "Connecting call to driver via Mock Telephony...",
    "mockCallError": "Could not connect call.",
    "callInitiationError": "Error initiating call.",


    "callbackInitiationError": "Error requesting callback.",
    "bookNowToGetContact": "Book Now to Get Contact",
    "partnersPrice": "Driver's price",
    "priceHistory": "Price History",
    "increaseAvailableNow": "You can increase prices now",
    "nextIncreaseAt": "Next price increase available at {{time}}",
    "noPriceChangesYet": "No price changes yet",
    "loadingHistory": "Loading history...",
    "changeIncrease": "INCREASE",
    "changeDecrease": "DECREASE",
    "changeMixed": "MIXED",
    "noFieldsChanged": "No explicit fields changed.",
    "typicalFareLabel": "Typical fare ₹{value}",
    "lessThanTypicalFare": "₹{amount} less than the typical fare",
    "regularPrice": "Regular Price",
    "typicalFareTooltip": "A typical fare for this route, based on local rates. Partners set their own prices independently.",
    "partnerOfferedPrice": "Partner Price",
    "partnerPricePrefix": "Price",
    "estimatedAmount": "Estimated Amount",
    "estimatedAmountCaption": "The final amount may change based on actual travel, tolls, parking or route changes.",
    "extrasNote": "Toll, border/state taxes and parking (if any) are extra and paid directly to the driver.",
    "youSaveComparedToRegular": "Compared to regular price.",
    "payDirectlyToPartner": "Pay only after confirming your trip with the travel partner.",
    "chargesDuringTrip": "Charges During Trip",
    "whyChooseSramika": "Why customers choose Sramika",
    "verifiedTravelPartners": "Trusted travel partners",
    "transparentPricing": "Transparent pricing",
    "directCommunication": "Direct partner contact",
    "noBookingCommission": "No booking commission",
    "secureBookingExperience": "Secure booking experience",
    "youSavePrefix": "You save",
    "saveBadge": "SAVE",
    "savingsBasedOnPartnerPrice": "Partner pricing helps you save more.",
    "licenseChecked": "Driving License Checked",
    "bestOffer": "Best Offer",
    "tripPriceDetails": "Trip Price Details",
    "transparentPartnerPricing": "Transparent partner pricing",
    "noSramikaBookingCommission": "No Sramika booking commission",
    "driverAllowance": "Driver Allowance",
    "nightAllowance": "Night Allowance",
    "transparentPricingNoHidden": "Transparent pricing - no hidden charges",
    "promoDiscount": "Promo Discount",
    "sramikaDiscount": "Sramika Discount",
    "couponAppliedMsg": "Coupon applied",
    "saveAmount": "Save ",
    "removeAction": "Remove",
    "applyAction": "Apply",
    "totalFare": "Total Fare",
    "finalPriceLabel": "Final Price",
    "partnerOfferSuffix": " Offer",
    "legacyFareVary": "The final fare may vary if there is any change in the actual KM travelled or trip duration.",
    "legacyTollsExcluded": "⚠️ **Note:** Toll gates, parking charges, and any border/state tax charges are **not included** in this fare and will be charged separately.",
    "estimateFareCalc1": "You can estimate your updated fare for any change in distance or time using our ",
    "pricingCalculator": "Pricing Calculator",
    "estimateFareCalc2": " anytime.",
    "pickup": "Pickup",
    "origin": "Origin",
    "destination": "Destination",
    "oneWay": "one-way",
"onb_lang_title": "In your language, for your convenience",
    "onb_lang_sub": "Content will be shown in your local language.",
    "onb_footer": "Local support. Local language. Better experience.",
    "noCabsFoundFor": "No cabs found for",
    "tryDifferentSearch": "Try a different search or use one of these suggestions:",
    "sramikaComingTo": "SRAMIKA is coming to",
    "onboardingDriversIn": "We're onboarding drivers in",
    "beTheFirstToKnow": ". Be the first to know when we launch.",
    "expectedLaunch": "Expected Launch",
    "yourName": "Your name",
    "whatsappNumber": "WhatsApp number (10 digits)",
    "notifyViaWhatsapp": "We'll notify you via WhatsApp when we launch",
    "joining": "Joining...",
    "onTheList": "You're on the list!",
    "goBackHome": "Go Back Home",
    "noDriversIn": "No available drivers in",
    "driverNetworkExpanding": "Our verified driver network is expanding rapidly. Be the first driver partner in this city and start receiving ride requests.",
    "registerAsDriver": "Register as Driver",
    "learnMore": "Learn More",
    "noCabsIn": "No available cabs in",
    "cabNetworkExpanding": "Our premium network is expanding rapidly. Be the first partner to launch our exclusive services in this city and start earning today.",
    "joinAsPartner": "Join as Partner",
    "exploreCities": "Explore Cities",
    "newDriver": "New Driver",
    "startsFrom": "Starts from",
    "contactDriver": "Contact Driver",
    "hireDriverTitle": "Hire Driver",
    "driverWillCome": "Driver will come to your location",
    "date": "Date",
    "time": "Time",
    "duration": "Duration",
    "yourCarType": "Your Car Type",
    "pickupAddress": "Pickup Address",
    "yourPhone": "Your Phone",
    "tripPurpose": "Trip Purpose (optional)",
    "youPayDriverDirectly": "You pay the driver directly. Sramika charges no commission.",
    "rateDriver": "Rate Driver",
    "howWasExperience": "How was your experience?",
    "shortReview": "Short Review (optional)",
    "callDriver": "Call Driver",
    "filter": "Filter",
    "loadingRequests": "Loading Requests...",
    "driverWillReview": "The driver will review your request and respond soon.",
    "dismiss": "Dismiss",
    "thankYouFeedback": "Thank you for your feedback. It helps other customers.",
    "selectCityHire": "Select a city to see hire drivers near you",
    "findingDriversIn": "Finding drivers in",
    "clearAll": "Clear all",
    "areYouDriver": "Are you a driver?",
    "registerAsHireDriver": "Register as a Hire Driver to be listed",
    "join": "Join",
    "fareCalculatorTitle": "Fare Calculator",
    "distanceLabel": "Distance",
    "durationLabel": "Duration",
    "booked": "Booked",
    "estimatedFareLabel": "Estimated Fare",
    "advanceAlreadyPaid": "Advance Already Paid",
    "payToDriverLabel": "Pay to Driver",
    "noTripDetails": "No trip details found.",
    "goHome": "Go Home",
    "earnCommissionBooking": "Earn commission on this booking",
    "customerNameReq": "Customer Name *",
    "customerPhoneReq": "Customer Phone *",
    "yourCab": "Your Cab",
    "paymentSummary": "Payment Summary",
    "cabFare": "Cab Fare",
    "totalTripCost": "Total Trip Cost",
    "payNowLabel": "Pay Now:",
    "advance10Percent": "Advance (10% of Cab Fare)",
    "balanceToDriver": "Balance to Driver",
    "selectPaymentMethod": "Select Payment Method",
    "howItWorks": "How It Works",
    "advanceFullyRefunded": "Advance fully refunded",
    "advanceNonRefundable": "Advance non-refundable",
    "additionalChargesActuals": "Additional charges at actuals",
    "profilePhoto": "Profile Photo",
    "startTrip": "Start Trip",
    "endTrip": "End Trip",
    "finalDistance": "Final Distance",
    "fareBreakdown": "Fare Breakdown",
    "totalDuration": "Total Duration",
    "withdrawalUnlock": "Withdrawal unlock",
    "quickWins": "Quick wins:",
    "yourTrustedCabPartner": "Your trusted cab partner",
    "usernameOrMobile": "Username or Mobile",
    "password": "Password",
    "expired": "Expired",
    "withdrawToUpi": "Withdraw to UPI",
    "minPtsWallet": "Min. 300 pts must stay in wallet",
    "availableToWithdraw": "Available to withdraw",
    "upiId": "UPI ID",
    "amountRupees": "Amount (₹)",
    "bookingId": "Booking ID",
    "lifetimeEarned": "Lifetime Earned",
    "withdrawable": "Withdrawable",
    "useOnRide": "Use on Ride",
    "recentActivity": "Recent Activity",
    "seeAll": "See all",
    "withdrawalLocked": "Withdrawal Locked",
    "transactionHistory": "Transaction History",
    "noTransactionsYet": "No transactions yet",
    "platformDisclaimer": "SRAMIKA is a technology platform. Transport services are provided by independent operators.",
    "topRated": "Top Rated",
    "newPartner": "New on Sramika",
    "nearby": "Nearby",
    "luxury": "Luxury",
    "familyTrip": "Family Trip",
    "fastBooking": "Fast Booking",
    "matched": "Matched",
    "estPrice": "Est Price",
    "baseRateLabel": "Base rate",
    "recentSearchesLabel": "Recent Searches",
    "anyCab": "Any Cab",
    "trip": "trip",
    "trips": "trips",
    "selectCity": "Select City",
    "detecting": "Detecting...",
    "detectLocation": "Detect Location",
    "typeCityName": "Type city name...",
    "filters": "Filters",
    "select": "Select",
    "bioHint": "Tell passengers a little about yourself",
    "searchCity": "Search city...",
    "selectCity2": "Select city",
    "findRightTaxi": "Find the right car",
    "lastBooked": "Last booked:",
    "more": "+ More",
    "hireDriver": "Hire Driver",
    "services": "Services",
    "account": "Account",
    "findRightDriver": "Find the right driver",
    "searchCabPlaceholder": "Search cab, model, area...",
    "searchDriverPlaceholder": "Search driver, area, language, experience...",
    "myHireRequests": "My Hire Requests",
    "driverCanSpeakLanguages": "Driver can speak languages",
    "referenceFare": "Reference Fare",
    "callDriver": "Call Driver",

    "driverDiscountLabel": "Discount",
    "connecting": "Connecting...",

    "mockCallConnecting": "Connecting call to driver via Mock Telephony...",
    "mockCallError": "Could not connect call.",
    "callInitiationError": "Error initiating call.",


    "callbackInitiationError": "Error requesting callback.",
    "bookNowToGetContact": "Book Now to Get Contact",
    "partnersPrice": "Driver's price",
    "priceHistory": "Price History",
    "increaseAvailableNow": "You can increase prices now",
    "nextIncreaseAt": "Next price increase available at {{time}}",
    "noPriceChangesYet": "No price changes yet",
    "loadingHistory": "Loading history...",
    "changeIncrease": "INCREASE",
    "changeDecrease": "DECREASE",
    "changeMixed": "MIXED",
    "noFieldsChanged": "No explicit fields changed.",
    "typicalFareLabel": "Typical fare ₹{value}",
    "lessThanTypicalFare": "₹{amount} less than the typical fare",
    "regularPrice": "Regular Price",
    "typicalFareTooltip": "A typical fare for this route, based on local rates. Partners set their own prices independently.",
    "partnerOfferedPrice": "Partner Price",
    "partnerPricePrefix": "Price",
    "estimatedAmount": "Estimated Amount",
    "estimatedAmountCaption": "The final amount may change based on actual travel, tolls, parking or route changes.",
    "extrasNote": "Toll, border/state taxes and parking (if any) are extra and paid directly to the driver.",
    "youSaveComparedToRegular": "Compared to regular price.",
    "payDirectlyToPartner": "Pay only after confirming your trip with the travel partner.",
    "chargesDuringTrip": "Charges During Trip",
    "whyChooseSramika": "Why customers choose Sramika",
    "verifiedTravelPartners": "Trusted travel partners",
    "transparentPricing": "Transparent pricing",
    "directCommunication": "Direct partner contact",
    "noBookingCommission": "No booking commission",
    "secureBookingExperience": "Secure booking experience",
    "youSavePrefix": "You save",
    "saveBadge": "SAVE",
    "savingsBasedOnPartnerPrice": "Partner pricing helps you save more.",
    "licenseChecked": "Driving License Checked",
    "bestOffer": "Best Offer",
    "tripPriceDetails": "Trip Price Details",
    "transparentPartnerPricing": "Transparent partner pricing",
    "noSramikaBookingCommission": "No Sramika booking commission",
    "driverAllowance": "Driver Allowance",
    "nightAllowance": "Night Allowance",
    "transparentPricingNoHidden": "Transparent pricing - no hidden charges",
    "promoDiscount": "Promo Discount",
    "sramikaDiscount": "Sramika Discount",
    "couponAppliedMsg": "Coupon applied",
    "saveAmount": "Save ",
    "removeAction": "Remove",
    "applyAction": "Apply",
    "totalFare": "Total Fare",
    "finalPriceLabel": "Final Price",
    "partnerOfferSuffix": " Offer",
    "legacyFareVary": "The final fare may vary if there is any change in the actual KM travelled or trip duration.",
    "legacyTollsExcluded": "⚠️ **Note:** Toll gates, parking charges, and any border/state tax charges are **not included** in this fare and will be charged separately.",
    "estimateFareCalc1": "You can estimate your updated fare for any change in distance or time using our ",
    "pricingCalculator": "Pricing Calculator",
    "estimateFareCalc2": " anytime.",
    "pickup": "Pickup",
    "origin": "Origin",
    "destination": "Destination",
    "oneWay": "one-way",
    "inclReturn": "incl. return",
    "hrs": "hrs",
    "estDuration": "est. duration",

    // Rating Modal
    "loadingRating": "Loading…",
    "updateRating": "Update Rating",
    "submitRating": "Submit Rating",
    "tapAStar": "Tap a star",
    "ratingPoor": "Poor",
    "ratingFair": "Fair",
    "ratingGood": "Good",
    "ratingVeryGood": "Very Good",
    "ratingExcellent": "Excellent",
    "tellUsExperience": "Tell us about your experience…",
    "typicalFareBare": "Market Price",
    "totalWithCharges": "Total with trip charges"
  },
  "hi": {
"rm_of": "{n} में {yes}",
"rm_driverCame": "बुक किया हुआ ड्राइवर ही आया",
"rm_carCame": "बुक की हुई कार ही आई",
"rm_no": "नहीं",
"rm_yes": "हाँ",
"rm_sameDriver": "जो ड्राइवर बुक किया था, वही आया?",
"rm_sameCar": "जो कार बुक की थी, वही आई?",
"lg_brand": "श्रामिक",
"tx_bonus": "बोनस",
"tx_referralBack": "रेफ़रल इनाम वापस लिया गया",
"tx_referral": "रेफ़रल इनाम",
"tx_welcome": "स्वागत ऑफ़र",
"tx_failed": "भुगतान नहीं हुआ",
"lc_offer": "विशेष ऑफ़र",
"lh_ref": "नं.",
"cv_mpv": "एमपीवी",
"ac_roleOwner": "ड्राइवर",
"ac_roleAdmin": "एडमिन",
"ac_roleSuper": "सुपर एडमिन",
"ac_roleDriver": "ड्राइवर",
"ac_roleAgent": "फ़ील्ड एजेंट",
"ac_ownerCarsLeads": "मेरी कारें और लीड",
"od_title": "मेरे ड्राइवर",
"od_list": "आपकी कारों के ड्राइवर",
"od_add": "ड्राइवर जोड़ें",
"od_addTitle": "नया ड्राइवर",
"od_name": "ड्राइवर का नाम",
"od_namePh": "जैसे रमेश कुमार",
"od_licencePh": "जैसे AP09 2024 0012345",
"od_licPhoto": "लाइसेंस की फ़ोटो",
"od_photo": "ड्राइवर की फ़ोटो",
"od_choose": "फ़ोटो चुनें",
"od_checkNote": "ड्राइवर दिखने से पहले श्रामिक लाइसेंस की जाँच करता है।",
"od_errName": "ड्राइवर का नाम लिखें।",
"od_errPhone": "10 अंकों का मोबाइल नंबर लिखें।",
"od_errLicence": "लाइसेंस नंबर लिखें।",
"od_errLicPhoto": "लाइसेंस की फ़ोटो जोड़ें।",
"od_errPhoto": "ड्राइवर की फ़ोटो जोड़ें।",
"od_addFail": "ड्राइवर नहीं जोड़ सके। फिर कोशिश करें।",
"od_addBtn": "यह ड्राइवर जोड़ें",
"od_adding": "जोड़ रहे हैं…",
"od_loading": "आपके ड्राइवर ला रहे हैं…",
"od_loadFail": "आपके ड्राइवर नहीं ला सके।",
"od_pending": "मंज़ूरी बाकी",
"od_remove": "हटाएँ",
"od_removeAsk": "इस ड्राइवर को अपनी सूची से हटाएँ?",
"od_removeYes": "हाँ, हटाएँ",
"od_removeFail": "ड्राइवर नहीं हटा सके। फिर कोशिश करें।",
"od_emptyTitle": "अभी कोई ड्राइवर नहीं",
"od_emptyText": "जो ड्राइवर आपकी कारें चलाते हैं, उन्हें जोड़ें।",
"ea_title": "खाते की जानकारी बदलें",
"ea_note": "यह जानकारी रजिस्ट्रेशन पर जाँची गई थी। बदलाव श्रामिक को जाता है और मंज़ूरी के बाद ही दिखता है।",
"ea_pendingTitle": "एक बदलाव मंज़ूरी का इंतज़ार कर रहा है",
"ea_pendingText": "आपका भेजा बदलाव श्रामिक जाँच रहा है। उसके बाद आप दूसरा भेज सकते हैं।",
"ea_sentTitle": "मंज़ूरी के लिए भेजा गया",
"ea_sentText": "श्रामिक के बदलाव मंज़ूर करने तक आपकी जानकारी वैसी ही रहेगी।",
"ea_toAccount": "मेरे खाते पर जाएँ",
"ea_loadFail": "आपके खाते की जानकारी नहीं ला सके।",
"ea_sendFail": "आपका बदलाव नहीं भेज सके। फिर कोशिश करें।",
"ea_phoneLocked": "सत्यापित नंबर बदलने के लिए श्रामिक को कॉल करें।",
"ea_blood": "ब्लड ग्रुप",
"ea_select": "चुनें",
"ea_contact": "पता और आपातकालीन संपर्क",
"ea_ap": "आंध्र प्रदेश",
"ea_tg": "तेलंगाना",
"ea_emName": "आपातकालीन संपर्क का नाम",
"ea_emPhone": "आपातकालीन संपर्क नंबर",
"ea_driving": "ड्राइविंग",
"ea_aadhaar": "आधार नंबर",
"ea_licence": "ड्राइविंग लाइसेंस नंबर",
"ea_bank": "बैंक की जानकारी",
"ea_accName": "खाताधारक का नाम",
"ea_accNo": "खाता नंबर",
"ea_ifsc": "आईएफएससी कोड",
"ea_send": "मंज़ूरी के लिए भेजें",
"pe_saved": "आपकी जानकारी सेव हो गई।",
"pe_saveFail": "सेव नहीं हुआ। फिर कोशिश करें।",
"pe_loading": "आपकी जानकारी ला रहे हैं…",
"pe_loadFail": "आपकी जानकारी नहीं ला सके।",
"pe_checked": "रजिस्ट्रेशन पर जाँची गई जानकारी",
"pe_car": "कार",
"pe_lockedText": "इन्हें बदलने के लिए श्रामिक को कॉल करें - पहले इनकी फिर जाँच होगी।",
"pe_about": "आपके बारे में",
"pe_business": "बिज़नेस का नाम (अगर हो)",
"pe_businessHint": "खाली छोड़ें तो आपका अपना नाम दिखेगा।",
"pe_businessPh": "जैसे श्री साई ट्रैवल्स",
"pe_other": "अन्य",
"pe_langs": "आप कौन-सी भाषाएँ बोलते हैं",
"pe_bio": "अपने बारे में कुछ शब्द",
"pe_bioHint": "ग्राहकों को अपने बारे में थोड़ा बताएँ।",
"pe_bioApproval": "यहाँ लिखी नई बात ग्राहकों को दिखाने से पहले श्रामिक जाँचता है।",
"pe_bioSent": "सेव हो गया। श्रामिक की मंज़ूरी के बाद आपकी नई बात दिखेगी।",
"pe_bioWaiting": "सेव हो गया। आपकी नई बात रुकी है - आपका एक और बदलाव श्रामिक के पास है।",
"pe_bioPending": "मंज़ूरी के लिए: “{bio}”",
"pe_bioPh": "जैसे 8 साल से गाड़ी चला रहा हूँ, विजयवाड़ा - हैदराबाद का रास्ता अच्छे से जानता हूँ।",
"pe_pincode": "पिनकोड",
"pe_phonePh": "10 अंकों का मोबाइल नंबर",
"pe_carTrips": "आपकी कार और यात्राएँ",
"pe_personalText": "अपना पता, भाषाएँ, लिंग और आपातकालीन संपर्क {account} → {edit} में बदलें। श्रामिक पहले बदलाव की जाँच करता है।",
"pe_personalBtn": "मेरी जानकारी बदलें",
"pe_acPerCar": "एसी हर कार के लिए अलग से {myCars} में सेट करें।",
"pe_moreCars": "+{n} और",
"pe_tripKinds": "आप कौन-सी यात्राएँ करते हैं",
"pe_hourly": "घंटे के हिसाब से",
"pe_dayRent": "दिन का किराया",
"pe_prices": "किराया",
"pe_week": "आप किन दिनों और घंटों में काम करते हैं",
"pe_from": "से",
"pe_to": "तक",
"pe_save": "बदलाव सेव करें",
"ld_sentDriver": "ड्राइवर को भेजी गई",
"ld_refNoteDriver": "यह वह कीमत है जो आपको दिखाई गई। अंतिम कीमत ड्राइवर से सीधे तय होती है।",
"ld_callDriver": "ड्राइवर को कॉल करें",
"dp_theDriver": "ड्राइवर",
"cv_ownerWord": "ड्राइवर",
"hm_nCars": "{n} कारें",
"hm_oneCar": "1 कार",
"as_title": "आपका बिज़नेस खाता निलंबित है",
"as_since": "{date} से",
"as_whatDriver": "आपकी ड्राइवर प्रोफ़ाइल ग्राहकों से छिपी है, और नए हायर अनुरोध नहीं आएँगे।",
"as_whatCars": "आपकी कारें ग्राहकों से छिपी हैं, और नई लीड नहीं आएँगी।",
"as_reason": "बताया गया कारण:",
"as_else": "बाकी सब चलता रहेगा। आप ग्राहक की तरह कैब देख सकते हैं, ड्राइवर को कॉल करके यात्रा बुक कर सकते हैं, और आपके पुराने रिकॉर्ड यहीं रहेंगे।",
"as_lift": "निलंबन सिर्फ़ हमारी टीम हटा सकती है।",
"as_liftCall": "श्रामिक को कॉल करें और अपना रजिस्टर्ड मोबाइल नंबर बताएँ।",
"as_call": "श्रामिक को कॉल · {phone}",
"lc_fee": "लीड शुल्क",
"lc_free": "मुफ़्त",
"lc_noCharges": "अभी कोई लीड शुल्क नहीं",
"lc_andAbove": "{min} और ऊपर",
"lc_ladderCar": "कार और कैब खाते",
"lc_ladderHire": "हायर ड्राइवर खाते",
"lc_bandCar": "ग्राहक को बताए गए किराये के हिसाब से",
"lc_bandHire": "ग्राहक को बताए गए ड्यूटी किराये के हिसाब से",
"lc_sub": "एक ग्राहक पूछताछ की आपकी लागत।",
"lc_loading": "मौजूदा शुल्क ला रहे हैं…",
"lc_loadFail": "लीड के दाम नहीं ला सके।",
"lc_freeNow": "लीड अभी मुफ़्त हैं",
"lc_freeText": "नीचे की हर लीड आज आपके लिए मुफ़्त है। वॉलेट से कुछ नहीं कटता, और कम बैलेंस की वजह से कोई लीड नहीं रुकती।",
"lc_validTill": "ऑफ़र {date} तक मान्य।",
"lc_worth": "नीचे के दाम एक लीड की कीमत हैं - ताकि शुल्क शुरू होने के दिन कोई हैरानी न हो। उस दिन से पहले हम आपको बताएँगे।",
"lc_active": "लीड शुल्क लागू हैं",
"lc_activeText": "हर लीड के लिए नीचे दिया शुल्क आपके वॉलेट से कटता है।",
"lc_tripFare": "यात्रा किराया",
"lc_good": "जानने योग्य",
"lc_g1": "आप लीड - यानी ग्राहक की पूछताछ - के लिए देते हैं, यात्रा पर कमीशन नहीं। ग्राहक जो देता है वह आपका है।",
"lc_g2": "शुल्क उस ग्राहक को बताए किराये पर निर्भर है, इसलिए छोटी यात्रा पर बड़ी यात्रा का शुल्क कभी नहीं लगता।",
"lc_g3": "वही ग्राहक जल्द दोबारा कॉल करे तो वह नई लीड नहीं है।",
"lc_g4": "ये शुल्क बदल सकते हैं। हर लीड आने के दिन उसकी कितनी लागत थी, यह आपके लीड इतिहास में हमेशा दिखता है।",
"dd_kycTitle": "लीड पाने के लिए ये पूरे करें",
"dd_kycBasic": "बुनियादी जानकारी",
"dd_kycEmergency": "आपातकालीन संपर्क",
"dd_kycLicence": "लाइसेंस",
"dd_kycPhoto": "फ़ोटो",
"dd_kycReview": "आपकी जानकारी की जाँच हो रही है",
"dd_kycReviewSub": "श्रामिक आपकी प्रोफ़ाइल देख रहा है।",
"dd_rbNew": "नए ड्राइवर - अभी कोई रेटिंग नहीं",
"dd_rbNewSub": "यात्राएँ पूरी करें और ग्राहकों से रेटिंग माँगें - अच्छी रेटिंग से आप सूची में ऊपर आते हैं।",
"dd_rbLine": "रेटिंग {r} · {tier} · {ratings}",
"dd_tSusp": "रोका गया",
"dd_cSusp": "ग्राहकों ने एक से ज़्यादा बार बताया कि आप नहीं आए, इसलिए रोका गया।",
"dd_tPriority": "प्राथमिकता",
"dd_cPriority": "ग्राहकों की खोज में आप ऊपर दिखते हैं।",
"dd_tStandard": "सामान्य",
"dd_cStandard": "ग्राहकों की खोज में सामान्य स्थान।",
"dd_tWarning": "चेतावनी",
"dd_cWarning": "आपकी प्रोफ़ाइल पर चेतावनी दिखती है और श्रामिक जाँच करेगा।",
"dd_tCritical": "गंभीर",
"dd_cCritical": "श्रामिक की जाँच होने तक नई लीड रुकी हैं।",
"dd_liTotal": "मिली लीड",
"dd_liMonth": "इस महीने",
"dd_liFees": "लीड शुल्क",
"dd_liConv": "{pct}% यात्राएँ बनीं · आपके चिह्नित {decided} में से {won}",
"dd_psTitle": "प्रोफ़ाइल की मज़बूती",
"dd_psFull": "✅ पूरी प्रोफ़ाइल - खोज में ऊपर दिखते हैं",
"dd_psGood": "अच्छी प्रोफ़ाइल",
"dd_psLow": "⚠️ प्रोफ़ाइल अधूरी - ग्राहकों को कम दिखते हैं",
"dd_psRank": "हायर ड्राइवर सूची में ऊपर आने के लिए",
"dd_psTip1": "उपलब्ध रहें। उपलब्ध ड्राइवर सबसे पहले दिखते हैं।",
"dd_psTip2": "100/100 तक पहुँचें। पूरी प्रोफ़ाइल बाकी से पहले दिखती हैं।",
"dd_psTip3": "4★ या अधिक पाएँ। खुश ग्राहकों से रेटिंग माँगें।",
"dd_psMissing": "स्कोर बढ़ाने के लिए ये जोड़ें:",
"dd_fPhoto": "प्रोफ़ाइल फ़ोटो",
"dd_fLicence": "ड्राइविंग लाइसेंस",
"dd_fBio": "आपके बारे में",
"dd_fGender": "लिंग",
"dd_fAge": "उम्र",
"dd_fCity": "शहर",
"dd_fAddress": "पूरा पता",
"dd_fAutomatic": "ऑटोमैटिक कार चलाना",
"dd_fTypes": "आप कौन-सी गाड़ियाँ चलाते हैं",
"dd_fOwnRates": "आपकी अपनी दरें",
"dd_fWeekly": "साप्ताहिक उपलब्धता",
"dd_fRating": "ग्राहक रेटिंग 4+",
"dd_avTitle": "आपकी उपलब्धता",
"dd_avOffline": "ऑफ़लाइन",
"dd_avHintAvail": "ग्राहक आपको ढूँढकर कॉल कर सकते हैं।",
"dd_avHintBusy": "आप सूची में रहते हैं, व्यस्त दिखाए जाते हैं।",
"dd_avHintOff": "नई लीड से आप छिपे रहते हैं।",
"dd_avHintSusp": "खाता निलंबित रहने तक ग्राहकों को नहीं दिखते - निलंबन हटने पर यह फिर लागू होगा।",
"dd_availFail": "उपलब्धता नहीं बदल सकी। फिर कोशिश करें।",
"dd_leadFail": "इस लीड का जवाब सेव नहीं हुआ। फिर कोशिश करें।",
"dd_rates": "आपकी दरें",
"dd_gBoth": "लोकल और आउटस्टेशन",
"dd_nightHalt": "रात रुकना",
"dd_usual": "सामान्य ₹{n}",
"dd_max": "अधिकतम ₹{n}",
"dd_cityStd": "शहर की सामान्य दर",
"dd_followsCity": "शहर की दर, उसी के साथ बदलेगी",
"dd_above": "सामान्य से ज़्यादा",
"dd_below": "सामान्य से कम",
"dd_nightRides": "रात की यात्राएँ ({from}-{to})",
"dd_yesPct": "हाँ, +{pct}%",
"dd_no": "नहीं",
"dd_raiseOnce": "दरें कभी भी घटा सकते हैं। बढ़ाना दिन में एक बार - अगली बार {when} के बाद।",
"dd_ratesSaved": "दरें सेव हो गईं।",
"dd_ratesSavedMax": "दरें सेव हो गईं। कुछ को आपके शहर की अधिकतम दर तक घटाया गया।",
"dd_ratesFail": "आपकी दरें सेव नहीं हुईं। फिर कोशिश करें।",
"dd_pending": "एक बदलाव मंज़ूरी का इंतज़ार कर रहा है। जाँच होने तक आपकी मौजूदा जानकारी ही दिखेगी।",
"dd_pickImage": "कृपया फ़ोटो चुनें।",
"dd_tooBig": "यह फ़ोटो बहुत बड़ी है। 6एमबी से छोटी चुनें।",
"dd_sentApproval": "मंज़ूरी के लिए भेजा गया।",
"dd_photoFail": "आपकी फ़ोटो नहीं भेज सके। फिर कोशिश करें।",
"dd_changePhoto": "फ़ोटो बदलें",
"dd_licExpired": "ड्राइविंग लाइसेंस की अवधि खत्म",
"dd_licToday": "लाइसेंस आज खत्म हो रहा है",
"dd_licOneDay": "लाइसेंस 1 दिन में खत्म होगा",
"dd_licDays": "लाइसेंस {n} दिन में खत्म होगा",
"dd_licUpdate": "लीड मिलती रहें, इसके लिए लाइसेंस अपडेट करें।",
"dd_lowFree": "वॉलेट ₹200 से कम (₹{bal})",
"dd_lowFreeText": "लीड अभी मुफ़्त हैं - कुछ नहीं कटता। लीड शुल्क शुरू होने से पहले पैसे जोड़ें।",
"dd_lowPaid": "वॉलेट बैलेंस कम है (₹{bal})",
"dd_lowPaidText": "लीड मिलती रहें, इसके लिए पैसे जोड़ें।",
"dd_leadHistory": "लीड इतिहास",
"dd_leadHistorySub": "श्रामिक के ज़रिए आपको कॉल करने वाले ग्राहक",
"dd_noLeads": "अभी कोई लीड नहीं। जब कोई ग्राहक श्रामिक से कॉल करेगा, वह यहाँ दिखेगा।",
"dd_pendingVer": "सत्यापन बाकी है",
"dd_details": "जानकारी",
"dd_exp": "अनुभव",
"dd_trips": "यात्रा के प्रकार",
"dd_tripsPick": "कम से कम एक तरह की यात्रा चुनें।",
"dd_tripsFail": "सेव नहीं हुआ। फिर से कोशिश करें।",
"dd_langs": "भाषाएँ",
"dd_docs": "आपके दस्तावेज़",
"dd_mobileLocked": "सत्यापित · बदला नहीं जा सकता",
"dd_licFront": "लाइसेंस - आगे का हिस्सा",
"dd_licBack": "लाइसेंस - पीछे का हिस्सा",
"dd_notUploaded": "अपलोड नहीं",
"dd_docsNote": "लाइसेंस या मोबाइल नंबर बदलने के लिए श्रामिक को कॉल करें - बदलने से पहले इनकी फिर जाँच होती है।",
"dd_editProfile": "प्रोफ़ाइल और दस्तावेज़ बदलें",
"dd_referrals": "रेफ़रल",
"dd_earned": "कमाई",
"dp_pDriving": "ड्राइविंग कौशल",
"dp_slabLocal": "लोकल - {n} घंटे तक",
"dp_slabOut": "आउटस्टेशन - {n} घंटे तक",
"dp_nightRide": "रात की यात्रा +{pct}%",
"dp_nightHalt": "रात रुकना × {n}",
"dp_notFound": "ड्राइवर नहीं मिला",
"dp_notFoundText": "यह ड्राइवर अब सूची में नहीं है।",
"dp_backDrivers": "ड्राइवरों पर वापस जाएं",
"dp_available": "अभी उपलब्ध",
"dp_busy": "अभी व्यस्त",
"dp_offline": "अभी उपलब्ध नहीं",
"dp_canDrive": "चला सकते हैं",
"dp_moreTypes": "+{n} और",
"dp_new": "नया ड्राइवर",
"dp_tooLong": "यह यात्रा एक ड्राइवर के लिए बहुत लंबी है।",
"dp_price": "ड्राइवर का किराया",
"dp_driverOnly": "सिर्फ़ ड्राइवर का शुल्क",
"dp_noPrice": "इस यात्रा का किराया अभी नहीं - कॉल करके पूछें।",
"dp_callFail": "कॉल नहीं जुड़ी। फिर कोशिश करें।",
"dp_trustDirect": "ड्राइवर से सीधे बात करें",
"wl_title": "श्रामिक वॉलेट",
"wl_balance": "बैलेंस",
"wl_recent": "हाल के लेनदेन",
"wl_needAmt": "बैलेंस कम है। आगे बढ़ने के लिए ₹{amt} रिचार्ज करें।",
"wl_badAmt": "सही राशि डालें।",
"wl_done": "रिचार्ज हो गया।",
"wl_payFail": "भुगतान नहीं हुआ: {reason}",
"wl_payStartFail": "भुगतान शुरू नहीं हो सका।",
"wl_txnOther": "वॉलेट एंट्री",
"wl_balAfter": "बैलेंस {amt}",
"wg_lowTitle": "आपकी फ्री कॉल पूरी हो गईं",
"wg_lowText": "अब हर जुड़ी हुई कॉल ₹{fee} की है। पैसे वॉलेट से तभी कटेंगे जब कॉल जुड़ेगी।",
"wg_balance": "वॉलेट बैलेंस: ₹{bal}",
"wg_resets": "फ्री कॉल फिर से {time} पर मिलेंगी",
"wg_pick": "राशि चुनें",
"wg_add": "₹{amt} जोड़ें",
"wg_paidTitle": "इस कॉल के ₹{fee} लगेंगे",
"wg_paidText": "पैसे वॉलेट से तभी कटेंगे जब कॉल जुड़ेगी। कॉल न जुड़े तो कुछ नहीं कटेगा।",
"wg_paidCall": "कॉल करें · ₹{fee}",
"wg_okTitle": "वॉलेट में ₹{amt} जुड़ गए",
"wg_okText": "नया बैलेंस: ₹{bal}",
"wg_callNow": "अभी कॉल करें",
"wg_done": "ठीक है",
"wg_failTitle": "भुगतान नहीं हुआ",
"wg_failText": "वॉलेट में कोई पैसा नहीं जुड़ा। अगर बैंक से पैसे कटे हैं, तो 5–7 कामकाजी दिनों में अपने-आप वापस आ जाएंगे।",
"wg_tryAgain": "फिर से कोशिश करें",
"wg_pendingTitle": "भुगतान की पुष्टि हो रही है",
"wg_pendingText": "इसमें एक मिनट लग सकता है। बैलेंस अपने-आप अपडेट हो जाएगा - कृपया दोबारा भुगतान न करें।",
"wg_soonTitle": "पैसे जोड़ना जल्द शुरू होगा",
"wg_soonText": "भुगतान अभी चालू नहीं हुआ है। आपकी फ्री कॉल चलती रहेंगी।",
"wg_startFail": "भुगतान पेज नहीं खुल सका। इंटरनेट जाँच कर फिर से कोशिश करें।",
"wg_extraTitle": "अतिरिक्त कॉल - ₹{fee}",
"wg_extraText": "सही बुकिंग के लिए हर {h} घंटे में {n} मुफ़्त कॉल।",
"wg_extraTalk": "इस कॉल से ड्राइवर से सीधे बात करें।",
"wg_balanceAfter": "बैलेंस ₹{bal} → ₹{after}",
"wg_payWallet": "वॉलेट से ₹{fee} · कॉल करें",
"wg_payUpi": "₹{amt} देकर कॉल करें",
"wg_freeAfter": "{time} के बाद मुफ़्त",
"wg_lastTitle": "यह आपकी आखिरी मुफ़्त कॉल है ({n}/{n})",
"wg_lastText": "{time} के बाद फिर {n} मुफ़्त कॉल।",
"wg_call": "कॉल करें",
"wg_ownTitle": "यह आपकी अपनी कार है",
"wg_ownProfile": "यह आपकी अपनी प्रोफ़ाइल है",
"wg_ownText": "आप अपने ही अकाउंट के लिए लीड नहीं बना सकते।",
"ib_title": "तुरंत बुकिंग",
"ib_text": "8 घंटे में शुरू होने वाली ट्रिप के लिए श्रामिक उपलब्धता के अनुसार कार सुझाता है।",
"ib_seats": "कितने लोग?",
"ib_seat5": "1–4 लोग",
"ib_seat7": "5–6 लोग",
"ib_seat12": "7–12 लोग",
"ib_model": "कार मॉडल (वैकल्पिक)",
"ib_modelHint": "जैसे: इनोवा",
"ib_fare": "इस ट्रिप का किराया: ₹{min} – ₹{max}",
"ib_pickSeats": "सीटें चुनें",
"ib_book": "अभी बुक करें",
"ib_finding": "आपकी कार कन्फर्म कर रहे हैं…",
"ib_confirmed": "बुकिंग कन्फर्म",
"ib_callYou": "ड्राइवर 10 मिनट में आपको कॉल करेंगे।",
"ib_team": "हमारी टीम 10 मिनट में आपको कॉल करेगी।",
"ib_error": "बुकिंग नहीं हो सकी। फिर से कोशिश करें।",
"ob_title": "⚡ तुरंत चाहिए?",
"ob_sub": "श्रामिक की सुझाई कार 2–10 मिनट में · ₹{min} – ₹{max}",
"ib_textAny": "श्रामिक उपलब्धता के अनुसार कार सुझाता है।",
"ib_urgentTitle": "⚡ यह तुरंत की ट्रिप है",
"ib_urgentText": "8 घंटे के अंदर की ट्रिप के लिए श्रामिक की सुझाई कार - आमतौर पर 2–10 मिनट में कन्फ़र्म। एक-एक को कॉल करने की ज़रूरत नहीं।",
"ib_urgentBtn": "⚡ 2–10 मिनट में कार बुक करें",
"ib_any": "कोई भी",
"ib_cars": "{n} कारें",
"ib_wait": "आमतौर पर 2–10 मिनट। 10 मिनट में कार कन्फ़र्म न हो तो हमारी टीम आपको कॉल करेगी।",
"ib_callDriver": "📞 ड्राइवर को कॉल करें",
"ib_private": "श्रामिक नंबर से - ड्राइवर को आपका नंबर नहीं दिखेगा",
"ib_calling": "📞 आपका फ़ोन अभी बजेगा - उठाते ही ड्राइवर से जोड़ देंगे।",
"tr_wants": "ग्राहक ने माँगा: {what}",
"wl_txnCall": "कॉल शुल्क",
"wl_minMax": "₹{min} से ₹{max} के बीच राशि जोड़ें।",
"sp_title": "मदद",
"sp_callTitle": "श्रामिक से बात करें",
"sp_callText": "कॉल, किराये, कार या ड्राइवर से जुड़ी किसी भी समस्या के लिए।",
"sp_callBtn": "श्रामिक को कॉल करें",
"sp_faqTitle": "अक्सर पूछे जाने वाले सवाल",
"sp_q1": "गाड़ी कैसे खोजें?",
"sp_a1": "पिकअप और ड्रॉप चुनें। गाड़ियों और उनके किराये की तुलना करें, फिर कॉल दबाकर ड्राइवर से सीधे बात करें।",
"sp_q2": "क्या कोई बुकिंग फीस है?",
"sp_a2": "नहीं। ऐप में कुछ भी बुक नहीं होता - यात्रा ड्राइवर से तय करें और उन्हें सीधे भुगतान करें।",
"sp_q3": "यात्रा कैसे रद्द करें?",
"sp_a3": "ड्राइवर को कॉल करके बता दें। यात्रा आपके और उनके बीच तय होती है, इसलिए यहाँ रद्द करने के लिए कोई बुकिंग नहीं है। आपकी पूछताछ हर हाल में इतिहास में रहेगी।",
"sp_q4": "भुगतान कैसे करें?",
"sp_a4": "ड्राइवर को सीधे भुगतान करें - नकद या यूपीआई, जैसा आप उनसे तय करें।",
"sp_q5": "किराये में क्या शामिल नहीं है?",
"sp_a5": "टोल, पार्किंग और स्टेट टैक्स - ड्राइवर को सीधे दें। ज़्यादा कि.मी. या घंटों का अलग किराया लगता है।",
"sp_q6": "समस्या कैसे बताएं?",
"sp_a6": "ऊपर के बटन से श्रामिक को कॉल करें। कौन सी यात्रा है, यह बताने के लिए इतिहास में वह पूछताछ खोलकर रखें।",
"sp_footer": "श्रामिक मदद · support@sramika.com",
"nc_soon": "जल्द आ रहा है",
"nc_title": "श्रामिक जल्द ही {city} में आ रहा है",
"nc_titleNoCity": "श्रामिक जल्द ही आपके शहर में आ रहा है",
"nc_text": "हम {city} में गाड़ियां और ड्राइवर जोड़ रहे हैं। अपना नंबर दें - तैयार होते ही व्हाट्सऐप पर बताएंगे।",
"nc_textNoCity": "हम आपके शहर में गाड़ियां और ड्राइवर जोड़ रहे हैं। अपना नंबर दें - तैयार होते ही व्हाट्सऐप पर बताएंगे।",
"nc_expected": "शुरू होने का अनुमान",
"nc_name": "आपका नाम",
"nc_phone": "व्हाट्सऐप नंबर (10 अंक)",
"nc_join": "शुरू होने पर बताएं",
"nc_enterName": "अपना नाम डालें।",
"nc_fail": "सेव नहीं हुआ। फिर कोशिश करें।",
"nc_doneTitle": "आपका नाम लिख लिया गया",
"nc_doneText": "{city} में श्रामिक शुरू होते ही व्हाट्सऐप पर बताएंगे।",
"nc_doneTextNoCity": "आपके शहर में श्रामिक शुरू होते ही व्हाट्सऐप पर बताएंगे।",
"nt_title": "सूचनाएं",
"nt_emptyTitle": "अभी कोई सूचना नहीं",
"nt_emptyText": "आपकी पूछताछ और खाते से जुड़ी खबरें यहाँ दिखेंगी।",
"nt_history": "मेरी पूछताछ देखें",
"nt_all": "सभी",
"nt_ride": "यात्राएं",
"nt_approval": "मंज़ूरी",
"nt_document": "दस्तावेज़",
"nt_wallet": "वॉलेट",
"nt_system": "अपडेट",
"nt_unread": "नई",
"nt_read": "देखी गई",
"nt_important": "ज़रूरी",
"nt_noneHere": "{name} में कुछ नहीं।",
"nt_showAll": "सभी दिखाएं",
"nt_notification": "सूचना",
"st_confirm": "पुष्टि करें",
"st_notSignedIn": "आप लॉग इन नहीं हैं",
"st_signInToManage": "प्रोफ़ाइल और सेटिंग्स बदलने के लिए लॉग इन करें",
"st_loginSignup": "लॉग इन / साइन अप",
"st_partnerLogin": "ड्राइवर लॉगिन",
"st_notEditable": "बदल नहीं सकते",
"st_usernamePh": "आपका यूज़रनेम",
"st_save": "सेव करें",
"st_notSet": "नहीं दिया",
"st_edit": "बदलें",
"st_cityPh": "जैसे: विजयवाड़ा",
"st_myRating": "मेरी रेटिंग",
"st_footer": "श्रामिक 1.0 · सारा डेटा एन्क्रिप्शन से सुरक्षित",
"st_nameSaved": "यूज़रनेम बदल गया।",
"st_nameFail": "यूज़रनेम सेव नहीं हुआ।",
"st_nfTitle": "यह पेज मौजूद नहीं है",
"st_nfText": "लिंक पुराना हो सकता है, या पते में गलती हो सकती है। सब कुछ यहीं है - होम पेज से शुरू करें।",
"st_nfCar": "गाड़ी खोजें",
"st_nfDriver": "ड्राइवर हायर करें",
"st_suInvalid": "यह पेज मोबाइल नंबर की पुष्टि के बाद खुलता है।",
"st_suToLogin": "लॉगिन पर जाएं",
"st_suNameTitle": "अपना यूज़रनेम बनाएं",
"st_suNameHint": "स्पेस डाल सकते हैं। बाद में बदला नहीं जा सकता।",
"st_suNameMissing": "आगे बढ़ने के लिए यूज़रनेम डालें।",
"st_suContinue": "आगे बढ़ें",
"st_suPwTitle": "अपना पासवर्ड बनाएं",
"st_suPwMissing": "आगे बढ़ने के लिए पासवर्ड डालें।",
"st_suPwFail": "पासवर्ड नहीं बना सके।",
"st_suNewPwPh": "नया पासवर्ड डालें",
"pl_brand": "श्रामिक बिज़नेस",
"pl_portal": "ड्राइवरों के लिए",
"pl_stepPhone": "मोबाइल डालें",
"pl_awaiting": "आपका खाता अभी चालू नहीं हुआ है। श्रामिक से संपर्क करें।",
"pl_continueFail": "आगे नहीं बढ़ सके। फिर कोशिश करें।",
"pl_badPw": "पासवर्ड गलत है। फिर कोशिश करें।",
"pl_hide": "छिपाएं",
"pl_show": "दिखाएं",
"pl_checking": "जाँच रहे हैं…",
"pl_continue": "आगे बढ़ें →",
"pl_welcomeBack": "फिर से स्वागत है! +91 {phone} से लॉग इन कर रहे हैं",
"pl_otpInstead": "इसके बजाय ओटीपी से लॉग इन",
"pl_otpLabel": "ओटीपी (एक बार का पासवर्ड)",
"pl_customerLogin": "← ग्राहक लॉगिन",
"pl_secs": "{n} से.",
"lg_tenDigit": "10 अंकों का नंबर",
"lg_moreDigits": "{n} अंक और चाहिए",
"lg_oneMoreDigit": "1 अंक और चाहिए",
"lg_startDigit": "6, 7, 8 या 9 से शुरू होना चाहिए",
"lg_enterMobile": "अपना मोबाइल नंबर डालें।",
"lg_otpSendFail": "ओटीपी नहीं भेज सके। फिर कोशिश करें।",
"lg_enterOtp": "ओटीपी डालें।",
"lg_otpInvalid": "ओटीपी गलत है। फिर कोशिश करें।",
"lg_otpResendFail": "ओटीपी दोबारा नहीं भेज सके।",
"lg_pwMin": "पासवर्ड कम से कम 8 अक्षर का होना चाहिए।",
"lg_pwMax": "पासवर्ड 64 अक्षरों से ज़्यादा नहीं होना चाहिए।",
"lg_pwRange": "पासवर्ड 8 से 64 अक्षरों का होना चाहिए।",
"lg_resetFail": "पासवर्ड नहीं बदल सके। फिर कोशिश करें।",
"lg_resetTitle": "पासवर्ड रीसेट करें",
"lg_verifyOtp": "ओटीपी जाँचें",
"lg_setNewPw": "नया पासवर्ड बनाएं",
"lg_forgotIntro": "अपना रजिस्टर्ड मोबाइल नंबर डालें। हम एक कोड भेजेंगे।",
"lg_mobile": "मोबाइल नंबर",
"lg_waNotice": "इस नंबर पर हम आपका ओटीपी और आपकी पूछताछ के अपडेट व्हाट्सऐप और एसएमएस पर भेजेंगे। अपडेट बंद करने के लिए व्हाट्सऐप पर “बंद” लिखकर भेजें।",
"lg_sending": "भेज रहे हैं…",
"lg_sendOtp": "ओटीपी भेजें",
"lg_otpSentTo": "+91 {phone} पर ओटीपी भेजा गया। नीचे 6 अंकों का कोड डालें।",
"lg_otp6": "6 अंकों का ओटीपी",
"lg_resendIn": "{n} सेकंड में फिर भेजें",
"lg_resend": "फिर भेजें",
"lg_verifying": "जाँच रहे हैं…",
"lg_otpDone": "ओटीपी सही है। अपना नया पासवर्ड बनाएं।",
"lg_newPw": "नया पासवर्ड",
"lg_pwHint": "8-64 अक्षर",
"lg_saving": "सेव कर रहे हैं…",
"lg_tagline": "आपकी भरोसेमंद कैब सेवा",
"lg_logIn": "लॉग इन",
"lg_signUp": "साइन अप",
"lg_password": "पासवर्ड",
"lg_otpLogin": "ओटीपी लॉगिन",
"lg_userOrMobile": "यूज़रनेम या मोबाइल",
"lg_userOrMobilePh": "यूज़रनेम या मोबाइल नंबर",
"lg_enterPw": "पासवर्ड डालें",
"lg_forgot": "पासवर्ड भूल गए?",
"lg_signingIn": "लॉग इन हो रहा है…",
"lg_signIn": "लॉग इन करें",
"lg_codeSentTo": "+91 {phone} पर आया 6 अंकों का कोड डालें",
"lg_verifySignIn": "जाँचें और लॉग इन करें",
"lg_userName": "यूज़रनेम",
"lg_nameTaken": "यह यूज़रनेम पहले से है।",
"lg_tryName": "यह आज़माएं: {name}",
"lg_numTaken": "यह मोबाइल नंबर पहले से रजिस्टर्ड है।",
"lg_signInInstead": "लॉग इन करें →",
"lg_email": "ईमेल",
"lg_fullName": "पूरा नाम",
"lg_enterOtp6": "6 अंकों का ओटीपी डालें",
"lg_setPw": "पासवर्ड बनाएं",
"lg_confirmPw": "पासवर्ड दोबारा",
"lg_reenterPw": "पासवर्ड फिर से डालें",
"lg_accept": "मैं {terms} और {privacy} स्वीकार करता/करती हूँ, और प्लेटफ़ॉर्म के संचालन के लिए अपनी निजी जानकारी के संग्रह के लिए स्पष्ट सहमति देता/देती हूँ।",
"lg_terms": "नियम और शर्तें",
"lg_privacy": "गोपनीयता नीति",
"lg_creating": "खाता बन रहा है…",
"lg_create": "खाता बनाएं",
"lg_earn": "श्रामिक के साथ कमाना चाहते हैं?",
"lg_joinAs": "ड्राइवर या आल्टिंग ड्राइवर के रूप में जुड़ें",
"lg_cabOwner": "ड्राइवर",
"lg_hireDriver": "हायर ड्राइवर",
"lg_enterUsername": "यूज़रनेम डालें।",
"lg_otherUsername": "कोई दूसरा यूज़रनेम चुनें।",
"lg_validMobile": "सही 10 अंकों का मोबाइल नंबर डालें।",
"lg_hasAccount": "इस नंबर का खाता पहले से है।",
"lg_otpSentShort": "+91 {phone} पर ओटीपी भेजा गया",
"lg_noAccount": "कोई खाता नहीं मिला - आइए खाता बनाएं।",
"lg_autoOtpFail": "ओटीपी नहीं भेज सके। फिर भेजें दबाएं।",
"lg_noPwYet": "आपके खाते में अभी पासवर्ड नहीं है - अभी बनाएं।",
"lg_enterOtpSent": "मोबाइल पर आया ओटीपी डालें।",
"lg_enterUserOrMobile": "यूज़रनेम या मोबाइल नंबर डालें।",
"lg_enterPwMsg": "पासवर्ड डालें।",
"lg_setPwFor": "अपने मोबाइल नंबर के लिए पासवर्ड बनाएं।",
"lg_badLogin": "यूज़रनेम/मोबाइल या पासवर्ड गलत है। जाँच लें।",
"lg_otpExpired": "ओटीपी की समय सीमा खत्म। फिर भेजें।",
"lg_pwMismatch": "पासवर्ड मेल नहीं खाते।",
"lg_enterEmail": "ईमेल डालें।",
"lg_enterFullName": "अपना पूरा नाम डालें।",
"lg_acceptFirst": "नियम और गोपनीयता नीति स्वीकार करें।",
"lg_createFail": "खाता नहीं बना सके।",
"cv_lExtraOneHr": "अतिरिक्त 1 घंटा",
"cv_24h": "24 घंटे",
"cv_back": "वापस",
"cv_share": "शेयर करें",
"cv_linkCopied": "लिंक कॉपी हो गया",
"cv_prevPhoto": "पिछली फोटो",
"cv_nextPhoto": "अगली फोटो",
"cv_close": "बंद करें",
"cv_nRatings": "{n} रेटिंग",
"cv_oneRating": "1 रेटिंग",
"cv_model": "{year} मॉडल",
"cv_manual": "मैनुअल",
"cv_auto": "ऑटोमैटिक",
"cv_male": "पुरुष",
"cv_female": "महिला",
"cv_licence": "लाइसेंस जाँचा गया",
"cv_yourTrip": "आपकी यात्रा",
"cv_change": "बदलें",
"cv_local": "लोकल",
"cv_partnerPrice": "ड्राइवर का किराया",
"cv_usualFare": "सामान्य किराया",
"cv_extrasShort": "टोल, पार्किंग अलग से",
"cv_priceDetails": "किराये का विवरण",
"cv_eta": "{name} {place} से {n} मिनट दूर हैं",
"cv_seePriceTitle": "अपनी यात्रा का किराया देखें",
"cv_seePriceText": "पिकअप और ड्रॉप चुनें - किराया यहाँ दिखेगा।",
"cv_setTrip": "पिकअप और ड्रॉप चुनें",
"cv_allDay": "हर दिन उपलब्ध · 24 घंटे",
"cv_everyDay": "हर दिन उपलब्ध · {hours}",
"cv_openToday": "आज उपलब्ध · {hours}",
"cv_closedToday": "आज उपलब्ध नहीं",
"cv_daysOpen": "हफ्ते में {n} दिन",
"cv_week": "हफ्ता",
"cv_dayOff": "छुट्टी",
"cv_dayBusy": "व्यस्त",
"cv_dayOpen": "उपलब्ध",
"cv_notConfirmed": "सामान्य समय - ड्राइवर ने अभी पुष्टि नहीं की",
"cv_rateTitle": "{name} के साथ आपकी यात्रा कैसी रही?",
"cv_rateNoName": "आपकी यात्रा कैसी रही?",
"cv_rateParts": "हर बात - चाहें तो बदलें, या ऐसे ही भेजें",
"cv_noRatings": "अभी कोई रेटिंग नहीं",
"cv_rateAfter": "इस कार से यात्रा की? यात्रा के बाद रेटिंग दें।",
"cv_partsFrom": "{m} में से {n} रेटिंग में हिस्से",
"rl_title": "{name} जी के साथ यात्रा को रेटिंग दें",
"rl_done": "धन्यवाद! आपकी रेटिंग सेव हो गई।",
"rl_gone": "यह लिंक पुराना हो गया। आपके स्टार के लिए धन्यवाद!",
"cv_trustDirect": "ड्राइवर से सीधे बात करें",
"cv_trustNoFee": "कोई बुकिंग फीस नहीं",
"cv_trustHelp": "ज़रूरत हो तो श्रामिक मदद",
"cv_help": "मदद चाहिए? श्रामिक को कॉल करें",
"cv_onTripBack": "यात्रा पर हैं · {when} तक लौटेंगे",
"cv_onTrip": "अभी यात्रा पर हैं",
"cv_notFree": "अभी खाली नहीं हैं",
"cv_notifyMe": "खाली होने पर बताएं",
"cv_notified": "हम आपको बताएंगे",
"cv_similar": "ऐसी ही गाड़ियाँ",
"cv_setByPartner": "किराया ड्राइवर ने तय किया · श्रामिक का कोई कमीशन नहीं",
"cv_kmBoth": "आना-जाना {km} कि.मी.",
"cv_nDays": "{n} दिन",
"cv_oneDay": "1 दिन",
"cv_nHrs": "{n} घंटे",
"cv_oneHr": "1 घंटा",
"cv_nNights": "{n} रातें",
"cv_oneNight": "1 रात",
"cv_nHalfDays": "{n} आधे दिन",
"cv_oneHalfDay": "1 आधा दिन",
"cv_lBase": "मूल किराया",
"cv_lDrop": "ड्रॉप किराया",
"cv_lDriver": "ड्राइवर भत्ता ({x})",
"cv_lNight": "रात्रि भत्ता ({x})",
"cv_lDropUpTo": "ड्रॉप ({km} कि.मी. तक)",
"cv_lDropFirst": "ड्रॉप (पहले {km} कि.मी.)",
"cv_lExtraKmRate": "अतिरिक्त {km} कि.मी. × ₹{rate}",
"cv_lPackage": "{n} घंटे का पैकेज",
"cv_lExtraHr": "अतिरिक्त {n} घंटे",
"cv_lExtraKm": "अतिरिक्त {n} कि.मी.",
"cv_lDayRent": "दिन का किराया ({x})",
"cv_lFuel": "ईंधन शुल्क",
"cv_youPay": "आप ड्राइवर को देंगे",
"cv_notIncl": "इसमें शामिल नहीं",
"cv_notIncl1": "टोल, पार्किंग और स्टेट टैक्स - ड्राइवर को सीधे दें",
"cv_notIncl2": "ज़्यादा कि.मी. या घंटों का अलग किराया",
"cv_calcLink": "ज़्यादा कि.मी. / घंटों का किराया जानें",
"cv_calcTitle": "किराया कैलकुलेटर",
"cv_calcSub": "ज़्यादा कि.मी. या घंटों का किराया",
"cv_calcHours": "यात्रा के घंटे",
"cv_calcKm": "कुल कि.मी.",
"cv_calcBtn": "किराया जानें",
"cv_calcTotal": "अनुमानित किराया",
"cv_calcNote": "टोल, पार्किंग और स्टेट टैक्स शामिल नहीं",
"cv_loading": "गाड़ी की जानकारी लोड हो रही है…",
"cv_goneTitle": "यह गाड़ी उपलब्ध नहीं है",
"cv_goneText": "यह गाड़ी अब सूची में नहीं है, या लिंक की अवधि खत्म हो गई है।",
"cv_backHome": "होम पर जाएं",
"hm_recentEnquiry": "आपकी हाल की पूछताछ",
"hm_nPartners": "{n} पार्टनर",
"hm_onePartner": "1 पार्टनर",
"hm_resAvailIn": "{city} में {items} उपलब्ध हैं",
"hm_resAvailInCars": "{city} में {items} उपलब्ध हैं",
"hm_changeLang": "भाषा बदलें",
"hm_changeCity": "शहर बदलें",
"hm_helpCall": "मदद के लिए श्रामिक को कॉल करें",
"hm_chooseCity": "अपना शहर चुनें",
"hm_typeCity": "अपने शहर का नाम लिखें",
"hm_useMyLocation": "मेरी लोकेशन लें",
"hm_finding": "आपकी लोकेशन ढूँढ रहे हैं…",
"hm_noCities": "इस नाम का कोई शहर नहीं",
"hm_locNotSupported": "यह फ़ोन अपनी लोकेशन नहीं दे सकता।",
"hm_locMapsOff": "मैप लोड नहीं हुआ। पेज रिफ़्रेश करें।",
"hm_locNotFound": "आपकी लोकेशन नहीं मिली। फिर कोशिश करें।",
"hm_locNoCity": "आपकी लोकेशन मिली, पर शहर पता नहीं चला। नीचे से चुनें।",
"hm_locDenied": "लोकेशन की अनुमति नहीं मिली। फ़ोन की सेटिंग में अनुमति देकर फिर कोशिश करें।",
"hm_locUnavailable": "लोकेशन उपलब्ध नहीं है। जीपीएस चालू करके फिर कोशिश करें।",
"hm_locTimeout": "लोकेशन ढूँढने में बहुत समय लगा। फिर कोशिश करें।",
"hm_guestTitle": "लॉग इन करें और ड्राइवरों को सीधे कॉल करें",
"hm_guestSubCars": "किराए की तुलना करें, फिर ड्राइवर से सीधे बात करें - कोई बुकिंग फ़ीस नहीं।",
"hm_guestSubDrivers": "मोबाइल नंबर से मुफ़्त। एक टच में कॉल करें और अपनी पूछताछ इतिहास में देखें। कोई बुकिंग फ़ीस नहीं।",
"hm_guestTitleCars": "लॉग इन करें और ड्राइवरों को सीधे कॉल करें",
"hm_guestSubCarsLogin": "मोबाइल नंबर से मुफ़्त। एक टच में कॉल करें और अपनी पूछताछ इतिहास में देखें। कोई बुकिंग फ़ीस नहीं।",
"hm_loginJoin": "लॉग इन / जुड़ें",
"hm_recent": "हाल की",
"hm_setTrip": "यात्रा चुनें",
"hm_km": "{km} किमी",
"hm_searchCars": "कार, मॉडल या इलाका खोजें",
"hm_searchDrivers": "ड्राइवर का नाम या भाषा खोजें",
"hm_filters": "फ़िल्टर",
"hm_clearSearch": "खोज हटाएँ",
"hm_removeFilter": "फ़िल्टर हटाएँ",
"hm_any": "कोई भी",
"hm_sort": "क्रम",
"hm_sortRec": "सुझाए गए",
"hm_sortPriceLow": "कम कीमत पहले",
"hm_sortPriceHigh": "ज़्यादा कीमत पहले",
"hm_sortRating": "अच्छी रेटिंग पहले",
"hm_sortEta": "नज़दीकी पहले",
"hm_sortNewest": "नई कारें पहले",
"hm_seats": "सीटें",
"hm_nSeats": "{n} सीटें",
"hm_carType": "कार का प्रकार",
"hm_price": "कीमत",
"hm_ctHatch": "हैचबैक",
"hm_ctSedan": "सेडान",
"hm_ctMiniSuv": "मिनी एसयूवी",
"hm_ctSuv": "एसयूवी",
"hm_ctMpv": "7 सीटर (एमपीवी)",
"hm_ctTempo": "टेम्पो ट्रैवलर",
"hm_ctBus": "बस",
"hm_fuel": "ईंधन",
"hm_fuelPetrol": "पेट्रोल",
"hm_fuelDiesel": "डीज़ल",
"hm_fuelCng": "सीएनजी",
"hm_fuelEv": "इलेक्ट्रिक",
"hm_year": "कार का साल",
"hm_yr2024": "2024 या नई",
"hm_yr2015": "2015 या पुरानी",
"hm_budUnder5": "₹5,000 से कम",
"hm_budAbove15": "₹15,000 से ज़्यादा",
"hm_sortExp": "ज़्यादा अनुभव पहले",
"hm_sortOnline": "अभी ऑनलाइन पहले",
"hm_sortFareLow": "कम किराया पहले",
"hm_dBudUnder1": "₹1,000 से कम",
"hm_dBudAbove3": "₹3,000 से ज़्यादा",
"hm_priceNeedsTrip": "पहले अपनी यात्रा चुनें - कीमत उसी पर निर्भर है।",
"hm_rating": "रेटिंग",
"hm_starsPlus": "{n}+ स्टार",
"hm_experience": "ड्राइविंग अनुभव",
"hm_expPlus": "{n}+ साल ड्राइविंग",
"hm_speaks": "भाषा",
"hm_goodAt": "ग्राहक कहते हैं",
"hm_tOnTime": "समय पर",
"hm_tPolite": "विनम्र",
"hm_tComfort": "आरामदायक सफ़र",
"hm_tClean": "साफ़ कार",
"hm_tSafe": "सुरक्षित ड्राइविंग",
"hm_driverAge": "ड्राइवर की उम्र",
"hm_ageRange": "{range} साल",
"hm_grpCar": "कार",
"hm_grpDriver": "ड्राइवर",
"hm_grpPrice": "कीमत",
"hm_grpTrip": "यात्रा",
"hm_clearAll": "सब हटाएँ",
"hm_close": "बंद करें",
"hm_showCars": "{n} कारें दिखाएँ",
"hm_showOneCar": "1 कार दिखाएँ",
"hm_showNoCars": "कोई कार मेल नहीं खाती",
"hm_showDrivers": "{n} ड्राइवर दिखाएँ",
"hm_showOneDriver": "1 ड्राइवर दिखाएँ",
"hm_showNoDrivers": "कोई ड्राइवर मेल नहीं खाता",
"hm_tripType": "यात्रा का प्रकार",
"hm_ttLocal": "लोकल",
"hm_ttOut": "आउटस्टेशन",
"hm_ttDrop": "ड्रॉपिंग",
"hm_availability": "उपलब्धता",
"hm_availNow": "अभी उपलब्ध",
"hm_nDrivers": "{n} ड्राइवर",
"hm_oneDriver": "1 ड्राइवर",
"hm_resRoute": "{route} के लिए {items}",
"hm_resNear": "{place} के पास {items}",
"hm_resFound": "मिले: {items}",
"hm_showAll": "सब दिखाएँ",
"hm_shareList": "लिस्ट भेजें",
"dk_trips": "यात्राएँ",
"dk_heroCars": "{city} में गाड़ियाँ",
"dk_subCars": "असली दाम देखें, फिर ड्राइवर को सीधे कॉल करें - कोई बुकिंग फ़ीस नहीं, कोई एडवांस नहीं।",
"dk_heroDrivers": "{city} में ड्राइवर किराये पर लें",
"dk_subDrivers": "आपकी गाड़ी, हमारा ड्राइवर - हर रेट देखें, फिर ड्राइवर को सीधे कॉल करें।",
"dk_searchCars": "गाड़ियाँ खोजें",
"dk_searchDrivers": "ड्राइवर खोजें",
"dk_when": "कब",
"dk_tripType": "यात्रा",
"dk_filters": "फ़िल्टर",
"dk_pickWhen": "तारीख चुनें",
"dk_tagline": "आपके पास गाड़ियाँ और ड्राइवर - दाम देखें और ड्राइवर को सीधे कॉल करें।",
"dk_fCustomers": "ग्राहकों के लिए",
"dk_fJoin": "श्रामिक से जुड़ें",
"dk_fAbout": "हमारे बारे में",
"dk_fByCity": "शहर के अनुसार",
"dk_fCabsByCity": "शहर के अनुसार कारें",
"dk_fDriversByCity": "शहर के अनुसार ड्राइवर",
"dk_fFareChart": "टैक्सी किराया सूची",
"dk_fAirport": "एयरपोर्ट टैक्सी",
"cbk_button": "🙋 हम कॉल करके बुक करेंगे",
"cbk_title": "हम आपको कॉल करेंगे",
"cbk_sub": "10 मिनट में श्रामिक टीम कॉल करके आपके लिए बुक करेगी। लॉगिन की ज़रूरत नहीं।",
"cbk_night": "अभी रात है - सुबह 8 बजे कॉल करेंगे।",
"cbk_name": "आपका नाम",
"cbk_phone": "मोबाइल नंबर",
"cbk_trip": "आपकी यात्रा",
"cbk_note": "कुछ और (वैकल्पिक)",
"cbk_notePh": "6 लोग, 3 बैग…",
"cbk_send": "कॉल करने को कहें",
"cbk_sending": "भेज रहे हैं…",
"cbk_done": "मिल गया! 10 मिनट में कॉल आएगा।",
"cbk_doneNight": "मिल गया! सुबह 8 बजे कॉल करेंगे।",
"cbk_already": "आपका अनुरोध पहले ही मिल गया है - जल्द कॉल करेंगे।",
"cbk_badPhone": "10 अंकों का मोबाइल नंबर डालें",
"cbk_noName": "अपना नाम डालें",
"cbk_error": "भेज नहीं पाए। कृपया {n} पर कॉल करें।",
"cbk_noLogin": "लॉगिन नहीं करना? हम कॉल करेंगे →",
"lcb_title": "नई ग्राहक कॉल",
"lcb_accept": "मैं लूँगा",
"lcb_reject": "अभी नहीं",
"lcb_ago": "{n} मिनट पहले",
"lcb_accepted": "ले लिया - लीड्स से ग्राहक को कॉल करें",
"lcb_rejected": "ठीक है - श्रामिक इस ग्राहक की मदद करेगा",
"tr_title": "नई ट्रिप",
"tr_yourPrice": "आपका किराया",
"tr_accept": "लूँगा",
"tr_decline": "नहीं",
"tr_won": "ट्रिप कन्फर्म",
"tr_taken": "किसी और ने ले ली",
"tr_closed": "यह रिक्वेस्ट बंद हो गई",
"tr_missedTip": "जो ड्राइवर पहले स्वीकार करे, ट्रिप उसी की। अगली बार जल्दी स्वीकार करें।",
"tr_declined": "मना किया",
"tr_free": "आज ट्रिप के लिए खाली",
"tr_call": "ग्राहक को कॉल करें",
"tr_calling": "कॉल जोड़ रहे हैं — पहले आपका फ़ोन बजेगा",
"tr_over": "ट्रिप खत्म हो गई",
"tr_callErr": "कॉल नहीं लगी। फिर से कोशिश करें।",
"tr_people": "{n} लोग",
"cbk_close": "बंद करें",
"dk_fRegisterCar": "अपनी गाड़ी जोड़ें",
"dk_fJoinDriver": "ड्राइवर के रूप में जुड़ें",
"dk_fTerms": "शर्तें",
"dk_fPrivacy": "गोपनीयता",
"dk_fRefunds": "रिफ़ंड",
"dk_fDelete": "खाता हटाएँ",
"bl_title": "दूसरे बिज़नेस को कॉल करने से पहले थोड़ा रुकें",
"bl_body": "ड्राइवर 6 घंटे में एक बिज़नेस को ही कॉल कर सकते हैं - ताकि एक ही पूछताछ बार-बार न पहुँचे।",
"bl_next": "अगला कॉल: {when} के बाद",
"bl_urgent": "जल्दी है? श्रामिक को कॉल करें",
"bl_ok": "ठीक है",
"cb_pill": "बुकिंग के लिए कॉल",
"cb_barTitle": "कौन सी गाड़ी लें, तय नहीं? हम बुक कर देंगे",
"cb_hours": "सुबह 8 – रात 9 · तेलुगु, हिंदी, अंग्रेज़ी",
"cb_call": "कॉल करें",
"cb_or": "या हमें कॉल करें, हम बुक कर देंगे:",
"cb_want": "हम आपके लिए बुक कर दें?",
"cb_quiet": "कॉल पर बुक करना है? हम बुक कर देंगे",
"cb_callUs": "कॉल करें",
"hm_guestCardT": "एक बार लॉग इन करें - किसी भी ड्राइवर को सीधे कॉल",
"hm_guestCardD": "मोबाइल नंबर से मुफ़्त। कोई बुकिंग फ़ीस नहीं।",
"hm_loginShort": "लॉग इन",
"vc_speak": "बोलें",
"vc_listening": "अब बोलिए…",
"vc_langs": "तेलुगु · हिंदी · अंग्रेज़ी - अपनी भाषा में",
"vc_stop": "रोकें",
"vc_errMic": "बोलने के लिए माइक की अनुमति दें",
"vc_errNone": "कुछ सुनाई नहीं दिया - फिर से कोशिश करें",
"vc_errOther": "अभी आवाज़ काम नहीं कर रही - टाइप करें",
"sq_phCars": "गाड़ी, जगह, यात्रा - कुछ भी पूछें",
"sq_phDrivers": "ड्राइवर, भाषा, यात्रा - कुछ भी पूछें",
"sq_recent": "आपकी पिछली खोजें",
"sq_clear": "सब हटाएँ",
"sq_remove": "हटाएँ",
"sq_try": "ऐसे पूछ सकते हैं",
"sq_trips": "लोकप्रिय यात्राएँ",
"sq_understood": "समझ गए:",
"sq_goTrip": "इस यात्रा के दाम देखें",
"sq_goCars": "ये गाड़ियाँ दिखाएँ",
"sq_goDrivers": "ये ड्राइवर दिखाएँ",
"sq_speaks": "{lang} बोलने वाला",
"sq_ex1": "कल तिरुपति के लिए 7 सीटर",
"sq_ex2": "एयरपोर्ट ड्रॉप",
"sq_ex3": "7 सीटर डीजल",
"sq_ex4": "परसों हैदराबाद आना-जाना",
"sq_dx1": "कल सुबह हैदराबाद आना-जाना",
"sq_dx2": "आज रात एयरपोर्ट ड्रॉप",
"sq_dx3": "कल हिंदी बोलने वाला ड्राइवर",
"sq_dx4": "कल तिरुपति",
"sq_inDrivers": "इस नाम से गाड़ी नहीं - ड्राइवरों में {n} मिले ›",
"sq_inCars": "इस नाम से ड्राइवर नहीं - गाड़ियों में {n} मिले ›",
"vr_titleCars": "आपकी गाड़ियाँ कितनी दूरी तक दिखें?",
"vr_titleDriver": "आपकी प्रोफ़ाइल कितनी दूरी तक दिखे?",
"vr_sub": "जिन ग्राहकों का पिकअप आपसे इतनी दूरी के अंदर है, उन्हें आप दिखेंगे।",
"vr_km": "{n} कि.मी.",
"vr_sramika": "श्रामिक",
"vr_legCity": "श्रामिक {n} कि.मी.",
"vr_legOwn": "आपकी {n} कि.मी.",
"vr_note": "दूरी बढ़ाने से ज़्यादा पूछताछ आती है - पर पिकअप तक आपको ही जाना होगा।",
"vr_save": "सेव करें",
"vr_reset": "श्रामिक की दूरी ({n} कि.मी.) रखें",
"vr_saved": "सेव हो गया",
"vr_err": "सेव नहीं हुआ - फिर से कोशिश करें",
"vr_later": "बाद में डैशबोर्ड पर बदल सकते हैं।",
"dk_bizSub": "ड्राइवरों के लिए।",
"dk_bizCalls": "ग्राहकों के सीधे कॉल",
"dk_bizPrices": "आपके अपने दाम",
"dk_bizHours": "आपका अपना समय",
"dk_bizJoin": "नए हैं? श्रामिक से जुड़ें",
"dk_step1": "फ़ॉर्म भरें",
"dk_step2": "श्रामिक जाँच करता है",
"dk_step3": "ग्राहक आपको कॉल करते हैं",
"dk_trustCars": "जाँची हुई गाड़ियाँ",
"dk_trustDrivers": "जाँचे हुए ड्राइवर",
"dk_trustPrice": "कॉल से पहले दाम",
"dk_trustCallOwner": "ड्राइवर को सीधे कॉल",
"dk_trustCallDriver": "ड्राइवर को सीधे कॉल",
"dk_tripReady": "सब तैयार - दिखाए गए दाम इसी यात्रा के हैं।",
"dk_tripReadyDrivers": "सब तैयार - हर ड्राइवर का दाम इसी यात्रा का है।",
"dk_route": "रास्ता",
"dk_group": "समूह",
"dk_people": "{n} लोग",
"dk_person": "1 व्यक्ति",
"dk_bags": "{n} बैग",
"dk_bag": "1 बैग",
"dk_kmApprox": "लगभग {km} कि.मी.",
"hm_linkCopied": "लिंक कॉपी हो गया - व्हाट्सऐप में भेजें",
"hm_setPickup": "पिकअप बनाएँ",
"hm_goingTo": "{city} जा रहे हैं?",
"hm_canTake": "{city} की {items} आपको वहाँ ले जा सकती हैं",
"hm_setDrop": "ड्रॉप बनाएँ",
"hm_seeBasedIn": "{city} की कारें देखें",
"hm_bTop": "टॉप रेटेड",
"hm_bNearby": "नज़दीक",
"hm_homeReturn": "{city} की कार · घर लौटते हुए आपको ले जाएगी",
"rc_badge": "श्रामिक अनुशंसित",
"join_vendor": "कार वॉश या कार जाँच का व्यवसाय? अपना व्यवसाय जोड़ें →",
"rc_checked": "श्रामिक ने जाँचा: दस्तावेज़, दाम, कॉल उठाते हैं, कोई शिकायत नहीं",
"rc_why": "अनुशंसित गाड़ियाँ पास के ग्राहकों को ऊपर दिखती हैं।",
"rc_has": "{date} तक आपके पास है",
"rc_c_verified": "सत्यापित",
"rc_c_profile": "सभी दाम भरें",
"rc_c_answers": "कॉल उठाएँ",
"rc_c_rated": "अच्छी रेटिंग",
"rc_c_price": "सही दाम",
"rc_c_clean": "कोई शिकायत नहीं",
"hm_bLuxury": "लग्ज़री",
"hm_bFamily": "फ़ैमिली ट्रिप",
"hm_bFast": "जल्दी बुकिंग",
"hm_bNew": "श्रामिक पर नया",
"hm_online": "ऑनलाइन",
"hm_newTag": "नया",
"hm_viewFare": "किराया देखें",
"hm_nReviews": "{n} समीक्षाएं",
"hm_onTrip": "ट्रिप पर",
"hm_repair": "मरम्मत में",
"hm_age": "उम्र {n}",
"hm_yrs": "{yrs} साल",
"hm_driving": "ड्राइविंग",
"hm_minAway": "{n} मिनट दूर",
"hm_kmAway": "{km} किमी दूर",
"hm_aboutKm": "लगभग {km} किमी",
"hm_under1km": "1 किमी से कम",
"hm_distFrom": "{place} से {dist}",
"hm_matchedBy": "मिलान: {what}",
"hm_mModel": "कार मॉडल",
"hm_mBrand": "ब्रांड",
"hm_mDriver": "ड्राइवर का नाम",
"hm_mLang": "भाषा",
"hm_mDetails": "कार का विवरण",
"hm_mName": "नाम",
"hm_mCity": "शहर",
"hm_mProfile": "प्रोफ़ाइल",
"hm_seePrice": "कीमत देखें",
"hm_saveAmt": "₹{amt} की बचत",
"hm_call": "कॉल",
"hm_viewCar": "{name} का विवरण देखें",
"hm_photoOf": "{name} की फ़ोटो {n}",
"hm_tooLong": "एक ड्राइवर के लिए बहुत दूर",
"hm_priceOnReq": "कीमत पूछकर",
"hm_oneHr": "1 घंटा",
"hm_busy": "व्यस्त",
"hm_offline": "ऑफ़लाइन",
"hm_confirmTitle": "{name} को कॉल करें?",
"hm_confirmText": "{car} के बारे में। आपकी यात्रा की जानकारी कॉल के साथ ड्राइवर को जाएगी।",
"hm_thePartner": "ड्राइवर",
"hm_cancel": "रद्द करें",
"hm_callConnecting": "आपको ड्राइवर से जोड़ रहे हैं।",
"hm_callFailed": "कॉल नहीं लगी। फिर कोशिश करें।",
"hm_partnerBusy": "यह ड्राइवर अभी कॉल नहीं ले सकते। दूसरी कार आज़माएँ।",
"hm_cantCall": "इस खाते से ड्राइवर को कॉल नहीं हो सकता। ग्राहक के रूप में लॉग इन करें।",
"hm_findingCars": "{city} में कारें ढूँढ रहे हैं…",
"hm_findingDrivers": "{city} में ड्राइवर ढूँढ रहे हैं…",
"hm_pickCityCars": "कारें देखने के लिए अपना शहर चुनें",
"hm_pickCityDrivers": "ड्राइवर देखने के लिए अपना शहर चुनें",
"hm_networkGrowing": "श्रामिक बढ़ रहा है",
"hm_noCarsIn": "{city} में अभी कारें नहीं हैं",
"hm_noCarsText": "हम यहाँ ड्राइवरों को जोड़ रहे हैं। दूसरा शहर देखें, या आपके पास कार है तो जुड़ें।",
"hm_noDriversIn": "{city} में अभी ड्राइवर नहीं हैं",
"hm_noDriversText": "हम यहाँ ड्राइवर जोड़ रहे हैं। दूसरा शहर देखें, या आप ड्राइवर हैं तो जुड़ें।",
"hm_joinPartner": "अपनी कार के साथ जुड़ें",
"hm_joinDriver": "ड्राइवर बनकर जुड़ें",
"hm_supTitle": "श्रामिक से मदद चाहिए?",
"hm_supText": "हमें कॉल करें। सही कार ढूँढने में हम मदद करेंगे।",
"hm_ocTitle": "{city} में कारें चाहिए?",
"hm_ocText": "आपका शहर अभी {current} है।",
"hm_switchTo": "{city} पर बदलें",
"hm_lookingFor": "{city} के पास “{q}” ढूँढ रहे हैं…",
"hm_iAccT": "अपना खाता ढूँढ रहे हैं?",
"hm_iAccD": "आपकी प्रोफ़ाइल और सेटिंग खाते में हैं।",
"hm_iAccB": "खाता खोलें",
"hm_iPartT": "अपनी कार श्रामिक में जोड़नी है?",
"hm_iPartD": "अपनी कार के साथ या ड्राइवर के रूप में श्रामिक पर बिज़नेस के तौर पर जुड़ें और ग्राहकों से कॉल पाएँ। कोई कमीशन नहीं।",
"hm_iTripsT": "अपनी यात्राएँ ढूँढ रहे हैं?",
"hm_iTripsD": "आपकी पूछताछ और यात्राएँ इतिहास में हैं।",
"hm_iTripsB": "इतिहास खोलें",
"hm_iPriceT": "कीमत देख रहे हैं?",
"hm_iPriceD": "हर कार की कीमत देखने के लिए ऊपर अपनी यात्रा चुनें।",
"hm_iRouteT": "कहीं जा रहे हैं?",
"hm_iRouteD": "अपनी यात्रा चुनने के लिए ऊपर “पिकअप लोकेशन” दबाएँ।",
"hm_noFound": "“{q}” के लिए कोई कार नहीं मिली",
"hm_noDriversFound": "“{q}” के लिए कोई ड्राइवर नहीं मिला",
"hm_noMatchCars": "आपके फ़िल्टर से कोई कार मेल नहीं खाती",
"hm_noMatchDrivers": "आपके फ़िल्टर से कोई ड्राइवर मेल नहीं खाता",
"hm_tryThese": "इनमें से कोई आज़माएँ:",
"hm_clearFilters": "फ़िल्टर हटाएँ",
"hm_hide": "छिपाएँ",
"hm_didBookCar": "क्या आपने {car} बुक की?",
"hm_didBookWith": "क्या आपने {name} के साथ {car} बुक की?",
"hm_didHire": "क्या आपने {name} को रखा?",
"hm_thanksSaid": "धन्यवाद - आपने “{answer}” कहा।",
"hm_askLater": "बाद में पूछें",
"hm_joinDriverT": "क्या आप ड्राइवर हैं?",
"hm_joinDriverD": "श्रामिक से जुड़ें और ग्राहकों से कॉल पाएँ।",
"hm_join": "जुड़ें",
"hm_joinCarT": "क्या आपके पास कार है?",
"hm_joinCarD": "अपनी कार श्रामिक में जोड़ें और ग्राहकों से कॉल पाएँ। कोई कमीशन नहीं।",
"hm_myRequests": "मेरे हायर अनुरोध",
"hm_loading": "लोड हो रहा है…",
"hm_reqPending": "इंतज़ार",
"hm_reqAccepted": "स्वीकार",
"hm_reqRejected": "मना किया",
"hm_halfDay": "आधा दिन (4 घंटे)",
"hm_fullDay": "पूरा दिन (8 घंटे)",
"hm_rateThisDriver": "इस ड्राइवर को रेटिंग दें",
"hm_rated": "रेटिंग दी",
"hm_reqSent": "अनुरोध भेजा गया",
"hm_reqSentText": "ड्राइवर आपका अनुरोध देखकर जल्द जवाब देंगे।",
"hm_ratingSent": "रेटिंग भेजी गई",
"hm_ratingThanks": "धन्यवाद। इससे दूसरे ग्राहकों को मदद मिलती है।",
"hm_ok": "ठीक है",
"mc_custRequest": "ग्राहक का अनुरोध",
"mc_helpLead": "इस लीड में मदद चाहिए? श्रामिक को कॉल करें",
"ld_stCall": "कॉल किया गया",
"ld_stAccepted": "स्वीकार किया",
"ld_stSuccess": "यात्रा सफल",
"ld_stConfirm": "पुष्टि करनी है",
"ld_stNotBooked": "बुक नहीं हुई",
"ld_waiting": "इंतज़ार",
"ld_afterTrip": "यात्रा के बाद",
"ld_chipDone": "पूरा हुआ",
"ld_chipConfirm": "आपका जवाब चाहिए",
"ld_chipUpcoming": "आने वाली",
"ld_chipSent": "पूछताछ भेजी",
"ld_title": "पूछताछ का विवरण",
"ld_sub": "अपनी पूछताछ देखें और बताएँ क्या हुआ",
"ld_tripEnquiry": "यात्रा पूछताछ",
"ld_sentTo": "{name} को भेजी गई",
"ld_sentPartner": "ड्राइवर को भेजी गई",
"ld_tripDetails": "यात्रा विवरण",
"ld_tripDate": "यात्रा की तारीख़",
"ld_enquiryDate": "पूछताछ की तारीख़",
"ld_distance": "दूरी",
"ld_passengers": "यात्री",
"ld_vehicle": "मांगा गया वाहन",
"ld_driverReq": "मांगा गया ड्राइवर",
"ld_refFare": "संदर्भ किराया",
"ld_refNote": "यह वह कीमत है जो आपको दिखाई गई। अंतिम कीमत ड्राइवर से सीधे तय होती है।",
"ld_didBook": "क्या आपने यह कार बुक की?",
"ld_didBookDriver": "क्या आपने यह ड्राइवर रखा?",
"ld_didBookSub": "बताइए इस पूछताछ का क्या हुआ।",
"ld_yes": "हाँ, बुक की",
"ld_yesSub": "उनके साथ गया",
"ld_no": "नहीं, बुक नहीं की",
"ld_noSub": "मैं नहीं गया",
"ld_maybe": "अभी तय नहीं",
"ld_maybeSub": "अभी पक्का नहीं",
"ld_beforeTrip": "यात्रा की तारीख़ के बाद जवाब दे सकते हैं।",
"ld_rateTitle": "आपका अनुभव कैसा रहा?",
"ld_rateSub": "आपके स्टार दूसरे ग्राहकों को चुनने में मदद करते हैं।",
"ld_ratePh": "अपने अनुभव के बारे में बताएँ (वैकल्पिक)",
"ld_rateSend": "रेटिंग भेजें",
"ld_rateThanks": "धन्यवाद - आपने {n} ★ दिए",
"ld_rateErr": "रेटिंग सेव नहीं हुई। फिर कोशिश करें।",
"ld_whyTitle": "बुक नहीं की, तो क्या हुआ?",
"ld_whySub": "इससे हम बेहतर सेवा दे पाएँगे (वैकल्पिक)",
"ld_rHigh": "कीमत ज़्यादा",
"ld_rNotAvail": "कार उपलब्ध नहीं",
"ld_rElsewhere": "कहीं और बुक की",
"ld_rNoResp": "जवाब नहीं मिला",
"ld_rPlans": "योजना बदली",
"ld_rOther": "अन्य",
"ld_rThanks": "बताने के लिए धन्यवाद।",
"ld_callPartner": "ड्राइवर को कॉल करें",
"ld_callSub": "पार्टनर से सीधे बात करें",
"mc_tabLeads": "लीड",
"mc_tabWallet": "वॉलेट",
"mc_free": "लीड अभी मुफ़्त हैं।",
"mc_freeSub": "आपके वॉलेट से कुछ नहीं कटता।",
"mc_low": "वॉलेट ₹{min} से कम - लीड पाते रहने के लिए पैसे जोड़ें।",
"mc_addMoney": "पैसे जोड़ें - श्रामिक को कॉल",
"mc_cars": "कारें",
"mc_available": "उपलब्ध",
"mc_busy": "व्यस्त",
"mc_inReview": "जाँच में",
"mc_myDrivers": "मेरे ड्राइवर",
"mc_limit": "वाहन सीमा पूरी ({n})",
"mc_live": "लाइव",
"mc_rejected": "मंज़ूर नहीं",
"mc_hidden": "छिपी हुई",
"mc_availability": "उपलब्धता",
"mc_onTrip": "यात्रा पर",
"mc_maint": "मरम्मत में",
"mc_avHint": "ग्राहकों को आपकी कार पर \"यात्रा पर\" या \"मरम्मत में\" दिखता है। 24 घंटे बाद यह फिर उपलब्ध हो जाती है।",
"mc_addDriver": "ड्राइवर जोड़ें",
"mc_driver": "ड्राइवर",
"mc_chooseDriver": "ड्राइवर चुनें",
"mc_drvPending": "(मंज़ूरी बाकी)",
"mc_pricesDetails": "कीमत और विवरण",
"mc_reviewText": "श्रामिक इस कार की जाँच कर रहा है। लाइव होने पर बताएँगे।",
"mc_editsPending": "आपके नए बदलाव मंज़ूरी का इंतज़ार कर रहे हैं।",
"mc_rejectedText": "यह कार मंज़ूर नहीं हुई। कारण जानने के लिए श्रामिक को कॉल करें।",
"mc_hiddenText": "ग्राहक यह कार नहीं देख सकते। फिर से दिखाने के लिए श्रामिक को कॉल करें।",
"mc_noCars": "अभी कोई कार नहीं",
"mc_noCarsSub": "कॉल पाने के लिए अपनी कार जोड़ें।",
"mc_regProgress": "कार का पंजीकरण चल रहा है",
"mc_regProgressSub": "आपकी कार तैयार की जा रही है। एक दिन से ज़्यादा लगे तो श्रामिक को कॉल करें।",
"mc_profileReview": "प्रोफ़ाइल जाँच में है",
"mc_profileReviewSub": "आपके दस्तावेज़ जाँचे जा रहे हैं। मंज़ूरी के बाद आपकी कारें लाइव होंगी।",
"mc_submitted": "भेजने की तारीख़",
"mc_appId": "आवेदन आईडी",
"mc_licExpired": "लाइसेंस की अवधि खत्म",
"mc_licExpiredSub": "आपका ड्राइविंग लाइसेंस खत्म हो गया है। नवीनीकरण करके फिर भेजें।",
"mc_licAgain": "लाइसेंस की फ़ोटो फिर चाहिए",
"mc_licAgainSub": "आपकी लाइसेंस फ़ोटो साफ़ नहीं थी। साफ़ फ़ोटो भेजें।",
"mc_loading": "आपकी कारें लोड हो रही हैं…",
"mc_loadErr": "लोड नहीं हुआ। फिर कोशिश करें।",
"mc_retry": "फिर कोशिश करें",
"mc_relogin": "फिर से लॉग इन करें",
"mc_moveDriver": "{a} को इस कार पर लगाएँ? {b} को दूसरी कार मिलेगी।",
"mc_replaceDriver": "{a} को इस कार पर लगाएँ? {b} को इससे हटा दिया जाएगा।",
"mc_assignErr": "ड्राइवर नहीं बदल सका। फिर कोशिश करें।",
"mc_getMore": "ज़्यादा कॉल पाएँ",
"mc_getMoreSub": "5 आसान कदम",
"mc_leadPrices": "लीड की कीमतें",
"mc_leadPricesSub": "एक लीड की कीमत",
"mc_yourLeads": "आपकी लीड",
"mc_leadsCount": "{n} · नई पहले",
"mc_noLeads": "अभी कोई लीड नहीं",
"mc_noLeadsSub": "जब ग्राहक श्रामिक से आपको कॉल करेंगे, वे यहाँ दिखेंगे।",
"mc_new": "नई",
"mc_called": "कॉल किया",
"mc_booked": "बुक हुई",
"mc_custPrice": "ग्राहक को दिखाई कीमत",
"mc_showNumber": "नंबर दिखाएँ",
"mc_revealSoon": "ग्राहक का नंबर दिखाना जल्द आ रहा है।",
"mc_didHappen": "क्या यह यात्रा हुई?",
"mc_youMarked": "आपका जवाब: {answer}",
"mc_locked": "बदल नहीं सकते",
"mc_changesLeft": "जवाब बदलें - {n} बाकी",
"mc_rateCust": "इस ग्राहक को रेटिंग दें",
"mc_rated": "धन्यवाद - रेटिंग दी",
"mc_leadDetails": "लीड का विवरण",
"mc_leadDetailsSub": "ग्राहक की पूछताछ और क्या हुआ",
"mc_customer": "ग्राहक",
"mc_quoted": "ग्राहक को दिखाई कीमत",
"mc_freeLine": "लीड अभी मुफ़्त हैं - इसमें से कुछ नहीं कटता।",
"mc_chargeLine": "लीड फ़ीस इसी बैलेंस से कटती है।",
"mc_refer": "किसी व्यापार को रेफ़र करें",
"mc_referText": "आपके बुलाए ड्राइवर के मंज़ूर होते ही, लीड फ़ीस के लिए आप दोनों को क्रेडिट मिलेगा।",
"mc_txns": "लेन-देन",
"mc_noTxns": "अभी कोई लेन-देन नहीं",
"mc_tip1": "लीड फ़ीस इसी वॉलेट से",
"mc_tip2": "कम बैलेंस से नई लीड रुक सकती हैं",
"mc_tip3": "सक्रिय रहने के लिए कभी भी पैसे जोड़ें",
"cd_title": "वाहन का विवरण",
"cd_photosNote": "जाँच के बाद नंबर प्लेट अपने आप छिप जाती है।",
"cd_photosMin": "कम से कम 3 फ़ोटो जोड़ें ({n} और चाहिए)",
"cd_photosSent": "जाँच के लिए भेजा। मंज़ूरी के बाद नई फ़ोटो दिखेंगी।",
"cd_addPhoto": "फ़ोटो जोड़ें",
"cd_replace": "बदलें",
"cd_remove": "हटाएँ",
"cd_newTag": "नई",
"cd_pendingTag": "जाँच में",
"cd_details": "कार का विवरण",
"cd_detailsNote": "फ़ोटो और विवरण के बदलाव श्रामिक की जाँच के बाद ही दिखते हैं।",
"cd_city": "शहर",
"cd_category": "कीमत समूह",
"cd_categoryNote": "आपके मॉडल और सीटों से तय होता है। गलत लगे तो श्रामिक को कॉल करें।",
"cd_notSet": "अभी तय नहीं",
"cd_acSub": "क्या इस कार में एसी चलता है?",
"cd_musicSub": "क्या म्यूज़िक या ब्लूटूथ चलता है?",
"cd_pricesNote": "तुरंत सेव हो जाता है। खाली बॉक्स में धूसर रंग में दिखी सुझाई कीमत लगती है।",
"cd_rule": "कीमत 24 घंटे में एक बार ही बढ़ा सकते हैं। घटाना कभी भी कर सकते हैं।",
"cd_suggestedUsed": "खाली: सुझाई गई {v} लगेगी",
"cd_savePrices": "मेरी कीमतें सेव करें",
"cd_saving": "सेव हो रहा है…",
"cd_saved": "सेव हुआ",
"cd_savedMsg": "आपकी कीमतें सेव हो गईं।",
"cd_saveErr": "आपकी कीमतें सेव नहीं हुईं। फिर कोशिश करें।",
"cd_noCat": "इस कार का अभी कोई कीमत समूह नहीं है। कृपया श्रामिक को कॉल करें।",
"cd_submit": "कार का विवरण मंज़ूरी के लिए भेजें",
"cd_sending": "भेज रहे हैं…",
"cd_sent": "भेजा गया",
"cd_sentMsg": "भेज दिया! श्रामिक जाँच करके आपके बदलाव मंज़ूर करेगा।",
"cd_sendErr": "भेज नहीं सके। फिर कोशिश करें।",
"cd_minPhotosErr": "कृपया कम से कम 3 फ़ोटो रखें।",
"cd_noChange": "कोई कीमत नहीं बदली",
"hl_phNote": "जैसे: मेरी कार ऑटोमैटिक है, हिंदी बोलने वाला ड्राइवर चाहिए...",
"hl_noteHint": "ड्राइवर को यह आपकी पूछताछ के साथ दिखेगा।",
"hl_yearFirst": "पहले साल डालें",
"lp_headerSub": "अपनी यात्रा तय करें और सबसे अच्छी कारें देखें",
"hl_headerSub": "अपनी यात्रा तय करें और सबसे अच्छे ड्राइवर देखें",
"lp_whenSub": "यात्रा की तारीख़ और समय चुनें",
"lp_prefSub": "कुछ और जानकारी दें",
"lp_optional": "(वैकल्पिक)",
"lp_clear": "साफ़ करें",
"hl_carTitle": "जिस कार के लिए ड्राइवर चाहिए",
"hl_carSub": "आपकी कार का साल और मॉडल",
"hl_year": "साल",
"hl_model": "मॉडल",
"hl_fuel": "ईंधन का प्रकार",
"hl_phYear": "जैसे 2018",
"hl_phModel": "मॉडल खोजें",
"hl_phFuel": "मॉडल से अपने आप भरेगा",
"hl_car": "आपकी कार",
"hl_farPickup": "{area} {city} से 30 किमी से ज़्यादा दूर है। 30 किमी के अंदर की जगह चुनें, या शहर बदलें।",
"hl_tooFar": "{from} से {to} {km} किमी है - एक ड्राइवर की सीमा {max} किमी है। कृपया {max} किमी के अंदर की जगह चुनें।",
"hl_noPlace": "आपकी लोकेशन से जगह का नाम नहीं मिला - कृपया अपना शहर लिखें।",
"navDashboard": "डैशबोर्ड",
"ac_language_sub": "ऐप की भाषा बदलें",
"ac_support": "सहायता",
"ac_support_sub": "मदद और सवाल-जवाब",
"ac_settings": "सेटिंग्स",
"ac_settings_sub": "प्रोफ़ाइल और पसंद",
"ac_profileInfo": "प्रोफ़ाइल जानकारी",
"ac_profileInfo_sub": "नाम, ईमेल, फ़ोन बदलें",
"ac_prefCity": "पसंदीदा शहर",
"ac_prefCity_sub": "डिफ़ॉल्ट शहर बदलें",
"ac_terms": "शर्तें",
"ac_terms_sub": "नियम और शर्तें",
"ac_privacy": "गोपनीयता",
"ac_privacy_sub": "गोपनीयता नीति",
"ac_history_sub": "आपकी पूछताछ और पिछली यात्राएँ",
"ac_notifications": "सूचनाएँ",
"ac_notif_sub_user": "यात्रा और खाते की अपडेट",
"ac_notif_sub": "खाते की अपडेट",
"ac_ownerDash": "ड्राइवर डैशबोर्ड",
"ac_ownerDash_sub": "लीड, कारें और वॉलेट",
"ac_myCars": "मेरी कारें",
"ac_myCars_sub": "अपने वाहनों की सूची",
"ac_addVehicle": "वाहन जोड़ें",
"ac_addVehicle_sub": "एक और कार मंज़ूरी के लिए भेजें",
"ac_driverDash": "ड्राइवर डैशबोर्ड",
"ac_driverDash_sub": "आपकी लीड, रेट और स्थिति",
"ac_menuUser": "मेरा खाता",
"ac_menuUser_sub": "अपनी यात्राएँ और खाता",
"ac_menuOwner": "ड्राइवर मेनू",
"ac_menuOwner_sub": "वाहन और ड्राइवर के काम",
"ac_menuDriver": "हायर ड्राइवर मेनू",
"ac_menuDriver_sub": "आपकी लीड और स्थिति",
"ac_menuAgent": "फ़ील्ड एजेंट मेनू",
"ac_menuAgent_sub": "आपका रेफ़रल कोड और खाता",
"ac_menuGeneral": "सामान्य विकल्प",
"ac_menuGeneral_sub": "खाता और ऐप की पसंद",
"ac_account": "खाता",
"ac_editProfile": "प्रोफ़ाइल बदलें",
"ac_changePhoto": "प्रोफ़ाइल फ़ोटो बदलें",
"ac_verified": "सत्यापित",
"ac_back": "वापस",
"ac_pendingTitle": "बिज़नेस आवेदन जाँच में है",
"ac_pendingText": "एडमिन आपका बिज़नेस आवेदन देख रहे हैं। मंज़ूरी मिलते ही आपको बताया जाएगा।",
"ac_strength": "प्रोफ़ाइल की मज़बूती",
"ac_strengthDone": "पूरा - सब तैयार है!",
"ac_strengthGood": "अच्छी स्थिति",
"ac_strengthLow": "अधूरा - प्रोफ़ाइल पूरी करें",
"ac_searchPh": "सेटिंग्स, डैशबोर्ड खोजें…",
"ac_clearSearch": "खोज साफ़ करें",
"ac_noMatch": "कुछ नहीं मिला",
"ac_tryElse": "कुछ और खोजकर देखें",
"ac_inSection": "{section} में",
"ac_agentCode": "रेफ़रल कोड",
"ac_agentCodeSub": "जिस ड्राइवर को जोड़ रहे हैं उसे यह दें",
"ac_noCode": "अभी कोई कोड नहीं",
"ac_copy": "कॉपी",
"ac_copied": "कॉपी हुआ",
"ac_working": "हो रहा है…",
"ac_genNew": "नया कोड बनाएँ",
"ac_gen": "कोड बनाएँ",
"ac_agentNote": "ड्राइवर को जुड़ते समय यह कोड डालना होगा, और तब तक यह मान्य होना चाहिए। नया कोड बनाने पर पुराना काम नहीं करेगा।",
"ac_agentConfirm": "नया कोड बनाएँ? आपका मौजूदा कोड तुरंत बंद हो जाएगा, जिनके पास लिखा है वे इसे इस्तेमाल नहीं कर पाएँगे। इससे पहले जुड़े खातों का क्रेडिट बना रहेगा।",
"ac_agentErr": "कोड नहीं बन सका। फिर कोशिश करें।",
"ac_refer": "रेफ़र करें और कमाएँ",
"ac_referCustSub": "ड्राइवर या आल्टिंग ड्राइवर को बुलाएँ",
"ac_referCustSubR": "ड्राइवर या आल्टिंग ड्राइवर को बुलाएँ, हर एक पर ₹{amt} पाएँ",
"ac_referCustText": "कोई ड्राइवर या आल्टिंग ड्राइवर जानते हैं? अपना कोड भेजें। उनका खाता मंज़ूर होते ही आपके श्रामिक वॉलेट में {reward} आएगा।",
"ac_aCredit": "रेफ़रल क्रेडिट",
"ac_share": "शेयर",
"ac_approved": "मंज़ूर",
"ac_waiting": "इंतज़ार में",
"ac_yourWallet": "आपका वॉलेट",
"ac_referBizSub": "किसी और ड्राइवर या आल्टिंग ड्राइवर को बुलाएँ",
"ac_referBizSubR": "किसी और ड्राइवर को बुलाएँ - दोनों को ₹{amt}",
"ac_referSoon": "आपका खाता मंज़ूर होते ही आपका रेफ़रल कोड आ जाएगा।",
"ac_referBizText": "अपना कोड भेजें। उनका खाता मंज़ूर होते ही, लीड फ़ीस के लिए आप दोनों को {credit} मिलेगा।",
"ac_creditAmt": "₹{amt} क्रेडिट",
"ac_credit": "क्रेडिट",
"ac_pickCar": "रेफ़रल किस कार पर दर्ज हो, चुनें।",
"ac_spaces": "स्पेस और डैश नहीं गिने जाते - किसी भी तरह लिखें, चलेगा।",
"ac_oneWallet": "आपके किसी भी कोड का क्रेडिट आपके एक ही वॉलेट में आता है।",
"ac_car": "कार {id}",
"ac_calcTitle": "ओडोमीटर और किराया कैलकुलेटर",
"ac_calcSub": "ओडोमीटर रीडिंग से किराए का अनुमान",
"ac_startOdo": "शुरू की रीडिंग (किमी)",
"ac_endOdo": "आख़िरी रीडिंग (किमी)",
"ac_endLess": "आख़िरी रीडिंग शुरू वाली से ज़्यादा होनी चाहिए।",
"ac_calcBtn": "किराया निकालें",
"ac_calcNone": "इस शहर में इस यात्रा और कार का किराया अभी नहीं है।",
"ac_pricedAs": "हिसाब: {mode}",
"ac_estNote": "शहर के सुझाए दामों पर अनुमान - अंतिम किराया ड्राइवर से तय करें। टोल, पार्किंग और राज्य परमिट अलग से।",
"ac_seats": "{n} सीट",
"ac_logout": "लॉग आउट",
"ac_loading": "प्रोफ़ाइल लोड हो रही है…",
"ac_takePhoto": "फ़ोटो लें",
"ac_gallery": "गैलरी से चुनें",
"ac_removePhoto": "फ़ोटो हटाएँ",
"ac_cancel": "रद्द करें",
"ms_title": "और सेवाएँ",
"ms_sub": "कार और यात्रा की सारी सेवाएँ एक जगह",
"ms_towing": "वाहन टोइंग वैन",
"ms_towing_sub": "अपना वाहन सुरक्षित पहुँचाएँ",
"ms_school": "ड्राइविंग स्कूल",
"ms_school_sub": "प्रमाणित ट्रेनर से सीखें",
"ms_lease": "मासिक कार लीज़",
"ms_lease_sub": "ड्राइवर के साथ कार, मासिक अनुबंध",
"ms_tours": "टूर और पैकेज",
"ms_tours_sub": "ग्रुप और अकेले टूर की कीमतें",
"ms_wash": "घर पर कार धुलाई",
"ms_wash_sub": "घर के दरवाज़े पर धुलाई",
"ms_mechanic": "घर पर कार मैकेनिक",
"ms_mechanic_sub": "भरोसेमंद मैकेनिक आपके दरवाज़े पर",
"ms_accessories": "एक्सेसरीज़ फ़िटिंग",
"ms_accessories_sub": "एक्सेसरीज़ घर पर पहुँचाकर लगाते हैं",
"ms_soon": "जल्द आ रहा है",
"ms_noneYet": "आपके शहर में अभी कोई सेवा नहीं है - हमें कॉल करके अपनी ज़रूरत बताइए।",
"ms_soonText": "{service} जल्द ही आपके शहर में आ रहा है। पहले चाहिए? हमें कॉल करके अपनी ज़रूरत बताइए।",
"ms_callUs": "श्रामिक को कॉल करें",
"ms_close": "बंद करें",
"ms_footer": "और सेवाएँ जल्द · संपर्क करें: {email}",
"navHireDriver": "ड्राइवर",
"hs_title": "इतिहास",
"hs_active": "चालू",
"hs_past": "पिछले",
"hs_loading": "आपका इतिहास लोड हो रहा है…",
"hs_emptyTitle": "अभी कुछ नहीं है",
"hs_emptyText": "आपकी कार पूछताछ और यात्रा इतिहास यहाँ दिखेंगे।",
"hs_findCar": "कार खोजें",
"hs_activeEmpty": "अभी कुछ चालू नहीं है। आपकी पूछताछ यात्रा की तारीख तक यहाँ दिखेगी।",
"hs_pastEmpty": "यहाँ अभी कुछ नहीं है।",
"hs_filterAll": "सभी",
"hs_filterNone": "इस फ़िल्टर में कुछ नहीं है।",
"hs_signInTitle": "मेरा इतिहास",
"hs_signInText": "अपनी पूछताछ और यात्राएँ देखने के लिए साइन इन करें।",
"hs_signIn": "साइन इन करें",
"hs_rateTitle": "आपकी पिछली यात्रा कैसी रही?",
"hs_rateTap": "रेटिंग देने के लिए स्टार पर टैप करें",
"hs_rateLow": "हम आपका अनुभव बेहतर करने पर काम करेंगे",
"hs_rateMid": "आपकी राय के लिए धन्यवाद!",
"hs_rateHigh": "खुशी है कि आपकी यात्रा अच्छी रही!",
"hs_rateSubmit": "रेटिंग जमा करें",
"hs_rateLater": "बाद में",
"hs_rateHelps": "आपकी रेटिंग आगे की यात्राएँ बेहतर बनाती है।",
"hs_rateVerified": "आपका खाता अब श्रामिक से सत्यापित है!",
"hs_rateDriver": "ड्राइवर को रेट करें",
"hs_editRating": "रेटिंग बदलें",
"hs_chatDriver": "ड्राइवर से चैट",
"hs_paid": "भुगतान: ₹{amt}",
"hs_stBooked": "बुक हुआ",
"hs_stNotBooked": "बुक नहीं हुआ",
"hs_stDeciding": "अभी तय नहीं",
"hs_stContacted": "ड्राइवर से संपर्क हुआ",
"hs_stSent": "पूछताछ भेजी गई",
"hs_oneWay": "एक तरफ़ा",
"hs_roundTrip": "राउंड ट्रिप",
"hs_enquiry": "पूछताछ",
"hs_callName": "{name} को कॉल करें",
"hs_callDriver": "ड्राइवर को कॉल करें",
"hs_askBooked": "क्या आपने यह यात्रा बुक की?",
"hs_yes": "हाँ",
"hs_no": "नहीं",
"hs_notYet": "अभी नहीं",
"hs_saveFailedRow": "सेव नहीं हुआ - पूछताछ खोलकर फिर कोशिश करें।",
"hs_saidBooked": "आपने बताया कि आपने यह बुक किया",
"hs_saidNot": "आपने बताया कि आपने यह बुक नहीं किया",
"hs_saidDeciding": "आपने बताया कि आप अभी तय कर रहे हैं",
"hs_details": "विवरण",
"hs_sheetTitle": "यात्रा पूछताछ",
"hs_pickup": "पिकअप",
"hs_drop": "ड्रॉप",
"hs_tripType": "यात्रा का प्रकार",
"hs_distTime": "दूरी / समय",
"hs_vehicle": "वाहन",
"hs_partner": "पार्टनर",
"hs_enquiryMade": "पूछताछ की तारीख",
"hs_timesCalled": "कितनी बार कॉल किया",
"hs_quoted": "आपको बताई गई कीमत",
"hs_quotedNote": "पूछताछ के समय दिखाई गई कीमत। अंतिम किराया पार्टनर से तय करें।",
"hs_whatHappened": "क्या हुआ",
"hs_tlCreated": "पूछताछ बनी",
"hs_tlViewed": "आपने {car} देखी",
"hs_tlShared": "नंबर दिया गया",
"hs_tlSharedNote": "पार्टनर का नंबर आपको दिखाया गया",
"hs_tlCalled": "आपने पार्टनर को कॉल किया",
"hs_tlCalls": "कुल {n} कॉल",
"hs_tlAnswered": "आपने जवाब दिया",
"hs_youBooked": "आपने यह यात्रा बुक की",
"hs_youNot": "आपने यह यात्रा बुक नहीं की",
"hs_youDeciding": "आप अभी तय कर रहे थे",
"hs_changeAnswer": "जवाब बदलें",
"hs_noMoreChanges": "अब और बदलाव नहीं हो सकता",
"hs_changesLeft": "बचे बदलाव: {n}",
"hs_changeYour": "अपना जवाब बदलें",
"hs_askWhy": "इससे हम आपको बेहतर कैब दिखा पाते हैं - और ड्राइवर को पता चलता है कि उनकी लिस्टिंग काम आई।",
"hs_ansYes": "हाँ, बुक किया",
"hs_ansNo": "नहीं, नहीं किया",
"hs_keep": "मेरा जवाब रहने दें",
"hs_saveErr": "सेव नहीं हुआ। फिर कोशिश करें।",
"hs_callAgain": "{name} को फिर कॉल करें",
"hs_callPartner": "पार्टनर को कॉल करें",
"hs_hrs": "{n} घंटे",
"hs_close": "बंद करें",
"hs_yourRequest": "आपका अनुरोध",
"hs_passengers": "यात्री: {n}",
"hs_luggage": "सामान: {n}",
"hs_noLuggage": "सामान नहीं",
"hs_helpEnquiry": "इस पूछताछ में मदद चाहिए? श्रामिक को कॉल करें",
"lp_route": "पिकअप और ड्रॉप",
"lp_lblPickup": "पिकअप लोकेशन",
"lp_lblDrop": "ड्रॉप लोकेशन",
"lp_cityLine": "शहर: {city}",
"lp_change": "बदलें",
"lp_sameAsDrivers": "ड्राइवर वाली ही यात्रा?",
"lp_sameAsCars": "गाड़ी वाली ही यात्रा?",
"lp_sameYes": "हाँ, यही लें",
"lp_sameNo": "नहीं, नई यात्रा",
"lp_swap": "पिकअप और ड्रॉप बदलें",
"lp_when": "कब",
"lp_pickupWhen": "पिकअप",
"lp_returnWhen": "वापसी",
"lp_today": "आज",
"lp_tomorrow": "कल",
"lp_sameDay": "उसी दिन",
"lp_nextDay": "अगले दिन",
"lp_otherDate": "दूसरी तारीख",
"lp_pickTime": "समय चुनें",
"lp_distanceLine": "लगभग {km} किमी · {time}",
"lp_hrMin": "{h} घं {m} मि",
"lp_minOnly": "{m} मि",
"lp_stillNeeded": "अभी चाहिए: {list}",
"lp_noteLabel": "ड्राइवर के लिए नोट",
"lp_noteHint": "यह आपकी पूछताछ के साथ ड्राइवर को दिखेगा।",
"pricesPerCarNote": "हर कार के दाम अलग होते हैं। देखने या बदलने के लिए अपनी कार खोलें।",
"changeMyPrices": "मेरे दाम बदलें",
"lp_btnAddStop": "+ स्टॉप जोड़ें",
"lp_btnDetectLocation": "📍 लोकेशन पता करें",
"lp_btnDetecting": "पता लगा रहे हैं…",
"lp_btnViewCabs": "कैब देखें",
"lp_btnViewDrivers": "ड्राइवर देखें",
"lp_btnViewDrivers": "ड्राइवर देखें",
"lp_btnCompleteDetails": "यात्रा विवरण पूरा करें",
"lp_tabRoundTrip": "राउंड ट्रिप",
"lp_tabOneWay": "ड्रॉपिंग",
"lp_tripDetails": "यात्रा विवरण",
"lp_hireDetails": "यात्रा विवरण",
"lp_tripPreferencesOptional": "यात्रा प्राथमिकताएँ (वैकल्पिक)",
"lp_lblPickupCity": "पिकअप शहर",
"lp_phTypeCity": "शहर टाइप करें",
"lp_lblExactLocation": "सटीक लोकेशन",
"lp_phPrecisePickup": "सटीक पिकअप स्थान दर्ज करें",
"lp_lblPickupSchedule": "पिकअप शेड्यूल",
"lp_phStop": "स्टॉप {n}",
"lp_lblFinalDestination": "अंतिम गंतव्य",
"lp_phDropLocation": "ड्रॉप लोकेशन दर्ज करें",
"lp_lblReturnSchedule": "रिटर्न शेड्यूल",
"lp_lblDropSchedule": "ड्रॉप ऑफ करने का समय",
"lp_hintOneWayReturnCost": "आपको और आपकी गाड़ी को छोड़ने के बाद ड्राइवर अपने आप वापस जाता है। उस वापसी का खर्च इस किराए में शामिल नहीं है - कृपया कॉल पर ड्राइवर से सीधे तय करें।",
"lp_lblPassengers": "आपके ग्रुप में यात्री",
"lp_subLblGroupCab": "आपका ग्रुप पूरी कैब बुक करता है",
"lp_lblLuggage": "सामान",
"lp_lblStops": "स्टॉप",
"lp_errSameLocation": "पिकअप और ड्रॉप एक ही लोकेशन नहीं हो सकते",
"lp_errReturnTooEarly": "{from} से {to} तक लगभग {hours} घंटे लगते हैं - कृपया बाद का रिटर्न समय चुनें",
"lp_backHomeBy": "घर लौटने का समय",
"lp_errBackTooEarly": "{from} से {to} जाकर लौटने में लगभग {hours} घंटे लगते हैं - कृपया बाद का समय चुनें",
"lp_hintCalculatingRoute": "रूट कैलकुलेट हो रहा है…",
"lp_phNote": "उदा. मुझे बेबी सीट, पेट फ्रेंडली कैब चाहिए...",
"lp_promoRoundTrip": "राउंड ट्रिप या मल्टी-स्टॉप?",
"lp_promoMoreStops": "अपनी यात्रा की योजना के लिए और स्टॉप जोड़ें।",
"lp_toastLocSuccess": "लोकेशन मिल गया ✅",
"lp_toastLocDeny": "इस सुविधा के लिए अपने ब्राउज़र में लोकेशन एक्सेस की अनुमति दें",
"lp_errMissingFields": "अनिवार्य फ़ील्ड गायब हैं: {list}",
"lp_errCity": "कृपया एक शहर चुनें।",
"lp_errPickupDt": "कृपया पिकअप तारीख और समय चुनें।",
"lp_errPickupTimeLimit": "पिकअप समय अभी से कम से कम 30 मिनट बाद होना चाहिए।",
"lp_errReturnDt": "कृपया रिटर्न/समाप्ति तारीख और समय चुनें।",
"lp_errReturnTimeLimit": "रिटर्न समय पिकअप समय के बाद होना चाहिए।",
"lp_errReturnMaxLimit": "रिटर्न तारीख पिकअप से 10 दिनों के भीतर होनी चाहिए",
"lp_errPickupLoc": "कृपया अपना पिकअप लोकेशन दर्ज करें।",
"lp_errPickupRadius": "कृपया {city} के {km} किमी के भीतर लोकेशन चुनें।",
"lp_errDestLoc": "कृपया अपना गंतव्य दर्ज करें।",
"lp_errDestRadius": "कृपया अपने पिकअप से 1000 किमी के भीतर गंतव्य चुनें।",
"lp_errStopValid": "कृपया सुझावों में से एक स्टॉप चुनें।",
"lp_errStopRadius": "कृपया अपने पिकअप से 1000 किमी के भीतर स्टॉप चुनें।",
"awaitingDriverResponse": "ड्राइवर के जवाब का इंतज़ार",
"driverConnected": "ड्राइवर से जुड़े",
"driverAccepted": "ड्राइवर ने स्वीकार किया",
"tripConfirmed": "यात्रा पक्की हुई",
"rideStarted": "यात्रा शुरू हुई",
"rideCompleted": "यात्रा पूरी हुई",
"connectionFeePaid": "कनेक्शन शुल्क दिया गया",
"waitingForPickup": "पिकअप का इंतज़ार",
"manageTrip": "यात्रा संभालें",
"tripType": "यात्रा का प्रकार",
"createdOn": "बनाने की तारीख",
"currentStatus": "मौजूदा स्थिति",
"connectionFee": "कनेक्शन शुल्क",
"estimatedFare": "अनुमानित किराया",
"tripId": "यात्रा आईडी",
"actualDriverName": "ड्राइवर का असली नाम",
"waitingForDriverAcceptance": "ड्राइवर के स्वीकार करने का इंतज़ार",
"vehicleName": "गाड़ी का नाम",
"vehicleDetailsAvailableAfter": "ड्राइवर की पुष्टि के बाद गाड़ी की जानकारी दिखेगी।",
"paidUsingWallet": "वॉलेट से भुगतान किया",
"paidUsingCredit": "1 मुफ़्त कॉल क्रेडिट इस्तेमाल हुआ",
"finalFareConfirmedDirectly": "अंतिम किराया आपके और ड्राइवर के बीच सीधे तय होता है।",
"tripTimeline": "यात्रा के चरण",
"contactSupport": "श्रामिक सहायता से संपर्क करें",
"needHelp": "मदद चाहिए?",
"upcomingTrips": "आने वाली",
"previousTrips": "पिछली",
"connectingIvrCall": "श्रामिक आईवीआर से आपकी कॉल जोड़ रहे हैं। हमारे सिस्टम की कॉल आने तक रुकें।",
"callConnectionFailed": "कॉल नहीं जुड़ सकी।",
"callError": "कॉल शुरू नहीं हो सकी।",
"pickupAddress": "????? ???",
"destination": "गंतव्य",
"vehicleNumber": "गाड़ी नंबर",
"callHistory": "कॉल इतिहास",
"callDriverToBook": "??????? ?? ??? ????",
"loadingCalls": "कॉल ला रहे हैं…",
"noCallsMade": "अभी तक कोई कॉल नहीं की गई।",
    "completeProfile": "अपनी प्रोफ़ाइल पूरी करें",
    "sramikaWallet": "श्रामिक वॉलेट",
    "walletBalance": "वॉलेट बैलेंस",
    "viewWallet": "वॉलेट देखें",
    "walletAvailableBalance": "उपलब्ध शेष राशि",

    "walletRemaining": "बचे हैं",
    "walletInfoTitle": "यह वॉलेट सिर्फ़ उन कॉल के लिए है जिन्हें श्रामिक आपके लिए जोड़ता है।",
    "walletInfo1": "इस वॉलेट में जोड़े गए पैसे वापस नहीं निकाले जा सकते।",
    "walletInfo2": "हर {hours} घंटे में {free} कॉल फ्री हैं। उसके बाद हर जुड़ी हुई कॉल ₹{fee} की है; कॉल न जुड़े तो कुछ नहीं कटता।",
    "walletAddMoney": "पैसे जोड़ें",
    "walletEnterAmount": "राशि दर्ज करें",
    "walletRecharge": "वॉलेट रिचार्ज करें",
    "walletProcessing": "प्रसंस्करण हो रहा है...",
    "walletNoTxns": "अभी तक कोई वॉलेट लेनदेन नहीं।",
    "walletNoTxnsSub": "जोड़े गए पैसे और कॉल शुल्क यहाँ दिखेंगे।",
    "walletTxnRecharge": "रिचार्ज",
    "walletTxnServiceFee": "कनेक्शन शुल्क",
    "walletTxnRefund": "वापसी",
    "callDriverToBook": "ड्राइवर को कॉल करके बुक करें","getDriversNumber": "ड्राइवर का नंबर पाएं","appName": "श्रामिक",
    "appSubtitle": "नज़दीकी कार ट्रैवल्स",
    "loginCta": "लॉगिन / शामिल हों",
    "findTaxiBy": "Sahi taxi dhoondhein",
    "from": "कहाँ से",
    "to": "कहाँ तक",
    "nearbyCars": "Paas ke best rated cars",
    "accountTitle": "मेरी प्रोफ़ाइल",
    "bookings": "इतिहास",
    "notifications": "नोटिफिकेशन्स",
    "support": "सपोर्ट",
    "settings": "सेटिंग्स",
    "logout": "लॉगआउट",
    "loginSignup": "लॉगिन / साइनअप",
    "noBookings": "Abhi tak koi booking nahi.",
    "startBooking": "Trusted local cabs book karein",
    "faqTitle": "सामान्य प्रश्न",
    "callSupport": "सपोर्ट को कॉल करें",
    "language": "भाषा",
    "fareCalculator": "किराया कैलकुलेटर",
    "terms": "नियम और शर्तें",
    "privacy": "गोपनीयता नीति",
    "manageProfile": "Apna profile manage karein",
    "mobileNumber": "मोबाइल नंबर",
    "username": "यूज़रनेम",
    "preferredCity": "पसंदीदा शहर",
    "referFriend": "दोस्त को रेफ़र करें",
    "comingSoon": "जल्द आ रहा है",
    "cabOwnerProfile": "ड्राइवर प्रोफाइल",
    "editCabOwnerProfile": "ड्राइवर की जानकारी बदलें",
    "accountActions": "अकाउंट एक्शन्स",
    "save": "बदलाव सेव करें",
    "edit": "बदलें",
    "verified": "सत्यापित",
    "notEditable": "Edit nahi kar sakte",
    "myRating": "Meri Rating",
    "notSet": "Set nahi hai",
    "upcoming": "आने वाली",
    "previous": "Pichli",
    "noUpcomingTrips": "Koi upcoming trip nahi.",
    "noPreviousTrips": "Koi pichli trip nahi.",
    "bookRide": "Ride Book Karein",
    "signIn": "Sign In Karein",
    "viewBookings": "Bookings Dekhein",
    "personalDetails": "Personal Jaankari",
    "location": "स्थान",
    "emergencyContact": "Emergency Contact",
    "vehicleOptions": "Gaadi ke Options",
    "tripTypesOffered": "Trip Types",
    "pricing": "दाम",
    "weeklyAvailability": "Weekly Schedule",
    "kycLocked": "KYC Details lock hain",
    "kycLockedDesc": "Naam, mobile, DL aur vehicle details yahan nahi badal sakte. Support se contact karein.",
    "verifiedInfo": "Verified Jaankari",
    "gender": "लिंग",
    "languagesSpoken": "बोली जाने वाली भाषाएँ",
    "bio": "छोटा परिचय",
    "address": "पता",
    "pincode": "पिनकोड",
    "contactName": "Contact ka Naam",
    "contactPhone": "Contact Phone",
    "acAvailable": "एसी उपलब्ध है",
    "wallet": "वॉलेट",
    "recentSearches": "Recent Searches",
    "home": "होम",
    "navCars": "कारें",
    "nearbyHireDrivers": "आस-पास के हायर ड्राइवर",
    "city": "शहर",
    "onb_skip": "छोड़ें",
    "onb_getStarted": "शुरू करें",
    "onb_p1_sign": "आस-पास की कारें",
    "onb_p1_title": "आस-पास के ड्राइवरों को खोजें",
    "onb_p1_sub": "सीधे आस-पास के ड्राइवरों से जुड़ें।",
    "onb_p1_badge": "कैब खातों के लिए 0% कमीशन",
    "onb_p2_sign": "आस-पास के अल्टींग ड्राइवर",
    "onb_p2_title": "आस-पास के निजी ड्राइवरों को किराए पर लें",
    "onb_p2_sub": "सीधे आस-पास के ड्राइवरों से जुड़ें।",
    "onb_p2_badge": "ड्राइवरों के लिए 0% कमीशन",
    "onb_p3_sign": "हम आपको भरोसेमंद लोगों से जोड़ते हैं",
    "onb_p3_title": "चुनने में मदद चाहिए?",
    "onb_p3_sub": "हमारी सहायता टीम आपको सही ड्राइवर से जोड़ सकती है।",
    "onb_p3_badge": "सहायता सेवा के लिए 0% कमीशन",
    "onb_p4_sign1": "कैब किराए पर लें",
    "onb_p4_sign2": "ड्राइवर किराए पर लें",
    "onb_p4_sign3": "अधिक सेवाएं",
    "onb_p4_title": "आपकी ज़रूरत की हर चीज़ एक जगह",
    "onb_p4_sub": "कैब और ड्राइवर किराए पर लें और अधिक यात्रा सेवाएं खोजें।",
    "onb_p4_badge": "अन्य सेवाओं पर 0% कमीशन",
    "onb_p5_sign": "एक ऐप। कई यात्रा सेवाएं।",
    "onb_p5_title": "आइए शुरू करें",
    "onb_p5_sub": "आस-पास की सेवाओं के साथ समझदारी से यात्रा करें।",
    "onb_p5_badge": "हमेशा 0% कमीशन",
    "onb_lang_title": "आपकी भाषा में, आपकी सुविधा के लिए",
    "onb_lang_sub": "सामग्री आपकी स्थानीय भाषा में दिखाई जाएगी।",
    "onb_footer": "स्थानीय सहायता। स्थानीय भाषा। बेहतर अनुभव।",
    "onb_language": "भाषा",
    "onb_intentTagline": "आस-पास की कैब और ड्राइवर",
    "onb_intentTitle": "आप श्रामिक का उपयोग कैसे करना चाहते हैं?",
    "onb_intentSub": "आगे बढ़ने के लिए एक विकल्प चुनें",
    "onb_intentRide": "कैब और ड्राइवर खोजें",
    "onb_intentRideSub": "लोकल या आउटस्टेशन कैब बुक करें, या अपनी कार के लिए ड्राइवर रखें।",
    "onb_intentEarn": "क्या आप श्रामिक के साथ कमाना चाहते हैं?",
    "onb_intentCab": "कैब अकाउंट के रूप में जुड़ें",
    "onb_intentCabSub": "अपनी कैब रजिस्टर करें और ग्राहकों से सीधे कॉल पाएँ।",
    "onb_intentDriver": "हायर ड्राइवर के रूप में जुड़ें",
    "onb_intentDriverSub": "कार की ज़रूरत नहीं। ग्राहकों की कार चलाएँ, घंटे या दिन के हिसाब से कमाएँ।",
    // The /join page for ads (Oct 2026).
    "join_title": "श्रामिक के साथ कमाएँ",
    "join_subShort": "ग्राहक सीधे आपको कॉल करते हैं।",
    "join_codeLine": "कोड {code} · मंज़ूरी पर ₹{amount}",
    "join_codeOnly": "कोड {code}",
    "join_car": "मेरे पास कार है",
    "join_carNeed": "लाइसेंस, आरसी, कार की फ़ोटो · 15 मिनट",
    "join_drv": "ड्राइविंग आती है, कार नहीं",
    "join_drvNeed": "लाइसेंस, फ़ोटो, आपके रेट · 10 मिनट",
    "join_needACar": "कार चाहिए?",
    "join_seeCarsShort": "कारें देखें",
    "onb_skipForNow": "अभी छोड़ें",
    "noCabsFoundFor": "के लिए कोई कैब नहीं मिली",
    "tryDifferentSearch": "कोई अन्य खोज आज़माएं या इन सुझावों का उपयोग करें:",
    "sramikaComingTo": "श्रामिक आ रहा है",
    "onboardingDriversIn": "हम ड्राइवर जोड़ रहे हैं",
    "beTheFirstToKnow": ". हमारे लॉन्च होने पर सबसे पहले जानने वाले बनें।",
    "expectedLaunch": "संभावित लॉन्च",
    "yourName": "आपका नाम",
    "whatsappNumber": "व्हाट्सऐप नंबर (10 अंक)",
    "notifyViaWhatsapp": "लॉन्च होने पर हम आपको व्हाट्सऐप के माध्यम से सूचित करेंगे",
    "joining": "शामिल हो रहे हैं...",
    "onTheList": "आप सूची में हैं!",
    "goBackHome": "होम पर वापस जाएं",
    "noDriversIn": "में कोई ड्राइवर उपलब्ध नहीं है:",
    "driverNetworkExpanding": "हमारा सत्यापित ड्राइवर नेटवर्क तेजी से बढ़ रहा है। इस शहर में पहले ड्राइवर पार्टनर बनें और राइड अनुरोध प्राप्त करना शुरू करें।",
    "registerAsDriver": "ड्राइवर के रूप में रजिस्टर करें",
    "learnMore": "और जानें",
    "noCabsIn": "में कोई कैब उपलब्ध नहीं है:",
    "cabNetworkExpanding": "हमारा प्रीमियम नेटवर्क तेजी से बढ़ रहा है। इस शहर में हमारी विशेष सेवाएं शुरू करने वाले पहले भागीदार बनें और आज ही कमाई शुरू करें।",
    "joinAsPartner": "पार्टनर के रूप में जुड़ें",
    "exploreCities": "शहर खोजें",
    "newDriver": "नया ड्राइवर",
    "startsFrom": "शुरुआती कीमत",
    "contactDriver": "ड्राइवर से संपर्क करें",
    "hireDriverTitle": "ड्राइवर हायर करें",
    "driverWillCome": "ड्राइवर आपके स्थान पर आएगा",
    "date": "तारीख",
    "time": "समय",
    "duration": "अवधि",
    "yourCarType": "आपकी कार का प्रकार",
    "pickupAddress": "पिकअप का पता",
    "yourPhone": "आपका फोन",
    "tripPurpose": "यात्रा का उद्देश्य (वैकल्पिक)",
    "youPayDriverDirectly": "आप सीधे ड्राइवर को भुगतान करते हैं। श्रामिक कोई कमीशन नहीं लेता।",
    "rateDriver": "ड्राइवर को रेट करें",
    "howWasExperience": "आपका अनुभव कैसा रहा?",
    "shortReview": "संक्षिप्त समीक्षा (वैकल्पिक)",
    "callDriver": "ड्राइवर को कॉल करें",
    "filter": "फ़िल्टर",
    "loadingRequests": "अनुरोध लोड हो रहे हैं...",
    "driverWillReview": "ड्राइवर आपके अनुरोध की समीक्षा करेगा और जल्द ही जवाब देगा।",
    "dismiss": "खारिज करें",
    "thankYouFeedback": "आपके फीडबैक के लिए धन्यवाद। यह अन्य ग्राहकों की मदद करता है।",
    "selectCityHire": "अपने आस-पास ड्राइवर हायर करने के लिए शहर चुनें",
    "findingDriversIn": "में ड्राइवर खोज रहे हैं",
    "clearAll": "सभी साफ़ करें",
    "areYouDriver": "क्या आप ड्राइवर हैं?",
    "registerAsHireDriver": "सूचीबद्ध होने के लिए हायर ड्राइवर के रूप में रजिस्टर करें",
    "join": "शामिल हों",
    "fareCalculatorTitle": "किराया कैलकुलेटर",
    "distanceLabel": "दूरी",
    "durationLabel": "अवधि",
    "booked": "बुक किया गया",
    "estimatedFareLabel": "अनुमानित किराया",
    "advanceAlreadyPaid": "अग्रिम भुगतान किया जा चुका है",
    "payToDriverLabel": "ड्राइवर को भुगतान करें",
    "noTripDetails": "कोई यात्रा विवरण नहीं मिला।",
    "goHome": "होम पर जाएं",
    "earnCommissionBooking": "इस बुकिंग पर कमीशन कमाएं",
    "customerNameReq": "ग्राहक का नाम *",
    "customerPhoneReq": "ग्राहक का फ़ोन *",
    "yourCab": "आपकी कैब",
    "paymentSummary": "भुगतान सारांश",
    "cabFare": "कैब का किराया",
    "totalTripCost": "कुल यात्रा लागत",
    "payNowLabel": "अभी भुगतान करें:",
    "advance10Percent": "अग्रिम (कैब किराए का 10%)",
    "balanceToDriver": "ड्राइवर को देय शेष",
    "selectPaymentMethod": "भुगतान विधि चुनें",
    "howItWorks": "यह कैसे काम करता है",
    "advanceFullyRefunded": "अग्रिम पूरी तरह से वापस",
    "advanceNonRefundable": "अग्रिम वापसी योग्य नहीं",
    "additionalChargesActuals": "अतिरिक्त शुल्क वास्तविक के अनुसार",
    "profilePhoto": "प्रोफ़ाइल फ़ोटो",
    "startTrip": "यात्रा शुरू करें",
    "endTrip": "यात्रा समाप्त करें",
    "finalDistance": "अंतिम दूरी",
    "fareBreakdown": "किराया विवरण",
    "totalDuration": "कुल अवधि",
    "withdrawalUnlock": "निकासी अनलॉक",
    "quickWins": "त्वरित लाभ:",
    "yourTrustedCabPartner": "आपका भरोसेमंद कैब पार्टनर",
    "usernameOrMobile": "यूज़रनेम या मोबाइल",
    "password": "पासवर्ड",
    "expired": "समाप्त",
    "withdrawToUpi": "यूपीआई में निकालें",
    "minPtsWallet": "न्यूनतम 300 अंक वॉलेट में रहने चाहिए",
    "availableToWithdraw": "निकालने के लिए उपलब्ध",
    "upiId": "यूपीआई आईडी",
    "amountRupees": "राशि (₹)",
    "bookingId": "बुकिंग आईडी",
    "lifetimeEarned": "आजीवन कमाई",
    "withdrawable": "निकालने योग्य",
    "useOnRide": "सवारी पर उपयोग करें",
    "recentActivity": "हाल की गतिविधि",
    "seeAll": "सभी देखें",
    "withdrawalLocked": "निकासी लॉक की गई",
    "transactionHistory": "लेनदेन इतिहास",
    "noTransactionsYet": "अभी तक कोई लेनदेन नहीं",
    "platformDisclaimer": "श्रामिक एक प्रौद्योगिकी मंच है। परिवहन सेवाएं स्वतंत्र ऑपरेटरों द्वारा प्रदान की जाती हैं।",
    "topRated": "टॉप रेटेड",
    "newPartner": "श्रामिक पर नया",
    "nearby": "नज़दीक",
    "luxury": "लक्ज़री",
    "familyTrip": "पारिवारिक यात्रा",
    "fastBooking": "फ़ास्ट बुकिंग",
    "matched": "मैच किया गया",
    "estPrice": "अनुमानित मूल्य",
    "baseRateLabel": "मूल दर",
    "recentSearchesLabel": "हाल की खोजें",
    "anyCab": "कोई भी कैब",
    "trip": "यात्रा",
    "trips": "यात्राएं",
    "selectCity": "शहर चुनें",
    "detecting": "पता लगा रहा है...",
    "detectLocation": "स्थान का पता लगाएं",
    "typeCityName": "शहर का नाम टाइप करें...",
    "filters": "फ़िल्टर",
    "select": "चुनें",
    "bioHint": "यात्रियों को अपने बारे में थोड़ा बताएं",
    "searchCity": "शहर खोजें...",
    "selectCity2": "शहर चुनें",
    "findRightTaxi": "सही टैक्सी खोजें",
    "lastBooked": "पिछली बुकिंग:",
    "more": "+ और",
    "hireDriver": "ड्राइवर हायर करें",
    "services": "सेवाएं",
    "account": "खाता",
    "findRightDriver": "सही ड्राइवर खोजें",
    "searchCabPlaceholder": "कैब, मॉडल, क्षेत्र खोजें...",
    "searchDriverPlaceholder": "ड्राइवर, क्षेत्र, भाषा, अनुभव खोजें...",
    "myHireRequests": "मेरे ड्राइवर अनुरोध",
    "driverCanSpeakLanguages": "ड्राइवर ये भाषाएँ बोल सकते हैं",
    "referenceFare": "संदर्भ किराया",
    "callDriver": "ड्राइवर को कॉल करें",

    "driverDiscountLabel": "छूट",
    "connecting": "कनेक्ट हो रहा है...",

    "mockCallConnecting": "मॉक टेलीफोनी के माध्यम से ड्राइवर को कॉल कनेक्ट किया जा रहा है...",
    "mockCallError": "कॉल कनेक्ट नहीं हो सका।",
    "callInitiationError": "कॉल आरंभ करने में त्रुटि।",


    "callbackInitiationError": "कॉल बैक का अनुरोध करने में त्रुटि।",
    "bookNowToGetContact": "संपर्क प्राप्त करने के लिए अभी बुक करें",
    "regularPrice": "नियमित मूल्य",
    "typicalFareTooltip": "A typical fare for this route, based on local rates. Partners set their own prices independently.", // TODO: Hindi translation pending.
    "partnersPrice": "ड्राइवर का किराया", // TODO: Hindi translation pending.
    "priceHistory": "दामों का इतिहास", // TODO: Hindi translation pending.
    "increaseAvailableNow": "अब आप दाम बढ़ा सकते हैं", // TODO: Hindi translation pending.
    "nextIncreaseAt": "अगली बार दाम {{time}} के बाद बढ़ा सकते हैं", // TODO: Hindi translation pending.
    "noPriceChangesYet": "अभी तक कोई दाम नहीं बदला", // TODO: Hindi translation pending.
    "loadingHistory": "इतिहास ला रहे हैं…", // TODO: Hindi translation pending.
    "changeIncrease": "बढ़ोतरी", // TODO: Hindi translation pending.
    "changeDecrease": "कमी", // TODO: Hindi translation pending.
    "changeMixed": "कुछ बढ़े, कुछ घटे", // TODO: Hindi translation pending.
    "noFieldsChanged": "कोई जानकारी नहीं बदली।", // TODO: Hindi translation pending.
    "typicalFareLabel": "सामान्य किराया ₹{value}",
    "lessThanTypicalFare": "सामान्य किराए से ₹{amount} कम",
    "partnerOfferedPrice": "पार्टनर मूल्य",
    "partnerPricePrefix": "मूल्य",
    "estimatedAmount": "अनुमानित राशि",
    "estimatedAmountCaption": "वास्तविक यात्रा, टोल, पार्किंग या मार्ग परिवर्तन के आधार पर अंतिम राशि बदल सकती है।",
    "extrasNote": "Toll, border/state taxes and parking (if any) are extra and paid directly to the driver.", // TODO: pending
    "youSaveComparedToRegular": "सामान्य मूल्य की तुलना में।",
    "payDirectlyToPartner": "यात्रा भागीदार के साथ अपनी यात्रा की पुष्टि करने के बाद ही भुगतान करें।",
    "chargesDuringTrip": "यात्रा के दौरान शुल्क",
    "whyChooseSramika": "ग्राहक श्रामिक को क्यों चुनते हैं",
    "verifiedTravelPartners": "Trusted travel partners", // TODO: pending
    "transparentPricing": "पारदर्शी मूल्य निर्धारण",
    "directCommunication": "सीधा भागीदार संपर्क",
    "noBookingCommission": "कोई बुकिंग कमीशन नहीं",
    "secureBookingExperience": "सुरक्षित बुकिंग अनुभव",
    "youSavePrefix": "आप बचाते हैं",
    "saveBadge": "बचत",
    "savingsBasedOnPartnerPrice": "भागीदार मूल्य निर्धारण आपको अधिक बचाने में मदद करता है।",
    "licenseChecked": "Driving License Checked", // TODO: pending
    "bestOffer": "बेहतरीन ऑफर",
    "tripPriceDetails": "यात्रा मूल्य विवरण",
    "transparentPartnerPricing": "पारदर्शी भागीदार मूल्य निर्धारण",
    "noSramikaBookingCommission": "कोई श्रामिक बुकिंग कमीशन नहीं",
    "driverAllowance": "चालक भत्ता",
    "nightAllowance": "रात्रि भत्ता",
    "transparentPricingNoHidden": "पारदर्शी मूल्य निर्धारण - कोई छिपा शुल्क नहीं",
    "promoDiscount": "प्रोमो छूट",
    "sramikaDiscount": "श्रामिक छूट",
    "couponAppliedMsg": "कूपन लागू किया गया",
    "saveAmount": "बचाएं ",
    "removeAction": "निकालें",
    "applyAction": "लागू करें",
    "totalFare": "कुल किराया",
    "finalPriceLabel": "अंतिम मूल्य",
    "partnerOfferSuffix": " ऑफ़र",
    "legacyFareVary": "अंतिम किराया भिन्न हो सकता है यदि वास्तविक किलोमीटर या यात्रा अवधि में कोई परिवर्तन होता है।",
    "legacyTollsExcluded": "⚠️ **नोट:** टोल गेट, पार्किंग शुल्क और कोई सीमा/राज्य कर शुल्क इस किराए में **शामिल नहीं** हैं और अलग से लिए जाएंगे।",
    "estimateFareCalc1": "आप हमारे ",
    "pricingCalculator": "मूल्य निर्धारण कैलकुलेटर",
    "estimateFareCalc2": " का उपयोग करके किसी भी समय दूरी या समय में परिवर्तन के लिए अपने अपडेट किए गए किराए का अनुमान लगा सकते हैं।",
    "pickup": "पिकअप",
    "origin": "मूल",
    "destination": "गंतव्य",
    "oneWay": "एक तरफ़ा",
    "inclReturn": "वापसी सहित",
    "hrs": "घंटे",
    "estDuration": "अनुमानित अवधि",

    // Rating Modal
    "loadingRating": "ला रहे हैं…", // TODO: pending
    "updateRating": "रेटिंग बदलें", // TODO: pending
    "submitRating": "रेटिंग भेजें", // TODO: pending
    "tapAStar": "Tap a star", // TODO: pending
    "ratingPoor": "Poor", // TODO: pending
    "ratingFair": "Fair", // TODO: pending
    "ratingGood": "Good", // TODO: pending
    "ratingVeryGood": "Very Good", // TODO: pending
    "ratingExcellent": "Excellent", // TODO: pending
    "tellUsExperience": "अपना अनुभव बताएँ…", // TODO: pending
    "typicalFareBare": "Market Price", // TODO: pending
    "totalWithCharges": "Total with trip charges" // TODO: pending
  },
  "te": {
"rm_of": "{n} లో {yes}",
"rm_driverCame": "బుక్ చేసిన డ్రైవరే వచ్చారు",
"rm_carCame": "బుక్ చేసిన కారే వచ్చింది",
"rm_no": "కాదు",
"rm_yes": "అవును",
"rm_sameDriver": "మీరు బుక్ చేసిన డ్రైవరే వచ్చారా?",
"rm_sameCar": "మీరు బుక్ చేసిన కారే వచ్చిందా?",
"lg_brand": "శ్రామిక",
"tx_bonus": "బోనస్",
"tx_referralBack": "రెఫరల్ బహుమతి వెనక్కి తీసుకున్నారు",
"tx_referral": "రెఫరల్ బహుమతి",
"tx_welcome": "స్వాగత ఆఫర్",
"tx_failed": "చెల్లింపు విఫలమైంది",
"lc_offer": "ప్రత్యేక ఆఫర్",
"lh_ref": "నం.",
"cv_mpv": "ఎంపీవీ",
"ac_roleOwner": "డ్రైవర్",
"ac_roleAdmin": "అడ్మిన్",
"ac_roleSuper": "సూపర్ అడ్మిన్",
"ac_roleDriver": "డ్రైవర్",
"ac_roleAgent": "ఫీల్డ్ ఏజెంట్",
"ac_ownerCarsLeads": "నా కార్లు, లీడ్స్",
"od_title": "నా డ్రైవర్లు",
"od_list": "మీ కార్ల డ్రైవర్లు",
"od_add": "డ్రైవర్‌ని జోడించండి",
"od_addTitle": "కొత్త డ్రైవర్",
"od_name": "డ్రైవర్ పేరు",
"od_namePh": "ఉదా. రమేష్ కుమార్",
"od_licencePh": "ఉదా. AP09 2024 0012345",
"od_licPhoto": "లైసెన్స్ ఫోటో",
"od_photo": "డ్రైవర్ ఫోటో",
"od_choose": "ఫోటో ఎంచుకోండి",
"od_checkNote": "డ్రైవర్ కనిపించే ముందు శ్రామిక లైసెన్స్ చెక్ చేస్తుంది.",
"od_errName": "డ్రైవర్ పేరు ఇవ్వండి.",
"od_errPhone": "10 అంకెల మొబైల్ నంబర్ ఇవ్వండి.",
"od_errLicence": "లైసెన్స్ నంబర్ ఇవ్వండి.",
"od_errLicPhoto": "లైసెన్స్ ఫోటో జోడించండి.",
"od_errPhoto": "డ్రైవర్ ఫోటో జోడించండి.",
"od_addFail": "డ్రైవర్‌ని జోడించలేకపోయాం. మళ్ళీ ప్రయత్నించండి.",
"od_addBtn": "ఈ డ్రైవర్‌ని జోడించండి",
"od_adding": "జోడిస్తున్నాం…",
"od_loading": "మీ డ్రైవర్లను తెస్తున్నాం…",
"od_loadFail": "మీ డ్రైవర్లను తేలేకపోయాం.",
"od_pending": "ఆమోదం కోసం వేచి ఉంది",
"od_remove": "తీసివేయండి",
"od_removeAsk": "ఈ డ్రైవర్‌ని మీ లిస్ట్ నుండి తీసివేయాలా?",
"od_removeYes": "అవును, తీసివేయండి",
"od_removeFail": "డ్రైవర్‌ని తీసివేయలేకపోయాం. మళ్ళీ ప్రయత్నించండి.",
"od_emptyTitle": "ఇంకా డ్రైవర్లు లేరు",
"od_emptyText": "మీ కార్లు నడిపే డ్రైవర్లను జోడించండి.",
"ea_title": "ఖాతా వివరాలు మార్చండి",
"ea_note": "ఇవి నమోదు సమయంలో చెక్ చేసినవి. మార్పు శ్రామికకు వెళ్తుంది, ఆమోదం వచ్చాకే కనిపిస్తుంది.",
"ea_pendingTitle": "ఒక మార్పు ఆమోదం కోసం వేచి ఉంది",
"ea_pendingText": "మీరు పంపిన మార్పును శ్రామిక చెక్ చేస్తోంది. అది పూర్తయ్యాక ఇంకోటి పంపవచ్చు.",
"ea_sentTitle": "ఆమోదం కోసం పంపాం",
"ea_sentText": "శ్రామిక మార్పును ఆమోదించే వరకు మీ వివరాలు ఇప్పటిలాగే ఉంటాయి.",
"ea_toAccount": "నా ఖాతాకు వెళ్ళండి",
"ea_loadFail": "మీ ఖాతా వివరాలు తేలేకపోయాం.",
"ea_sendFail": "మీ మార్పు పంపలేకపోయాం. మళ్ళీ ప్రయత్నించండి.",
"ea_phoneLocked": "ధృవీకరించిన నంబర్ మార్చాలంటే శ్రామికకు కాల్ చేయండి.",
"ea_blood": "రక్త గ్రూపు",
"ea_select": "ఎంచుకోండి",
"ea_contact": "చిరునామా మరియు అత్యవసర కాంటాక్ట్",
"ea_ap": "ఆంధ్రప్రదేశ్",
"ea_tg": "తెలంగాణ",
"ea_emName": "అత్యవసర కాంటాక్ట్ పేరు",
"ea_emPhone": "అత్యవసర కాంటాక్ట్ నంబర్",
"ea_driving": "డ్రైవింగ్",
"ea_aadhaar": "ఆధార్ నంబర్",
"ea_licence": "డ్రైవింగ్ లైసెన్స్ నంబర్",
"ea_bank": "బ్యాంక్ వివరాలు",
"ea_accName": "ఖాతాదారు పేరు",
"ea_accNo": "ఖాతా నంబర్",
"ea_ifsc": "ఐఎఫ్‌ఎస్‌సీ కోడ్",
"ea_send": "ఆమోదం కోసం పంపండి",
"pe_saved": "మీ వివరాలు సేవ్ అయ్యాయి.",
"pe_saveFail": "సేవ్ కాలేదు. మళ్ళీ ప్రయత్నించండి.",
"pe_loading": "మీ వివరాలు తెస్తున్నాం…",
"pe_loadFail": "మీ వివరాలు తేలేకపోయాం.",
"pe_checked": "నమోదు సమయంలో చెక్ చేసినవి",
"pe_car": "కారు",
"pe_lockedText": "ఇవి మార్చాలంటే శ్రామికకు కాల్ చేయండి - ముందు మళ్ళీ చెక్ చేస్తాం.",
"pe_about": "మీ గురించి",
"pe_business": "బిజినెస్ పేరు (ఉంటే)",
"pe_businessHint": "ఖాళీగా వదిలేస్తే మీ పేరే కనిపిస్తుంది.",
"pe_businessPh": "ఉదా. శ్రీ సాయి ట్రావెల్స్",
"pe_other": "ఇతర",
"pe_langs": "మీరు మాట్లాడే భాషలు",
"pe_bio": "మీ గురించి కొన్ని మాటలు",
"pe_bioHint": "కస్టమర్లకు మీ గురించి కొంచెం చెప్పండి.",
"pe_bioApproval": "ఇక్కడ రాసిన కొత్త మాటలను కస్టమర్లకు చూపించే ముందు శ్రామిక చెక్ చేస్తుంది.",
"pe_bioSent": "సేవ్ అయింది. శ్రామిక ఆమోదించాక మీ కొత్త మాటలు కనిపిస్తాయి.",
"pe_bioWaiting": "సేవ్ అయింది. మీ కొత్త మాటలు ఆగాయి - మీ మరో మార్పు శ్రామిక దగ్గర ఉంది.",
"pe_bioPending": "ఆమోదం కోసం: “{bio}”",
"pe_bioPh": "ఉదా. 8 సంవత్సరాలుగా డ్రైవింగ్, విజయవాడ - హైదరాబాద్ రూట్ బాగా తెలుసు.",
"pe_pincode": "పిన్‌కోడ్",
"pe_phonePh": "10 అంకెల మొబైల్ నంబర్",
"pe_carTrips": "మీ కారు మరియు ట్రిప్‌లు",
"pe_personalText": "మీ చిరునామా, భాషలు, లింగం, అత్యవసర కాంటాక్ట్ {account} → {edit} లో మార్చండి. శ్రామిక ముందు ఆ మార్పును చెక్ చేస్తుంది.",
"pe_personalBtn": "నా వివరాలు మార్చండి",
"pe_acPerCar": "ఏసీ ప్రతి కారుకు విడిగా {myCars} లో సెట్ చేయండి.",
"pe_moreCars": "+{n} ఇంకా",
"pe_tripKinds": "మీరు చేసే ట్రిప్‌లు",
"pe_hourly": "గంటల లెక్కన",
"pe_dayRent": "రోజు అద్దె",
"pe_prices": "ధరలు",
"pe_week": "మీరు పని చేసే రోజులు, సమయం",
"pe_from": "నుండి",
"pe_to": "వరకు",
"pe_save": "మార్పులు సేవ్ చేయండి",
"ld_sentDriver": "డ్రైవర్‌కి పంపబడింది",
"ld_refNoteDriver": "ఇది మీకు చూపిన ధర. చివరి ధర డ్రైవర్‌తో నేరుగా మాట్లాడి నిర్ణయించుకోవాలి.",
"ld_callDriver": "డ్రైవర్‌కి కాల్ చేయండి",
"dp_theDriver": "డ్రైవర్",
"cv_ownerWord": "డ్రైవర్",
"hm_nCars": "{n} కార్లు",
"hm_oneCar": "1 కారు",
"as_title": "మీ బిజినెస్ ఖాతా నిలిపివేయబడింది",
"as_since": "{date} నుండి",
"as_whatDriver": "మీ డ్రైవర్ ప్రొఫైల్ కస్టమర్లకు కనిపించదు, కొత్త హైర్ రిక్వెస్ట్‌లు రావు.",
"as_whatCars": "మీ కార్లు కస్టమర్లకు కనిపించవు, కొత్త లీడ్స్ రావు.",
"as_reason": "కారణం:",
"as_else": "మిగతావన్నీ పని చేస్తాయి. కస్టమర్‌గా క్యాబ్‌లు చూడవచ్చు, డ్రైవర్‌కి కాల్ చేసి ట్రిప్ బుక్ చేయవచ్చు, మీ పాత రికార్డులు ఇక్కడే ఉంటాయి.",
"as_lift": "నిలిపివేతను మా టీమ్ మాత్రమే తీసివేయగలదు.",
"as_liftCall": "శ్రామికకు కాల్ చేసి మీ రిజిస్టర్డ్ మొబైల్ నంబర్ చెప్పండి.",
"as_call": "శ్రామికకు కాల్ · {phone}",
"lc_fee": "లీడ్ ఫీజు",
"lc_free": "ఉచితం",
"lc_noCharges": "ఇంకా లీడ్ ఛార్జీలు లేవు",
"lc_andAbove": "{min} మరియు ఎక్కువ",
"lc_ladderCar": "కార్ మరియు క్యాబ్ ఖాతాలు",
"lc_ladderHire": "హైర్ డ్రైవర్ ఖాతాలు",
"lc_bandCar": "కస్టమర్‌కి చెప్పిన ట్రిప్ ఛార్జీ బట్టి",
"lc_bandHire": "కస్టమర్‌కి చెప్పిన డ్యూటీ ఛార్జీ బట్టి",
"lc_sub": "ఒక కస్టమర్ ఎంక్వైరీకి మీకు అయ్యే ఖర్చు.",
"lc_loading": "ప్రస్తుత ఛార్జీలు తెస్తున్నాం…",
"lc_loadFail": "లీడ్ ధరలు తేలేకపోయాం.",
"lc_freeNow": "లీడ్స్ ఇప్పుడు ఉచితం",
"lc_freeText": "కింద ఉన్న ప్రతి లీడ్ ఈరోజు మీకు ఉచితం. మీ వాలెట్ నుండి ఏమీ తీసుకోము, తక్కువ బ్యాలెన్స్ వల్ల ఏ లీడ్ ఆగదు.",
"lc_validTill": "ఆఫర్ {date} వరకు.",
"lc_worth": "కింద ఉన్న ధరలు ఒక లీడ్ విలువ - ఛార్జీలు మొదలైన రోజు ఆశ్చర్యం లేకుండా ఉండాలని చూపిస్తున్నాం. ఆ రోజుకు ముందే మీకు చెబుతాం.",
"lc_active": "లీడ్ ఛార్జీలు అమల్లో ఉన్నాయి",
"lc_activeText": "మీకు వచ్చే ప్రతి లీడ్‌కి కింద ఉన్న ఫీజు మీ వాలెట్ నుండి తీసుకుంటాం.",
"lc_tripFare": "ట్రిప్ ఛార్జీ",
"lc_good": "తెలుసుకోండి",
"lc_g1": "మీరు చెల్లించేది లీడ్‌కి - అంటే కస్టమర్ ఎంక్వైరీకి - ట్రిప్‌పై కమిషన్ కాదు. కస్టమర్ మీకు ఇచ్చేది పూర్తిగా మీదే.",
"lc_g2": "ఫీజు ఆ కస్టమర్‌కి చెప్పిన ఛార్జీ బట్టి ఉంటుంది, కాబట్టి చిన్న ట్రిప్‌కి పెద్ద ట్రిప్ ఫీజు ఎప్పుడూ పడదు.",
"lc_g3": "అదే కస్టమర్ మళ్ళీ త్వరలో కాల్ చేస్తే, అది కొత్త లీడ్ కాదు.",
"lc_g4": "ఈ ఛార్జీలు మారవచ్చు. ప్రతి లీడ్ వచ్చిన రోజు దానికి ఎంత అయిందో మీ లీడ్ చరిత్రలో ఎప్పుడూ కనిపిస్తుంది.",
"dd_kycTitle": "లీడ్స్ రావాలంటే ఇవి పూర్తి చేయండి",
"dd_kycBasic": "ప్రాథమిక వివరాలు",
"dd_kycEmergency": "అత్యవసర కాంటాక్ట్",
"dd_kycLicence": "లైసెన్స్",
"dd_kycPhoto": "ఫోటో",
"dd_kycReview": "మీ వివరాలు చెక్ చేస్తున్నాం",
"dd_kycReviewSub": "శ్రామిక మీ ప్రొఫైల్‌ను చూస్తోంది.",
"dd_rbNew": "కొత్త డ్రైవర్ - ఇంకా రేటింగ్‌లు లేవు",
"dd_rbNewSub": "ట్రిప్‌లు పూర్తి చేసి, కస్టమర్లను రేటింగ్ ఇవ్వమని అడగండి - మంచి రేటింగ్ ఉంటే లిస్ట్‌లో పైన వస్తారు.",
"dd_rbLine": "రేటింగ్ {r} · {tier} · {ratings}",
"dd_tSusp": "ఆపివేయబడింది",
"dd_cSusp": "మీరు రాలేదని కస్టమర్లు ఒకటి కంటే ఎక్కువ సార్లు చెప్పినందున ఆపివేశాం.",
"dd_tPriority": "ప్రాధాన్యత",
"dd_cPriority": "కస్టమర్ల వెతుకులాటలో మీరు పైన కనిపిస్తారు.",
"dd_tStandard": "సాధారణ",
"dd_cStandard": "కస్టమర్ల వెతుకులాటలో సాధారణ స్థానం.",
"dd_tWarning": "హెచ్చరిక",
"dd_cWarning": "మీ ప్రొఫైల్‌పై హెచ్చరిక కనిపిస్తుంది, శ్రామిక పరిశీలిస్తుంది.",
"dd_tCritical": "తీవ్రం",
"dd_cCritical": "శ్రామిక మీ ప్రొఫైల్ చూసే వరకు కొత్త లీడ్స్ ఆపివేశాం.",
"dd_liTotal": "వచ్చిన లీడ్స్",
"dd_liMonth": "ఈ నెల",
"dd_liFees": "లీడ్ ఫీజులు",
"dd_liConv": "{pct}% ట్రిప్‌లుగా మారాయి · మీరు గుర్తించిన {decided}లో {won}",
"dd_psTitle": "ప్రొఫైల్ బలం",
"dd_psFull": "✅ పూర్తి ప్రొఫైల్ - వెతుకులాటలో పైన కనిపిస్తారు",
"dd_psGood": "మంచి ప్రొఫైల్",
"dd_psLow": "⚠️ ప్రొఫైల్ పూర్తి కాలేదు - కస్టమర్లకు తక్కువగా కనిపిస్తారు",
"dd_psRank": "హైర్ డ్రైవర్ లిస్ట్‌లో పైకి రావడానికి",
"dd_psTip1": "అందుబాటులో ఉండండి. అందుబాటులో ఉన్న డ్రైవర్లు ముందుగా కనిపిస్తారు.",
"dd_psTip2": "100/100 చేరుకోండి. పూర్తి ప్రొఫైల్‌లు మిగతావాటి కంటే ముందు వస్తాయి.",
"dd_psTip3": "4★ లేదా ఎక్కువ పొందండి. సంతోషంగా ఉన్న కస్టమర్లను రేటింగ్ ఇవ్వమని అడగండి.",
"dd_psMissing": "స్కోర్ పెంచడానికి ఇవి జోడించండి:",
"dd_fPhoto": "ప్రొఫైల్ ఫోటో",
"dd_fLicence": "డ్రైవింగ్ లైసెన్స్",
"dd_fBio": "మీ గురించి",
"dd_fGender": "లింగం",
"dd_fAge": "వయస్సు",
"dd_fCity": "నగరం",
"dd_fAddress": "పూర్తి చిరునామా",
"dd_fAutomatic": "ఆటోమేటిక్ కారు నడపడం",
"dd_fTypes": "మీరు నడిపే కార్ల రకాలు",
"dd_fOwnRates": "మీ సొంత ధరలు",
"dd_fWeekly": "వారపు అందుబాటు",
"dd_fRating": "కస్టమర్ రేటింగ్ 4+",
"dd_avTitle": "మీ అందుబాటు",
"dd_avOffline": "ఆఫ్‌లైన్",
"dd_avHintAvail": "కస్టమర్లు మిమ్మల్ని చూసి కాల్ చేయగలరు.",
"dd_avHintBusy": "మీరు లిస్ట్‌లో ఉంటారు, బిజీగా చూపిస్తాం.",
"dd_avHintOff": "కొత్త లీడ్స్‌కి మీరు కనిపించరు.",
"dd_avHintSusp": "మీ ఖాతా నిలిపివేయబడి ఉన్నంత వరకు కస్టమర్లకు కనిపించరు - తీసివేసిన తర్వాత ఇది మళ్ళీ పని చేస్తుంది.",
"dd_availFail": "మీ అందుబాటును మార్చలేకపోయాం. మళ్ళీ ప్రయత్నించండి.",
"dd_leadFail": "ఈ లీడ్‌కి మీ సమాధానం సేవ్ కాలేదు. మళ్ళీ ప్రయత్నించండి.",
"dd_rates": "మీ ధరలు",
"dd_gBoth": "లోకల్ మరియు అవుట్‌స్టేషన్",
"dd_nightHalt": "రాత్రి బస",
"dd_usual": "సాధారణం ₹{n}",
"dd_max": "గరిష్ఠం ₹{n}",
"dd_cityStd": "నగర సాధారణ ధర",
"dd_followsCity": "నగర ధర, దానితో పాటు మారుతుంది",
"dd_above": "సాధారణం కంటే ఎక్కువ",
"dd_below": "సాధారణం కంటే తక్కువ",
"dd_nightRides": "రాత్రి ప్రయాణాలు ({from}-{to})",
"dd_yesPct": "అవును, +{pct}%",
"dd_no": "లేదు",
"dd_raiseOnce": "ధరలను ఎప్పుడైనా తగ్గించవచ్చు. పెంచడం రోజుకు ఒక్కసారే - మళ్ళీ {when} తర్వాత పెంచవచ్చు.",
"dd_ratesSaved": "ధరలు సేవ్ అయ్యాయి.",
"dd_ratesSavedMax": "ధరలు సేవ్ అయ్యాయి. కొన్నింటిని మీ నగర గరిష్ఠ ధరకు తగ్గించాం.",
"dd_ratesFail": "మీ ధరలు సేవ్ కాలేదు. మళ్ళీ ప్రయత్నించండి.",
"dd_pending": "ఒక మార్పు ఆమోదం కోసం వేచి ఉంది. చెక్ అయ్యే వరకు మీ ప్రస్తుత వివరాలే కనిపిస్తాయి.",
"dd_pickImage": "దయచేసి ఫోటో ఎంచుకోండి.",
"dd_tooBig": "ఆ ఫోటో చాలా పెద్దది. 6ఎంబీ కంటే తక్కువది ఎంచుకోండి.",
"dd_sentApproval": "ఆమోదం కోసం పంపాం.",
"dd_photoFail": "మీ ఫోటో పంపలేకపోయాం. మళ్ళీ ప్రయత్నించండి.",
"dd_changePhoto": "ఫోటో మార్చండి",
"dd_licExpired": "డ్రైవింగ్ లైసెన్స్ గడువు ముగిసింది",
"dd_licToday": "లైసెన్స్ గడువు ఈరోజు ముగుస్తుంది",
"dd_licOneDay": "లైసెన్స్ గడువు 1 రోజులో ముగుస్తుంది",
"dd_licDays": "లైసెన్స్ గడువు {n} రోజుల్లో ముగుస్తుంది",
"dd_licUpdate": "లీడ్స్ వస్తూ ఉండాలంటే మీ లైసెన్స్ అప్‌డేట్ చేయండి.",
"dd_lowFree": "వాలెట్ ₹200 కంటే తక్కువ (₹{bal})",
"dd_lowFreeText": "లీడ్స్ ఇప్పుడు ఉచితం - ఏమీ తీసుకోము. లీడ్ ఫీజులు మొదలయ్యే ముందు డబ్బు జోడించండి.",
"dd_lowPaid": "వాలెట్ బ్యాలెన్స్ తక్కువగా ఉంది (₹{bal})",
"dd_lowPaidText": "లీడ్స్ వస్తూ ఉండాలంటే డబ్బు జోడించండి.",
"dd_leadHistory": "లీడ్ చరిత్ర",
"dd_leadHistorySub": "శ్రామిక ద్వారా మీకు కాల్ చేసిన కస్టమర్లు",
"dd_noLeads": "ఇంకా లీడ్స్ లేవు. శ్రామిక ద్వారా కస్టమర్ కాల్ చేసినప్పుడు ఇక్కడ కనిపిస్తుంది.",
"dd_pendingVer": "ధృవీకరణ కోసం వేచి ఉంది",
"dd_details": "వివరాలు",
"dd_exp": "అనుభవం",
"dd_trips": "ట్రిప్ రకాలు",
"dd_tripsPick": "కనీసం ఒక రకం ట్రిప్ ఎంచుకోండి.",
"dd_tripsFail": "సేవ్ కాలేదు. మళ్ళీ ప్రయత్నించండి.",
"dd_langs": "భాషలు",
"dd_docs": "మీ పత్రాలు",
"dd_mobileLocked": "ధృవీకరించబడింది · మార్చలేరు",
"dd_licFront": "లైసెన్స్ - ముందు వైపు",
"dd_licBack": "లైసెన్స్ - వెనుక వైపు",
"dd_notUploaded": "అప్‌లోడ్ చేయలేదు",
"dd_docsNote": "లైసెన్స్ లేదా మొబైల్ నంబర్ మార్చాలంటే శ్రామికకు కాల్ చేయండి - మారే ముందు వీటిని మళ్ళీ చెక్ చేస్తాం.",
"dd_editProfile": "ప్రొఫైల్ మరియు పత్రాలు మార్చండి",
"dd_referrals": "రిఫరల్స్",
"dd_earned": "సంపాదించింది",
"dp_pDriving": "డ్రైవింగ్ నైపుణ్యం",
"dp_slabLocal": "లోకల్ - {n} గం. వరకు",
"dp_slabOut": "అవుట్‌స్టేషన్ - {n} గం. వరకు",
"dp_nightRide": "రాత్రి ప్రయాణం +{pct}%",
"dp_nightHalt": "రాత్రి బస × {n}",
"dp_notFound": "డ్రైవర్ దొరకలేదు",
"dp_notFoundText": "ఈ డ్రైవర్ ఇప్పుడు లిస్ట్‌లో లేరు.",
"dp_backDrivers": "డ్రైవర్ల దగ్గరకు వెళ్ళండి",
"dp_available": "ఇప్పుడు అందుబాటులో",
"dp_busy": "ప్రస్తుతం బిజీ",
"dp_offline": "ప్రస్తుతం అందుబాటులో లేరు",
"dp_canDrive": "నడపగలిగేవి",
"dp_moreTypes": "+{n} మరిన్ని",
"dp_new": "కొత్త డ్రైవర్",
"dp_tooLong": "ఈ ట్రిప్ ఒక్క డ్రైవర్‌కి చాలా పొడవు.",
"dp_price": "డ్రైవర్ ధర",
"dp_driverOnly": "డ్రైవర్ ఛార్జీ మాత్రమే",
"dp_noPrice": "ఈ ట్రిప్‌కి ఇంకా ధర లేదు - కాల్ చేసి అడగండి.",
"dp_callFail": "కాల్ కలపలేకపోయాం. మళ్ళీ ప్రయత్నించండి.",
"dp_trustDirect": "డ్రైవర్‌తో నేరుగా మాట్లాడండి",
"wl_title": "శ్రామిక వాలెట్",
"wl_balance": "బ్యాలెన్స్",
"wl_recent": "ఇటీవలి లావాదేవీలు",
"wl_needAmt": "బ్యాలెన్స్ సరిపోదు. కొనసాగడానికి ₹{amt} రీఛార్జ్ చేయండి.",
"wl_badAmt": "సరైన మొత్తం ఎంటర్ చేయండి.",
"wl_done": "రీఛార్జ్ అయింది.",
"wl_payFail": "చెల్లింపు విఫలమైంది: {reason}",
"wl_payStartFail": "చెల్లింపు మొదలుపెట్టలేకపోయాం.",
"wl_txnOther": "వాలెట్ ఎంట్రీ",
"wl_balAfter": "బ్యాలెన్స్ {amt}",
"wg_lowTitle": "మీ ఉచిత కాల్స్ అయిపోయాయి",
"wg_lowText": "ఇప్పుడు కలిసిన ప్రతి కాల్‌కు ₹{fee}. కాల్ కలిస్తేనే మీ వాలెట్ నుండి తీసుకుంటాం.",
"wg_balance": "వాలెట్ బ్యాలెన్స్: ₹{bal}",
"wg_resets": "ఉచిత కాల్స్ మళ్ళీ {time} కి వస్తాయి",
"wg_pick": "మొత్తం ఎంచుకోండి",
"wg_add": "₹{amt} జోడించండి",
"wg_paidTitle": "ఈ కాల్‌కు ₹{fee}",
"wg_paidText": "కాల్ కలిస్తేనే మీ వాలెట్ నుండి తీసుకుంటాం. కలవకపోతే ఏమీ తీసుకోం.",
"wg_paidCall": "కాల్ చేయండి · ₹{fee}",
"wg_okTitle": "మీ వాలెట్‌లో ₹{amt} జమైంది",
"wg_okText": "కొత్త బ్యాలెన్స్: ₹{bal}",
"wg_callNow": "ఇప్పుడే కాల్ చేయండి",
"wg_done": "సరే",
"wg_failTitle": "చెల్లింపు జరగలేదు",
"wg_failText": "మీ వాలెట్‌లో డబ్బు జమ కాలేదు. బ్యాంక్ నుండి డబ్బు కట్ అయి ఉంటే, 5–7 పని దినాల్లో అదే తిరిగి వస్తుంది.",
"wg_tryAgain": "మళ్ళీ ప్రయత్నించండి",
"wg_pendingTitle": "మీ చెల్లింపును నిర్ధారిస్తున్నాం",
"wg_pendingText": "దీనికి ఒక నిమిషం పట్టవచ్చు. బ్యాలెన్స్ దానంతట అదే మారుతుంది - దయచేసి మళ్ళీ చెల్లించకండి.",
"wg_soonTitle": "డబ్బు జోడించడం త్వరలో మొదలవుతుంది",
"wg_soonText": "చెల్లింపులు ఇంకా మొదలవలేదు. మీ ఉచిత కాల్స్ పనిచేస్తూనే ఉంటాయి.",
"wg_startFail": "చెల్లింపు పేజీ తెరవలేకపోయాం. ఇంటర్నెట్ చూసి మళ్ళీ ప్రయత్నించండి.",
"wg_extraTitle": "అదనపు కాల్ - ₹{fee}",
"wg_extraText": "నిజమైన బుకింగ్‌ల కోసం {h} గంటలకు {n} ఉచిత కాల్స్.",
"wg_extraTalk": "ఈ కాల్‌తో డ్రైవర్‌తో నేరుగా మాట్లాడండి.",
"wg_balanceAfter": "బ్యాలెన్స్ ₹{bal} → ₹{after}",
"wg_payWallet": "వాలెట్ నుండి ₹{fee} · కాల్ చేయండి",
"wg_payUpi": "₹{amt} చెల్లించి కాల్ చేయండి",
"wg_freeAfter": "{time} తర్వాత ఉచితంగా",
"wg_lastTitle": "ఇది మీ చివరి ఉచిత కాల్ ({n}/{n})",
"wg_lastText": "{time} తర్వాత మళ్ళీ {n} ఉచిత కాల్స్.",
"wg_call": "కాల్ చేయండి",
"wg_ownTitle": "ఇది మీ సొంత కారు",
"wg_ownProfile": "ఇది మీ సొంత ప్రొఫైల్",
"wg_ownText": "మీ అకౌంట్‌కి మీరే లీడ్ ఇవ్వలేరు.",
"ib_title": "వెంటనే బుకింగ్",
"ib_text": "8 గంటల్లో మొదలయ్యే ట్రిప్పులకి అందుబాటును బట్టి శ్రామిక కారును సూచిస్తుంది.",
"ib_seats": "ఎంత మంది?",
"ib_seat5": "1–4 మంది",
"ib_seat7": "5–6 మంది",
"ib_seat12": "7–12 మంది",
"ib_model": "కారు మోడల్ (ఐచ్ఛికం)",
"ib_modelHint": "ఉదా: ఇన్నోవా",
"ib_fare": "ఈ ట్రిప్ ధర: ₹{min} – ₹{max}",
"ib_pickSeats": "సీట్లు ఎంచుకోండి",
"ib_book": "ఇప్పుడే బుక్ చేయండి",
"ib_finding": "మీ కారు కన్ఫర్మ్ చేస్తున్నాం…",
"ib_confirmed": "బుకింగ్ కన్ఫర్మ్",
"ib_callYou": "డ్రైవర్ 10 నిమిషాల్లో మీకు కాల్ చేస్తారు.",
"ib_team": "మా టీమ్ 10 నిమిషాల్లో మీకు కాల్ చేస్తుంది.",
"ib_error": "బుక్ కాలేదు. మళ్ళీ ప్రయత్నించండి.",
"ob_title": "⚡ అత్యవసర ట్రిప్?",
"ob_sub": "శ్రామిక సూచించిన కారు 2–10 నిమిషాల్లో · ₹{min} – ₹{max}",
"ib_textAny": "అందుబాటును బట్టి శ్రామిక కారును సూచిస్తుంది.",
"ib_urgentTitle": "⚡ ఇది అత్యవసర ట్రిప్",
"ib_urgentText": "8 గంటల్లోపు ప్రయాణానికి శ్రామిక సూచించిన కారు - సాధారణంగా 2–10 నిమిషాల్లో కన్ఫర్మ్. ఒక్కొక్కరికి కాల్ చేయాల్సిన అవసరం లేదు.",
"ib_urgentBtn": "⚡ 2–10 నిమిషాల్లో కారు బుక్ చేయండి",
"ib_any": "ఏదైనా",
"ib_cars": "{n} కార్లు",
"ib_wait": "సాధారణంగా 2–10 నిమిషాలు. 10 నిమిషాల్లో కారు కన్ఫర్మ్ కాకపోతే, మా టీమ్ మీకు కాల్ చేస్తుంది.",
"ib_callDriver": "📞 డ్రైవర్‌కి కాల్ చేయండి",
"ib_private": "శ్రామిక నంబర్ ద్వారా - మీ నంబర్ డ్రైవర్‌కి కనిపించదు",
"ib_calling": "📞 మీ ఫోన్ ఇప్పుడు మోగుతుంది - ఎత్తగానే డ్రైవర్‌తో కలుపుతాం.",
"tr_wants": "కస్టమర్ అడిగింది: {what}",
"wl_txnCall": "కాల్ ఛార్జీ",
"wl_minMax": "₹{min} నుండి ₹{max} మధ్య మొత్తం జోడించండి.",
"sp_title": "సహాయం",
"sp_callTitle": "శ్రామికతో మాట్లాడండి",
"sp_callText": "కాల్, ధర, కారు లేదా డ్రైవర్‌తో ఏ సమస్య ఉన్నా.",
"sp_callBtn": "శ్రామికకు కాల్ చేయండి",
"sp_faqTitle": "తరచుగా అడిగే ప్రశ్నలు",
"sp_q1": "కారు ఎలా వెతకాలి?",
"sp_a1": "పికప్, డ్రాప్ ఎంచుకోండి. కార్లు, వాటి ధరలు పోల్చి చూసి, కాల్ నొక్కి డ్రైవర్‌తో నేరుగా మాట్లాడండి.",
"sp_q2": "బుకింగ్ ఫీజు ఉందా?",
"sp_a2": "లేదు. యాప్‌లో ఏదీ బుక్ అవ్వదు - ట్రిప్ గురించి డ్రైవర్‌తో మాట్లాడుకుని వాళ్ళకే నేరుగా చెల్లించండి.",
"sp_q3": "ట్రిప్ ఎలా రద్దు చేయాలి?",
"sp_a3": "డ్రైవర్‌కి కాల్ చేసి చెప్పండి. ట్రిప్ మీరూ వారూ మాట్లాడుకున్నది, కాబట్టి ఇక్కడ రద్దు చేయాల్సిన బుకింగ్ ఏదీ లేదు. మీ విచారణ ఎలాగైనా చరిత్రలో ఉంటుంది.",
"sp_q4": "ఎలా చెల్లించాలి?",
"sp_a4": "డ్రైవర్‌కి నేరుగా చెల్లించండి - నగదు లేదా యూపీఐ, మీరు ఎలా మాట్లాడుకుంటే అలా.",
"sp_q5": "ధరలో లేనివి ఏమిటి?",
"sp_a5": "టోల్, పార్కింగ్, స్టేట్ టాక్స్ - డ్రైవర్‌కి నేరుగా చెల్లించండి. అదనపు కి.మీ లేదా గంటలకు అదనపు ఛార్జీ ఉంటుంది.",
"sp_q6": "సమస్య ఎలా చెప్పాలి?",
"sp_a6": "పై బటన్‌తో శ్రామికకు కాల్ చేయండి. ఏ ట్రిప్ గురించో చెప్పడానికి చరిత్రలో ఆ విచారణ తెరిచి ఉంచండి.",
"sp_footer": "శ్రామిక సహాయం · support@sramika.com",
"nc_soon": "త్వరలో",
"nc_title": "శ్రామిక త్వరలో {city} కి వస్తోంది",
"nc_titleNoCity": "శ్రామిక త్వరలో మీ నగరానికి వస్తోంది",
"nc_text": "{city} లో కార్లు, డ్రైవర్లను చేర్చుతున్నాం. మీ నంబర్ ఇవ్వండి - సిద్ధమైనప్పుడు వాట్సాప్ లో చెబుతాం.",
"nc_textNoCity": "మీ నగరంలో కార్లు, డ్రైవర్లను చేర్చుతున్నాం. మీ నంబర్ ఇవ్వండి - సిద్ధమైనప్పుడు వాట్సాప్ లో చెబుతాం.",
"nc_expected": "మొదలయ్యే అంచనా",
"nc_name": "మీ పేరు",
"nc_phone": "వాట్సాప్ నంబర్ (10 అంకెలు)",
"nc_join": "మొదలైనప్పుడు చెప్పండి",
"nc_enterName": "మీ పేరు ఎంటర్ చేయండి.",
"nc_fail": "సేవ్ కాలేదు. మళ్ళీ ప్రయత్నించండి.",
"nc_doneTitle": "మీ పేరు నమోదైంది",
"nc_doneText": "{city} లో శ్రామిక మొదలైనప్పుడు వాట్సాప్ లో చెబుతాం.",
"nc_doneTextNoCity": "మీ నగరంలో శ్రామిక మొదలైనప్పుడు వాట్సాప్ లో చెబుతాం.",
"nt_title": "నోటిఫికేషన్లు",
"nt_emptyTitle": "ఇంకా నోటిఫికేషన్లు లేవు",
"nt_emptyText": "మీ విచారణలు, ఖాతా గురించి వార్తలు ఇక్కడ కనిపిస్తాయి.",
"nt_history": "నా విచారణలు చూడండి",
"nt_all": "అన్నీ",
"nt_ride": "ట్రిప్పులు",
"nt_approval": "ఆమోదాలు",
"nt_document": "పత్రాలు",
"nt_wallet": "వాలెట్",
"nt_system": "అప్‌డేట్స్",
"nt_unread": "కొత్తవి",
"nt_read": "చూసినవి",
"nt_important": "ముఖ్యం",
"nt_noneHere": "{name} లో ఏమీ లేవు.",
"nt_showAll": "అన్నీ చూపించండి",
"nt_notification": "నోటిఫికేషన్",
"st_confirm": "సరే",
"st_notSignedIn": "మీరు లాగిన్ అవ్వలేదు",
"st_signInToManage": "మీ ప్రొఫైల్, సెట్టింగ్స్ మార్చడానికి లాగిన్ అవ్వండి",
"st_loginSignup": "లాగిన్ / సైన్ అప్",
"st_partnerLogin": "డ్రైవర్ లాగిన్",
"st_notEditable": "మార్చలేరు",
"st_usernamePh": "మీ యూజర్ నేమ్",
"st_save": "సేవ్ చేయండి",
"st_notSet": "పెట్టలేదు",
"st_edit": "మార్చండి",
"st_cityPh": "ఉదా: విజయవాడ",
"st_myRating": "నా రేటింగ్",
"st_footer": "శ్రామిక 1.0 · మీ డేటా అంతా ఎన్‌క్రిప్షన్‌తో సురక్షితం",
"st_nameSaved": "యూజర్ నేమ్ మార్చబడింది.",
"st_nameFail": "యూజర్ నేమ్ సేవ్ కాలేదు.",
"st_nfTitle": "ఈ పేజీ లేదు",
"st_nfText": "లింక్ పాతది కావచ్చు, లేదా అడ్రస్‌లో తప్పు ఉండవచ్చు. అన్నీ అలాగే ఉన్నాయి - హోమ్ పేజీ నుండి మొదలుపెట్టండి.",
"st_nfCar": "కారు వెతకండి",
"st_nfDriver": "డ్రైవర్‌ని హైర్ చేయండి",
"st_suInvalid": "మొబైల్ నంబర్ ధృవీకరించిన తర్వాతే ఈ పేజీ తెరుచుకుంటుంది.",
"st_suToLogin": "లాగిన్‌కి వెళ్ళండి",
"st_suNameTitle": "మీ యూజర్ నేమ్ పెట్టండి",
"st_suNameHint": "ఖాళీలు వాడవచ్చు. తర్వాత మార్చలేరు.",
"st_suNameMissing": "కొనసాగడానికి యూజర్ నేమ్ ఎంటర్ చేయండి.",
"st_suContinue": "కొనసాగించండి",
"st_suPwTitle": "మీ పాస్‌వర్డ్ పెట్టండి",
"st_suPwMissing": "కొనసాగడానికి పాస్‌వర్డ్ ఎంటర్ చేయండి.",
"st_suPwFail": "పాస్‌వర్డ్ పెట్టలేకపోయాం.",
"st_suNewPwPh": "కొత్త పాస్‌వర్డ్ ఎంటర్ చేయండి",
"pl_brand": "శ్రామిక బిజినెస్",
"pl_portal": "డ్రైవర్ల కోసం",
"pl_stepPhone": "మొబైల్ ఎంటర్ చేయండి",
"pl_awaiting": "మీ ఖాతా ఇంకా యాక్టివేట్ కాలేదు. శ్రామికను సంప్రదించండి.",
"pl_continueFail": "ముందుకు వెళ్ళలేకపోయాం. మళ్ళీ ప్రయత్నించండి.",
"pl_badPw": "పాస్‌వర్డ్ తప్పు. మళ్ళీ ప్రయత్నించండి.",
"pl_hide": "దాచండి",
"pl_show": "చూపించండి",
"pl_checking": "చూస్తున్నాం…",
"pl_continue": "కొనసాగించండి →",
"pl_welcomeBack": "మళ్ళీ స్వాగతం! +91 {phone} తో లాగిన్ అవుతున్నారు",
"pl_otpInstead": "బదులుగా ఓటీపీ తో లాగిన్",
"pl_otpLabel": "ఓటీపీ (ఒకసారి వాడే పాస్‌వర్డ్)",
"pl_customerLogin": "← కస్టమర్ లాగిన్",
"pl_secs": "{n} సె.",
"lg_tenDigit": "10 అంకెల నంబర్",
"lg_moreDigits": "ఇంకా {n} అంకెలు కావాలి",
"lg_oneMoreDigit": "ఇంకా 1 అంకె కావాలి",
"lg_startDigit": "6, 7, 8 లేదా 9 తో మొదలవ్వాలి",
"lg_enterMobile": "మీ మొబైల్ నంబర్ ఎంటర్ చేయండి.",
"lg_otpSendFail": "ఓటీపీ పంపలేకపోయాం. మళ్ళీ ప్రయత్నించండి.",
"lg_enterOtp": "ఓటీపీ ఎంటర్ చేయండి.",
"lg_otpInvalid": "ఓటీపీ తప్పు. మళ్ళీ ప్రయత్నించండి.",
"lg_otpResendFail": "ఓటీపీ మళ్ళీ పంపలేకపోయాం.",
"lg_pwMin": "పాస్‌వర్డ్ కనీసం 8 అక్షరాలు ఉండాలి.",
"lg_pwMax": "పాస్‌వర్డ్ 64 అక్షరాలకు మించకూడదు.",
"lg_pwRange": "పాస్‌వర్డ్ 8 నుండి 64 అక్షరాలు ఉండాలి.",
"lg_resetFail": "పాస్‌వర్డ్ మార్చలేకపోయాం. మళ్ళీ ప్రయత్నించండి.",
"lg_resetTitle": "పాస్‌వర్డ్ రీసెట్",
"lg_verifyOtp": "ఓటీపీ ధృవీకరించండి",
"lg_setNewPw": "కొత్త పాస్‌వర్డ్ పెట్టండి",
"lg_forgotIntro": "మీ రిజిస్టర్డ్ మొబైల్ నంబర్ ఎంటర్ చేయండి. మేము ఒక కోడ్ పంపుతాం.",
"lg_mobile": "మొబైల్ నంబర్",
"lg_waNotice": "ఈ నంబర్‌కు మీ ఓటీపీ, మీ విచారణల అప్‌డేట్‌లు వాట్సాప్, ఎస్ఎంఎస్‌లో పంపుతాం. అప్‌డేట్‌లు ఆపాలంటే వాట్సాప్‌లో “ఆపు” అని పంపండి.",
"lg_sending": "పంపుతున్నాం…",
"lg_sendOtp": "ఓటీపీ పంపండి",
"lg_otpSentTo": "+91 {phone} కి ఓటీపీ పంపాం. కింద 6 అంకెల కోడ్ ఎంటర్ చేయండి.",
"lg_otp6": "6 అంకెల ఓటీపీ",
"lg_resendIn": "{n} సె. లో మళ్ళీ పంపండి",
"lg_resend": "మళ్ళీ పంపండి",
"lg_verifying": "ధృవీకరిస్తున్నాం…",
"lg_otpDone": "ఓటీపీ ధృవీకరించబడింది. మీ కొత్త పాస్‌వర్డ్ పెట్టండి.",
"lg_newPw": "కొత్త పాస్‌వర్డ్",
"lg_pwHint": "8-64 అక్షరాలు",
"lg_saving": "సేవ్ చేస్తున్నాం…",
"lg_tagline": "మీ నమ్మకమైన క్యాబ్ సేవ",
"lg_logIn": "లాగిన్",
"lg_signUp": "సైన్ అప్",
"lg_password": "పాస్‌వర్డ్",
"lg_otpLogin": "ఓటీపీ లాగిన్",
"lg_userOrMobile": "యూజర్ నేమ్ లేదా మొబైల్",
"lg_userOrMobilePh": "యూజర్ నేమ్ లేదా మొబైల్ నంబర్",
"lg_enterPw": "పాస్‌వర్డ్ ఎంటర్ చేయండి",
"lg_forgot": "పాస్‌వర్డ్ మర్చిపోయారా?",
"lg_signingIn": "లాగిన్ అవుతోంది…",
"lg_signIn": "లాగిన్ అవ్వండి",
"lg_codeSentTo": "+91 {phone} కి వచ్చిన 6 అంకెల కోడ్ ఎంటర్ చేయండి",
"lg_verifySignIn": "ధృవీకరించి లాగిన్ అవ్వండి",
"lg_userName": "యూజర్ నేమ్",
"lg_nameTaken": "ఈ యూజర్ నేమ్ ఇప్పటికే ఉంది.",
"lg_tryName": "ఇది ప్రయత్నించండి: {name}",
"lg_numTaken": "ఈ మొబైల్ నంబర్ ఇప్పటికే రిజిస్టర్ అయింది.",
"lg_signInInstead": "లాగిన్ అవ్వండి →",
"lg_email": "ఈమెయిల్",
"lg_fullName": "పూర్తి పేరు",
"lg_enterOtp6": "6 అంకెల ఓటీపీ ఎంటర్ చేయండి",
"lg_setPw": "పాస్‌వర్డ్ పెట్టండి",
"lg_confirmPw": "పాస్‌వర్డ్ మళ్ళీ",
"lg_reenterPw": "పాస్‌వర్డ్ మళ్ళీ ఎంటర్ చేయండి",
"lg_accept": "నేను {terms}, {privacy} ను అంగీకరిస్తున్నాను. ప్లాట్‌ఫామ్ కార్యకలాపాల కోసం నా వ్యక్తిగత సమాచారం సేకరించడానికి స్పష్టంగా సమ్మతిస్తున్నాను.",
"lg_terms": "నియమాలు & షరతులు",
"lg_privacy": "గోప్యతా విధానం",
"lg_creating": "ఖాతా తయారవుతోంది…",
"lg_create": "ఖాతా తెరవండి",
"lg_earn": "శ్రామికతో సంపాదించాలనుకుంటున్నారా?",
"lg_joinAs": "డ్రైవర్ లేదా ఆల్టింగ్ డ్రైవర్‌గా చేరండి",
"lg_cabOwner": "డ్రైవర్",
"lg_hireDriver": "హైర్ డ్రైవర్",
"lg_enterUsername": "యూజర్ నేమ్ ఎంటర్ చేయండి.",
"lg_otherUsername": "వేరే యూజర్ నేమ్ ఎంచుకోండి.",
"lg_validMobile": "సరైన 10 అంకెల మొబైల్ నంబర్ ఎంటర్ చేయండి.",
"lg_hasAccount": "ఈ నంబర్‌కి ఇప్పటికే ఖాతా ఉంది.",
"lg_otpSentShort": "+91 {phone} కి ఓటీపీ పంపాం",
"lg_noAccount": "ఖాతా లేదు - కొత్త ఖాతా తెరుద్దాం.",
"lg_autoOtpFail": "ఓటీపీ పంపలేకపోయాం. మళ్ళీ పంపండి నొక్కండి.",
"lg_noPwYet": "మీ ఖాతాకు ఇంకా పాస్‌వర్డ్ లేదు - ఇప్పుడే పెట్టండి.",
"lg_enterOtpSent": "మీ మొబైల్‌కి వచ్చిన ఓటీపీ ఎంటర్ చేయండి.",
"lg_enterUserOrMobile": "యూజర్ నేమ్ లేదా మొబైల్ నంబర్ ఎంటర్ చేయండి.",
"lg_enterPwMsg": "పాస్‌వర్డ్ ఎంటర్ చేయండి.",
"lg_setPwFor": "మీ మొబైల్ నంబర్‌కి పాస్‌వర్డ్ పెట్టండి.",
"lg_badLogin": "యూజర్ నేమ్/మొబైల్ లేదా పాస్‌వర్డ్ తప్పు. ఒకసారి చూడండి.",
"lg_otpExpired": "ఓటీపీ గడువు ముగిసింది. మళ్ళీ పంపండి.",
"lg_pwMismatch": "పాస్‌వర్డ్‌లు ఒకేలా లేవు.",
"lg_enterEmail": "ఈమెయిల్ ఎంటర్ చేయండి.",
"lg_enterFullName": "మీ పూర్తి పేరు ఎంటర్ చేయండి.",
"lg_acceptFirst": "నియమాలు, గోప్యతా విధానం అంగీకరించండి.",
"lg_createFail": "ఖాతా తెరవలేకపోయాం.",
"cv_lExtraOneHr": "అదనపు 1 గం.",
"cv_24h": "24 గంటలు",
"cv_back": "వెనక్కి",
"cv_share": "షేర్ చేయండి",
"cv_linkCopied": "లింక్ కాపీ అయింది",
"cv_prevPhoto": "ముందు ఫోటో",
"cv_nextPhoto": "తర్వాతి ఫోటో",
"cv_close": "మూసివేయండి",
"cv_nRatings": "{n} రేటింగ్‌లు",
"cv_oneRating": "1 రేటింగ్",
"cv_model": "{year} మోడల్",
"cv_manual": "మాన్యువల్",
"cv_auto": "ఆటోమేటిక్",
"cv_male": "పురుషుడు",
"cv_female": "మహిళ",
"cv_licence": "లైసెన్స్ చెక్ చేశాం",
"cv_yourTrip": "మీ ట్రిప్",
"cv_change": "మార్చండి",
"cv_local": "లోకల్",
"cv_partnerPrice": "డ్రైవర్ ధర",
"cv_usualFare": "సాధారణ ఛార్జీ",
"cv_extrasShort": "టోల్, పార్కింగ్ అదనం",
"cv_priceDetails": "ధర వివరాలు",
"cv_eta": "{name} {place} కి {n} నిమి. దూరంలో ఉన్నారు",
"cv_seePriceTitle": "మీ ట్రిప్ ధర చూడండి",
"cv_seePriceText": "పికప్, డ్రాప్ ఎంచుకోండి - ధర ఇక్కడ కనిపిస్తుంది.",
"cv_setTrip": "పికప్ & డ్రాప్ ఎంచుకోండి",
"cv_allDay": "ప్రతిరోజూ అందుబాటులో · 24 గంటలు",
"cv_everyDay": "ప్రతిరోజూ అందుబాటులో · {hours}",
"cv_openToday": "ఈరోజు అందుబాటులో · {hours}",
"cv_closedToday": "ఈరోజు అందుబాటులో లేరు",
"cv_daysOpen": "వారంలో {n} రోజులు",
"cv_week": "వారం",
"cv_dayOff": "సెలవు",
"cv_dayBusy": "బిజీ",
"cv_dayOpen": "అందుబాటులో",
"cv_notConfirmed": "సాధారణ సమయాలు - డ్రైవర్ ఇంకా నిర్ధారించలేదు",
"cv_rateTitle": "{name} తో మీ ట్రిప్ ఎలా ఉంది?",
"cv_rateNoName": "మీ ట్రిప్ ఎలా ఉంది?",
"cv_rateParts": "ఒక్కో అంశం - కావాలంటే మార్చండి, లేదా అలాగే పంపండి",
"cv_noRatings": "ఇంకా రేటింగ్‌లు లేవు",
"cv_rateAfter": "ఈ కారులో ప్రయాణించారా? ట్రిప్ తర్వాత రేటింగ్ ఇవ్వండి.",
"cv_partsFrom": "{m} రేటింగ్‌లలో {n} నుండి వివరాలు",
"rl_title": "{name} గారితో ట్రిప్‌కి రేటింగ్ ఇవ్వండి",
"rl_done": "ధన్యవాదాలు! మీ రేటింగ్ సేవ్ అయింది.",
"rl_gone": "ఈ లింక్ గడువు ముగిసింది. మీ రేటింగ్‌కి ధన్యవాదాలు!",
"cv_trustDirect": "డ్రైవర్‌తో నేరుగా మాట్లాడండి",
"cv_trustNoFee": "బుకింగ్ ఫీజు లేదు",
"cv_trustHelp": "అవసరమైతే శ్రామిక సహాయం",
"cv_help": "సహాయం కావాలా? శ్రామికకు కాల్ చేయండి",
"cv_onTripBack": "ట్రిప్‌లో ఉన్నారు · {when} కి తిరిగి వస్తారు",
"cv_onTrip": "ప్రస్తుతం ట్రిప్‌లో ఉన్నారు",
"cv_notFree": "ప్రస్తుతం ఖాళీగా లేరు",
"cv_notifyMe": "ఖాళీ అయితే చెప్పండి",
"cv_notified": "మీకు తెలియజేస్తాం",
"cv_similar": "ఇలాంటి కార్లు",
"cv_setByPartner": "ధర డ్రైవర్ నిర్ణయించారు · శ్రామిక కమీషన్ లేదు",
"cv_kmBoth": "రెండు వైపులా {km} కి.మీ",
"cv_nDays": "{n} రోజులు",
"cv_oneDay": "1 రోజు",
"cv_nHrs": "{n} గం.",
"cv_oneHr": "1 గం.",
"cv_nNights": "{n} రాత్రులు",
"cv_oneNight": "1 రాత్రి",
"cv_nHalfDays": "{n} అర రోజులు",
"cv_oneHalfDay": "1 అర రోజు",
"cv_lBase": "బేస్ ఛార్జీ",
"cv_lDrop": "డ్రాప్ ఛార్జీ",
"cv_lDriver": "డ్రైవర్ బత్తా ({x})",
"cv_lNight": "నైట్ బత్తా ({x})",
"cv_lDropUpTo": "డ్రాప్ ({km} కి.మీ వరకు)",
"cv_lDropFirst": "డ్రాప్ (మొదటి {km} కి.మీ)",
"cv_lExtraKmRate": "అదనపు {km} కి.మీ × ₹{rate}",
"cv_lPackage": "{n} గంటల ప్యాకేజీ",
"cv_lExtraHr": "అదనపు {n} గం.",
"cv_lExtraKm": "అదనపు {n} కి.మీ",
"cv_lDayRent": "రోజు అద్దె ({x})",
"cv_lFuel": "ఇంధన ఛార్జీ",
"cv_youPay": "మీరు డ్రైవర్‌కి చెల్లించేది",
"cv_notIncl": "ఇందులో లేనివి",
"cv_notIncl1": "టోల్, పార్కింగ్, స్టేట్ టాక్స్ - డ్రైవర్‌కి నేరుగా చెల్లించండి",
"cv_notIncl2": "అదనపు కి.మీ లేదా గంటలకు అదనపు ఛార్జీ",
"cv_calcLink": "అదనపు కి.మీ / గంటల ధర లెక్కించండి",
"cv_calcTitle": "ధర లెక్కింపు",
"cv_calcSub": "ఎక్కువ కి.మీ లేదా గంటలకు ధర",
"cv_calcHours": "ట్రిప్ గంటలు",
"cv_calcKm": "మొత్తం కి.మీ",
"cv_calcBtn": "ధర లెక్కించండి",
"cv_calcTotal": "అంచనా ధర",
"cv_calcNote": "టోల్, పార్కింగ్, స్టేట్ టాక్స్ ఇందులో లేవు",
"cv_loading": "కారు వివరాలు లోడ్ అవుతున్నాయి…",
"cv_goneTitle": "ఈ కారు అందుబాటులో లేదు",
"cv_goneText": "ఈ కారు ఇప్పుడు లిస్ట్‌లో లేదు, లేదా లింక్ గడువు ముగిసింది.",
"cv_backHome": "హోమ్‌కి వెళ్ళండి",
"hm_recentEnquiry": "మీ ఇటీవలి విచారణ",
"hm_nPartners": "{n} పార్ట్‌నర్లు",
"hm_onePartner": "1 పార్ట్‌నర్",
"hm_resAvailIn": "{city} లో {items} అందుబాటులో ఉన్నారు",
"hm_resAvailInCars": "{city} లో {items} అందుబాటులో ఉన్నాయి",
"hm_changeLang": "భాష మార్చండి",
"hm_changeCity": "నగరం మార్చండి",
"hm_helpCall": "సహాయం కోసం శ్రామికకు కాల్ చేయండి",
"hm_chooseCity": "మీ నగరం ఎంచుకోండి",
"hm_typeCity": "మీ నగరం పేరు టైప్ చేయండి",
"hm_useMyLocation": "నా లొకేషన్ వాడండి",
"hm_finding": "మీ లొకేషన్ వెతుకుతోంది…",
"hm_noCities": "ఈ పేరుతో నగరం లేదు",
"hm_locNotSupported": "ఈ ఫోన్ లొకేషన్ పంచుకోలేదు.",
"hm_locMapsOff": "మ్యాప్ లోడ్ కాలేదు. పేజీని రిఫ్రెష్ చేయండి.",
"hm_locNotFound": "మీ లొకేషన్ దొరకలేదు. మళ్ళీ ప్రయత్నించండి.",
"hm_locNoCity": "మీ లొకేషన్ దొరికింది, కానీ నగరం తెలియలేదు. కింద నుండి ఎంచుకోండి.",
"hm_locDenied": "లొకేషన్ అనుమతి ఇవ్వలేదు. ఫోన్ సెట్టింగ్స్‌లో అనుమతించి మళ్ళీ ప్రయత్నించండి.",
"hm_locUnavailable": "లొకేషన్ అందుబాటులో లేదు. జీపీఎస్ ఆన్ చేసి మళ్ళీ ప్రయత్నించండి.",
"hm_locTimeout": "లొకేషన్ కనుక్కోవడానికి చాలా సమయం పట్టింది. మళ్ళీ ప్రయత్నించండి.",
"hm_guestTitle": "లాగిన్ అయి డ్రైవర్లకు నేరుగా కాల్ చేయండి",
"hm_guestSubCars": "ధరలు పోల్చి చూసి, డ్రైవర్‌తో నేరుగా మాట్లాడండి - బుకింగ్ ఫీజు లేదు.",
"hm_guestSubDrivers": "మొబైల్ నంబర్‌తో ఉచితం. ఒక్క టచ్‌తో కాల్ చేయండి, మీ విచారణలు హిస్టరీలో చూడండి. బుకింగ్ ఫీజు లేదు.",
"hm_guestTitleCars": "లాగిన్ అయి డ్రైవర్లకు నేరుగా కాల్ చేయండి",
"hm_guestSubCarsLogin": "మొబైల్ నంబర్‌తో ఉచితం. ఒక్క టచ్‌తో కాల్ చేయండి, మీ విచారణలు హిస్టరీలో చూడండి. బుకింగ్ ఫీజు లేదు.",
"hm_loginJoin": "లాగిన్ / చేరండి",
"hm_recent": "ఇటీవలి",
"hm_setTrip": "ప్రయాణం సెట్ చేయండి",
"hm_km": "{km} కి.మీ",
"hm_searchCars": "కారు, మోడల్, ప్రాంతం వెతకండి",
"hm_searchDrivers": "డ్రైవర్ పేరు, భాష వెతకండి",
"hm_filters": "ఫిల్టర్లు",
"hm_clearSearch": "సెర్చ్ తీసేయండి",
"hm_removeFilter": "ఫిల్టర్ తీసేయండి",
"hm_any": "ఏదైనా",
"hm_sort": "వరుస",
"hm_sortRec": "సిఫార్సు",
"hm_sortPriceLow": "తక్కువ ధర ముందు",
"hm_sortPriceHigh": "ఎక్కువ ధర ముందు",
"hm_sortRating": "మంచి రేటింగ్ ముందు",
"hm_sortEta": "దగ్గరివి ముందు",
"hm_sortNewest": "కొత్త కార్లు ముందు",
"hm_seats": "సీట్లు",
"hm_nSeats": "{n} సీట్లు",
"hm_carType": "కారు రకం",
"hm_price": "ధర",
"hm_ctHatch": "హ్యాచ్‌బ్యాక్",
"hm_ctSedan": "సెడాన్",
"hm_ctMiniSuv": "మినీ ఎస్‌యూవీ",
"hm_ctSuv": "ఎస్‌యూవీ",
"hm_ctMpv": "7 సీటర్ (ఎంపీవీ)",
"hm_ctTempo": "టెంపో ట్రావెలర్",
"hm_ctBus": "బస్",
"hm_fuel": "ఇంధనం",
"hm_fuelPetrol": "పెట్రోల్",
"hm_fuelDiesel": "డీజిల్",
"hm_fuelCng": "సీఎన్‌జీ",
"hm_fuelEv": "ఎలక్ట్రిక్",
"hm_year": "కారు సంవత్సరం",
"hm_yr2024": "2024 లేదా కొత్తది",
"hm_yr2015": "2015 లేదా పాతది",
"hm_budUnder5": "₹5,000 లోపు",
"hm_budAbove15": "₹15,000 పైన",
"hm_sortExp": "ఎక్కువ అనుభవం ముందు",
"hm_sortOnline": "ఇప్పుడు ఆన్‌లైన్ ముందు",
"hm_sortFareLow": "తక్కువ ఛార్జీ ముందు",
"hm_dBudUnder1": "₹1,000 లోపు",
"hm_dBudAbove3": "₹3,000 పైన",
"hm_priceNeedsTrip": "ముందు మీ ప్రయాణం వివరాలు ఇవ్వండి - ధర దానిపై ఆధారపడుతుంది.",
"hm_rating": "రేటింగ్",
"hm_starsPlus": "{n}+ స్టార్లు",
"hm_experience": "డ్రైవింగ్ అనుభవం",
"hm_expPlus": "{n}+ సం. డ్రైవింగ్",
"hm_speaks": "మాట్లాడే భాష",
"hm_goodAt": "కస్టమర్లు చెప్పింది",
"hm_tOnTime": "సమయానికి వస్తారు",
"hm_tPolite": "మర్యాదగా ఉంటారు",
"hm_tComfort": "సౌకర్యంగా ప్రయాణం",
"hm_tClean": "శుభ్రమైన కారు",
"hm_tSafe": "సురక్షిత డ్రైవింగ్",
"hm_driverAge": "డ్రైవర్ వయసు",
"hm_ageRange": "{range} ఏళ్ళు",
"hm_grpCar": "కారు",
"hm_grpDriver": "డ్రైవర్",
"hm_grpPrice": "ధర",
"hm_grpTrip": "ప్రయాణం",
"hm_clearAll": "అన్నీ తీసేయండి",
"hm_close": "మూసివేయండి",
"hm_showCars": "{n} కార్లు చూపించు",
"hm_showOneCar": "1 కారు చూపించు",
"hm_showNoCars": "ఏ కారూ సరిపోలేదు",
"hm_showDrivers": "{n} డ్రైవర్లను చూపించు",
"hm_showOneDriver": "1 డ్రైవర్‌ని చూపించు",
"hm_showNoDrivers": "ఏ డ్రైవరూ సరిపోలేదు",
"hm_tripType": "ప్రయాణ రకం",
"hm_ttLocal": "లోకల్",
"hm_ttOut": "అవుట్‌స్టేషన్",
"hm_ttDrop": "డ్రాపింగ్",
"hm_availability": "అందుబాటు",
"hm_availNow": "ఇప్పుడు అందుబాటులో",
"hm_nDrivers": "{n} డ్రైవర్లు",
"hm_oneDriver": "1 డ్రైవర్",
"hm_resRoute": "{route} కోసం {items}",
"hm_resNear": "{place} దగ్గర {items}",
"hm_resFound": "దొరికినవి: {items}",
"hm_showAll": "అన్నీ చూపించు",
"hm_shareList": "లిస్ట్ పంపండి",
"dk_trips": "యాత్రలు",
"dk_heroCars": "{city} లో కార్లు",
"dk_subCars": "అసలు ధరలు చూసి, డ్రైవర్‌కి నేరుగా కాల్ చేయండి - బుకింగ్ ఫీజు లేదు, అడ్వాన్స్ లేదు.",
"dk_heroDrivers": "{city} లో డ్రైవర్‌ని తీసుకోండి",
"dk_subDrivers": "మీ కారు, మా డ్రైవర్ - రేట్లన్నీ చూసి, డ్రైవర్‌కి నేరుగా కాల్ చేయండి.",
"dk_searchCars": "కార్లు వెతకండి",
"dk_searchDrivers": "డ్రైవర్లను వెతకండి",
"dk_when": "ఎప్పుడు",
"dk_tripType": "ట్రిప్",
"dk_filters": "ఫిల్టర్లు",
"dk_pickWhen": "తేదీ ఎంచుకోండి",
"dk_tagline": "మీ దగ్గరలో కార్లు, డ్రైవర్లు - ధరలు చూసి డ్రైవర్‌కి నేరుగా కాల్ చేయండి.",
"dk_fCustomers": "కస్టమర్ల కోసం",
"dk_fJoin": "శ్రామికలో చేరండి",
"dk_fAbout": "మా గురించి",
"dk_fByCity": "నగరాల వారీగా",
"dk_fCabsByCity": "నగరాల వారీగా కార్లు",
"dk_fDriversByCity": "నగరాల వారీగా డ్రైవర్లు",
"dk_fFareChart": "ట్యాక్సీ ఛార్జీల పట్టిక",
"dk_fAirport": "ఎయిర్‌పోర్ట్ ట్యాక్సీ",
"cbk_button": "🙋 మేమే కాల్ చేసి బుక్ చేస్తాం",
"cbk_title": "మీకు మేమే కాల్ చేస్తాం",
"cbk_sub": "10 నిమిషాల్లో శ్రామిక టీమ్ కాల్ చేసి, మీ కోసం బుక్ చేస్తుంది. లాగిన్ అవసరం లేదు.",
"cbk_night": "ఇప్పుడు రాత్రి - ఉదయం 8 గంటలకు కాల్ చేస్తాం.",
"cbk_name": "మీ పేరు",
"cbk_phone": "మొబైల్ నంబర్",
"cbk_trip": "మీ ట్రిప్",
"cbk_note": "ఇంకేమైనా (ఐచ్ఛికం)",
"cbk_notePh": "6 మంది, 3 బ్యాగులు…",
"cbk_send": "కాల్ చేయమని అడగండి",
"cbk_sending": "పంపుతున్నాం…",
"cbk_done": "అందింది! 10 నిమిషాల్లో కాల్ వస్తుంది.",
"cbk_doneNight": "అందింది! ఉదయం 8 గంటలకు కాల్ చేస్తాం.",
"cbk_already": "మీ అభ్యర్థన ఇప్పటికే అందింది - త్వరలో కాల్ చేస్తాం.",
"cbk_badPhone": "10 అంకెల మొబైల్ నంబర్ ఇవ్వండి",
"cbk_noName": "మీ పేరు ఇవ్వండి",
"cbk_error": "పంపలేకపోయాం. దయచేసి {n} కి కాల్ చేయండి.",
"cbk_noLogin": "లాగిన్ వద్దా? మేమే కాల్ చేస్తాం →",
"lcb_title": "కొత్త కస్టమర్ కాల్",
"lcb_accept": "తీసుకుంటాను",
"lcb_reject": "కుదరదు",
"lcb_ago": "{n} నిమిషాల క్రితం",
"lcb_accepted": "తీసుకున్నారు — లీడ్స్ నుండి కస్టమర్‌కి కాల్ చేయండి",
"lcb_rejected": "సరే — శ్రామిక ఈ కస్టమర్‌కి సహాయం చేస్తుంది",
"tr_title": "కొత్త ట్రిప్",
"tr_yourPrice": "మీ ధర",
"tr_accept": "తీసుకుంటాను",
"tr_decline": "కుదరదు",
"tr_won": "ట్రిప్ కన్ఫర్మ్",
"tr_taken": "వేరే డ్రైవర్ తీసుకున్నారు",
"tr_closed": "ఈ రిక్వెస్ట్ ముగిసింది",
"tr_missedTip": "ముందు ఒప్పుకున్న డ్రైవర్‌కే ట్రిప్. తర్వాతి సారి త్వరగా ఒప్పుకోండి.",
"tr_declined": "కుదరదు అన్నారు",
"tr_free": "ఈ రోజు ట్రిప్పులకి ఖాళీ",
"tr_call": "కస్టమర్‌కి కాల్ చేయండి",
"tr_calling": "కాల్ కలుపుతున్నాం — ముందు మీ ఫోన్ రింగ్ అవుతుంది",
"tr_over": "ట్రిప్ ముగిసింది",
"tr_callErr": "కాల్ కలవలేదు. మళ్ళీ ప్రయత్నించండి.",
"tr_people": "{n} మంది",
"cbk_close": "మూసివేయండి",
"dk_fRegisterCar": "మీ కారు నమోదు చేయండి",
"dk_fJoinDriver": "డ్రైవర్‌గా చేరండి",
"dk_fTerms": "నిబంధనలు",
"dk_fPrivacy": "గోప్యత",
"dk_fRefunds": "రీఫండ్",
"dk_fDelete": "ఖాతా తొలగించండి",
"bl_title": "ఇంకో బిజినెస్‌కి కాల్ చేయడానికి కాస్త ఆగాలి",
"bl_body": "డ్రైవర్లు 6 గంటల్లో ఒక బిజినెస్‌కి మాత్రమే కాల్ చేయగలరు - ఒకే ఎంక్వైరీ మళ్లీ మళ్లీ రాకుండా.",
"bl_next": "తదుపరి కాల్: {when} తర్వాత",
"bl_urgent": "అర్జెంటా? శ్రామికకు కాల్ చేయండి",
"bl_ok": "సరే",
"cb_pill": "బుకింగ్‌కి కాల్",
"cb_barTitle": "ఏ కారు తీసుకోవాలో తెలియట్లేదా? మేమే బుక్ చేస్తాం",
"cb_hours": "ఉదయం 8 – రాత్రి 9 · తెలుగు, హిందీ, ఇంగ్లీష్",
"cb_call": "కాల్ చేయండి",
"cb_or": "లేదా మాకు కాల్ చేయండి, మేమే బుక్ చేస్తాం:",
"cb_want": "మీ కోసం మేమే బుక్ చేయాలా?",
"cb_quiet": "కాల్ చేసి బుక్ చేయాలా? మేమే బుక్ చేస్తాం",
"cb_callUs": "కాల్ చేయండి",
"hm_guestCardT": "ఒక్కసారి లాగిన్ - ఏ డ్రైవర్‌కైనా నేరుగా కాల్",
"hm_guestCardD": "మొబైల్ నంబర్‌తో ఉచితం. బుకింగ్ ఫీజు లేదు.",
"hm_loginShort": "లాగిన్",
"vc_speak": "మాట్లాడండి",
"vc_listening": "మాట్లాడండి…",
"vc_langs": "తెలుగు · హిందీ · ఇంగ్లీష్ - మీ భాషలోనే",
"vc_stop": "ఆపండి",
"vc_errMic": "మాట్లాడటానికి మైక్ అనుమతి ఇవ్వండి",
"vc_errNone": "ఏమీ వినిపించలేదు - మళ్లీ ప్రయత్నించండి",
"vc_errOther": "ఇప్పుడు వాయిస్ పని చేయడం లేదు - టైప్ చేయండి",
"sq_phCars": "కారు, ఊరు, ట్రిప్ - ఏదైనా అడగండి",
"sq_phDrivers": "డ్రైవర్, భాష, ట్రిప్ - ఏదైనా అడగండి",
"sq_recent": "ఇటీవల మీరు వెతికినవి",
"sq_clear": "అన్నీ తీసేయండి",
"sq_remove": "తీసేయండి",
"sq_try": "ఇలా అడగొచ్చు",
"sq_trips": "ప్రముఖ యాత్రలు",
"sq_understood": "అర్థమైంది:",
"sq_goTrip": "ఈ ట్రిప్‌కి ధరలు చూడండి",
"sq_goCars": "ఈ కార్లు చూపించండి",
"sq_goDrivers": "ఈ డ్రైవర్లను చూపించండి",
"sq_speaks": "{lang} మాట్లాడే డ్రైవర్",
"sq_ex1": "రేపు తిరుపతికి 7 సీటర్",
"sq_ex2": "ఎయిర్‌పోర్ట్ డ్రాప్",
"sq_ex3": "7 సీటర్ డీజిల్",
"sq_ex4": "ఎల్లుండి హైదరాబాద్ వెళ్ళి రావాలి",
"sq_dx1": "రేపు ఉదయం హైదరాబాద్ వెళ్ళి రావాలి",
"sq_dx2": "ఈరోజు రాత్రి ఎయిర్‌పోర్ట్ డ్రాప్",
"sq_dx3": "రేపు హిందీ మాట్లాడే డ్రైవర్",
"sq_dx4": "రేపు తిరుపతి",
"sq_inDrivers": "ఈ పేరుతో కారు లేదు - డ్రైవర్లలో {n} దొరికారు ›",
"sq_inCars": "ఈ పేరుతో డ్రైవర్ లేరు - కార్లలో {n} దొరికాయి ›",
"vr_titleCars": "మీ కార్లు ఎంత దూరం వరకు కనిపించాలి?",
"vr_titleDriver": "మీ ప్రొఫైల్ ఎంత దూరం వరకు కనిపించాలి?",
"vr_sub": "కస్టమర్ పికప్ మీ దగ్గర నుండి ఈ దూరం లోపల ఉంటే మీరు వాళ్లకు కనిపిస్తారు.",
"vr_km": "{n} కి.మీ",
"vr_sramika": "శ్రామిక",
"vr_legCity": "శ్రామిక {n} కి.మీ",
"vr_legOwn": "మీది {n} కి.మీ",
"vr_note": "దూరం పెరిగితే ఎక్కువ ఎంక్వైరీలు వస్తాయి - కానీ దూరం నుండి పికప్‌కి మీరే రావాలి.",
"vr_save": "సేవ్ చేయండి",
"vr_reset": "శ్రామిక దూరానికే ({n} కి.మీ) మార్చండి",
"vr_saved": "సేవ్ అయింది",
"vr_err": "సేవ్ కాలేదు - మళ్లీ ప్రయత్నించండి",
"vr_later": "తర్వాత డాష్‌బోర్డ్‌లో మార్చుకోవచ్చు.",
"dk_bizSub": "డ్రైవర్ల కోసం.",
"dk_bizCalls": "కస్టమర్ల నుండి నేరుగా కాల్స్",
"dk_bizPrices": "మీ సొంత ధరలు",
"dk_bizHours": "మీ సొంత సమయాలు",
"dk_bizJoin": "కొత్తవారా? శ్రామికలో చేరండి",
"dk_step1": "ఫారం నింపండి",
"dk_step2": "శ్రామిక చెక్ చేస్తుంది",
"dk_step3": "కస్టమర్లు మీకు కాల్ చేస్తారు",
"dk_trustCars": "తనిఖీ చేసిన కార్లు",
"dk_trustDrivers": "తనిఖీ చేసిన డ్రైవర్లు",
"dk_trustPrice": "కాల్ చేసే ముందే ధర",
"dk_trustCallOwner": "డ్రైవర్‌కి నేరుగా కాల్",
"dk_trustCallDriver": "డ్రైవర్‌కి నేరుగా కాల్",
"dk_tripReady": "అంతా సిద్ధం - చూపించే ధరలు ఈ ట్రిప్‌కే.",
"dk_tripReadyDrivers": "అంతా సిద్ధం - ప్రతి డ్రైవర్ ధర ఈ ట్రిప్‌కే.",
"dk_route": "రూట్",
"dk_group": "గ్రూప్",
"dk_people": "{n} మంది",
"dk_person": "ఒక్కరు",
"dk_bags": "{n} బ్యాగులు",
"dk_bag": "1 బ్యాగ్",
"dk_kmApprox": "సుమారు {km} కి.మీ.",
"hm_linkCopied": "లింక్ కాపీ అయింది - వాట్సాప్‌లో పంపండి",
"hm_setPickup": "పికప్‌గా పెట్టండి",
"hm_goingTo": "{city} కి వెళ్తున్నారా?",
"hm_canTake": "{city} నుండి {items} మిమ్మల్ని అక్కడికి తీసుకెళ్తాయి",
"hm_setDrop": "డ్రాప్‌గా పెట్టండి",
"hm_seeBasedIn": "{city} లో ఉన్న కార్లు చూడండి",
"hm_bTop": "టాప్ రేటింగ్",
"hm_bNearby": "దగ్గరలో",
"hm_homeReturn": "{city} కారు · తిరిగి వెళ్తూ మిమ్మల్ని తీసుకెళ్తుంది",
"rc_badge": "శ్రామిక సిఫార్సు",
"join_vendor": "కార్ వాష్ లేదా కార్ తనిఖీ వ్యాపారమా? మీ వ్యాపారాన్ని చేర్చండి →",
"rc_checked": "శ్రామిక పరిశీలించింది: పత్రాలు, ధరలు, కాల్స్ ఎత్తుతారు, ఫిర్యాదులు లేవు",
"rc_why": "సిఫార్సు ఉన్న కార్లు దగ్గర్లోని కస్టమర్లకు పైన కనిపిస్తాయి.",
"rc_has": "{date} వరకు మీకు ఉంది",
"rc_c_verified": "ధృవీకరించబడింది",
"rc_c_profile": "అన్ని ధరలు పెట్టండి",
"rc_c_answers": "కాల్స్ ఎత్తండి",
"rc_c_rated": "మంచి రేటింగ్స్",
"rc_c_price": "సరైన ధర",
"rc_c_clean": "ఫిర్యాదులు లేవు",
"hm_bLuxury": "లగ్జరీ",
"hm_bFamily": "ఫ్యామిలీ ట్రిప్",
"hm_bFast": "త్వరగా బుకింగ్",
"hm_bNew": "శ్రామికలో కొత్త",
"hm_online": "ఆన్‌లైన్",
"hm_newTag": "కొత్త",
"hm_viewFare": "ధర చూడండి",
"hm_nReviews": "{n} సమీక్షలు",
"hm_onTrip": "ట్రిప్‌లో ఉంది",
"hm_repair": "రిపేర్‌లో ఉంది",
"hm_age": "వయసు {n}",
"hm_yrs": "{yrs} సం.",
"hm_driving": "డ్రైవింగ్",
"hm_minAway": "{n} నిమి. దూరం",
"hm_kmAway": "{km} కి.మీ దూరం",
"hm_aboutKm": "సుమారు {km} కి.మీ",
"hm_under1km": "1 కి.మీ లోపు",
"hm_distFrom": "{place} నుండి {dist}",
"hm_matchedBy": "సరిపోయింది: {what}",
"hm_mModel": "కారు మోడల్",
"hm_mBrand": "బ్రాండ్",
"hm_mDriver": "డ్రైవర్ పేరు",
"hm_mLang": "భాష",
"hm_mDetails": "కారు వివరాలు",
"hm_mName": "పేరు",
"hm_mCity": "నగరం",
"hm_mProfile": "ప్రొఫైల్",
"hm_seePrice": "ధర చూడండి",
"hm_saveAmt": "₹{amt} ఆదా",
"hm_call": "కాల్",
"hm_viewCar": "{name} వివరాలు చూడండి",
"hm_photoOf": "{name} ఫోటో {n}",
"hm_tooLong": "ఒక్క డ్రైవర్‌కి చాలా దూరం",
"hm_priceOnReq": "ధర అడిగి తెలుసుకోండి",
"hm_oneHr": "1 గం",
"hm_busy": "బిజీ",
"hm_offline": "ఆఫ్‌లైన్",
"hm_confirmTitle": "{name} కి కాల్ చేయాలా?",
"hm_confirmText": "{car} గురించి. మీ ప్రయాణ వివరాలు కాల్‌తో పాటు డ్రైవర్‌కి వెళ్తాయి.",
"hm_thePartner": "డ్రైవర్",
"hm_cancel": "వద్దు",
"hm_callConnecting": "మిమ్మల్ని డ్రైవర్‌కి కలుపుతున్నాం.",
"hm_callFailed": "కాల్ కలవలేదు. మళ్ళీ ప్రయత్నించండి.",
"hm_partnerBusy": "ఈ డ్రైవర్ ఇప్పుడు కాల్స్ తీసుకోలేరు. వేరే కారు ప్రయత్నించండి.",
"hm_cantCall": "ఈ ఖాతా నుండి డ్రైవర్లకు కాల్ చేయలేరు. కస్టమర్‌గా లాగిన్ అవ్వండి.",
"hm_findingCars": "{city} లో కార్లు వెతుకుతోంది…",
"hm_findingDrivers": "{city} లో డ్రైవర్లను వెతుకుతోంది…",
"hm_pickCityCars": "కార్లు చూడటానికి మీ నగరం ఎంచుకోండి",
"hm_pickCityDrivers": "డ్రైవర్లను చూడటానికి మీ నగరం ఎంచుకోండి",
"hm_networkGrowing": "శ్రామిక విస్తరిస్తోంది",
"hm_noCarsIn": "{city} లో ఇంకా కార్లు లేవు",
"hm_noCarsText": "ఇక్కడ డ్రైవర్లను చేర్చుకుంటున్నాం. వేరే నగరం చూడండి, లేదా మీకు కారు ఉంటే చేరండి.",
"hm_noDriversIn": "{city} లో ఇంకా డ్రైవర్లు లేరు",
"hm_noDriversText": "ఇక్కడ డ్రైవర్లను చేర్చుకుంటున్నాం. వేరే నగరం చూడండి, లేదా మీరు డ్రైవర్ అయితే చేరండి.",
"hm_joinPartner": "మీ కారుతో చేరండి",
"hm_joinDriver": "డ్రైవర్‌గా చేరండి",
"hm_supTitle": "శ్రామిక సహాయం కావాలా?",
"hm_supText": "మాకు కాల్ చేయండి. సరైన కారు దొరకడానికి సహాయం చేస్తాం.",
"hm_ocTitle": "{city} లో కార్లు కావాలా?",
"hm_ocText": "మీ నగరం ఇప్పుడు {current}.",
"hm_switchTo": "{city} కి మార్చండి",
"hm_lookingFor": "{city} దగ్గర “{q}” కోసం వెతుకుతోంది…",
"hm_iAccT": "మీ ఖాతా కోసం చూస్తున్నారా?",
"hm_iAccD": "మీ ప్రొఫైల్, సెట్టింగ్స్ ఖాతాలో ఉంటాయి.",
"hm_iAccB": "ఖాతా తెరవండి",
"hm_iPartT": "మీ కారును శ్రామికలో చేర్చాలా?",
"hm_iPartD": "మీ కారుతో లేదా డ్రైవర్‌గా శ్రామికలో బిజినెస్‌గా చేరి కస్టమర్ల నుండి కాల్స్ పొందండి. కమీషన్ లేదు.",
"hm_iTripsT": "మీ ప్రయాణాల కోసం చూస్తున్నారా?",
"hm_iTripsD": "మీ విచారణలు, ప్రయాణాలు చరిత్రలో ఉంటాయి.",
"hm_iTripsB": "చరిత్ర తెరవండి",
"hm_iPriceT": "ధరలు చూస్తున్నారా?",
"hm_iPriceD": "ప్రతి కారు ధర చూడటానికి పైన మీ ప్రయాణం వివరాలు ఇవ్వండి.",
"hm_iRouteT": "ఎక్కడికైనా వెళ్తున్నారా?",
"hm_iRouteD": "మీ ప్రయాణం ఇవ్వడానికి పైన “పికప్ లొకేషన్” నొక్కండి.",
"hm_noFound": "“{q}” కి కార్లు దొరకలేదు",
"hm_noDriversFound": "“{q}” కి డ్రైవర్లు దొరకలేదు",
"hm_noMatchCars": "మీ ఫిల్టర్లకు సరిపోయే కార్లు లేవు",
"hm_noMatchDrivers": "మీ ఫిల్టర్లకు సరిపోయే డ్రైవర్లు లేరు",
"hm_tryThese": "వీటిలో ఒకటి ప్రయత్నించండి:",
"hm_clearFilters": "ఫిల్టర్లు తీసేయండి",
"hm_hide": "దాచు",
"hm_didBookCar": "{car} బుక్ చేశారా?",
"hm_didBookWith": "{name} తో {car} బుక్ చేశారా?",
"hm_didHire": "{name} ని పెట్టుకున్నారా?",
"hm_thanksSaid": "ధన్యవాదాలు - మీరు “{answer}” అన్నారు.",
"hm_askLater": "తర్వాత అడగండి",
"hm_joinDriverT": "మీరు డ్రైవరా?",
"hm_joinDriverD": "శ్రామికలో చేరి కస్టమర్ల నుండి కాల్స్ పొందండి.",
"hm_join": "చేరండి",
"hm_joinCarT": "మీకు కారు ఉందా?",
"hm_joinCarD": "మీ కారును శ్రామికలో చేర్చి కస్టమర్ల నుండి కాల్స్ పొందండి. కమీషన్ లేదు.",
"hm_myRequests": "నా హైర్ అభ్యర్థనలు",
"hm_loading": "లోడ్ అవుతోంది…",
"hm_reqPending": "వేచి ఉంది",
"hm_reqAccepted": "అంగీకరించారు",
"hm_reqRejected": "తిరస్కరించారు",
"hm_halfDay": "అర రోజు (4 గం)",
"hm_fullDay": "పూర్తి రోజు (8 గం)",
"hm_rateThisDriver": "ఈ డ్రైవర్‌కి రేటింగ్ ఇవ్వండి",
"hm_rated": "రేటింగ్ ఇచ్చారు",
"hm_reqSent": "అభ్యర్థన పంపబడింది",
"hm_reqSentText": "డ్రైవర్ మీ అభ్యర్థన చూసి త్వరలో జవాబు ఇస్తారు.",
"hm_ratingSent": "రేటింగ్ పంపబడింది",
"hm_ratingThanks": "ధన్యవాదాలు. ఇది ఇతర కస్టమర్లకు సహాయపడుతుంది.",
"hm_ok": "సరే",
"mc_custRequest": "కస్టమర్ అభ్యర్థన",
"mc_helpLead": "ఈ లీడ్‌లో సహాయం కావాలా? శ్రామికకు కాల్ చేయండి",
"ld_stCall": "కాల్ చేశారు",
"ld_stAccepted": "అంగీకరించారు",
"ld_stSuccess": "ప్రయాణం విజయవంతం",
"ld_stConfirm": "నిర్ధారించాలి",
"ld_stNotBooked": "బుక్ కాలేదు",
"ld_waiting": "వేచి ఉంది",
"ld_afterTrip": "ప్రయాణం తర్వాత",
"ld_chipDone": "పూర్తయింది",
"ld_chipConfirm": "మీ జవాబు కావాలి",
"ld_chipUpcoming": "రాబోయేది",
"ld_chipSent": "విచారణ పంపారు",
"ld_title": "విచారణ వివరాలు",
"ld_sub": "మీ విచారణ చూసి, ఏమైందో చెప్పండి",
"ld_tripEnquiry": "ప్రయాణ విచారణ",
"ld_sentTo": "{name} కి పంపబడింది",
"ld_sentPartner": "డ్రైవర్‌కి పంపబడింది",
"ld_tripDetails": "ప్రయాణ వివరాలు",
"ld_tripDate": "ప్రయాణ తేదీ",
"ld_enquiryDate": "విచారణ తేదీ",
"ld_distance": "దూరం",
"ld_passengers": "ప్రయాణికులు",
"ld_vehicle": "అడిగిన వాహనం",
"ld_driverReq": "అడిగిన డ్రైవర్",
"ld_refFare": "సూచన ధర",
"ld_refNote": "ఇది మీకు చూపిన ధర. చివరి ధర డ్రైవర్‌తో నేరుగా మాట్లాడి నిర్ణయించుకోవాలి.",
"ld_didBook": "ఈ కారు బుక్ చేశారా?",
"ld_didBookDriver": "ఈ డ్రైవర్‌ని పెట్టుకున్నారా?",
"ld_didBookSub": "ఈ విచారణ ఏమైందో మాకు చెప్పండి.",
"ld_yes": "అవును, బుక్ చేశాను",
"ld_yesSub": "వారితో వెళ్ళాను",
"ld_no": "లేదు, బుక్ చేయలేదు",
"ld_noSub": "నేను వెళ్ళలేదు",
"ld_maybe": "ఇంకా నిర్ణయించలేదు",
"ld_maybeSub": "ఇంకా తెలియదు",
"ld_beforeTrip": "ప్రయాణ తేదీ తర్వాత జవాబు ఇవ్వవచ్చు.",
"ld_rateTitle": "మీ అనుభవం ఎలా ఉంది?",
"ld_rateSub": "మీ స్టార్లు ఇతర కస్టమర్లు ఎంచుకోవడానికి సహాయపడతాయి.",
"ld_ratePh": "మీ అనుభవం గురించి చెప్పండి (ఐచ్ఛికం)",
"ld_rateSend": "రేటింగ్ పంపండి",
"ld_rateThanks": "ధన్యవాదాలు - మీరు {n} ★ ఇచ్చారు",
"ld_rateErr": "రేటింగ్ సేవ్ కాలేదు. మళ్ళీ ప్రయత్నించండి.",
"ld_whyTitle": "బుక్ చేయకపోతే, ఏమైంది?",
"ld_whySub": "మీకు మంచి సేవ ఇవ్వడానికి (ఐచ్ఛికం)",
"ld_rHigh": "ధర ఎక్కువ",
"ld_rNotAvail": "కారు అందుబాటులో లేదు",
"ld_rElsewhere": "వేరే చోట బుక్ చేశాను",
"ld_rNoResp": "స్పందన లేదు",
"ld_rPlans": "ప్లాన్ మారింది",
"ld_rOther": "ఇతర",
"ld_rThanks": "చెప్పినందుకు ధన్యవాదాలు.",
"ld_callPartner": "డ్రైవర్‌కి కాల్ చేయండి",
"ld_callSub": "పార్ట్‌నర్‌తో నేరుగా మాట్లాడండి",
"mc_tabLeads": "లీడ్స్",
"mc_tabWallet": "వాలెట్",
"mc_free": "లీడ్స్ ఇప్పుడు ఉచితం.",
"mc_freeSub": "మీ వాలెట్ నుండి ఏమీ తీసుకోము.",
"mc_low": "వాలెట్ ₹{min} కంటే తక్కువ - లీడ్స్ రావాలంటే డబ్బు జోడించండి.",
"mc_addMoney": "డబ్బు జోడించండి - శ్రామికకు కాల్",
"mc_cars": "కార్లు",
"mc_available": "అందుబాటులో",
"mc_busy": "బిజీ",
"mc_inReview": "పరిశీలనలో",
"mc_myDrivers": "నా డ్రైవర్లు",
"mc_limit": "వాహనాల పరిమితి చేరింది ({n})",
"mc_live": "లైవ్",
"mc_rejected": "ఆమోదించలేదు",
"mc_hidden": "దాచబడింది",
"mc_availability": "అందుబాటు",
"mc_onTrip": "ట్రిప్‌లో ఉంది",
"mc_maint": "మరమ్మతులో",
"mc_avHint": "\"ట్రిప్‌లో ఉంది\" లేదా \"మరమ్మతులో\" అని కస్టమర్లకు మీ కారు మీద కనిపిస్తుంది. 24 గంటల తర్వాత మళ్ళీ అందుబాటులోకి వస్తుంది.",
"mc_addDriver": "డ్రైవర్ జోడించండి",
"mc_driver": "డ్రైవర్",
"mc_chooseDriver": "డ్రైవర్‌ని ఎంచుకోండి",
"mc_drvPending": "(ఆమోదం కోసం)",
"mc_pricesDetails": "ధరలు & వివరాలు",
"mc_reviewText": "శ్రామిక ఈ కారుని పరిశీలిస్తోంది. లైవ్ అయినప్పుడు మీకు చెబుతాం.",
"mc_editsPending": "మీ తాజా మార్పులు ఆమోదం కోసం వేచి ఉన్నాయి.",
"mc_rejectedText": "ఈ కారు ఆమోదం పొందలేదు. కారణం తెలుసుకోవడానికి శ్రామికకు కాల్ చేయండి.",
"mc_hiddenText": "ఈ కారు కస్టమర్లకు కనిపించదు. మళ్ళీ చూపించడానికి శ్రామికకు కాల్ చేయండి.",
"mc_noCars": "ఇంకా కార్లు లేవు",
"mc_noCarsSub": "కాల్స్ రావడానికి మీ కారుని జోడించండి.",
"mc_regProgress": "కారు నమోదు జరుగుతోంది",
"mc_regProgressSub": "మీ కారు సిద్ధం చేస్తున్నాం. ఒక రోజు కంటే ఎక్కువ పడితే శ్రామికకు కాల్ చేయండి.",
"mc_profileReview": "ప్రొఫైల్ పరిశీలనలో ఉంది",
"mc_profileReviewSub": "మీ డాక్యుమెంట్లు పరిశీలిస్తున్నాం. ఆమోదం తర్వాత మీ కార్లు లైవ్ అవుతాయి.",
"mc_submitted": "పంపిన తేదీ",
"mc_appId": "దరఖాస్తు ఐడీ",
"mc_licExpired": "లైసెన్స్ గడువు ముగిసింది",
"mc_licExpiredSub": "మీ డ్రైవింగ్ లైసెన్స్ గడువు ముగిసింది. రెన్యూ చేసి మళ్ళీ పంపండి.",
"mc_licAgain": "లైసెన్స్ ఫోటో మళ్ళీ కావాలి",
"mc_licAgainSub": "మీ లైసెన్స్ ఫోటో స్పష్టంగా లేదు. స్పష్టమైన ఫోటో పంపండి.",
"mc_loading": "మీ కార్లు లోడ్ అవుతున్నాయి…",
"mc_loadErr": "లోడ్ కాలేదు. మళ్ళీ ప్రయత్నించండి.",
"mc_retry": "మళ్ళీ ప్రయత్నించండి",
"mc_relogin": "మళ్ళీ లాగిన్ అవ్వండి",
"mc_moveDriver": "{a} ని ఈ కారుకి మార్చాలా? {b} కి వేరే కారు వస్తుంది.",
"mc_replaceDriver": "{a} ని ఈ కారుకి పెట్టాలా? {b} ని దీని నుండి తీసేస్తాం.",
"mc_assignErr": "డ్రైవర్‌ని మార్చలేకపోయాం. మళ్ళీ ప్రయత్నించండి.",
"mc_getMore": "మరిన్ని కాల్స్ పొందండి",
"mc_getMoreSub": "5 సులభమైన దశలు",
"mc_leadPrices": "లీడ్ ధరలు",
"mc_leadPricesSub": "ఒక లీడ్ ధర ఎంత",
"mc_yourLeads": "మీ లీడ్స్",
"mc_leadsCount": "{n} · కొత్తవి ముందు",
"mc_noLeads": "ఇంకా లీడ్స్ లేవు",
"mc_noLeadsSub": "కస్టమర్లు శ్రామిక ద్వారా మీకు కాల్ చేసినప్పుడు ఇక్కడ కనిపిస్తారు.",
"mc_new": "కొత్తది",
"mc_called": "కాల్ చేశారు",
"mc_booked": "బుక్ అయింది",
"mc_custPrice": "కస్టమర్‌కి చూపిన ధర",
"mc_showNumber": "నంబర్ చూపించు",
"mc_revealSoon": "కస్టమర్ నంబర్ చూపించడం త్వరలో వస్తోంది.",
"mc_didHappen": "ఈ ప్రయాణం జరిగిందా?",
"mc_youMarked": "మీ జవాబు: {answer}",
"mc_locked": "మార్చలేరు",
"mc_changesLeft": "జవాబు మార్చండి - {n} మిగిలాయి",
"mc_rateCust": "ఈ కస్టమర్‌కి రేటింగ్ ఇవ్వండి",
"mc_rated": "ధన్యవాదాలు - రేటింగ్ ఇచ్చారు",
"mc_leadDetails": "లీడ్ వివరాలు",
"mc_leadDetailsSub": "కస్టమర్ విచారణ, ఏమైంది",
"mc_customer": "కస్టమర్",
"mc_quoted": "కస్టమర్‌కి చూపిన ధర",
"mc_freeLine": "లీడ్స్ ఇప్పుడు ఉచితం - దీని నుండి ఏమీ తీసుకోము.",
"mc_chargeLine": "లీడ్ ఫీజులు ఈ బ్యాలెన్స్ నుండి తీసుకుంటాం.",
"mc_refer": "ఒక వ్యాపారాన్ని రిఫర్ చేయండి",
"mc_referText": "మీరు ఆహ్వానించిన డ్రైవర్ ఆమోదం పొందగానే, లీడ్ ఫీజుల కోసం మీ ఇద్దరికీ క్రెడిట్ వస్తుంది.",
"mc_txns": "లావాదేవీలు",
"mc_noTxns": "ఇంకా లావాదేవీలు లేవు",
"mc_tip1": "లీడ్ ఫీజులు ఈ వాలెట్ నుండి",
"mc_tip2": "బ్యాలెన్స్ తక్కువైతే కొత్త లీడ్స్ ఆగవచ్చు",
"mc_tip3": "యాక్టివ్‌గా ఉండటానికి ఎప్పుడైనా డబ్బు జోడించండి",
"cd_title": "వాహన వివరాలు",
"cd_photosNote": "పరిశీలన తర్వాత నంబర్ ప్లేట్లు ఆటోమేటిక్‌గా దాచబడతాయి.",
"cd_photosMin": "కనీసం 3 ఫోటోలు జోడించండి (ఇంకా {n} కావాలి)",
"cd_photosSent": "పరిశీలనకు పంపాం. ఆమోదం తర్వాత కొత్త ఫోటోలు కనిపిస్తాయి.",
"cd_addPhoto": "ఫోటో జోడించండి",
"cd_replace": "మార్చు",
"cd_remove": "తీసేయి",
"cd_newTag": "కొత్తది",
"cd_pendingTag": "పరిశీలనలో",
"cd_details": "కారు వివరాలు",
"cd_detailsNote": "ఫోటోలు, వివరాల్లో మార్పులు శ్రామిక పరిశీలించిన తర్వాతే కనిపిస్తాయి.",
"cd_city": "నగరం",
"cd_category": "ధర గ్రూప్",
"cd_categoryNote": "మీ మోడల్, సీట్ల బట్టి నిర్ణయమవుతుంది. తప్పుగా ఉంటే శ్రామికకు కాల్ చేయండి.",
"cd_notSet": "ఇంకా నిర్ణయించలేదు",
"cd_acSub": "ఈ కారులో ఏసీ పనిచేస్తుందా?",
"cd_musicSub": "మ్యూజిక్ లేదా బ్లూటూత్ పనిచేస్తుందా?",
"cd_pricesNote": "వెంటనే సేవ్ అవుతుంది. ఖాళీ బాక్స్ కి బూడిద రంగులో చూపిన సూచన ధర వాడతాం.",
"cd_rule": "ధరలు 24 గంటలకు ఒకసారి మాత్రమే పెంచవచ్చు. తగ్గించడం ఎప్పుడైనా చేయవచ్చు.",
"cd_suggestedUsed": "ఖాళీ: సూచన {v} వాడతాం",
"cd_savePrices": "నా ధరలు సేవ్ చేయండి",
"cd_saving": "సేవ్ అవుతోంది…",
"cd_saved": "సేవ్ అయింది",
"cd_savedMsg": "మీ ధరలు సేవ్ అయ్యాయి.",
"cd_saveErr": "మీ ధరలు సేవ్ కాలేదు. మళ్ళీ ప్రయత్నించండి.",
"cd_noCat": "ఈ కారుకి ఇంకా ధర గ్రూప్ లేదు. దయచేసి శ్రామికకు కాల్ చేయండి.",
"cd_submit": "కారు వివరాలు ఆమోదానికి పంపండి",
"cd_sending": "పంపుతోంది…",
"cd_sent": "పంపాం",
"cd_sentMsg": "పంపాం! శ్రామిక పరిశీలించి మీ మార్పులను ఆమోదిస్తుంది.",
"cd_sendErr": "పంపలేకపోయాం. మళ్ళీ ప్రయత్నించండి.",
"cd_minPhotosErr": "దయచేసి కనీసం 3 ఫోటోలు ఉంచండి.",
"cd_noChange": "ఏ ధరా మారలేదు",
"hl_phNote": "ఉదా: నా కారు ఆటోమేటిక్, హిందీ మాట్లాడే డ్రైవర్ కావాలి...",
"hl_noteHint": "మీ విచారణతో పాటు డ్రైవర్‌కి ఇది కనిపిస్తుంది.",
"hl_yearFirst": "ముందు సంవత్సరం ఇవ్వండి",
"lp_headerSub": "మీ ప్రయాణం ప్లాన్ చేసి, మంచి కార్లు చూడండి",
"hl_headerSub": "మీ ప్రయాణం ప్లాన్ చేసి, మంచి డ్రైవర్లను చూడండి",
"lp_whenSub": "ప్రయాణ తేదీలు, సమయాలు ఎంచుకోండి",
"lp_prefSub": "ఇంకొన్ని వివరాలు చెప్పండి",
"lp_optional": "(ఐచ్ఛికం)",
"lp_clear": "తుడిచేయి",
"hl_carTitle": "డ్రైవర్ నడపాల్సిన మీ కారు",
"hl_carSub": "మీ కారు సంవత్సరం, మోడల్",
"hl_year": "సంవత్సరం",
"hl_model": "మోడల్",
"hl_fuel": "ఇంధన రకం",
"hl_phYear": "ఉదా: 2018",
"hl_phModel": "మోడల్ వెతకండి",
"hl_phFuel": "మోడల్ నుండి వస్తుంది",
"hl_car": "మీ కారు",
"hl_farPickup": "{area} {city} నుండి 30 కి.మీ కంటే ఎక్కువ దూరంలో ఉంది. 30 కి.మీ లోపల ఉన్న చోటు ఎంచుకోండి, లేదా నగరం మార్చండి.",
"hl_tooFar": "{from} నుండి {to} {km} కి.మీ - ఒక్క డ్రైవర్‌కి పరిమితి {max} కి.మీ. దయచేసి {max} కి.మీ లోపల గమ్యం ఎంచుకోండి.",
"hl_noPlace": "మీ లొకేషన్ నుండి ప్రదేశం పేరు తెలియలేదు - దయచేసి మీ నగరం టైప్ చేయండి.",
"navDashboard": "డ్యాష్‌బోర్డ్",
"ac_language_sub": "యాప్ భాష మార్చండి",
"ac_support": "సహాయం",
"ac_support_sub": "సహాయం & ప్రశ్నలు",
"ac_settings": "సెట్టింగ్స్",
"ac_settings_sub": "ప్రొఫైల్ & ఎంపికలు",
"ac_profileInfo": "ప్రొఫైల్ వివరాలు",
"ac_profileInfo_sub": "పేరు, ఈమెయిల్, ఫోన్ మార్చండి",
"ac_prefCity": "నచ్చిన నగరం",
"ac_prefCity_sub": "డిఫాల్ట్ నగరం మార్చండి",
"ac_terms": "నిబంధనలు",
"ac_terms_sub": "నిబంధనలు & షరతులు",
"ac_privacy": "గోప్యత",
"ac_privacy_sub": "గోప్యతా విధానం",
"ac_history_sub": "మీ విచారణలు, గత ప్రయాణాలు",
"ac_notifications": "నోటిఫికేషన్లు",
"ac_notif_sub_user": "ప్రయాణం & ఖాతా అప్‌డేట్లు",
"ac_notif_sub": "ఖాతా అప్‌డేట్లు",
"ac_ownerDash": "డ్రైవర్ డ్యాష్‌బోర్డ్",
"ac_ownerDash_sub": "లీడ్స్, కార్లు, వాలెట్",
"ac_myCars": "నా కార్లు",
"ac_myCars_sub": "మీ వాహనాల జాబితా",
"ac_addVehicle": "వాహనం జోడించండి",
"ac_addVehicle_sub": "ఇంకో కారును ఆమోదం కోసం పంపండి",
"ac_driverDash": "డ్రైవర్ డ్యాష్‌బోర్డ్",
"ac_driverDash_sub": "మీ లీడ్స్, ధరలు, స్థితి",
"ac_menuUser": "నా ఖాతా",
"ac_menuUser_sub": "మీ ప్రయాణాలు & ఖాతా",
"ac_menuOwner": "డ్రైవర్ మెనూ",
"ac_menuOwner_sub": "వాహనాలు & డ్రైవర్ పనులు",
"ac_menuDriver": "హైర్ డ్రైవర్ మెనూ",
"ac_menuDriver_sub": "మీ లీడ్స్ & స్థితి",
"ac_menuAgent": "ఫీల్డ్ ఏజెంట్ మెనూ",
"ac_menuAgent_sub": "మీ రిఫరల్ కోడ్ & ఖాతా",
"ac_menuGeneral": "సాధారణ ఎంపికలు",
"ac_menuGeneral_sub": "ఖాతా & యాప్ ఎంపికలు",
"ac_account": "ఖాతా",
"ac_editProfile": "ప్రొఫైల్ మార్చండి",
"ac_changePhoto": "ప్రొఫైల్ ఫోటో మార్చండి",
"ac_verified": "ధృవీకరించబడింది",
"ac_back": "వెనక్కి",
"ac_pendingTitle": "బిజినెస్ దరఖాస్తు పరిశీలనలో ఉంది",
"ac_pendingText": "మీ బిజినెస్ దరఖాస్తును అడ్మిన్ పరిశీలిస్తున్నారు. ఆమోదం రాగానే మీకు తెలియజేస్తాం.",
"ac_strength": "ప్రొఫైల్ బలం",
"ac_strengthDone": "పూర్తయింది - అంతా సిద్ధం!",
"ac_strengthGood": "బాగుంది",
"ac_strengthLow": "అసంపూర్ణం - ప్రొఫైల్ పూర్తి చేయండి",
"ac_searchPh": "సెట్టింగ్స్, డ్యాష్‌బోర్డ్ వెతకండి…",
"ac_clearSearch": "వెతుకుట తుడిచేయి",
"ac_noMatch": "ఏమీ దొరకలేదు",
"ac_tryElse": "వేరే మాటతో వెతకండి",
"ac_inSection": "{section} లో",
"ac_agentCode": "రిఫరల్ కోడ్",
"ac_agentCodeSub": "మీరు చేర్చే డ్రైవర్‌కి ఇది ఇవ్వండి",
"ac_noCode": "ఇంకా కోడ్ లేదు",
"ac_copy": "కాపీ",
"ac_copied": "కాపీ అయింది",
"ac_working": "పని జరుగుతోంది…",
"ac_genNew": "కొత్త కోడ్ సృష్టించండి",
"ac_gen": "కోడ్ సృష్టించండి",
"ac_agentNote": "డ్రైవర్ చేరేటప్పుడు ఈ కోడ్ ఇవ్వాలి, అప్పటికి అది చెల్లుబాటులో ఉండాలి. కొత్త కోడ్ సృష్టిస్తే పాత కోడ్ పనిచేయదు.",
"ac_agentConfirm": "కొత్త కోడ్ సృష్టించాలా? మీ ప్రస్తుత కోడ్ వెంటనే పనిచేయదు, దాన్ని రాసుకున్న వారు వాడలేరు. ఇప్పటికే దానితో చేరిన ఖాతాలకు క్రెడిట్ ఉంటుంది.",
"ac_agentErr": "కోడ్ సృష్టించలేకపోయాం. మళ్ళీ ప్రయత్నించండి.",
"ac_refer": "రిఫర్ చేసి సంపాదించండి",
"ac_referCustSub": "డ్రైవర్ లేదా ఆల్టింగ్ డ్రైవర్‌ని ఆహ్వానించండి",
"ac_referCustSubR": "డ్రైవర్ లేదా ఆల్టింగ్ డ్రైవర్‌ని ఆహ్వానించి, ఒక్కొక్కరికి ₹{amt} పొందండి",
"ac_referCustText": "క్యాబ్ ఉన్నవారు లేదా హైర్‌కి నడిపేవారు తెలుసా? మీ కోడ్ పంపండి. వారి ఖాతా ఆమోదం పొందగానే, మీ శ్రామిక వాలెట్‌లో {reward} వస్తుంది.",
"ac_aCredit": "రిఫరల్ క్రెడిట్",
"ac_share": "షేర్",
"ac_approved": "ఆమోదించారు",
"ac_waiting": "వేచి ఉంది",
"ac_yourWallet": "మీ వాలెట్",
"ac_referBizSub": "ఇంకో డ్రైవర్ లేదా ఆల్టింగ్ డ్రైవర్‌ని ఆహ్వానించండి",
"ac_referBizSubR": "ఇంకో డ్రైవర్‌ని ఆహ్వానించండి - ఇద్దరికీ ₹{amt}",
"ac_referSoon": "మీ ఖాతా ఆమోదం పొందగానే మీ రిఫరల్ కోడ్ వస్తుంది.",
"ac_referBizText": "మీ కోడ్ పంపండి. వారి ఖాతా ఆమోదం పొందగానే, లీడ్ ఫీజుల కోసం మీ ఇద్దరికీ {credit} వస్తుంది.",
"ac_creditAmt": "₹{amt} క్రెడిట్",
"ac_credit": "క్రెడిట్",
"ac_pickCar": "రిఫరల్ ఏ కారుకు నమోదు కావాలో ఎంచుకోండి.",
"ac_spaces": "ఖాళీలు, గీతలు పట్టించుకోము - ఎలా టైప్ చేసినా పనిచేస్తుంది.",
"ac_oneWallet": "మీ ఏ కోడ్ క్రెడిట్ అయినా మీ ఒకే వాలెట్‌లోకి వస్తుంది.",
"ac_car": "కారు {id}",
"ac_calcTitle": "ఓడోమీటర్ & ధర లెక్కింపు",
"ac_calcSub": "ఓడోమీటర్ రీడింగ్‌లతో ధర అంచనా",
"ac_startOdo": "మొదటి రీడింగ్ (కి.మీ)",
"ac_endOdo": "చివరి రీడింగ్ (కి.మీ)",
"ac_endLess": "చివరి రీడింగ్ మొదటిదాని కంటే ఎక్కువ ఉండాలి.",
"ac_calcBtn": "ధర లెక్కించండి",
"ac_calcNone": "ఈ నగరంలో ఈ ప్రయాణానికి, కారుకు ఇంకా ధర లేదు.",
"ac_pricedAs": "లెక్క విధానం: {mode}",
"ac_estNote": "నగరపు సూచించిన ధరలతో అంచనా - చివరి ధరను డ్రైవర్‌తో నిర్ధారించుకోండి. టోల్, పార్కింగ్, రాష్ట్ర పర్మిట్లు అదనం.",
"ac_seats": "{n} సీట్లు",
"ac_logout": "లాగ్ అవుట్",
"ac_loading": "ప్రొఫైల్ లోడ్ అవుతోంది…",
"ac_takePhoto": "ఫోటో తీయండి",
"ac_gallery": "గ్యాలరీ నుండి ఎంచుకోండి",
"ac_removePhoto": "ఫోటో తీసేయండి",
"ac_cancel": "రద్దు",
"ms_title": "మరిన్ని సేవలు",
"ms_sub": "కారు & ప్రయాణ సేవలన్నీ ఒకే చోట",
"ms_towing": "వాహనం తరలించే వ్యాన్",
"ms_towing_sub": "మీ వాహనాన్ని సురక్షితంగా తరలించండి",
"ms_school": "డ్రైవింగ్ స్కూల్స్",
"ms_school_sub": "సర్టిఫైడ్ శిక్షకుల దగ్గర నేర్చుకోండి",
"ms_lease": "నెలవారీ కారు లీజు",
"ms_lease_sub": "డ్రైవర్‌తో కార్లు, నెలవారీ ఒప్పందం",
"ms_tours": "టూర్లు & ప్యాకేజీలు",
"ms_tours_sub": "గ్రూప్ & వ్యక్తిగత టూర్ ధరలు",
"ms_wash": "ఇంటి వద్ద కారు వాష్",
"ms_wash_sub": "మీ ఇంటి దగ్గరే వాష్",
"ms_mechanic": "ఇంటి వద్ద మెకానిక్",
"ms_mechanic_sub": "నమ్మకమైన మెకానిక్‌లు మీ ఇంటికే",
"ms_accessories": "యాక్సెసరీస్ ఫిట్టింగ్",
"ms_accessories_sub": "యాక్సెసరీస్ ఇంటికే తెచ్చి అమర్చుతాం",
"ms_soon": "త్వరలో వస్తోంది",
"ms_noneYet": "మీ నగరంలో ఇంకా ఏ సేవా లేదు - మాకు కాల్ చేసి మీ అవసరం చెప్పండి.",
"ms_soonText": "{service} త్వరలో మీ నగరానికి వస్తోంది. ముందే కావాలా? మాకు కాల్ చేసి మీ అవసరం చెప్పండి.",
"ms_callUs": "శ్రామికకు కాల్ చేయండి",
"ms_close": "మూసివేయి",
"ms_footer": "మరిన్ని సేవలు త్వరలో · మమ్మల్ని సంప్రదించండి: {email}",
"navHireDriver": "డ్రైవర్లు",
"hs_title": "చరిత్ర",
"hs_active": "ప్రస్తుతం",
"hs_past": "గతం",
"hs_loading": "మీ చరిత్ర లోడ్ అవుతోంది…",
"hs_emptyTitle": "ఇంకా ఏమీ లేదు",
"hs_emptyText": "మీ కారు విచారణలు, ప్రయాణాల చరిత్ర ఇక్కడ కనిపిస్తాయి.",
"hs_findCar": "కారు వెతకండి",
"hs_activeEmpty": "ఇప్పుడు ఏమీ లేదు. మీరు చేసే విచారణలు ప్రయాణ తేదీ వరకు ఇక్కడ ఉంటాయి.",
"hs_pastEmpty": "ఇక్కడ ఇంకా ఏమీ లేదు.",
"hs_filterAll": "అన్నీ",
"hs_filterNone": "ఈ ఎంపికకు సరిపోయేవి లేవు.",
"hs_signInTitle": "నా చరిత్ర",
"hs_signInText": "మీ విచారణలు, ప్రయాణాలు చూడటానికి లాగిన్ అవ్వండి.",
"hs_signIn": "లాగిన్ అవ్వండి",
"hs_rateTitle": "మీ చివరి ప్రయాణం ఎలా ఉంది?",
"hs_rateTap": "రేటింగ్ ఇవ్వడానికి స్టార్ నొక్కండి",
"hs_rateLow": "మీ అనుభవాన్ని మెరుగుపరచడానికి ప్రయత్నిస్తాం",
"hs_rateMid": "మీ అభిప్రాయానికి ధన్యవాదాలు!",
"hs_rateHigh": "మీ ప్రయాణం బాగా జరిగినందుకు సంతోషం!",
"hs_rateSubmit": "రేటింగ్ సమర్పించండి",
"hs_rateLater": "తర్వాత",
"hs_rateHelps": "మీ రేటింగ్ తదుపరి ప్రయాణాలను మెరుగుపరుస్తుంది.",
"hs_rateVerified": "మీ ఖాతాను ఇప్పుడు శ్రామిక ధృవీకరించింది!",
"hs_rateDriver": "డ్రైవర్‌కి రేటింగ్ ఇవ్వండి",
"hs_editRating": "రేటింగ్ మార్చండి",
"hs_chatDriver": "డ్రైవర్‌తో చాట్",
"hs_paid": "చెల్లించారు: ₹{amt}",
"hs_stBooked": "బుక్ అయింది",
"hs_stNotBooked": "బుక్ కాలేదు",
"hs_stDeciding": "ఇంకా నిర్ణయించలేదు",
"hs_stContacted": "డ్రైవర్‌ని సంప్రదించారు",
"hs_stSent": "విచారణ పంపారు",
"hs_oneWay": "వన్ వే",
"hs_roundTrip": "రౌండ్ ట్రిప్",
"hs_enquiry": "విచారణ",
"hs_callName": "{name} కి కాల్ చేయండి",
"hs_callDriver": "డ్రైవర్‌కి కాల్ చేయండి",
"hs_askBooked": "ఈ ప్రయాణం బుక్ చేశారా?",
"hs_yes": "అవును",
"hs_no": "లేదు",
"hs_notYet": "ఇంకా లేదు",
"hs_saveFailedRow": "సేవ్ కాలేదు - విచారణ తెరిచి మళ్ళీ ప్రయత్నించండి.",
"hs_saidBooked": "మీరు బుక్ చేశామని చెప్పారు",
"hs_saidNot": "మీరు బుక్ చేయలేదని చెప్పారు",
"hs_saidDeciding": "మీరు ఇంకా నిర్ణయించలేదని చెప్పారు",
"hs_details": "వివరాలు",
"hs_sheetTitle": "ప్రయాణ విచారణ",
"hs_pickup": "పికప్",
"hs_drop": "డ్రాప్",
"hs_tripType": "ప్రయాణ రకం",
"hs_distTime": "దూరం / సమయం",
"hs_vehicle": "వాహనం",
"hs_partner": "పార్ట్‌నర్",
"hs_enquiryMade": "విచారణ చేసిన తేదీ",
"hs_timesCalled": "ఎన్నిసార్లు కాల్ చేశారు",
"hs_quoted": "మీకు చెప్పిన ధర",
"hs_quotedNote": "మీరు విచారించినప్పుడు చూపిన ధర. చివరి ధరను పార్ట్‌నర్‌తో మాట్లాడి నిర్ధారించుకోండి.",
"hs_whatHappened": "ఏం జరిగింది",
"hs_tlCreated": "విచారణ మొదలైంది",
"hs_tlViewed": "మీరు {car} చూశారు",
"hs_tlShared": "నంబర్ ఇచ్చారు",
"hs_tlSharedNote": "పార్ట్‌నర్ నంబర్ మీకు చూపించాం",
"hs_tlCalled": "మీరు పార్ట్‌నర్‌కి కాల్ చేశారు",
"hs_tlCalls": "మొత్తం {n} కాల్స్",
"hs_tlAnswered": "మీరు జవాబిచ్చారు",
"hs_youBooked": "మీరు ఈ ప్రయాణం బుక్ చేశారు",
"hs_youNot": "మీరు ఈ ప్రయాణం బుక్ చేయలేదు",
"hs_youDeciding": "మీరు ఇంకా నిర్ణయించలేదు",
"hs_changeAnswer": "జవాబు మార్చండి",
"hs_noMoreChanges": "ఇక మార్చడానికి వీలు లేదు",
"hs_changesLeft": "మిగిలిన మార్పులు: {n}",
"hs_changeYour": "మీ జవాబు మార్చండి",
"hs_askWhy": "దీనితో మీకు మంచి క్యాబ్‌లు చూపించగలం, డ్రైవర్‌కి కూడా ఉపయోగం.",
"hs_ansYes": "అవును, బుక్ చేశాను",
"hs_ansNo": "లేదు, చేయలేదు",
"hs_keep": "నా జవాబు అలాగే ఉంచండి",
"hs_saveErr": "సేవ్ కాలేదు. మళ్ళీ ప్రయత్నించండి.",
"hs_callAgain": "{name} కి మళ్ళీ కాల్ చేయండి",
"hs_callPartner": "పార్ట్‌నర్‌కి కాల్ చేయండి",
"hs_hrs": "{n} గం",
"hs_close": "మూసివేయి",
"hs_yourRequest": "మీ అభ్యర్థన",
"hs_passengers": "ప్రయాణికులు: {n}",
"hs_luggage": "లగేజీ: {n}",
"hs_noLuggage": "లగేజీ లేదు",
"hs_helpEnquiry": "ఈ విచారణలో సహాయం కావాలా? శ్రామికకు కాల్ చేయండి",
"lp_route": "పికప్ & డ్రాప్",
"lp_lblPickup": "పికప్ లొకేషన్",
"lp_lblDrop": "డ్రాప్ లొకేషన్",
"lp_cityLine": "నగరం: {city}",
"lp_change": "మార్చు",
"lp_sameAsDrivers": "డ్రైవర్లలో పెట్టిన ట్రిప్పేనా?",
"lp_sameAsCars": "కార్లలో పెట్టిన ట్రిప్పేనా?",
"lp_sameYes": "అవును, అదే",
"lp_sameNo": "కాదు, కొత్త ట్రిప్",
"lp_swap": "పికప్, డ్రాప్ మార్చు",
"lp_when": "ఎప్పుడు",
"lp_pickupWhen": "పికప్",
"lp_returnWhen": "తిరుగు ప్రయాణం",
"lp_today": "ఈరోజు",
"lp_tomorrow": "రేపు",
"lp_sameDay": "అదే రోజు",
"lp_nextDay": "మరుసటి రోజు",
"lp_otherDate": "వేరే తేదీ",
"lp_pickTime": "సమయం ఎంచుకోండి",
"lp_distanceLine": "సుమారు {km} కి.మీ · {time}",
"lp_hrMin": "{h} గం {m} ని",
"lp_minOnly": "{m} ని",
"lp_stillNeeded": "ఇంకా కావాలి: {list}",
"lp_noteLabel": "డ్రైవర్‌కి నోట్",
"lp_noteHint": "మీ విచారణతో పాటు డ్రైవర్‌కి ఇది కనిపిస్తుంది.",
"pricesPerCarNote": "ప్రతి కారుకి ధరలు వేరుగా ఉంటాయి. చూడటానికి లేదా మార్చడానికి మీ కారుని తెరవండి.",
"changeMyPrices": "నా ధరలు మార్చండి",
"lp_btnAddStop": "+ స్టాప్ జోడించు",
"lp_btnDetectLocation": "📍 లొకేషన్ గుర్తించు",
"lp_btnDetecting": "గుర్తిస్తోంది…",
"lp_btnViewCabs": "క్యాబ్‌లు చూడండి",
"lp_btnViewDrivers": "డ్రైవర్లను చూడండి",
"lp_btnViewDrivers": "డ్రైవర్లను చూడండి",
"lp_btnCompleteDetails": "ట్రిప్ వివరాలు పూర్తి చేయండి",
"lp_tabRoundTrip": "రౌండ్ ట్రిప్",
"lp_tabOneWay": "డ్రాపింగ్",
"lp_tripDetails": "ట్రిప్ వివరాలు",
"lp_hireDetails": "ట్రిప్ వివరాలు",
"lp_tripPreferencesOptional": "ట్రిప్ ప్రాధాన్యతలు (ఐచ్ఛికం)",
"lp_lblPickupCity": "పికప్ నగరం",
"lp_phTypeCity": "నగరం టైప్ చేయండి",
"lp_lblExactLocation": "ఖచ్చితమైన లొకేషన్",
"lp_phPrecisePickup": "ఖచ్చితమైన పికప్ పాయింట్ ఎంటర్ చేయండి",
"lp_lblPickupSchedule": "పికప్ షెడ్యూల్",
"lp_phStop": "స్టాప్ {n}",
"lp_lblFinalDestination": "చివరి గమ్యస్థానం",
"lp_phDropLocation": "డ్రాప్ లొకేషన్ ఎంటర్ చేయండి",
"lp_lblReturnSchedule": "రిటర్న్ షెడ్యూల్",
"lp_lblDropSchedule": "డ్రాప్ ఆఫ్ చేయవలసిన సమయం",
"lp_hintOneWayReturnCost": "మిమ్మల్ని మరియు మీ వాహనాన్ని దింపిన తర్వాత డ్రైవర్ సొంతంగా తిరిగి వెళ్తారు. ఆ తిరుగు ప్రయాణ ఖర్చు ఈ ఛార్జీలో భాగం కాదు - దయచేసి కాల్‌లో డ్రైవర్‌తో నేరుగా మాట్లాడి ఖరారు చేసుకోండి.",
"lp_lblPassengers": "మీ గ్రూప్లో ప్రయాణికులు",
"lp_subLblGroupCab": "మీ గ్రూప్ మొత్తం క్యాబ్ను బుక్ చేస్తుంది",
"lp_lblLuggage": "లగేజీ",
"lp_lblStops": "స్టాప్లు",
"lp_errSameLocation": "పికప్ మరియు డ్రాప్ ఒకే లొకేషన్ కాకూడదు",
"lp_errReturnTooEarly": "{from} నుండి {to} కు సుమారు {hours} గంటలు పడుతుంది - దయచేసి తర్వాత రిటర్న్ సమయం ఎంచుకోండి",
"lp_backHomeBy": "ఇంటికి చేరే సమయం",
"lp_errBackTooEarly": "{from} నుండి {to} కు వెళ్ళి రావడానికి సుమారు {hours} గంటలు పడుతుంది - దయచేసి తర్వాతి సమయం ఎంచుకోండి",
"lp_hintCalculatingRoute": "మార్గం లెక్కిస్తోంది…",
"lp_phNote": "ఉదా. నాకు బేబీ సీట్, పెట్ ఫ్రెండ్లీ క్యాబ్ కావాలి...",
"lp_promoRoundTrip": "రౌండ్ ట్రిప్ లేదా మల్టీ-స్టాప్?",
"lp_promoMoreStops": "మీ ప్రయాణాన్ని ప్లాన్ చేసుకోవడానికి మరిన్ని స్టాప్లు జోడించండి.",
"lp_toastLocSuccess": "లొకేషన్ గుర్తించబడింది ✅",
"lp_toastLocDeny": "ఈ ఫీచర్ ఉపయోగించడానికి మీ బ్రౌజర్లో లొకేషన్ యాక్సెస్ అనుమతించండి",
"lp_errMissingFields": "తప్పనిసరి ఫీల్డ్లు లేవు: {list}",
"lp_errCity": "దయచేసి నగరాన్ని ఎంచుకోండి.",
"lp_errPickupDt": "దయచేసి పికప్ తేదీ మరియు సమయాన్ని ఎంచుకోండి.",
"lp_errPickupTimeLimit": "పికప్ సమయం ఇప్పటి నుండి కనీసం 30 నిమిషాల తర్వాత ఉండాలి.",
"lp_errReturnDt": "దయచేసి రిటర్న్/ముగింపు తేదీ మరియు సమయాన్ని ఎంచుకోండి.",
"lp_errReturnTimeLimit": "రిటర్న్ సమయం పికప్ సమయం తర్వాత ఉండాలి.",
"lp_errReturnMaxLimit": "రిటర్న్ తేదీ పికప్ నుండి 10 రోజుల లోపల ఉండాలి",
"lp_errPickupLoc": "దయచేసి మీ పికప్ లొకేషన్ ఎంటర్ చేయండి.",
"lp_errPickupRadius": "దయచేసి {city}కి {km} కి.మీ లోపల లొకేషన్ ఎంచుకోండి.",
"lp_errDestLoc": "దయచేసి మీ గమ్యస్థానాన్ని ఎంటర్ చేయండి.",
"lp_errDestRadius": "దయచేసి మీ పికప్ నుండి 1000 కి.మీ లోపల గమ్యస్థానాన్ని ఎంచుకోండి.",
"lp_errStopValid": "దయచేసి సూచనల నుండి స్టాప్ ఎంచుకోండి.",
"lp_errStopRadius": "దయచేసి మీ పికప్ నుండి 1000 కి.మీ లోపల స్టాప్ ఎంచుకోండి.",
"awaitingDriverResponse": "డ్రైవర్ జవాబు కోసం వేచి ఉంది",
"driverConnected": "డ్రైవర్‌తో కలిశారు",
"driverAccepted": "డ్రైవర్ ఒప్పుకున్నారు",
"tripConfirmed": "ట్రిప్ ఖరారైంది",
"rideStarted": "ప్రయాణం మొదలైంది",
"rideCompleted": "ప్రయాణం పూర్తయింది",
"connectionFeePaid": "కనెక్షన్ ఫీజు చెల్లించారు",
"waitingForPickup": "పికప్ కోసం వేచి ఉంది",
"manageTrip": "ట్రిప్ నిర్వహించండి",
"tripType": "ట్రిప్ రకం",
"createdOn": "నమోదైన తేదీ",
"currentStatus": "ప్రస్తుత స్థితి",
"connectionFee": "కనెక్షన్ ఫీజు",
"estimatedFare": "అంచనా ధర",
"tripId": "ట్రిప్ ఐడీ",
"actualDriverName": "డ్రైవర్ అసలు పేరు",
"waitingForDriverAcceptance": "డ్రైవర్ ఒప్పుకోవడం కోసం వేచి ఉంది",
"vehicleName": "వాహనం పేరు",
"vehicleDetailsAvailableAfter": "డ్రైవర్ ఖరారు చేసిన తర్వాత వాహన వివరాలు కనిపిస్తాయి.",
"paidUsingWallet": "వాలెట్ ద్వారా చెల్లించారు",
"paidUsingCredit": "1 ఉచిత కాల్ క్రెడిట్ వాడారు",
"finalFareConfirmedDirectly": "చివరి ధర మీకూ డ్రైవర్‌కూ మధ్య నేరుగా నిర్ణయమవుతుంది.",
"tripTimeline": "ట్రిప్ దశలు",
"contactSupport": "శ్రామిక సహాయాన్ని సంప్రదించండి",
"needHelp": "సహాయం కావాలా?",
"upcomingTrips": "రాబోయేవి",
"previousTrips": "గతంలోవి",
"connectingIvrCall": "శ్రామిక ఐవీఆర్ ద్వారా మీ కాల్ కలుపుతున్నాం. మా సిస్టమ్ మీకు కాల్ చేసే వరకు వేచి ఉండండి.",
"callConnectionFailed": "కాల్ కలపలేకపోయాం.",
"callError": "కాల్ మొదలుపెట్టలేకపోయాం.",
"pickupAddress": "????? ????????",
"destination": "గమ్యం",
"vehicleNumber": "వాహనం నంబర్",
"callHistory": "కాల్ చరిత్ర",
"callDriverToBook": "?????????? ???? ??????",
"loadingCalls": "కాల్స్ తెస్తున్నాం…",
"noCallsMade": "ఇంకా కాల్స్ చేయలేదు.",
    "completeProfile": "మీ ప్రొఫైల్‌ను పూర్తి చేయండి",
    "sramikaWallet": "శ్రామిక వాలెట్",
    "walletBalance": "వాలెట్ బ్యాలెన్స్",
    "viewWallet": "వాలెట్ చూడండి",

    "walletRemaining": "మిగిలి ఉన్నవి",
    "walletInfoTitle": "శ్రామిక మీ కోసం కలిపే కాల్స్‌కు చెల్లించడానికి మాత్రమే ఈ వాలెట్.",
    "walletInfo1": "ఈ వాలెట్‌కు జోడించిన డబ్బును విత్‌డ్రా చేయడం కుదరదు.",
    "walletInfo2": "ప్రతి {hours} గంటలకు {free} కాల్స్ ఉచితం. ఆ తర్వాత కలిసిన ప్రతి కాల్‌కు ₹{fee}; కాల్ కలవకపోతే ఏమీ తీసుకోం.",
    "walletAddMoney": "డబ్బు జోడించండి",
    "walletEnterAmount": "మొత్తం నమోదు చేయండి",
    "walletRecharge": "వాలెట్ రీఛార్జ్ చేయండి",
    "walletProcessing": "ప్రాసెస్ చేయబడుతోంది...",
    "walletNoTxns": "ఇంకా ఎలాంటి వాలెట్ లావాదేవీలు లేవు.",
    "walletNoTxnsSub": "మీరు జోడించిన డబ్బు, కాల్ ఛార్జీలు ఇక్కడ కనిపిస్తాయి.",
    "walletTxnRecharge": "రీఛార్జ్",
    "walletTxnServiceFee": "కనెక్షన్ ఫీజు",
    "walletTxnRefund": "రీఫండ్",
    "callDriverToBook": "డ్రైవర్కు కాల్ చేసి బుక్ చేయండి","getDriversNumber": "డ్రైవర్ నంబర్ తెప్పించండి","appName": "శ్రామిక",
    "appSubtitle": "సమీప కార్ ట్రావెల్స్",
    "loginCta": "లాగిన్ / చేరండి",
    "findTaxiBy": "సరైన టాక్సీని కనుగొనండి",
    "from": "ఎక్కడినుంచి",
    "to": "ఎక్కడికి",
    "nearbyCars": "సమీపంగా రేటింగ్ ఉన్న కార్లు",
    "accountTitle": "నా ప్రొఫైల్",
    "bookings": "చరిత్ర",
    "notifications": "నోటిఫికేషన్లు",
    "support": "సపోర్ట్",
    "settings": "సెట్టింగ్స్",
    "logout": "లాగ్ అవుట్",
    "loginSignup": "లాగిన్ / సైన్ అప్",
    "noBookings": "ఇప్పటివరకు బుకింగ్స్ లేవు.",
    "startBooking": "స్థానిక విశ్వసనీయ క్యాబ్స్ బుక్ చేయండి",
    "faqTitle": "ఎఫ్ఏక్యూ (FAQs)",
    "callSupport": "సపోర్ట్ కాల్ చేయండి",
    "language": "భాష",
    "fareCalculator": "ఛార్జీల కాలిక్యులేటర్",
    "terms": "నిబంధనలు మరియు షరతులు",
    "privacy": "గోప్యతా విధానం",
    "manageProfile": "మీ ప్రొఫైల్ మరియు ప్రాధాన్యతలను నిర్వహించండి",
    "mobileNumber": "మొబైల్ నంబర్",
    "username": "యూజర్ నేమ్",
    "preferredCity": "ప్రాధాన్య నగరం",
    "referFriend": "స్నేహితుడికి సూచించండి",
    "comingSoon": "త్వరలో వస్తుంది",
    "cabOwnerProfile": "డ్రైవర్ ప్రొఫైల్",
    "editCabOwnerProfile": "డ్రైవర్ వివరాలను సవరించండి",
    "accountActions": "ఖాతా చర్యలు",
    "save": "మార్పులు సేవ్ చేయండి",
    "edit": "సవరించు",
    "verified": "ధృవీకరించబడింది",
    "notEditable": "మార్చలేరు",
    "myRating": "నా రేటింగ్",
    "notSet": "సెట్ చేయబడలేదు",
    "upcoming": "రాబోయే",
    "previous": "గత",
    "noUpcomingTrips": "రాబోయే ట్రిప్పులు లేవు.",
    "noPreviousTrips": "గత ట్రిప్పులు లేవు.",
    "bookRide": "రైడ్ బుక్ చేయండి",
    "signIn": "సైన్ ఇన్ చేయండి",
    "viewBookings": "బుకింగ్స్ చూడండి",
    "personalDetails": "వ్యక్తిగత వివరాలు",
    "location": "స్థానం",
    "emergencyContact": "అత్యవసర సంప్రదింపు",
    "vehicleOptions": "వాహన ఎంపికలు",
    "tripTypesOffered": "ట్రిప్ రకాలు",
    "pricing": "ధరలు",
    "weeklyAvailability": "వారపు లభ్యత",
    "kycLocked": "KYC వివరాలు లాక్ చేయబడ్డాయి",
    "kycLockedDesc": "పేరు, మొబైల్, ఆధార్, DL మరియు వాహన వివరాలు ఇక్కడ మార్చలేరు. సపోర్ట్‌ని సంప్రదించండి.",
    "verifiedInfo": "ధృవీకరించిన సమాచారం",
    "gender": "లింగం",
    "languagesSpoken": "మాట్లాడే భాషలు",
    "bio": "చిన్న పరిచయం",
    "address": "చిరునామా",
    "pincode": "పిన్‌కోడ్",
    "contactName": "సంప్రదింపు పేరు",
    "contactPhone": "సంప్రదింపు ఫోన్",
    "acAvailable": "ఏసీ అందుబాటులో ఉంది",
    "wallet": "వాలెట్",
    "recentSearches": "ఇటీవలి శోధనలు",
    "home": "హోమ్",
    "navCars": "కార్లు",
    "nearbyHireDrivers": "సమీపంలోని హైర్ డ్రైవర్లు",
    "city": "నగరం",
    "onb_skip": "దాటవేయి",
    "onb_getStarted": "ప్రారంభించండి",
    "onb_p1_sign": "దగ్గరలోని కార్లు",
    "onb_p1_title": "దగ్గరలోని డ్రైవర్లను కనుగొనండి",
    "onb_p1_sub": "దగ్గరలోని డ్రైవర్లతో నేరుగా కనెక్ట్ అవ్వండి.",
    "onb_p1_badge": "క్యాబ్ ఖాతాలకు 0% కమీషన్",
    "onb_p2_sign": "దగ్గరలోని ఆల్టింగ్ డ్రైవర్",
    "onb_p2_title": "దగ్గరలోని వ్యక్తిగత డ్రైవర్లను నియమించుకోండి",
    "onb_p2_sub": "దగ్గరలోని డ్రైవర్లతో నేరుగా కనెక్ట్ అవ్వండి.",
    "onb_p2_badge": "డ్రైవర్లకు 0% కమీషన్",
    "onb_p3_sign": "మేము మిమ్మల్ని విశ్వసనీయ వ్యక్తులతో కలుపుతాము",
    "onb_p3_title": "ఎంచుకోవడంలో సహాయం కావాలా?",
    "onb_p3_sub": "మా సపోర్ట్ టీమ్ మిమ్మల్ని సరైన క్యాబ్ డ్రైవర్‌తో కనెక్ట్ చేయగలదు.",
    "onb_p3_badge": "సపోర్ట్ సహాయానికి 0% కమీషన్",
    "onb_p4_sign1": "క్యాబ్ అద్దెకు",
    "onb_p4_sign2": "డ్రైవర్ అద్దెకు",
    "onb_p4_sign3": "మరిన్ని సేవలు",
    "onb_p4_title": "మీకు కావలసినవన్నీ ఒకే చోట",
    "onb_p4_sub": "క్యాబ్‌లు, డ్రైవర్లను అద్దెకు తీసుకోండి మరియు మరిన్ని ప్రయాణ సేవలను కనుగొనండి.",
    "onb_p4_badge": "మరిన్ని సేవలపై 0% కమీషన్",
    "onb_p5_sign": "ఒకే యాప్. అనేక ప్రయాణ సేవలు.",
    "onb_p5_title": "ప్రారంభిద్దాం",
    "onb_p5_sub": "దగ్గరలోని సేవలతో మరింత తెలివిగా ప్రయాణించండి.",
    "onb_p5_badge": "ఎల్లప్పుడూ 0% కమీషన్",
    "onb_lang_title": "మీ భాషలో, మీ సౌలభ్యం కోసం",
    "onb_lang_sub": "సమాచారం మీ స్థానిక భాషలో చూపబడుతుంది.",
    "onb_footer": "స్థానిక మద్దతు. స్థానిక భాష. మెరుగైన అనుభవం.",
    "onb_language": "భాష",
    "onb_intentTagline": "దగ్గరలోని క్యాబ్‌లు & డ్రైవర్లు",
    "onb_intentTitle": "మీరు శ్రామికను ఎలా ఉపయోగించాలనుకుంటున్నారు?",
    "onb_intentSub": "కొనసాగడానికి ఒక ఎంపికను ఎంచుకోండి",
    "onb_intentRide": "క్యాబ్‌లు & డ్రైవర్లను కనుగొనండి",
    "onb_intentRideSub": "లోకల్ లేదా ఔట్‌స్టేషన్ క్యాబ్ బుక్ చేయండి, లేదా మీ కారుకు డ్రైవర్‌ను నియమించుకోండి.",
    "onb_intentEarn": "శ్రామికతో సంపాదించాలనుకుంటున్నారా?",
    "onb_intentCab": "క్యాబ్ ఖాతాగా చేరండి",
    "onb_intentCabSub": "మీ క్యాబ్‌ను నమోదు చేసి, కస్టమర్ల నుండి నేరుగా కాల్స్ పొందండి.",
    "onb_intentDriver": "హైర్ డ్రైవర్‌గా చేరండి",
    "onb_intentDriverSub": "కారు అవసరం లేదు. కస్టమర్ల కార్లు నడపండి, గంట లేదా రోజు చొప్పున సంపాదించండి.",
    // The /join page for ads (Oct 2026).
    "join_title": "శ్రామికతో సంపాదించండి",
    "join_subShort": "కస్టమర్లు నేరుగా మీకే కాల్ చేస్తారు.",
    "join_codeLine": "కోడ్ {code} · అప్రూవ్ అయ్యాక ₹{amount}",
    "join_codeOnly": "కోడ్ {code}",
    "join_car": "నా దగ్గర కారు ఉంది",
    "join_carNeed": "లైసెన్స్, ఆర్‌సీ, కారు ఫోటోలు · 15 నిమిషాలు",
    "join_drv": "డ్రైవింగ్ వచ్చు, కారు లేదు",
    "join_drvNeed": "లైసెన్స్, ఫోటో, మీ రేట్లు · 10 నిమిషాలు",
    "join_needACar": "కారు కావాలా?",
    "join_seeCarsShort": "కార్లు చూడండి",
    "onb_skipForNow": "ప్రస్తుతానికి దాటవేయి",
    "newDriver": "కొత్త డ్రైవర్",
    "startsFrom": "ప్రారంభ ధర",
    "contactDriver": "డ్రైవర్‌ను సంప్రదించండి",
    "hireDriverTitle": "డ్రైవర్‌ను నియమించుకోండి",
    "driverWillCome": "డ్రైవర్ మీ స్థానానికి వస్తారు",
    "date": "తేదీ",
    "time": "సమయం",
    "duration": "వ్యవధి",
    "yourCarType": "మీ కారు రకం",
    "pickupAddress": "పికప్ చిరునామా",
    "yourPhone": "మీ ఫోన్",
    "yourName": "మీ పేరు",
    "tripPurpose": "ప్రయాణ ఉద్దేశ్యం (ఐచ్ఛికం)",
    "youPayDriverDirectly": "మీరు నేరుగా డ్రైవర్‌కు చెల్లించండి. శ్రామిక ఎటువంటి కమీషన్ తీసుకోదు.",
    "rateDriver": "డ్రైవర్‌కు రేటింగ్ ఇవ్వండి",
    "howWasExperience": "మీ అనుభవం ఎలా ఉంది?",
    "shortReview": "చిన్న సమీక్ష (ఐచ్ఛికం)",
    "callDriver": "డ్రైవర్‌కు కాల్ చేయండి",
    "filter": "ఫిల్టర్",
    "loadingRequests": "అభ్యర్థనలు లోడ్ అవుతున్నాయి...",
    "driverWillReview": "డ్రైవర్ మీ అభ్యర్థనను సమీక్షించి త్వరలో స్పందిస్తారు.",
    "dismiss": "తిరస్కరించండి",
    "thankYouFeedback": "మీ అభిప్రాయానికి ధన్యవాదాలు. ఇది ఇతర వినియోగదారులకు సహాయపడుతుంది.",
    "selectCityHire": "మీ దగ్గర ఉన్న డ్రైవర్లను చూడటానికి నగరాన్ని ఎంచుకోండి",
    "findingDriversIn": "లో డ్రైవర్ల కోసం వెతుకుతోంది",
    "clearAll": "అన్నింటినీ క్లియర్ చేయండి",
    "areYouDriver": "మీరు డ్రైవర్ కాదా?",
    "registerAsHireDriver": "జాబితాలో చేర్చబడటానికి కిరాయి డ్రైవర్‌గా నమోదు చేసుకోండి",
    "join": "చేరండి",
    "fareCalculatorTitle": "ఛార్జీల కాలిక్యులేటర్",
    "distanceLabel": "దూరం",
    "durationLabel": "వ్యవధి",
    "booked": "బుక్ చేయబడింది",
    "estimatedFareLabel": "అంచనా ఛార్జీ",
    "advanceAlreadyPaid": "అడ్వాన్స్ ఇప్పటికే చెల్లించబడింది",
    "payToDriverLabel": "డ్రైవర్‌కు చెల్లించండి",
    "noTripDetails": "ట్రిప్ వివరాలు కనుగొనబడలేదు.",
    "goHome": "హోమ్‌కు వెళ్లండి",
    "earnCommissionBooking": "ఈ బుకింగ్‌పై కమీషన్ సంపాదించండి",
    "customerNameReq": "కస్టమర్ పేరు *",
    "customerPhoneReq": "కస్టమర్ ఫోన్ *",
    "yourCab": "మీ క్యాబ్",
    "paymentSummary": "చెల్లింపు సారాంశం",
    "cabFare": "క్యాబ్ ఛార్జీ",
    "totalTripCost": "మొత్తం ట్రిప్ ఖర్చు",
    "payNowLabel": "ఇప్పుడు చెల్లించండి:",
    "advance10Percent": "అడ్వాన్స్ (క్యాబ్ ఛార్జీలో 10%)",
    "balanceToDriver": "డ్రైవర్‌కు బ్యాలెన్స్",
    "selectPaymentMethod": "చెల్లింపు పద్ధతిని ఎంచుకోండి",
    "howItWorks": "ఇది ఎలా పనిచేస్తుంది",
    "advanceFullyRefunded": "అడ్వాన్స్ పూర్తిగా రీఫండ్ చేయబడింది",
    "advanceNonRefundable": "అడ్వాన్స్ రీఫండ్ చేయబడదు",
    "additionalChargesActuals": "అదనపు ఛార్జీలు వాస్తవాల ప్రకారం",
    "profilePhoto": "ప్రొఫైల్ ఫోటో",
    "startTrip": "ట్రిప్ ప్రారంభించండి",
    "endTrip": "ట్రిప్ ముగించండి",
    "finalDistance": "తుది దూరం",
    "fareBreakdown": "ఛార్జీల విభజన",
    "totalDuration": "మొత్తం వ్యవధి",
    "withdrawalUnlock": "విత్‌డ్రా అన్‌లాక్",
    "quickWins": "త్వరిత విజయాలు:",
    "yourTrustedCabPartner": "మీ నమ్మకమైన క్యాబ్ భాగస్వామి",
    "usernameOrMobile": "యూజర్ నేమ్ లేదా మొబైల్",
    "password": "పాస్వర్డ్",
    "expired": "గడువు ముగిసింది",
    "withdrawToUpi": "యూపీఐ కి విత్‌డ్రా చేయండి",
    "minPtsWallet": "కనీసం 300 పాయింట్లు వాలెట్‌లో ఉండాలి",
    "availableToWithdraw": "విత్‌డ్రా చేయడానికి అందుబాటులో ఉంది",
    "upiId": "యూపీఐ ఐడీ",
    "amountRupees": "మొత్తం (₹)",
    "bookingId": "బుకింగ్ ఐడీ",
    "lifetimeEarned": "జీవితకాలం సంపాదించినవి",
    "withdrawable": "విత్‌డ్రా చేయదగినవి",
    "useOnRide": "రైడ్‌లో ఉపయోగించండి",
    "recentActivity": "ఇటీవలి కార్యాచరణ",
    "seeAll": "అన్నింటినీ చూడండి",
    "withdrawalLocked": "విత్‌డ్రా లాక్ చేయబడింది",
    "transactionHistory": "లావాదేవీ చరిత్ర",
    "noTransactionsYet": "ఇంకా లావాదేవీలు లేవు",
    "noCabsFoundFor": "సమీపంలో క్యాబ్‌లు కనిపించలేదు:",
    "tryDifferentSearch": "వేరే ప్రాంతంలో వెతకండి లేదా క్రింది సూచనలను ప్రయత్నించండి:",
    "sramikaComingTo": "శ్రామిక త్వరలో వస్తోంది:",
    "onboardingDriversIn": "మేము ప్రస్తుతం డ్రైవర్లను నమోదు చేస్తున్న ప్రాంతం:",
    "beTheFirstToKnow": ". సేవలు ప్రారంభమైన వెంటనే సమాచారం పొందండి.",
    "expectedLaunch": "ప్రారంభమయ్యే సమయం",
    "whatsappNumber": "వాట్సాప్ నంబర్ (10 అంకెలు)",
    "notifyViaWhatsapp": "సేవలు ప్రారంభమైన వెంటనే వాట్సాప్ ద్వారా మీకు తెలియజేస్తాము",
    "joining": "చేరుతోంది...",
    "onTheList": "మీరు జాబితాలో చేరారు!",
    "goBackHome": "హోమ్ పేజీకి వెళ్ళండి",
    "noDriversIn": "ప్రస్తుతం డ్రైవర్లు అందుబాటులో లేరు:",
    "driverNetworkExpanding": "మా ధృవీకరించబడిన డ్రైవర్ నెట్‌వర్క్ వేగంగా విస్తరిస్తోంది. ఈ నగరంలో మొదటి డ్రైవర్ భాగస్వామిగా చేరి వెంటనే బుకింగ్‌లు పొందండి.",
    "registerAsDriver": "డ్రైవర్‌గా నమోదు చేసుకోండి",
    "learnMore": "మరింత తెలుసుకోండి",
    "noCabsIn": "ప్రస్తుతం క్యాబ్‌లు అందుబాటులో లేవు:",
    "cabNetworkExpanding": "మా ప్రీమియం నెట్‌వర్క్ వేగంగా విస్తరిస్తోంది. ఈ నగరంలో మా ప్రత్యేక సేవలను ప్రారంభించే మొదటి భాగస్వామిగా చేరి ఈరోజే సంపాదించడం ప్రారంభించండి.",
    "joinAsPartner": "భాగస్వామిగా చేరండి",
    "exploreCities": "నగరాలను చూడండి",
    "platformDisclaimer": "శ్రామిక ఒక సాంకేతిక వేదిక. రవాణా సేవలు స్వతంత్ర ఆపరేటర్ల ద్వారా అందించబడతాయి.",
    "topRated": "అత్యుత్తమ రేటింగ్",
    "newPartner": "శ్రామికలో కొత్త",
    "nearby": "దగ్గరలో",
    "luxury": "లగ్జరీ",
    "familyTrip": "కుటుంబ ప్రయాణం",
    "fastBooking": "వేగవంతమైన బుకింగ్",
    "matched": "సరిపోలింది",
    "estPrice": "అంచనా ధర",
    "baseRateLabel": "ప్రాథమిక ధర",
    "recentSearchesLabel": "ఇటీవలి శోధనలు",
    "anyCab": "ఏదైనా క్యాబ్",
    "trip": "ట్రిప్",
    "trips": "ట్రిప్పులు",
    "selectCity": "నగరాన్ని ఎంచుకోండి",
    "detecting": "గుర్తిస్తోంది...",
    "detectLocation": "స్థానాన్ని గుర్తించండి",
    "typeCityName": "నగరం పేరు టైప్ చేయండి...",
    "filters": "ఫిల్టర్లు",
    "select": "ఎంచుకోండి",
    "bioHint": "ప్రయాణీకులకు మీ గురించి కొంచెం చెప్పండి",
    "searchCity": "నగరాన్ని శోధించండి...",
    "selectCity2": "నగరాన్ని ఎంచుకోండి",
    "findRightTaxi": "సరైన ట్యాక్సీని కనుగొనండి",
    "lastBooked": "చివరిగా బుక్ చేసింది:",
    "more": "+ మరిన్ని",
    "hireDriver": "డ్రైవర్‌ను నియమించుకోండి",
    "services": "సేవలు",
    "account": "ఖాతా",
    "findRightDriver": "సరైన డ్రైవర్‌ను కనుగొనండి",
    "searchCabPlaceholder": "క్యాబ్, మోడల్, ప్రాంతం శోధించండి...",
    "searchDriverPlaceholder": "డ్రైవర్, ప్రాంతం, భాష, అనుభవం శోధించండి...",
    "myHireRequests": "నా డ్రైవర్ అభ్యర్థనలు",
    "driverCanSpeakLanguages": "డ్రైవర్ మాట్లాడగల భాషలు",
    "referenceFare": "రిఫరెన్స్ ఛార్జీ",
    "callDriver": "డ్రైవర్‌కు కాల్ చేయండి",

    "driverDiscountLabel": "డిస్కౌంట్",
    "connecting": "కనెక్ట్ అవుతోంది...",

    "mockCallConnecting": "మాక్ టెలిఫోనీ ద్వారా డ్రైవర్‌కు కాల్ కనెక్ట్ చేయబడుతోంది...",
    "mockCallError": "కాల్ కనెక్ట్ చేయబడలేదు.",
    "callInitiationError": "కాల్ ప్రారంభించడంలో లోపం.",


    "callbackInitiationError": "కాల్ బ్యాక్ అభ్యర్థనలో లోపం.",
    "bookNowToGetContact": "సంప్రదింపు నంబర్ పొందడానికి ఇప్పుడే బుక్ చేయండి",
    "partnersPrice": "డ్రైవర్ ధర", // TODO: Telugu translation pending.
    "priceHistory": "ధరల చరిత్ర", // TODO: Telugu translation pending.
    "increaseAvailableNow": "ఇప్పుడు ధరలు పెంచవచ్చు", // TODO: Telugu translation pending.
    "nextIncreaseAt": "మళ్ళీ ధర పెంచడం {{time}} తర్వాత", // TODO: Telugu translation pending.
    "noPriceChangesYet": "ఇంకా ధరల మార్పులు లేవు", // TODO: Telugu translation pending.
    "loadingHistory": "చరిత్ర తెస్తున్నాం…", // TODO: Telugu translation pending.
    "changeIncrease": "పెంపు", // TODO: Telugu translation pending.
    "changeDecrease": "తగ్గింపు", // TODO: Telugu translation pending.
    "changeMixed": "కొన్ని పెంపు, కొన్ని తగ్గింపు", // TODO: Telugu translation pending.
    "noFieldsChanged": "ఏ వివరమూ మారలేదు.", // TODO: Telugu translation pending.
    "typicalFareLabel": "సాధారణ ఛార్జీ ₹{value}",
    "lessThanTypicalFare": "సాధారణ ఛార్జీ కంటే ₹{amount} తక్కువ",
    "regularPrice": "సాధారణ ధర",
    "typicalFareTooltip": "A typical fare for this route, based on local rates. Partners set their own prices independently.", // TODO: Telugu translation pending.
    "partnerOfferedPrice": "భాగస్వామి ధర",
    "partnerPricePrefix": "ధర",
    "estimatedAmount": "అంచనా వేసిన మొత్తం",
    "estimatedAmountCaption": "వాస్తవ ప్రయాణం, టోల్స్, పార్కింగ్ లేదా మార్గం మార్పుల ఆధారంగా తుది మొత్తం మారవచ్చు.",
    "extrasNote": "Toll, border/state taxes and parking (if any) are extra and paid directly to the driver.", // TODO: pending
    "youSaveComparedToRegular": "సాధారణ ధరతో పోలిస్తే.",
    "payDirectlyToPartner": "ట్రావెల్ పార్టనర్‌తో మీ ట్రిప్‌ను నిర్ధారించిన తర్వాత మాత్రమే చెల్లించండి.",
    "chargesDuringTrip": "ప్రయాణ సమయంలో ఛార్జీలు",
    "whyChooseSramika": "కస్టమర్‌లు శ్రామికను ఎందుకు ఎంచుకుంటారు",
    "verifiedTravelPartners": "Trusted travel partners", // TODO: pending
    "transparentPricing": "పారదర్శక ధర",
    "directCommunication": "ప్రత్యక్ష భాగస్వామి పరిచయం",
    "noBookingCommission": "బుకింగ్ కమీషన్ లేదు",
    "secureBookingExperience": "సురక్షితమైన బుకింగ్ అనుభవం",
    "youSavePrefix": "మీరు ఆదా చేస్తారు",
    "saveBadge": "ఆదా",
    "savingsBasedOnPartnerPrice": "భాగస్వామి ధర నిర్ణయించడం ద్వారా మీరు మరింత ఆదా చేయవచ్చు.",
    "licenseChecked": "Driving License Checked", // TODO: pending
    "bestOffer": "ఉత్తమ ఆఫర్",
    "tripPriceDetails": "ట్రిప్ ధర వివరాలు",
    "transparentPartnerPricing": "పారదర్శక భాగస్వామి ధర",
    "noSramikaBookingCommission": "శ్రామిక బుకింగ్ కమీషన్ లేదు",
    "driverAllowance": "డ్రైవర్ భత్యం",
    "nightAllowance": "రాత్రి భత్యం",
    "transparentPricingNoHidden": "పారదర్శక ధర - దాచిన ఛార్జీలు లేవు",
    "promoDiscount": "ప్రోమో డిస్కౌంట్",
    "sramikaDiscount": "శ్రామిక డిస్కౌంట్",
    "couponAppliedMsg": "కూపన్ వర్తించబడింది",
    "saveAmount": "ఆదా చేయండి ",
    "removeAction": "తొలగించు",
    "applyAction": "వర్తించు",
    "totalFare": "మొత్తం ఛార్జీ",
    "finalPriceLabel": "తుది ధర",
    "partnerOfferSuffix": " ఆఫర్",
    "legacyFareVary": "వాస్తవ KM ప్రయాణించిన లేదా ట్రిప్ వ్యవధిలో ఏవైనా మార్పులు ఉంటే తుది ఛార్జీ మారవచ్చు.",
    "legacyTollsExcluded": "⚠️ **గమనిక:** టోల్ గేట్‌లు, పార్కింగ్ ఛార్జీలు మరియు ఏదైనా సరిహద్దు/రాష్ట్ర పన్ను ఛార్జీలు ఈ ఛార్జీలో **చేర్చబడలేదు** మరియు విడిగా ఛార్జ్ చేయబడతాయి.",
    "estimateFareCalc1": "మీరు మా ",
    "pricingCalculator": "ధర కాలిక్యులేటర్",
    "estimateFareCalc2": " ను ఉపయోగించి ఎప్పుడైనా దూరం లేదా సమయంలో ఏదైనా మార్పు కోసం మీ నవీకరించబడిన ఛార్జీని అంచనా వేయవచ్చు.",
    "pickup": "పికప్",
    "origin": "మూలం",
    "destination": "గమ్యం",
    "oneWay": "వన్-వే",
    "inclReturn": "రిటర్న్ తో సహా",
    "hrs": "గంటలు",
    "estDuration": "అంచనా వ్యవధి",

    // Rating Modal
    "loadingRating": "తెస్తున్నాం…", // TODO: pending
    "updateRating": "రేటింగ్ మార్చండి", // TODO: pending
    "submitRating": "రేటింగ్ పంపండి", // TODO: pending
    "tapAStar": "Tap a star", // TODO: pending
    "ratingPoor": "Poor", // TODO: pending
    "ratingFair": "Fair", // TODO: pending
    "ratingGood": "Good", // TODO: pending
    "ratingVeryGood": "Very Good", // TODO: pending
    "ratingExcellent": "Excellent", // TODO: pending
    "tellUsExperience": "మీ అనుభవం చెప్పండి…", // TODO: pending
    "typicalFareBare": "Market Price", // TODO: pending
    "totalWithCharges": "Total with trip charges" // TODO: pending
  },
  "ta": {
"rm_of": "{n}-இல் {yes}",
"rm_driverCame": "புக் செய்த அதே டிரைவர் வந்தார்",
"rm_carCame": "புக் செய்த அதே கார் வந்தது",
"rm_no": "இல்லை",
"rm_yes": "ஆம்",
"rm_sameDriver": "நீங்கள் புக் செய்த அதே டிரைவர் வந்தாரா?",
"rm_sameCar": "நீங்கள் புக் செய்த அதே கார் வந்ததா?",
"lg_brand": "ஸ்ராமிகா",
"tx_bonus": "போனஸ்",
"tx_referralBack": "பரிந்துரை வெகுமதி திரும்பப் பெறப்பட்டது",
"tx_referral": "பரிந்துரை வெகுமதி",
"tx_welcome": "வரவேற்பு சலுகை",
"tx_failed": "பணம் செலுத்த முடியவில்லை",
"lc_offer": "சிறப்பு சலுகை",
"lh_ref": "எண்",
"cv_mpv": "எம்பிவி",
"ac_roleOwner": "டிரைவர்",
"ac_roleAdmin": "நிர்வாகி",
"ac_roleSuper": "சூப்பர் நிர்வாகி",
"ac_roleDriver": "டிரைவர்",
"ac_roleAgent": "கள முகவர்",
"ac_ownerCarsLeads": "என் கார்கள், லீட்கள்",
"od_title": "என் டிரைவர்கள்",
"od_list": "உங்கள் கார்களின் டிரைவர்கள்",
"od_add": "டிரைவரைச் சேர்",
"od_addTitle": "புதிய டிரைவர்",
"od_name": "டிரைவர் பெயர்",
"od_namePh": "எ.கா. ரமேஷ் குமார்",
"od_licencePh": "எ.கா. AP09 2024 0012345",
"od_licPhoto": "உரிமத்தின் புகைப்படம்",
"od_photo": "டிரைவர் புகைப்படம்",
"od_choose": "புகைப்படத்தைத் தேர்ந்தெடு",
"od_checkNote": "டிரைவர் காட்டப்படும் முன் ஸ்ராமிகா உரிமத்தைச் சரிபார்க்கும்.",
"od_errName": "டிரைவர் பெயரை உள்ளிடவும்.",
"od_errPhone": "10 இலக்க மொபைல் எண்ணை உள்ளிடவும்.",
"od_errLicence": "உரிம எண்ணை உள்ளிடவும்.",
"od_errLicPhoto": "உரிமத்தின் புகைப்படத்தைச் சேர்க்கவும்.",
"od_errPhoto": "டிரைவர் புகைப்படத்தைச் சேர்க்கவும்.",
"od_addFail": "டிரைவரைச் சேர்க்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
"od_addBtn": "இந்த டிரைவரைச் சேர்",
"od_adding": "சேர்க்கிறோம்…",
"od_loading": "உங்கள் டிரைவர்களை ஏற்றுகிறோம்…",
"od_loadFail": "உங்கள் டிரைவர்களை ஏற்ற முடியவில்லை.",
"od_pending": "ஒப்புதலுக்குக் காத்திருக்கிறது",
"od_remove": "நீக்கு",
"od_removeAsk": "இந்த டிரைவரை உங்கள் பட்டியலிலிருந்து நீக்கவா?",
"od_removeYes": "ஆம், நீக்கு",
"od_removeFail": "டிரைவரை நீக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
"od_emptyTitle": "இன்னும் டிரைவர்கள் இல்லை",
"od_emptyText": "உங்கள் கார்களை ஓட்டும் டிரைவர்களைச் சேர்க்கவும்.",
"ea_title": "கணக்கு விவரங்களை மாற்று",
"ea_note": "இவை பதிவின்போது சரிபார்க்கப்பட்டவை. மாற்றம் ஸ்ராமிகாவுக்குச் செல்லும், ஒப்புதல் கிடைத்த பிறகே தெரியும்.",
"ea_pendingTitle": "ஒரு மாற்றம் ஒப்புதலுக்காகக் காத்திருக்கிறது",
"ea_pendingText": "நீங்கள் அனுப்பிய மாற்றத்தை ஸ்ராமிகா சரிபார்க்கிறது. அது முடிந்ததும் இன்னொன்றை அனுப்பலாம்.",
"ea_sentTitle": "ஒப்புதலுக்கு அனுப்பப்பட்டது",
"ea_sentText": "ஸ்ராமிகா மாற்றத்தை ஒப்புக்கொள்ளும் வரை உங்கள் விவரங்கள் அப்படியே இருக்கும்.",
"ea_toAccount": "என் கணக்குக்குச் செல்",
"ea_loadFail": "உங்கள் கணக்கு விவரங்களை ஏற்ற முடியவில்லை.",
"ea_sendFail": "உங்கள் மாற்றத்தை அனுப்ப முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
"ea_phoneLocked": "சரிபார்க்கப்பட்ட எண்ணை மாற்ற ஸ்ராமிகாவை அழைக்கவும்.",
"ea_blood": "இரத்த வகை",
"ea_select": "தேர்ந்தெடுக்கவும்",
"ea_contact": "முகவரி மற்றும் அவசரத் தொடர்பு",
"ea_ap": "ஆந்திரப் பிரதேசம்",
"ea_tg": "தெலங்கானா",
"ea_emName": "அவசரத் தொடர்பு பெயர்",
"ea_emPhone": "அவசரத் தொடர்பு எண்",
"ea_driving": "ஓட்டுதல்",
"ea_aadhaar": "ஆதார் எண்",
"ea_licence": "ஓட்டுநர் உரிம எண்",
"ea_bank": "வங்கி விவரங்கள்",
"ea_accName": "கணக்கு வைத்திருப்பவர் பெயர்",
"ea_accNo": "கணக்கு எண்",
"ea_ifsc": "ஐஎஃப்எஸ்சி குறியீடு",
"ea_send": "ஒப்புதலுக்கு அனுப்பு",
"pe_saved": "உங்கள் விவரங்கள் சேமிக்கப்பட்டன.",
"pe_saveFail": "சேமிக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
"pe_loading": "உங்கள் விவரங்களை ஏற்றுகிறோம்…",
"pe_loadFail": "உங்கள் விவரங்களை ஏற்ற முடியவில்லை.",
"pe_checked": "பதிவின்போது சரிபார்க்கப்பட்டவை",
"pe_car": "கார்",
"pe_lockedText": "இவற்றை மாற்ற ஸ்ராமிகாவை அழைக்கவும் - முதலில் மீண்டும் சரிபார்க்கப்படும்.",
"pe_about": "உங்களைப் பற்றி",
"pe_business": "பிசினஸ் பெயர் (இருந்தால்)",
"pe_businessHint": "காலியாக விட்டால் உங்கள் பெயரே தெரியும்.",
"pe_businessPh": "எ.கா. ஸ்ரீ சாய் டிராவல்ஸ்",
"pe_other": "மற்றவை",
"pe_langs": "நீங்கள் பேசும் மொழிகள்",
"pe_bio": "உங்களைப் பற்றி சில வார்த்தைகள்",
"pe_bioHint": "வாடிக்கையாளர்களுக்கு உங்களைப் பற்றி கொஞ்சம் சொல்லுங்கள்.",
"pe_bioApproval": "இங்கே எழுதும் புதிய வரிகளை வாடிக்கையாளர்களுக்குக் காட்டும் முன் ஸ்ராமிகா சரிபார்க்கும்.",
"pe_bioSent": "சேமிக்கப்பட்டது. ஸ்ராமிகா ஒப்புதல் அளித்த பிறகு உங்கள் புதிய வரிகள் தெரியும்.",
"pe_bioWaiting": "சேமிக்கப்பட்டது. உங்கள் புதிய வரிகள் காத்திருக்கின்றன - உங்கள் வேறொரு மாற்றம் ஸ்ராமிகாவிடம் உள்ளது.",
"pe_bioPending": "ஒப்புதலுக்காக: “{bio}”",
"pe_bioPh": "எ.கா. 8 ஆண்டுகளாக ஓட்டுகிறேன், விஜயவாடா - ஹைதராபாத் வழி நன்றாகத் தெரியும்.",
"pe_pincode": "பின்கோடு",
"pe_phonePh": "10 இலக்க மொபைல் எண்",
"pe_carTrips": "உங்கள் கார் மற்றும் பயணங்கள்",
"pe_personalText": "உங்கள் முகவரி, மொழிகள், பாலினம், அவசரத் தொடர்பை {account} → {edit} பகுதியில் மாற்றுங்கள். ஸ்ராமிகா முதலில் மாற்றத்தைச் சரிபார்க்கும்.",
"pe_personalBtn": "என் விவரங்களை மாற்று",
"pe_acPerCar": "ஏசி ஒவ்வொரு காருக்கும் தனியாக {myCars} பகுதியில் அமைக்கவும்.",
"pe_moreCars": "+{n} மேலும்",
"pe_tripKinds": "நீங்கள் செல்லும் பயணங்கள்",
"pe_hourly": "மணி நேர அடிப்படையில்",
"pe_dayRent": "நாள் வாடகை",
"pe_prices": "விலைகள்",
"pe_week": "நீங்கள் வேலை செய்யும் நாட்கள், நேரம்",
"pe_from": "முதல்",
"pe_to": "வரை",
"pe_save": "மாற்றங்களைச் சேமிக்கவும்",
"ld_sentDriver": "டிரைவருக்கு அனுப்பப்பட்டது",
"ld_refNoteDriver": "இது உங்களுக்குக் காட்டப்பட்ட விலை. இறுதி விலை டிரைவருடன் நேரடியாக முடிவு செய்யப்படும்.",
"ld_callDriver": "டிரைவரை அழைக்கவும்",
"dp_theDriver": "டிரைவர்",
"cv_ownerWord": "டிரைவர்",
"hm_nCars": "{n} கார்கள்",
"hm_oneCar": "1 கார்",
"newPartner": "ஸ்ராமிகாவில் புதியது",
"as_title": "உங்கள் பிசினஸ் கணக்கு நிறுத்தி வைக்கப்பட்டுள்ளது",
"as_since": "{date} முதல்",
"as_whatDriver": "உங்கள் டிரைவர் சுயவிவரம் வாடிக்கையாளர்களுக்குத் தெரியாது, புதிய ஹையர் கோரிக்கைகள் வராது.",
"as_whatCars": "உங்கள் கார்கள் வாடிக்கையாளர்களுக்குத் தெரியாது, புதிய லீட்கள் வராது.",
"as_reason": "கொடுக்கப்பட்ட காரணம்:",
"as_else": "மற்ற அனைத்தும் இயங்கும். வாடிக்கையாளராக கேப்களைப் பார்க்கலாம், டிரைவரை அழைத்துப் பயணம் பதிவு செய்யலாம், உங்கள் பழைய பதிவுகள் இங்கேயே இருக்கும்.",
"as_lift": "நிறுத்தத்தை எங்கள் குழு மட்டுமே நீக்க முடியும்.",
"as_liftCall": "ஸ்ராமிகாவை அழைத்து உங்கள் பதிவு செய்த மொபைல் எண்ணைச் சொல்லுங்கள்.",
"as_call": "ஸ்ராமிகாவை அழை · {phone}",
"lc_fee": "லீட் கட்டணம்",
"lc_free": "இலவசம்",
"lc_noCharges": "இன்னும் லீட் கட்டணம் இல்லை",
"lc_andAbove": "{min} மற்றும் அதற்கு மேல்",
"lc_ladderCar": "கார் மற்றும் கேப் கணக்குகள்",
"lc_ladderHire": "ஹையர் டிரைவர் கணக்குகள்",
"lc_bandCar": "வாடிக்கையாளருக்குச் சொன்ன பயணக் கட்டணத்தின்படி",
"lc_bandHire": "வாடிக்கையாளருக்குச் சொன்ன பணிக் கட்டணத்தின்படி",
"lc_sub": "ஒரு வாடிக்கையாளர் விசாரணைக்கு உங்களுக்கு ஆகும் செலவு.",
"lc_loading": "தற்போதைய கட்டணங்களை ஏற்றுகிறோம்…",
"lc_loadFail": "லீட் விலைகளை ஏற்ற முடியவில்லை.",
"lc_freeNow": "லீட்கள் இப்போது இலவசம்",
"lc_freeText": "கீழே உள்ள ஒவ்வொரு லீடும் இன்று உங்களுக்கு இலவசம். உங்கள் வாலெட்டிலிருந்து எதுவும் எடுக்கப்படாது, குறைந்த இருப்பால் எந்த லீடும் நிறுத்தப்படாது.",
"lc_validTill": "சலுகை {date} வரை.",
"lc_worth": "கீழே உள்ள விலைகள் ஒரு லீடின் மதிப்பு - கட்டணம் தொடங்கும் நாளில் அதிர்ச்சி இல்லாமல் இருக்கக் காட்டுகிறோம். அந்த நாளுக்கு முன்பே சொல்வோம்.",
"lc_active": "லீட் கட்டணம் நடைமுறையில் உள்ளது",
"lc_activeText": "நீங்கள் பெறும் ஒவ்வொரு லீடுக்கும் கீழே உள்ள கட்டணம் உங்கள் வாலெட்டிலிருந்து எடுக்கப்படும்.",
"lc_tripFare": "பயணக் கட்டணம்",
"lc_good": "தெரிந்துகொள்ளுங்கள்",
"lc_g1": "நீங்கள் செலுத்துவது லீடுக்கு - வாடிக்கையாளரின் விசாரணைக்கு - பயணத்தின் மீது கமிஷன் அல்ல. வாடிக்கையாளர் தருவது முழுதும் உங்களுடையது.",
"lc_g2": "கட்டணம் அந்த வாடிக்கையாளருக்குச் சொன்ன கட்டணத்தைப் பொறுத்தது, எனவே சிறிய பயணத்திற்குப் பெரிய பயணக் கட்டணம் ஒருபோதும் வராது.",
"lc_g3": "அதே வாடிக்கையாளர் விரைவில் மீண்டும் அழைத்தால், அது புதிய லீட் அல்ல.",
"lc_g4": "இந்தக் கட்டணங்கள் மாறலாம். ஒவ்வொரு லீடும் வந்த நாளில் எவ்வளவு ஆனது என்பது உங்கள் லீட் வரலாற்றில் எப்போதும் தெரியும்.",
"dd_kycTitle": "லீட்கள் பெற இவற்றை முடிக்கவும்",
"dd_kycBasic": "அடிப்படை விவரங்கள்",
"dd_kycEmergency": "அவசரத் தொடர்பு",
"dd_kycLicence": "உரிமம்",
"dd_kycPhoto": "புகைப்படம்",
"dd_kycReview": "உங்கள் விவரங்கள் சரிபார்க்கப்படுகின்றன",
"dd_kycReviewSub": "ஸ்ராமிகா உங்கள் சுயவிவரத்தைப் பார்க்கிறது.",
"dd_rbNew": "புதிய டிரைவர் - இன்னும் மதிப்பீடுகள் இல்லை",
"dd_rbNewSub": "பயணங்களை முடித்து, வாடிக்கையாளர்களிடம் மதிப்பீடு கேளுங்கள் - நல்ல மதிப்பீடு இருந்தால் பட்டியலில் மேலே வருவீர்கள்.",
"dd_rbLine": "மதிப்பீடு {r} · {tier} · {ratings}",
"dd_tSusp": "நிறுத்தப்பட்டது",
"dd_cSusp": "நீங்கள் வரவில்லை என வாடிக்கையாளர்கள் பலமுறை தெரிவித்ததால் நிறுத்தப்பட்டது.",
"dd_tPriority": "முன்னுரிமை",
"dd_cPriority": "வாடிக்கையாளர் தேடலில் நீங்கள் மேலே காட்டப்படுவீர்கள்.",
"dd_tStandard": "சாதாரண",
"dd_cStandard": "வாடிக்கையாளர் தேடலில் சாதாரண இடம்.",
"dd_tWarning": "எச்சரிக்கை",
"dd_cWarning": "உங்கள் சுயவிவரத்தில் எச்சரிக்கை தெரியும், ஸ்ராமிகா பரிசீலிக்கும்.",
"dd_tCritical": "கடுமை",
"dd_cCritical": "ஸ்ராமிகா உங்கள் சுயவிவரத்தைப் பார்க்கும் வரை புதிய லீட்கள் நிறுத்தப்பட்டுள்ளன.",
"dd_liTotal": "வந்த லீட்கள்",
"dd_liMonth": "இந்த மாதம்",
"dd_liFees": "லீட் கட்டணம்",
"dd_liConv": "{pct}% பயணங்களாக மாறின · நீங்கள் குறித்த {decided}-இல் {won}",
"dd_psTitle": "சுயவிவர வலிமை",
"dd_psFull": "✅ முழுமையான சுயவிவரம் - தேடலில் மேலே தெரிவீர்கள்",
"dd_psGood": "நல்ல சுயவிவரம்",
"dd_psLow": "⚠️ சுயவிவரம் முழுமையில்லை - வாடிக்கையாளர்களுக்குக் குறைவாகத் தெரிவீர்கள்",
"dd_psRank": "ஹையர் டிரைவர் பட்டியலில் மேலே வர",
"dd_psTip1": "கிடைக்கும் நிலையில் இருங்கள். கிடைக்கும் டிரைவர்கள் முதலில் காட்டப்படுவார்கள்.",
"dd_psTip2": "100/100 அடையுங்கள். முழுமையான சுயவிவரங்கள் மற்றவற்றுக்கு முன் வரும்.",
"dd_psTip3": "4★ அல்லது அதற்கு மேல் பெறுங்கள். மகிழ்ச்சியான வாடிக்கையாளர்களிடம் மதிப்பீடு கேளுங்கள்.",
"dd_psMissing": "மதிப்பெண் உயர இவற்றைச் சேர்க்கவும்:",
"dd_fPhoto": "சுயவிவரப் புகைப்படம்",
"dd_fLicence": "ஓட்டுநர் உரிமம்",
"dd_fBio": "உங்களைப் பற்றி",
"dd_fGender": "பாலினம்",
"dd_fAge": "வயது",
"dd_fCity": "நகரம்",
"dd_fAddress": "முழு முகவரி",
"dd_fAutomatic": "ஆட்டோமேட்டிக் கார் ஓட்டுதல்",
"dd_fTypes": "நீங்கள் ஓட்டும் கார் வகைகள்",
"dd_fOwnRates": "உங்கள் சொந்தக் கட்டணங்கள்",
"dd_fWeekly": "வாரக் கிடைக்கும் நிலை",
"dd_fRating": "வாடிக்கையாளர் மதிப்பீடு 4+",
"dd_avTitle": "உங்கள் கிடைக்கும் நிலை",
"dd_avOffline": "ஆஃப்லைன்",
"dd_avHintAvail": "வாடிக்கையாளர்கள் உங்களைக் கண்டு அழைக்கலாம்.",
"dd_avHintBusy": "நீங்கள் பட்டியலில் இருப்பீர்கள், பிஸி எனக் காட்டப்படும்.",
"dd_avHintOff": "புதிய லீட்களுக்கு நீங்கள் மறைக்கப்படுவீர்கள்.",
"dd_avHintSusp": "கணக்கு நிறுத்தப்பட்டிருக்கும் வரை வாடிக்கையாளர்களுக்குத் தெரியமாட்டீர்கள் - நீக்கிய பின் இது மீண்டும் செயல்படும்.",
"dd_availFail": "உங்கள் கிடைக்கும் நிலையை மாற்ற முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
"dd_leadFail": "இந்த லீடுக்கான உங்கள் பதிலைச் சேமிக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
"dd_rates": "உங்கள் கட்டணங்கள்",
"dd_gBoth": "உள்ளூர் மற்றும் வெளியூர்",
"dd_nightHalt": "இரவுத் தங்கல்",
"dd_usual": "வழக்கம் ₹{n}",
"dd_max": "அதிகபட்சம் ₹{n}",
"dd_cityStd": "நகர வழக்கம்",
"dd_followsCity": "நகரக் கட்டணம், அதனுடன் மாறும்",
"dd_above": "வழக்கத்தை விட அதிகம்",
"dd_below": "வழக்கத்தை விட குறைவு",
"dd_nightRides": "இரவுப் பயணங்கள் ({from}-{to})",
"dd_yesPct": "ஆம், +{pct}%",
"dd_no": "இல்லை",
"dd_raiseOnce": "விலைகளை எப்போது வேண்டுமானாலும் குறைக்கலாம். உயர்த்துவது நாளுக்கு ஒருமுறை - அடுத்து {when} பிறகு.",
"dd_ratesSaved": "கட்டணங்கள் சேமிக்கப்பட்டன.",
"dd_ratesSavedMax": "கட்டணங்கள் சேமிக்கப்பட்டன. சில உங்கள் நகரின் அதிகபட்சத்திற்குக் குறைக்கப்பட்டன.",
"dd_ratesFail": "உங்கள் கட்டணங்களைச் சேமிக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
"dd_pending": "ஒரு மாற்றம் ஒப்புதலுக்காகக் காத்திருக்கிறது. சரிபார்க்கும் வரை உங்கள் தற்போதைய விவரங்களே தெரியும்.",
"dd_pickImage": "தயவுசெய்து ஒரு புகைப்படத்தைத் தேர்ந்தெடுக்கவும்.",
"dd_tooBig": "அந்தப் புகைப்படம் மிகப் பெரியது. 6எம்பி-க்குக் குறைவானதைத் தேர்ந்தெடுக்கவும்.",
"dd_sentApproval": "ஒப்புதலுக்கு அனுப்பப்பட்டது.",
"dd_photoFail": "உங்கள் புகைப்படத்தை அனுப்ப முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
"dd_changePhoto": "புகைப்படத்தை மாற்று",
"dd_licExpired": "ஓட்டுநர் உரிமம் காலாவதியானது",
"dd_licToday": "உரிமம் இன்று காலாவதியாகிறது",
"dd_licOneDay": "உரிமம் 1 நாளில் காலாவதியாகும்",
"dd_licDays": "உரிமம் {n} நாட்களில் காலாவதியாகும்",
"dd_licUpdate": "லீட்கள் தொடர்ந்து வர உங்கள் உரிமத்தைப் புதுப்பிக்கவும்.",
"dd_lowFree": "வாலெட் ₹200-க்குக் குறைவு (₹{bal})",
"dd_lowFreeText": "லீட்கள் இப்போது இலவசம் - எதுவும் எடுக்கப்படாது. லீட் கட்டணம் தொடங்கும் முன் பணம் சேர்க்கவும்.",
"dd_lowPaid": "வாலெட் இருப்பு குறைவு (₹{bal})",
"dd_lowPaidText": "லீட்கள் தொடர்ந்து வர பணம் சேர்க்கவும்.",
"dd_leadHistory": "லீட் வரலாறு",
"dd_leadHistorySub": "ஸ்ராமிகா மூலம் உங்களை அழைத்த வாடிக்கையாளர்கள்",
"dd_noLeads": "இன்னும் லீட்கள் இல்லை. ஸ்ராமிகா மூலம் வாடிக்கையாளர் அழைக்கும்போது இங்கே தெரியும்.",
"dd_pendingVer": "சரிபார்ப்புக்குக் காத்திருக்கிறது",
"dd_details": "விவரங்கள்",
"dd_exp": "அனுபவம்",
"dd_trips": "பயண வகைகள்",
"dd_tripsPick": "குறைந்தது ஒரு வகை பயணத்தைத் தேர்ந்தெடுக்கவும்.",
"dd_tripsFail": "சேமிக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
"dd_langs": "மொழிகள்",
"dd_docs": "உங்கள் ஆவணங்கள்",
"dd_mobileLocked": "சரிபார்க்கப்பட்டது · மாற்ற முடியாது",
"dd_licFront": "உரிமம் - முன்பக்கம்",
"dd_licBack": "உரிமம் - பின்பக்கம்",
"dd_notUploaded": "பதிவேற்றவில்லை",
"dd_docsNote": "உரிமம் அல்லது மொபைல் எண்ணை மாற்ற ஸ்ராமிகாவை அழைக்கவும் - மாற்றும் முன் இவை மீண்டும் சரிபார்க்கப்படும்.",
"dd_editProfile": "சுயவிவரம், ஆவணங்களைத் திருத்து",
"dd_referrals": "பரிந்துரைகள்",
"dd_earned": "சம்பாதித்தது",
"dp_pDriving": "ஓட்டும் திறன்",
"dp_slabLocal": "உள்ளூர் - {n} மணி வரை",
"dp_slabOut": "வெளியூர் - {n} மணி வரை",
"dp_nightRide": "இரவுப் பயணம் +{pct}%",
"dp_nightHalt": "இரவுத் தங்கல் × {n}",
"dp_notFound": "டிரைவர் கிடைக்கவில்லை",
"dp_notFoundText": "இந்த டிரைவர் இப்போது பட்டியலில் இல்லை.",
"dp_backDrivers": "டிரைவர்களுக்குத் திரும்பு",
"dp_available": "இப்போது கிடைக்கிறார்",
"dp_busy": "இப்போது பிஸி",
"dp_offline": "இப்போது கிடைக்கவில்லை",
"dp_canDrive": "ஓட்டக்கூடியவை",
"dp_moreTypes": "+{n} மேலும்",
"dp_new": "புதிய டிரைவர்",
"dp_tooLong": "இந்தப் பயணம் ஒரு டிரைவருக்கு மிக நீளம்.",
"dp_price": "டிரைவர் கட்டணம்",
"dp_driverOnly": "டிரைவர் கட்டணம் மட்டும்",
"dp_noPrice": "இந்தப் பயணத்திற்கு இன்னும் விலை இல்லை - அழைத்துக் கேளுங்கள்.",
"dp_callFail": "அழைப்பை இணைக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
"dp_trustDirect": "டிரைவரிடம் நேரடியாகப் பேசுங்கள்",
"wl_title": "ஸ்ராமிகா வாலெட்",
"wl_balance": "இருப்பு",
"wl_recent": "சமீபத்திய பரிவர்த்தனைகள்",
"wl_needAmt": "இருப்பு போதவில்லை. தொடர ₹{amt} ரீசார்ஜ் செய்யுங்கள்.",
"wl_badAmt": "சரியான தொகையை உள்ளிடுங்கள்.",
"wl_done": "ரீசார்ஜ் ஆனது.",
"wl_payFail": "பணம் செலுத்துதல் தோல்வி: {reason}",
"wl_payStartFail": "பணம் செலுத்துதலைத் தொடங்க முடியவில்லை.",
"wl_txnOther": "வாலெட் பதிவு",
"wl_balAfter": "இருப்பு {amt}",
"wg_lowTitle": "உங்கள் இலவச அழைப்புகள் முடிந்தன",
"wg_lowText": "இப்போது இணையும் ஒவ்வொரு அழைப்புக்கும் ₹{fee}. அழைப்பு இணைந்தால் மட்டுமே உங்கள் வாலெட்டிலிருந்து எடுக்கப்படும்.",
"wg_balance": "வாலெட் இருப்பு: ₹{bal}",
"wg_resets": "இலவச அழைப்புகள் {time} முதல் மீண்டும் கிடைக்கும்",
"wg_pick": "தொகையைத் தேர்ந்தெடுக்கவும்",
"wg_add": "₹{amt} சேர்க்கவும்",
"wg_paidTitle": "இந்த அழைப்புக்கு ₹{fee}",
"wg_paidText": "அழைப்பு இணைந்தால் மட்டுமே உங்கள் வாலெட்டிலிருந்து எடுக்கப்படும். இணையவில்லை என்றால் எதுவும் எடுக்கப்படாது.",
"wg_paidCall": "அழை · ₹{fee}",
"wg_okTitle": "உங்கள் வாலெட்டில் ₹{amt} சேர்க்கப்பட்டது",
"wg_okText": "புதிய இருப்பு: ₹{bal}",
"wg_callNow": "இப்போது அழை",
"wg_done": "சரி",
"wg_failTitle": "பணம் செலுத்துதல் நடக்கவில்லை",
"wg_failText": "உங்கள் வாலெட்டில் பணம் சேர்க்கப்படவில்லை. வங்கியிலிருந்து பணம் எடுக்கப்பட்டிருந்தால், 5–7 வேலை நாட்களில் தானாகத் திரும்பி வரும்.",
"wg_tryAgain": "மீண்டும் முயற்சி செய்",
"wg_pendingTitle": "உங்கள் பணம் செலுத்துதலை உறுதிசெய்கிறோம்",
"wg_pendingText": "இதற்கு ஒரு நிமிடம் ஆகலாம். இருப்பு தானாகப் புதுப்பிக்கப்படும் - மீண்டும் பணம் செலுத்த வேண்டாம்.",
"wg_soonTitle": "பணம் சேர்க்கும் வசதி விரைவில்",
"wg_soonText": "பணம் செலுத்தும் வசதி இன்னும் தொடங்கவில்லை. உங்கள் இலவச அழைப்புகள் தொடர்ந்து வேலை செய்யும்.",
"wg_startFail": "பணம் செலுத்தும் பக்கத்தைத் திறக்க முடியவில்லை. இணையத்தைச் சரிபார்த்து மீண்டும் முயற்சிக்கவும்.",
"wg_extraTitle": "கூடுதல் அழைப்பு - ₹{fee}",
"wg_extraText": "உண்மையான பதிவுகளுக்காக {h} மணி நேரத்திற்கு {n} இலவச அழைப்புகள்.",
"wg_extraTalk": "இந்த அழைப்பில் டிரைவரிடம் நேரடியாகப் பேசுங்கள்.",
"wg_balanceAfter": "இருப்பு ₹{bal} → ₹{after}",
"wg_payWallet": "வாலெட்டிலிருந்து ₹{fee} · அழை",
"wg_payUpi": "₹{amt} செலுத்தி அழை",
"wg_freeAfter": "{time}க்குப் பிறகு இலவசம்",
"wg_lastTitle": "இது உங்கள் கடைசி இலவச அழைப்பு ({n}/{n})",
"wg_lastText": "{time}க்குப் பிறகு மீண்டும் {n} இலவச அழைப்புகள்.",
"wg_call": "அழை",
"wg_ownTitle": "இது உங்கள் சொந்த கார்",
"wg_ownProfile": "இது உங்கள் சொந்த சுயவிவரம்",
"wg_ownText": "உங்கள் சொந்த கணக்கிற்கு நீங்களே லீட் உருவாக்க முடியாது.",
"ib_title": "உடனடி பதிவு",
"ib_text": "8 மணி நேரத்தில் தொடங்கும் பயணங்களுக்கு, கிடைப்பதைப் பொறுத்து ஸ்ராமிகா காரைப் பரிந்துரைக்கும்.",
"ib_seats": "எத்தனை பேர்?",
"ib_seat5": "1–4 பேர்",
"ib_seat7": "5–6 பேர்",
"ib_seat12": "7–12 பேர்",
"ib_model": "கார் மாடல் (விருப்பம்)",
"ib_modelHint": "எ.கா: இன்னோவா",
"ib_fare": "இந்தப் பயணக் கட்டணம்: ₹{min} – ₹{max}",
"ib_pickSeats": "இருக்கைகளைத் தேர்ந்தெடுக்கவும்",
"ib_book": "இப்போது பதிவு செய்",
"ib_finding": "உங்கள் காரை உறுதி செய்கிறோம்…",
"ib_confirmed": "பதிவு உறுதியானது",
"ib_callYou": "டிரைவர் 10 நிமிடத்தில் உங்களை அழைப்பார்.",
"ib_team": "எங்கள் குழு 10 நிமிடங்களில் உங்களை அழைக்கும்.",
"ib_error": "பதிவு செய்ய முடியவில்லை. மீண்டும் முயலவும்.",
"ob_title": "⚡ அவசரப் பயணமா?",
"ob_sub": "ஸ்ராமிகா பரிந்துரைக்கும் கார் 2–10 நிமிடத்தில் · ₹{min} – ₹{max}",
"ib_textAny": "கிடைப்பதைப் பொறுத்து ஸ்ராமிகா காரைப் பரிந்துரைக்கும்.",
"ib_urgentTitle": "⚡ இது அவசரப் பயணம்",
"ib_urgentText": "8 மணி நேரத்திற்குள் பயணத்திற்கு ஸ்ராமிகா பரிந்துரைக்கும் கார் - பொதுவாக 2–10 நிமிடங்களில் உறுதி. ஒவ்வொருவரையும் அழைக்க வேண்டியதில்லை.",
"ib_urgentBtn": "⚡ 2–10 நிமிடத்தில் கார் பதிவு செய்யுங்கள்",
"ib_any": "ஏதேனும்",
"ib_cars": "{n} கார்கள்",
"ib_wait": "பொதுவாக 2–10 நிமிடங்கள். 10 நிமிடத்தில் கார் உறுதியாகவில்லை என்றால், எங்கள் குழு உங்களை அழைக்கும்.",
"ib_callDriver": "📞 டிரைவரை அழையுங்கள்",
"ib_private": "ஸ்ராமிகா எண் வழியாக - உங்கள் எண் டிரைவருக்குத் தெரியாது",
"ib_calling": "📞 உங்கள் போன் இப்போது ஒலிக்கும் - எடுத்தவுடன் டிரைவருடன் இணைப்போம்.",
"tr_wants": "வாடிக்கையாளர் கேட்டது: {what}",
"wl_txnCall": "அழைப்புக் கட்டணம்",
"wl_minMax": "₹{min} முதல் ₹{max} வரை சேர்க்கவும்.",
"sp_title": "உதவி",
"sp_callTitle": "ஸ்ராமிகாவுடன் பேசுங்கள்",
"sp_callText": "அழைப்பு, விலை, கார் அல்லது டிரைவர் தொடர்பான எந்தப் பிரச்சினைக்கும்.",
"sp_callBtn": "ஸ்ராமிகாவை அழைக்கவும்",
"sp_faqTitle": "அடிக்கடி கேட்கப்படும் கேள்விகள்",
"sp_q1": "கார் எப்படித் தேடுவது?",
"sp_a1": "பிக்கப், டிராப் இடங்களைத் தேர்ந்தெடுங்கள். கார்களையும் விலைகளையும் ஒப்பிட்டு, அழை என்பதை அழுத்தி டிரைவரிடம் நேரடியாகப் பேசுங்கள்.",
"sp_q2": "புக்கிங் கட்டணம் உண்டா?",
"sp_a2": "இல்லை. ஆப்பில் எதுவும் புக் ஆவதில்லை - பயணத்தை டிரைவருடன் பேசி முடிவு செய்து, அவர்களிடமே நேரடியாகச் செலுத்துங்கள்.",
"sp_q3": "பயணத்தை எப்படி ரத்து செய்வது?",
"sp_a3": "டிரைவரை அழைத்துச் சொல்லுங்கள். பயணம் உங்களுக்கும் அவர்களுக்கும் இடையே பேசி முடிவானது, எனவே இங்கே ரத்து செய்ய புக்கிங் எதுவும் இல்லை. உங்கள் விசாரணை எப்படியும் வரலாற்றில் இருக்கும்.",
"sp_q4": "எப்படிச் செலுத்துவது?",
"sp_a4": "டிரைவரிடம் நேரடியாகச் செலுத்துங்கள் - பணம் அல்லது யுபிஐ, நீங்கள் பேசி முடிவு செய்தபடி.",
"sp_q5": "விலையில் சேராதவை எவை?",
"sp_a5": "டோல், பார்க்கிங், மாநில வரி - டிரைவரிடம் நேரடியாகச் செலுத்துங்கள். கூடுதல் கி.மீ அல்லது மணி நேரத்திற்கு கூடுதல் கட்டணம்.",
"sp_q6": "பிரச்சினையை எப்படித் தெரிவிப்பது?",
"sp_a6": "மேலே உள்ள பொத்தானில் ஸ்ராமிகாவை அழையுங்கள். எந்தப் பயணம் என்று சொல்ல, வரலாற்றில் அந்த விசாரணையைத் திறந்து வையுங்கள்.",
"sp_footer": "ஸ்ராமிகா உதவி · support@sramika.com",
"nc_soon": "விரைவில்",
"nc_title": "ஸ்ராமிகா விரைவில் {city} க்கு வருகிறது",
"nc_titleNoCity": "ஸ்ராமிகா விரைவில் உங்கள் நகரத்திற்கு வருகிறது",
"nc_text": "{city} இல் கார்கள் மற்றும் டிரைவர்களைச் சேர்க்கிறோம். உங்கள் எண்ணைக் கொடுங்கள் - தயாரானதும் வாட்ஸ்அப் இல் சொல்வோம்.",
"nc_textNoCity": "உங்கள் நகரத்தில் கார்கள் மற்றும் டிரைவர்களைச் சேர்க்கிறோம். உங்கள் எண்ணைக் கொடுங்கள் - தயாரானதும் வாட்ஸ்அப் இல் சொல்வோம்.",
"nc_expected": "தொடக்க எதிர்பார்ப்பு",
"nc_name": "உங்கள் பெயர்",
"nc_phone": "வாட்ஸ்அப் எண் (10 இலக்கங்கள்)",
"nc_join": "தொடங்கியதும் சொல்லுங்கள்",
"nc_enterName": "உங்கள் பெயரை உள்ளிடுங்கள்.",
"nc_fail": "சேமிக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
"nc_doneTitle": "உங்கள் பெயர் பதிவாகிவிட்டது",
"nc_doneText": "{city} இல் ஸ்ராமிகா தொடங்கியதும் வாட்ஸ்அப் இல் சொல்வோம்.",
"nc_doneTextNoCity": "உங்கள் நகரத்தில் ஸ்ராமிகா தொடங்கியதும் வாட்ஸ்அப் இல் சொல்வோம்.",
"nt_title": "அறிவிப்புகள்",
"nt_emptyTitle": "இன்னும் அறிவிப்புகள் இல்லை",
"nt_emptyText": "உங்கள் விசாரணைகள் மற்றும் கணக்கு பற்றிய செய்திகள் இங்கே தெரியும்.",
"nt_history": "என் விசாரணைகளைப் பாருங்கள்",
"nt_all": "அனைத்தும்",
"nt_ride": "பயணங்கள்",
"nt_approval": "ஒப்புதல்கள்",
"nt_document": "ஆவணங்கள்",
"nt_wallet": "வாலெட்",
"nt_system": "புதுப்பிப்புகள்",
"nt_unread": "புதியவை",
"nt_read": "பார்த்தவை",
"nt_important": "முக்கியம்",
"nt_noneHere": "{name} இல் எதுவும் இல்லை.",
"nt_showAll": "அனைத்தையும் காட்டு",
"nt_notification": "அறிவிப்பு",
"st_confirm": "உறுதிசெய்",
"st_notSignedIn": "நீங்கள் உள்நுழையவில்லை",
"st_signInToManage": "சுயவிவரம் மற்றும் அமைப்புகளை மாற்ற உள்நுழையுங்கள்",
"st_loginSignup": "உள்நுழை / பதிவு செய்",
"st_partnerLogin": "டிரைவர் உள்நுழைவு",
"st_notEditable": "மாற்ற முடியாது",
"st_usernamePh": "உங்கள் பயனர் பெயர்",
"st_save": "சேமி",
"st_notSet": "அமைக்கவில்லை",
"st_edit": "மாற்று",
"st_cityPh": "எ.கா: விஜயவாடா",
"st_myRating": "என் மதிப்பீடு",
"st_footer": "ஸ்ராமிகா 1.0 · எல்லா தரவும் குறியாக்கத்துடன் பாதுகாப்பானது",
"st_nameSaved": "பயனர் பெயர் மாற்றப்பட்டது.",
"st_nameFail": "பயனர் பெயரைச் சேமிக்க முடியவில்லை.",
"st_nfTitle": "இந்தப் பக்கம் இல்லை",
"st_nfText": "இணைப்பு பழையதாக இருக்கலாம், அல்லது முகவரியில் பிழை இருக்கலாம். எல்லாம் இங்கேயே உள்ளது - முகப்புப் பக்கத்திலிருந்து தொடங்குங்கள்.",
"st_nfCar": "கார் தேடுங்கள்",
"st_nfDriver": "டிரைவரை வாடகைக்கு எடுங்கள்",
"st_suInvalid": "மொபைல் எண் சரிபார்த்த பிறகே இந்தப் பக்கம் திறக்கும்.",
"st_suToLogin": "உள்நுழைவுக்குச் செல்",
"st_suNameTitle": "உங்கள் பயனர் பெயரை அமையுங்கள்",
"st_suNameHint": "இடைவெளிகள் அனுமதிக்கப்படும். பின்னர் மாற்ற முடியாது.",
"st_suNameMissing": "தொடர பயனர் பெயரை உள்ளிடுங்கள்.",
"st_suContinue": "தொடரவும்",
"st_suPwTitle": "உங்கள் கடவுச்சொல்லை அமையுங்கள்",
"st_suPwMissing": "தொடர கடவுச்சொல்லை உள்ளிடுங்கள்.",
"st_suPwFail": "கடவுச்சொல்லை அமைக்க முடியவில்லை.",
"st_suNewPwPh": "புதிய கடவுச்சொல்லை உள்ளிடுங்கள்",
"pl_brand": "ஸ்ராமிகா பிசினஸ்",
"pl_portal": "டிரைவர்களுக்கு",
"pl_stepPhone": "மொபைல் எண்",
"pl_awaiting": "உங்கள் கணக்கு இன்னும் செயல்படுத்தப்படவில்லை. ஸ்ராமிகாவைத் தொடர்பு கொள்ளுங்கள்.",
"pl_continueFail": "தொடர முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
"pl_badPw": "கடவுச்சொல் தவறு. மீண்டும் முயற்சிக்கவும்.",
"pl_hide": "மறை",
"pl_show": "காட்டு",
"pl_checking": "சரிபார்க்கிறோம்…",
"pl_continue": "தொடரவும் →",
"pl_welcomeBack": "மீண்டும் வருக! +91 {phone} மூலம் உள்நுழைகிறீர்கள்",
"pl_otpInstead": "பதிலாக ஓடிபி மூலம் உள்நுழை",
"pl_otpLabel": "ஓடிபி (ஒருமுறை கடவுச்சொல்)",
"pl_customerLogin": "← வாடிக்கையாளர் உள்நுழைவு",
"pl_secs": "{n} வி.",
"lg_tenDigit": "10 இலக்க எண்",
"lg_moreDigits": "இன்னும் {n} இலக்கங்கள் தேவை",
"lg_oneMoreDigit": "இன்னும் 1 இலக்கம் தேவை",
"lg_startDigit": "6, 7, 8 அல்லது 9 இல் தொடங்க வேண்டும்",
"lg_enterMobile": "உங்கள் மொபைல் எண்ணை உள்ளிடுங்கள்.",
"lg_otpSendFail": "ஓடிபி அனுப்ப முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
"lg_enterOtp": "ஓடிபி ஐ உள்ளிடுங்கள்.",
"lg_otpInvalid": "ஓடிபி தவறு. மீண்டும் முயற்சிக்கவும்.",
"lg_otpResendFail": "ஓடிபி மீண்டும் அனுப்ப முடியவில்லை.",
"lg_pwMin": "கடவுச்சொல் குறைந்தது 8 எழுத்துகள் இருக்க வேண்டும்.",
"lg_pwMax": "கடவுச்சொல் 64 எழுத்துகளுக்கு மேல் இருக்கக்கூடாது.",
"lg_pwRange": "கடவுச்சொல் 8 முதல் 64 எழுத்துகள் இருக்க வேண்டும்.",
"lg_resetFail": "கடவுச்சொல்லை மாற்ற முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
"lg_resetTitle": "கடவுச்சொல்லை மீட்டமை",
"lg_verifyOtp": "ஓடிபி சரிபார்",
"lg_setNewPw": "புதிய கடவுச்சொல் அமை",
"lg_forgotIntro": "பதிவு செய்த மொபைல் எண்ணை உள்ளிடுங்கள். நாங்கள் ஒரு குறியீடு அனுப்புவோம்.",
"lg_mobile": "மொபைல் எண்",
"lg_waNotice": "இந்த எண்ணுக்கு உங்கள் ஓடிபி-யையும் உங்கள் விசாரணைகளின் அப்டேட்களையும் வாட்ஸ்அப், எஸ்எம்எஸ் மூலம் அனுப்புவோம். அப்டேட்களை நிறுத்த வாட்ஸ்அப்பில் “நிறுத்து” என்று அனுப்பவும்.",
"lg_sending": "அனுப்புகிறோம்…",
"lg_sendOtp": "ஓடிபி அனுப்பு",
"lg_otpSentTo": "+91 {phone} க்கு ஓடிபி அனுப்பப்பட்டது. கீழே 6 இலக்கக் குறியீட்டை உள்ளிடுங்கள்.",
"lg_otp6": "6 இலக்க ஓடிபி",
"lg_resendIn": "{n} வி. இல் மீண்டும் அனுப்பு",
"lg_resend": "மீண்டும் அனுப்பு",
"lg_verifying": "சரிபார்க்கிறோம்…",
"lg_otpDone": "ஓடிபி சரிபார்க்கப்பட்டது. புதிய கடவுச்சொல்லை அமையுங்கள்.",
"lg_newPw": "புதிய கடவுச்சொல்",
"lg_pwHint": "8-64 எழுத்துகள்",
"lg_saving": "சேமிக்கிறோம்…",
"lg_tagline": "உங்கள் நம்பகமான கேப் சேவை",
"lg_logIn": "உள்நுழை",
"lg_signUp": "பதிவு செய்",
"lg_password": "கடவுச்சொல்",
"lg_otpLogin": "ஓடிபி உள்நுழைவு",
"lg_userOrMobile": "பயனர் பெயர் அல்லது மொபைல்",
"lg_userOrMobilePh": "பயனர் பெயர் அல்லது மொபைல் எண்",
"lg_enterPw": "கடவுச்சொல்லை உள்ளிடுங்கள்",
"lg_forgot": "கடவுச்சொல் மறந்துவிட்டதா?",
"lg_signingIn": "உள்நுழைகிறது…",
"lg_signIn": "உள்நுழையுங்கள்",
"lg_codeSentTo": "+91 {phone} க்கு வந்த 6 இலக்கக் குறியீட்டை உள்ளிடுங்கள்",
"lg_verifySignIn": "சரிபார்த்து உள்நுழையுங்கள்",
"lg_userName": "பயனர் பெயர்",
"lg_nameTaken": "இந்தப் பயனர் பெயர் ஏற்கனவே உள்ளது.",
"lg_tryName": "இதை முயற்சிக்கவும்: {name}",
"lg_numTaken": "இந்த மொபைல் எண் ஏற்கனவே பதிவு செய்யப்பட்டுள்ளது.",
"lg_signInInstead": "உள்நுழையுங்கள் →",
"lg_email": "மின்னஞ்சல்",
"lg_fullName": "முழுப் பெயர்",
"lg_enterOtp6": "6 இலக்க ஓடிபி ஐ உள்ளிடுங்கள்",
"lg_setPw": "கடவுச்சொல் அமை",
"lg_confirmPw": "கடவுச்சொல்லை உறுதிசெய்",
"lg_reenterPw": "கடவுச்சொல்லை மீண்டும் உள்ளிடுங்கள்",
"lg_accept": "நான் {terms} மற்றும் {privacy} ஐ ஏற்கிறேன்; தள செயல்பாடுகளுக்காக என் தனிப்பட்ட தகவல்களைச் சேகரிக்க வெளிப்படையாக ஒப்புதல் அளிக்கிறேன்.",
"lg_terms": "விதிமுறைகள் & நிபந்தனைகள்",
"lg_privacy": "தனியுரிமைக் கொள்கை",
"lg_creating": "கணக்கு உருவாகிறது…",
"lg_create": "கணக்கை உருவாக்கு",
"lg_earn": "ஸ்ராமிகாவுடன் சம்பாதிக்க வேண்டுமா?",
"lg_joinAs": "டிரைவர் அல்லது ஆல்டிங் டிரைவராக சேருங்கள்",
"lg_cabOwner": "டிரைவர்",
"lg_hireDriver": "வாடகை டிரைவர்",
"lg_enterUsername": "பயனர் பெயரை உள்ளிடுங்கள்.",
"lg_otherUsername": "வேறு பயனர் பெயரைத் தேர்ந்தெடுங்கள்.",
"lg_validMobile": "சரியான 10 இலக்க மொபைல் எண்ணை உள்ளிடுங்கள்.",
"lg_hasAccount": "இந்த எண்ணுக்கு ஏற்கனவே கணக்கு உள்ளது.",
"lg_otpSentShort": "+91 {phone} க்கு ஓடிபி அனுப்பப்பட்டது",
"lg_noAccount": "கணக்கு இல்லை - புதிய கணக்கை உருவாக்குவோம்.",
"lg_autoOtpFail": "ஓடிபி அனுப்ப முடியவில்லை. மீண்டும் அனுப்பு என்பதை அழுத்துங்கள்.",
"lg_noPwYet": "உங்கள் கணக்கிற்கு இன்னும் கடவுச்சொல் இல்லை - இப்போதே அமையுங்கள்.",
"lg_enterOtpSent": "மொபைலுக்கு வந்த ஓடிபி ஐ உள்ளிடுங்கள்.",
"lg_enterUserOrMobile": "பயனர் பெயர் அல்லது மொபைல் எண்ணை உள்ளிடுங்கள்.",
"lg_enterPwMsg": "கடவுச்சொல்லை உள்ளிடுங்கள்.",
"lg_setPwFor": "உங்கள் மொபைல் எண்ணுக்கு கடவுச்சொல் அமையுங்கள்.",
"lg_badLogin": "பயனர் பெயர்/மொபைல் அல்லது கடவுச்சொல் தவறு. சரிபாருங்கள்.",
"lg_otpExpired": "ஓடிபி காலாவதியானது. மீண்டும் அனுப்புங்கள்.",
"lg_pwMismatch": "கடவுச்சொற்கள் பொருந்தவில்லை.",
"lg_enterEmail": "மின்னஞ்சலை உள்ளிடுங்கள்.",
"lg_enterFullName": "உங்கள் முழுப் பெயரை உள்ளிடுங்கள்.",
"lg_acceptFirst": "விதிமுறைகள் மற்றும் தனியுரிமைக் கொள்கையை ஏற்றுக்கொள்ளுங்கள்.",
"lg_createFail": "கணக்கை உருவாக்க முடியவில்லை.",
"cv_lExtraOneHr": "கூடுதல் 1 மணி",
"cv_24h": "24 மணி நேரம்",
"cv_back": "பின்செல்",
"cv_share": "பகிர்",
"cv_linkCopied": "இணைப்பு நகலெடுக்கப்பட்டது",
"cv_prevPhoto": "முந்தைய படம்",
"cv_nextPhoto": "அடுத்த படம்",
"cv_close": "மூடு",
"cv_nRatings": "{n} மதிப்பீடுகள்",
"cv_oneRating": "1 மதிப்பீடு",
"cv_model": "{year} மாடல்",
"cv_manual": "மேனுவல்",
"cv_auto": "ஆட்டோமேட்டிக்",
"cv_male": "ஆண்",
"cv_female": "பெண்",
"cv_licence": "லைசென்ஸ் சரிபார்க்கப்பட்டது",
"cv_yourTrip": "உங்கள் பயணம்",
"cv_change": "மாற்று",
"cv_local": "உள்ளூர்",
"cv_partnerPrice": "டிரைவர் விலை",
"cv_usualFare": "வழக்கமான கட்டணம்",
"cv_extrasShort": "டோல், பார்க்கிங் தனி",
"cv_priceDetails": "விலை விவரம்",
"cv_eta": "{name} {place} இலிருந்து {n} நிமிட தூரத்தில் உள்ளார்",
"cv_seePriceTitle": "உங்கள் பயணத்தின் விலையைப் பாருங்கள்",
"cv_seePriceText": "பிக்கப், டிராப் இடங்களைத் தேர்ந்தெடுங்கள் - விலை இங்கே தெரியும்.",
"cv_setTrip": "பிக்கப் & டிராப் தேர்வு",
"cv_allDay": "தினமும் கிடைக்கும் · 24 மணி நேரம்",
"cv_everyDay": "தினமும் கிடைக்கும் · {hours}",
"cv_openToday": "இன்று கிடைக்கும் · {hours}",
"cv_closedToday": "இன்று கிடைக்காது",
"cv_daysOpen": "வாரத்தில் {n} நாட்கள்",
"cv_week": "வாரம்",
"cv_dayOff": "விடுமுறை",
"cv_dayBusy": "பிஸி",
"cv_dayOpen": "கிடைக்கும்",
"cv_notConfirmed": "வழக்கமான நேரம் - டிரைவர் இன்னும் உறுதிப்படுத்தவில்லை",
"cv_rateTitle": "{name} உடன் உங்கள் பயணம் எப்படி இருந்தது?",
"cv_rateNoName": "உங்கள் பயணம் எப்படி இருந்தது?",
"cv_rateParts": "ஒவ்வொன்றும் - வேண்டுமானால் மாற்றுங்கள், அல்லது அப்படியே அனுப்புங்கள்",
"cv_noRatings": "இன்னும் மதிப்பீடுகள் இல்லை",
"cv_rateAfter": "இந்தக் காரில் பயணித்தீர்களா? பயணத்திற்குப் பிறகு மதிப்பிடுங்கள்.",
"cv_partsFrom": "{m} மதிப்பீடுகளில் {n} இலிருந்து விவரம்",
"rl_title": "{name} உடனான பயணத்தை மதிப்பிடுங்கள்",
"rl_done": "நன்றி! உங்கள் மதிப்பீடு சேமிக்கப்பட்டது.",
"rl_gone": "இந்த இணைப்பு காலாவதியானது. உங்கள் நட்சத்திரங்களுக்கு நன்றி!",
"cv_trustDirect": "டிரைவரிடம் நேரடியாகப் பேசுங்கள்",
"cv_trustNoFee": "புக்கிங் கட்டணம் இல்லை",
"cv_trustHelp": "தேவைப்பட்டால் ஸ்ராமிகா உதவி",
"cv_help": "உதவி வேண்டுமா? ஸ்ராமிகாவை அழைக்கவும்",
"cv_onTripBack": "பயணத்தில் உள்ளார் · {when} திரும்புவார்",
"cv_onTrip": "இப்போது பயணத்தில் உள்ளார்",
"cv_notFree": "இப்போது கிடைக்கவில்லை",
"cv_notifyMe": "கிடைக்கும்போது சொல்லுங்கள்",
"cv_notified": "உங்களுக்குத் தெரிவிப்போம்",
"cv_similar": "இதுபோன்ற கார்கள்",
"cv_setByPartner": "விலையை டிரைவர் நிர்ணயித்தார் · ஸ்ராமிகா கமிஷன் இல்லை",
"cv_kmBoth": "போக வர {km} கி.மீ",
"cv_nDays": "{n} நாட்கள்",
"cv_oneDay": "1 நாள்",
"cv_nHrs": "{n} மணி",
"cv_oneHr": "1 மணி",
"cv_nNights": "{n} இரவுகள்",
"cv_oneNight": "1 இரவு",
"cv_nHalfDays": "{n} அரை நாட்கள்",
"cv_oneHalfDay": "1 அரை நாள்",
"cv_lBase": "அடிப்படைக் கட்டணம்",
"cv_lDrop": "டிராப் கட்டணம்",
"cv_lDriver": "டிரைவர் பேட்டா ({x})",
"cv_lNight": "இரவு பேட்டா ({x})",
"cv_lDropUpTo": "டிராப் ({km} கி.மீ வரை)",
"cv_lDropFirst": "டிராப் (முதல் {km} கி.மீ)",
"cv_lExtraKmRate": "கூடுதல் {km} கி.மீ × ₹{rate}",
"cv_lPackage": "{n} மணி நேர பேக்கேஜ்",
"cv_lExtraHr": "கூடுதல் {n} மணி",
"cv_lExtraKm": "கூடுதல் {n} கி.மீ",
"cv_lDayRent": "நாள் வாடகை ({x})",
"cv_lFuel": "எரிபொருள் கட்டணம்",
"cv_youPay": "நீங்கள் டிரைவருக்கு செலுத்துவது",
"cv_notIncl": "இதில் சேர்க்கப்படாதவை",
"cv_notIncl1": "டோல், பார்க்கிங், மாநில வரி - டிரைவரிடம் நேரடியாகச் செலுத்துங்கள்",
"cv_notIncl2": "கூடுதல் கி.மீ அல்லது மணி நேரத்திற்கு கூடுதல் கட்டணம்",
"cv_calcLink": "கூடுதல் கி.மீ / மணி நேர விலையைக் கணக்கிடுங்கள்",
"cv_calcTitle": "விலை கணக்கீடு",
"cv_calcSub": "அதிக கி.மீ அல்லது மணி நேரத்திற்கான விலை",
"cv_calcHours": "பயண மணி நேரம்",
"cv_calcKm": "மொத்த கி.மீ",
"cv_calcBtn": "விலையைக் கணக்கிடு",
"cv_calcTotal": "மதிப்பிடப்பட்ட விலை",
"cv_calcNote": "டோல், பார்க்கிங், மாநில வரி சேர்க்கப்படவில்லை",
"cv_loading": "கார் விவரங்கள் ஏற்றப்படுகின்றன…",
"cv_goneTitle": "இந்த கார் கிடைக்கவில்லை",
"cv_goneText": "இந்த கார் இப்போது பட்டியலில் இல்லை, அல்லது இணைப்பு காலாவதியாகிவிட்டது.",
"cv_backHome": "முகப்புக்குச் செல்",
"hm_recentEnquiry": "சமீபத்திய விசாரணை",
"hm_nPartners": "{n} பார்ட்னர்கள்",
"hm_onePartner": "1 பார்ட்னர்",
"hm_resAvailIn": "{city}-இல் {items} உள்ளனர்",
"hm_resAvailInCars": "{city}-இல் {items} உள்ளன",
"hm_changeLang": "மொழியை மாற்று",
"hm_changeCity": "நகரத்தை மாற்று",
"hm_helpCall": "உதவிக்கு ஸ்ராமிகாவை அழைக்கவும்",
"hm_chooseCity": "உங்கள் நகரத்தைத் தேர்ந்தெடுக்கவும்",
"hm_typeCity": "நகரத்தின் பெயரை எழுதுங்கள்",
"hm_useMyLocation": "என் இருப்பிடத்தைப் பயன்படுத்து",
"hm_finding": "உங்கள் இருப்பிடத்தைத் தேடுகிறது…",
"hm_noCities": "இந்தப் பெயரில் நகரம் இல்லை",
"hm_locNotSupported": "இந்த போன் இருப்பிடத்தைப் பகிர முடியாது.",
"hm_locMapsOff": "வரைபடம் ஏற்றப்படவில்லை. பக்கத்தை மீண்டும் ஏற்றவும்.",
"hm_locNotFound": "உங்கள் இருப்பிடம் கிடைக்கவில்லை. மீண்டும் முயலவும்.",
"hm_locNoCity": "உங்கள் இருப்பிடம் கிடைத்தது, ஆனால் நகரம் தெரியவில்லை. கீழே இருந்து தேர்ந்தெடுக்கவும்.",
"hm_locDenied": "இருப்பிட அனுமதி வழங்கப்படவில்லை. போன் அமைப்புகளில் அனுமதித்து மீண்டும் முயலவும்.",
"hm_locUnavailable": "இருப்பிடம் கிடைக்கவில்லை. ஜிபிஎஸ்-ஐ இயக்கி மீண்டும் முயலவும்.",
"hm_locTimeout": "இருப்பிடத்தைக் கண்டறிய அதிக நேரம் ஆனது. மீண்டும் முயலவும்.",
"hm_guestTitle": "உள்நுழைந்து ஓட்டுநர்களை நேரடியாக அழையுங்கள்",
"hm_guestSubCars": "கட்டணங்களை ஒப்பிட்டு, டிரைவருடன் நேரடியாகப் பேசுங்கள் - புக்கிங் கட்டணம் இல்லை.",
"hm_guestSubDrivers": "மொபைல் எண்ணுடன் இலவசம். ஒரே தொடுதலில் அழையுங்கள், உங்கள் விசாரணைகளை வரலாற்றில் பாருங்கள். முன்பதிவுக் கட்டணம் இல்லை.",
"hm_guestTitleCars": "உள்நுழைந்து டிரைவர்களை நேரடியாக அழையுங்கள்",
"hm_guestSubCarsLogin": "மொபைல் எண்ணுடன் இலவசம். ஒரே தொடுதலில் அழையுங்கள், உங்கள் விசாரணைகளை வரலாற்றில் பாருங்கள். முன்பதிவுக் கட்டணம் இல்லை.",
"hm_loginJoin": "உள்நுழை / சேர்",
"hm_recent": "சமீபத்திய",
"hm_setTrip": "பயணத்தை அமை",
"hm_km": "{km} கி.மீ",
"hm_searchCars": "கார், பகுதி தேடுங்கள்",
"hm_searchDrivers": "ஓட்டுநர், மொழி தேடுங்கள்",
"hm_filters": "வடிகட்டி",
"hm_clearSearch": "தேடலை அழி",
"hm_removeFilter": "வடிகட்டியை நீக்கு",
"hm_any": "எதுவும்",
"hm_sort": "வரிசை",
"hm_sortRec": "பரிந்துரைக்கப்பட்டவை",
"hm_sortPriceLow": "குறைந்த விலை முதலில்",
"hm_sortPriceHigh": "அதிக விலை முதலில்",
"hm_sortRating": "சிறந்த மதிப்பீடு முதலில்",
"hm_sortEta": "அருகில் உள்ளவை முதலில்",
"hm_sortNewest": "புதிய கார்கள் முதலில்",
"hm_seats": "இருக்கைகள்",
"hm_nSeats": "{n} இருக்கைகள்",
"hm_carType": "கார் வகை",
"hm_price": "விலை",
"hm_ctHatch": "ஹேட்ச்பேக்",
"hm_ctSedan": "செடான்",
"hm_ctMiniSuv": "மினி எஸ்யூவி",
"hm_ctSuv": "எஸ்யூவி",
"hm_ctMpv": "7 இருக்கை (எம்பிவி)",
"hm_ctTempo": "டெம்போ டிராவலர்",
"hm_ctBus": "பஸ்",
"hm_fuel": "எரிபொருள்",
"hm_fuelPetrol": "பெட்ரோல்",
"hm_fuelDiesel": "டீசல்",
"hm_fuelCng": "சிஎன்ஜி",
"hm_fuelEv": "மின்சாரம்",
"hm_year": "கார் ஆண்டு",
"hm_yr2024": "2024 அல்லது புதியது",
"hm_yr2015": "2015 அல்லது பழையது",
"hm_budUnder5": "₹5,000-க்குள்",
"hm_budAbove15": "₹15,000-க்கு மேல்",
"hm_sortExp": "அதிக அனுபவம் முதலில்",
"hm_sortOnline": "இப்போது இணைப்பில் உள்ளவர் முதலில்",
"hm_sortFareLow": "குறைந்த கட்டணம் முதலில்",
"hm_dBudUnder1": "₹1,000-க்குள்",
"hm_dBudAbove3": "₹3,000-க்கு மேல்",
"hm_priceNeedsTrip": "முதலில் உங்கள் பயணத்தை அமைக்கவும் - விலை அதைப் பொறுத்தது.",
"hm_rating": "மதிப்பீடு",
"hm_starsPlus": "{n}+ நட்சத்திரங்கள்",
"hm_experience": "ஓட்டுநர் அனுபவம்",
"hm_expPlus": "{n}+ ஆண்டு அனுபவம்",
"hm_speaks": "பேசும் மொழி",
"hm_goodAt": "வாடிக்கையாளர்கள் சொல்வது",
"hm_tOnTime": "சரியான நேரம்",
"hm_tPolite": "மரியாதையானவர்",
"hm_tComfort": "வசதியான பயணம்",
"hm_tClean": "சுத்தமான கார்",
"hm_tSafe": "பாதுகாப்பான ஓட்டுதல்",
"hm_driverAge": "ஓட்டுநர் வயது",
"hm_ageRange": "{range} வயது",
"hm_grpCar": "கார்",
"hm_grpDriver": "ஓட்டுநர்",
"hm_grpPrice": "விலை",
"hm_grpTrip": "பயணம்",
"hm_clearAll": "அனைத்தையும் நீக்கு",
"hm_close": "மூடு",
"hm_showCars": "{n} கார்களைக் காட்டு",
"hm_showOneCar": "1 காரைக் காட்டு",
"hm_showNoCars": "எந்தக் காரும் பொருந்தவில்லை",
"hm_showDrivers": "{n} ஓட்டுநர்களைக் காட்டு",
"hm_showOneDriver": "1 ஓட்டுநரைக் காட்டு",
"hm_showNoDrivers": "எந்த ஓட்டுநரும் பொருந்தவில்லை",
"hm_tripType": "பயண வகை",
"hm_ttLocal": "உள்ளூர்",
"hm_ttOut": "வெளியூர்",
"hm_ttDrop": "டிராப்பிங்",
"hm_availability": "கிடைக்கும் நிலை",
"hm_availNow": "இப்போது கிடைப்பவர்",
"hm_nDrivers": "{n} ஓட்டுநர்கள்",
"hm_oneDriver": "1 ஓட்டுநர்",
"hm_resRoute": "{route}-க்கு {items}",
"hm_resNear": "{place} அருகில் {items}",
"hm_resFound": "கிடைத்தவை: {items}",
"hm_showAll": "அனைத்தையும் காட்டு",
"hm_shareList": "பட்டியலை அனுப்பு",
"dk_trips": "பயணங்கள்",
"dk_heroCars": "{city} இல் கார்கள்",
"dk_subCars": "உண்மையான விலைகளைப் பார்த்து, டிரைவரை நேரடியாக அழையுங்கள் - முன்பதிவுக் கட்டணம் இல்லை, முன்பணம் இல்லை.",
"dk_heroDrivers": "{city} இல் ஓட்டுநரை அமர்த்துங்கள்",
"dk_subDrivers": "உங்கள் கார், எங்கள் ஓட்டுநர் - எல்லாக் கட்டணங்களையும் பார்த்து ஓட்டுநரை நேரடியாக அழையுங்கள்.",
"dk_searchCars": "கார்களைத் தேடு",
"dk_searchDrivers": "ஓட்டுநர்களைத் தேடு",
"dk_when": "எப்போது",
"dk_tripType": "பயணம்",
"dk_filters": "வடிகட்டிகள்",
"dk_pickWhen": "தேதியைத் தேர்ந்தெடுங்கள்",
"dk_tagline": "உங்கள் அருகில் கார்கள், டிரைவர்கள் - விலைகளைப் பார்த்து டிரைவரை நேரடியாக அழையுங்கள்.",
"dk_fCustomers": "வாடிக்கையாளர்களுக்கு",
"dk_fJoin": "ஸ்ராமிகாவில் சேருங்கள்",
"dk_fAbout": "எங்களைப் பற்றி",
"dk_fByCity": "நகர வாரியாக",
"dk_fCabsByCity": "நகர வாரியாக கார்கள்",
"dk_fDriversByCity": "நகர வாரியாக ஓட்டுநர்கள்",
"dk_fFareChart": "டாக்ஸி கட்டணப் பட்டியல்",
"dk_fAirport": "விமான நிலைய டாக்ஸி",
"cbk_button": "🙋 நாங்களே அழைத்து புக் செய்கிறோம்",
"cbk_title": "நாங்கள் உங்களை அழைக்கிறோம்",
"cbk_sub": "10 நிமிடத்தில் ஸ்ராமிகா குழு அழைத்து உங்களுக்காக புக் செய்யும். உள்நுழைவு தேவையில்லை.",
"cbk_night": "இப்போது இரவு - காலை 8 மணிக்கு அழைக்கிறோம்.",
"cbk_name": "உங்கள் பெயர்",
"cbk_phone": "கைபேசி எண்",
"cbk_trip": "உங்கள் பயணம்",
"cbk_note": "வேறு ஏதாவது (விருப்பம்)",
"cbk_notePh": "6 பேர், 3 பைகள்…",
"cbk_send": "அழைக்கச் சொல்லுங்கள்",
"cbk_sending": "அனுப்புகிறோம்…",
"cbk_done": "கிடைத்தது! 10 நிமிடத்தில் அழைப்பு வரும்.",
"cbk_doneNight": "கிடைத்தது! காலை 8 மணிக்கு அழைக்கிறோம்.",
"cbk_already": "உங்கள் கோரிக்கை ஏற்கனவே கிடைத்தது - விரைவில் அழைக்கிறோம்.",
"cbk_badPhone": "10 இலக்க கைபேசி எண்ணை உள்ளிடுங்கள்",
"cbk_noName": "உங்கள் பெயரை உள்ளிடுங்கள்",
"cbk_error": "அனுப்ப முடியவில்லை. {n} எண்ணை அழையுங்கள்.",
"cbk_noLogin": "உள்நுழைய வேண்டாமா? நாங்களே அழைக்கிறோம் →",
"lcb_title": "புதிய வாடிக்கையாளர் அழைப்பு",
"lcb_accept": "எடுத்துக்கொள்கிறேன்",
"lcb_reject": "இப்போது முடியாது",
"lcb_ago": "{n} நிமிடங்களுக்கு முன்",
"lcb_accepted": "ஏற்றுக்கொண்டீர்கள் — லீட்ஸிலிருந்து வாடிக்கையாளரை அழைக்கவும்",
"lcb_rejected": "சரி — ஸ்ராமிகா இந்த வாடிக்கையாளருக்கு உதவும்",
"tr_title": "புதிய பயணம்",
"tr_yourPrice": "உங்கள் கட்டணம்",
"tr_accept": "ஏற்கிறேன்",
"tr_decline": "முடியாது",
"tr_won": "பயணம் உறுதி",
"tr_taken": "வேறொருவர் ஏற்றுக்கொண்டார்",
"tr_closed": "இந்தக் கோரிக்கை முடிந்தது",
"tr_missedTip": "முதலில் ஏற்கும் டிரைவருக்கே பயணம். அடுத்த முறை விரைவாக ஏற்கவும்.",
"tr_declined": "மறுத்தீர்கள்",
"tr_free": "இன்று பயணங்களுக்கு காலி",
"tr_call": "வாடிக்கையாளரை அழைக்கவும்",
"tr_calling": "இணைக்கிறோம் — முதலில் உங்கள் போன் ஒலிக்கும்",
"tr_over": "பயணம் முடிந்தது",
"tr_callErr": "அழைப்பு இணையவில்லை. மீண்டும் முயலவும்.",
"tr_people": "{n} பேர்",
"cbk_close": "மூடு",
"dk_fRegisterCar": "உங்கள் காரைப் பதிவு செய்யுங்கள்",
"dk_fJoinDriver": "ஓட்டுநராகச் சேருங்கள்",
"dk_fTerms": "விதிமுறைகள்",
"dk_fPrivacy": "தனியுரிமை",
"dk_fRefunds": "பணத்திருப்பம்",
"dk_fDelete": "கணக்கை நீக்கு",
"bl_title": "இன்னொரு நிறுவனத்தை அழைக்கச் சற்றுக் காத்திருங்கள்",
"bl_body": "டிரைவர்கள் 6 மணி நேரத்தில் ஒரு நிறுவனத்தை மட்டுமே அழைக்கலாம் - ஒரே விசாரணை மீண்டும் மீண்டும் செல்லாமல் இருக்க.",
"bl_next": "அடுத்த அழைப்பு: {when} பிறகு",
"bl_urgent": "அவசரமா? ஸ்ராமிகாவை அழையுங்கள்",
"bl_ok": "சரி",
"cb_pill": "முன்பதிவுக்கு அழையுங்கள்",
"cb_barTitle": "எந்த கார் என்று தெரியவில்லையா? நாங்களே முன்பதிவு செய்கிறோம்",
"cb_hours": "காலை 8 – இரவு 9 · தெலுங்கு, இந்தி, ஆங்கிலம்",
"cb_call": "அழையுங்கள்",
"cb_or": "அல்லது எங்களை அழையுங்கள், நாங்களே முன்பதிவு செய்கிறோம்:",
"cb_want": "உங்களுக்காக நாங்களே முன்பதிவு செய்யவா?",
"cb_quiet": "அழைத்து முன்பதிவு செய்யவா? நாங்களே செய்து தருகிறோம்",
"cb_callUs": "அழையுங்கள்",
"hm_guestCardT": "ஒருமுறை உள்நுழையுங்கள் - எந்த டிரைவரையும் நேரடியாக அழையுங்கள்",
"hm_guestCardD": "மொபைல் எண்ணுடன் இலவசம். முன்பதிவுக் கட்டணம் இல்லை.",
"hm_loginShort": "உள்நுழை",
"vc_speak": "பேசுங்கள்",
"vc_listening": "இப்போது பேசுங்கள்…",
"vc_langs": "தெலுங்கு · ஹிந்தி · ஆங்கிலம் - உங்கள் மொழியிலேயே",
"vc_stop": "நிறுத்து",
"vc_errMic": "பேச மைக் அனுமதி தாருங்கள்",
"vc_errNone": "எதுவும் கேட்கவில்லை - மீண்டும் முயலுங்கள்",
"vc_errOther": "இப்போது குரல் வேலை செய்யவில்லை - தட்டச்சு செய்யுங்கள்",
"sq_phCars": "கார், ஊர், பயணம் - எதுவும் கேளுங்கள்",
"sq_phDrivers": "ஓட்டுநர், மொழி, பயணம் - எதுவும் கேளுங்கள்",
"sq_recent": "நீங்கள் சமீபத்தில் தேடியவை",
"sq_clear": "அனைத்தையும் நீக்கு",
"sq_remove": "நீக்கு",
"sq_try": "இப்படிக் கேட்கலாம்",
"sq_trips": "பிரபல பயணங்கள்",
"sq_understood": "புரிந்தது:",
"sq_goTrip": "இந்தப் பயணத்தின் விலைகளைப் பாருங்கள்",
"sq_goCars": "இந்தக் கார்களைக் காட்டு",
"sq_goDrivers": "இந்த ஓட்டுநர்களைக் காட்டு",
"sq_speaks": "{lang} பேசும் ஓட்டுநர்",
"sq_ex1": "நாளை திருப்பதிக்கு 7 சீட்டர்",
"sq_ex2": "ஏர்போர்ட் ட்ராப்",
"sq_ex3": "7 சீட்டர் டீசல்",
"sq_ex4": "நாளை மறுநாள் ஹைதராபாத் போய் வர",
"sq_dx1": "நாளை காலை ஹைதராபாத் போய் வர",
"sq_dx2": "இன்று இரவு ஏர்போர்ட் ட்ராப்",
"sq_dx3": "நாளை ஹிந்தி பேசும் ஓட்டுநர்",
"sq_dx4": "நாளை திருப்பதி",
"sq_inDrivers": "இந்தப் பெயரில் கார் இல்லை - ஓட்டுநர்களில் {n} கிடைத்தனர் ›",
"sq_inCars": "இந்தப் பெயரில் ஓட்டுநர் இல்லை - கார்களில் {n} கிடைத்தன ›",
"vr_titleCars": "உங்கள் கார்கள் எவ்வளவு தூரம் வரை தெரிய வேண்டும்?",
"vr_titleDriver": "உங்கள் சுயவிவரம் எவ்வளவு தூரம் வரை தெரிய வேண்டும்?",
"vr_sub": "வாடிக்கையாளரின் பிக்அப் உங்களிடமிருந்து இந்த தூரத்துக்குள் இருந்தால் நீங்கள் அவர்களுக்குத் தெரிவீர்கள்.",
"vr_km": "{n} கி.மீ",
"vr_sramika": "ஸ்ராமிகா",
"vr_legCity": "ஸ்ராமிகா {n} கி.மீ",
"vr_legOwn": "உங்களுடையது {n} கி.மீ",
"vr_note": "தூரம் கூடினால் அதிக விசாரணைகள் வரும் - ஆனால் பிக்அப்புக்கு நீங்களே வர வேண்டும்.",
"vr_save": "சேமி",
"vr_reset": "ஸ்ராமிகா தூரத்துக்கே ({n} கி.மீ) மாற்று",
"vr_saved": "சேமிக்கப்பட்டது",
"vr_err": "சேமிக்க முடியவில்லை - மீண்டும் முயலுங்கள்",
"vr_later": "பின்னர் டாஷ்போர்டில் மாற்றலாம்.",
"dk_bizSub": "டிரைவர்களுக்கு.",
"dk_bizCalls": "வாடிக்கையாளர்களிடமிருந்து நேரடி அழைப்புகள்",
"dk_bizPrices": "உங்கள் சொந்த விலைகள்",
"dk_bizHours": "உங்கள் சொந்த நேரம்",
"dk_bizJoin": "புதியவரா? ஸ்ராமிகாவில் சேருங்கள்",
"dk_step1": "படிவத்தை நிரப்புங்கள்",
"dk_step2": "ஸ்ராமிகா சரிபார்க்கும்",
"dk_step3": "வாடிக்கையாளர்கள் உங்களை அழைப்பார்கள்",
"dk_trustCars": "சரிபார்த்த கார்கள்",
"dk_trustDrivers": "சரிபார்த்த ஓட்டுநர்கள்",
"dk_trustPrice": "அழைப்பதற்கு முன்பே விலை",
"dk_trustCallOwner": "டிரைவரை நேரடியாக அழையுங்கள்",
"dk_trustCallDriver": "ஓட்டுநரை நேரடியாக அழையுங்கள்",
"dk_tripReady": "எல்லாம் தயார் - காட்டும் விலைகள் இந்தப் பயணத்துக்கே.",
"dk_tripReadyDrivers": "எல்லாம் தயார் - ஒவ்வொரு ஓட்டுநரின் விலையும் இந்தப் பயணத்துக்கே.",
"dk_route": "வழி",
"dk_group": "குழு",
"dk_people": "{n} பேர்",
"dk_person": "ஒருவர்",
"dk_bags": "{n} பைகள்",
"dk_bag": "1 பை",
"dk_kmApprox": "சுமார் {km} கி.மீ.",
"hm_linkCopied": "இணைப்பு நகலெடுக்கப்பட்டது - வாட்ஸ்அப்பில் அனுப்புங்கள்",
"hm_setPickup": "பிக்கப்பாக அமை",
"hm_goingTo": "{city}-க்குப் போகிறீர்களா?",
"hm_canTake": "{city}-இலிருந்து {items} உங்களை அங்கே அழைத்துச் செல்லும்",
"hm_setDrop": "டிராப்பாக அமை",
"hm_seeBasedIn": "{city}-இல் உள்ள கார்களைப் பாருங்கள்",
"hm_bTop": "சிறந்த மதிப்பீடு",
"hm_bNearby": "அருகில்",
"hm_homeReturn": "{city} கார் · திரும்பும் வழியில் உங்களை அழைத்துச் செல்லும்",
"rc_badge": "ஸ்ராமிகா பரிந்துரை",
"join_vendor": "கார் வாஷ் அல்லது கார் சோதனை தொழிலா? உங்கள் தொழிலைச் சேர்க்கவும் →",
"rc_checked": "ஸ்ராமிகா சரிபார்த்தது: ஆவணங்கள், விலைகள், அழைப்புகளை எடுப்பார், புகார் இல்லை",
"rc_why": "பரிந்துரைக்கப்பட்ட கார்கள் அருகிலுள்ள வாடிக்கையாளர்களுக்கு மேலே காட்டப்படும்.",
"rc_has": "{date} வரை உங்களிடம் உள்ளது",
"rc_c_verified": "சரிபார்க்கப்பட்டது",
"rc_c_profile": "அனைத்து விலைகளையும் அமைக்கவும்",
"rc_c_answers": "அழைப்புகளை எடுக்கவும்",
"rc_c_rated": "நல்ல மதிப்பீடுகள்",
"rc_c_price": "நியாயமான விலை",
"rc_c_clean": "புகார் இல்லை",
"hm_bLuxury": "ஆடம்பரம்",
"hm_bFamily": "குடும்பப் பயணம்",
"hm_bFast": "விரைவு புக்கிங்",
"hm_bNew": "ஸ்ராமிகாவில் புதியது",
"hm_online": "தயார்",
"hm_newTag": "புதியவர்",
"hm_viewFare": "கட்டணம்",
"hm_nReviews": "{n} மதிப்புரைகள்",
"hm_onTrip": "பயணத்தில்",
"hm_repair": "பழுதுபார்ப்பில்",
"hm_age": "வயது {n}",
"hm_yrs": "{yrs} ஆண்டு",
"hm_driving": "அனுபவம்",
"hm_minAway": "{n} நிமிட தூரம்",
"hm_kmAway": "{km} கி.மீ தூரம்",
"hm_aboutKm": "சுமார் {km} கி.மீ",
"hm_under1km": "1 கி.மீ-க்குள்",
"hm_distFrom": "{place}-இலிருந்து {dist}",
"hm_matchedBy": "பொருந்தியது: {what}",
"hm_mModel": "கார் மாடல்",
"hm_mBrand": "பிராண்ட்",
"hm_mDriver": "ஓட்டுநர் பெயர்",
"hm_mLang": "மொழி",
"hm_mDetails": "கார் விவரங்கள்",
"hm_mName": "பெயர்",
"hm_mCity": "நகரம்",
"hm_mProfile": "சுயவிவரம்",
"hm_seePrice": "விலையைப் பாருங்கள்",
"hm_saveAmt": "₹{amt} சேமிப்பு",
"hm_call": "அழை",
"hm_viewCar": "{name} விவரங்களைப் பாருங்கள்",
"hm_photoOf": "{name} புகைப்படம் {n}",
"hm_tooLong": "ஒரு ஓட்டுநருக்கு மிக அதிக தூரம்",
"hm_priceOnReq": "கேட்டால் விலை",
"hm_oneHr": "1 மணி",
"hm_busy": "பிஸி",
"hm_offline": "ஆஃப்லைன்",
"hm_confirmTitle": "{name}-ஐ அழைக்கவா?",
"hm_confirmText": "{car} பற்றி. உங்கள் பயண விவரங்கள் அழைப்புடன் டிரைவருக்குச் செல்லும்.",
"hm_thePartner": "டிரைவர்",
"hm_cancel": "வேண்டாம்",
"hm_callConnecting": "உங்களை டிரைவருடன் இணைக்கிறோம்.",
"hm_callFailed": "அழைப்பை இணைக்க முடியவில்லை. மீண்டும் முயலவும்.",
"hm_partnerBusy": "இந்த டிரைவர் இப்போது அழைப்புகளை ஏற்க முடியாது. வேறு காரை முயலவும்.",
"hm_cantCall": "இந்தக் கணக்கிலிருந்து டிரைவர்களை அழைக்க முடியாது. வாடிக்கையாளராக உள்நுழையவும்.",
"hm_findingCars": "{city}-இல் கார்களைத் தேடுகிறது…",
"hm_findingDrivers": "{city}-இல் ஓட்டுநர்களைத் தேடுகிறது…",
"hm_pickCityCars": "கார்களைப் பார்க்க உங்கள் நகரத்தைத் தேர்ந்தெடுக்கவும்",
"hm_pickCityDrivers": "ஓட்டுநர்களைப் பார்க்க உங்கள் நகரத்தைத் தேர்ந்தெடுக்கவும்",
"hm_networkGrowing": "ஸ்ராமிகா விரிவடைகிறது",
"hm_noCarsIn": "{city}-இல் இன்னும் கார்கள் இல்லை",
"hm_noCarsText": "இங்கே டிரைவர்களைச் சேர்க்கிறோம். வேறு நகரத்தைப் பாருங்கள், அல்லது உங்களிடம் கார் இருந்தால் சேருங்கள்.",
"hm_noDriversIn": "{city}-இல் இன்னும் ஓட்டுநர்கள் இல்லை",
"hm_noDriversText": "இங்கே ஓட்டுநர்களைச் சேர்க்கிறோம். வேறு நகரத்தைப் பாருங்கள், அல்லது நீங்கள் ஓட்டுநர் என்றால் சேருங்கள்.",
"hm_joinPartner": "உங்கள் காருடன் சேருங்கள்",
"hm_joinDriver": "ஓட்டுநராகச் சேருங்கள்",
"hm_supTitle": "ஸ்ராமிகாவின் உதவி வேண்டுமா?",
"hm_supText": "எங்களை அழையுங்கள். சரியான காரைக் கண்டுபிடிக்க உதவுவோம்.",
"hm_ocTitle": "{city}-இல் கார்கள் வேண்டுமா?",
"hm_ocText": "உங்கள் நகரம் இப்போது {current}.",
"hm_switchTo": "{city}-க்கு மாற்று",
"hm_lookingFor": "{city} அருகில் “{q}” தேடுகிறது…",
"hm_iAccT": "உங்கள் கணக்கைத் தேடுகிறீர்களா?",
"hm_iAccD": "உங்கள் சுயவிவரமும் அமைப்புகளும் கணக்கில் உள்ளன.",
"hm_iAccB": "கணக்கைத் திற",
"hm_iPartT": "உங்கள் காரை ஸ்ராமிகாவில் சேர்க்க வேண்டுமா?",
"hm_iPartD": "உங்கள் காருடன் அல்லது டிரைவராக ஸ்ராமிகாவில் பிசினஸாகச் சேர்ந்து வாடிக்கையாளர் அழைப்புகளைப் பெறுங்கள். கமிஷன் இல்லை.",
"hm_iTripsT": "உங்கள் பயணங்களைத் தேடுகிறீர்களா?",
"hm_iTripsD": "உங்கள் விசாரணைகளும் பயணங்களும் வரலாற்றில் உள்ளன.",
"hm_iTripsB": "வரலாற்றைத் திற",
"hm_iPriceT": "விலைகளைப் பார்க்கிறீர்களா?",
"hm_iPriceD": "ஒவ்வொரு காரின் விலையைப் பார்க்க மேலே உங்கள் பயணத்தை அமைக்கவும்.",
"hm_iRouteT": "எங்காவது போகிறீர்களா?",
"hm_iRouteD": "உங்கள் பயணத்தை அமைக்க மேலே “பிக்கப் இடம்” என்பதைத் தட்டவும்.",
"hm_noFound": "“{q}”-க்கு கார்கள் கிடைக்கவில்லை",
"hm_noDriversFound": "“{q}”-க்கு ஓட்டுநர்கள் கிடைக்கவில்லை",
"hm_noMatchCars": "உங்கள் வடிகட்டிகளுக்குப் பொருந்தும் கார்கள் இல்லை",
"hm_noMatchDrivers": "உங்கள் வடிகட்டிகளுக்குப் பொருந்தும் ஓட்டுநர்கள் இல்லை",
"hm_tryThese": "இவற்றில் ஒன்றை முயலவும்:",
"hm_clearFilters": "வடிகட்டிகளை நீக்கு",
"hm_hide": "மறை",
"hm_didBookCar": "{car}-ஐ புக் செய்தீர்களா?",
"hm_didBookWith": "{name}-உடன் {car}-ஐ புக் செய்தீர்களா?",
"hm_didHire": "{name}-ஐ அமர்த்தினீர்களா?",
"hm_thanksSaid": "நன்றி - நீங்கள் “{answer}” என்றீர்கள்.",
"hm_askLater": "பிறகு கேளுங்கள்",
"hm_joinDriverT": "நீங்கள் ஓட்டுநரா?",
"hm_joinDriverD": "ஸ்ராமிகாவில் சேர்ந்து வாடிக்கையாளர் அழைப்புகளைப் பெறுங்கள்.",
"hm_join": "சேருங்கள்",
"hm_joinCarT": "உங்களிடம் கார் உள்ளதா?",
"hm_joinCarD": "உங்கள் காரை ஸ்ராமிகாவில் சேர்த்து வாடிக்கையாளர் அழைப்புகளைப் பெறுங்கள். கமிஷன் இல்லை.",
"hm_myRequests": "என் வாடகை கோரிக்கைகள்",
"hm_loading": "ஏற்றுகிறது…",
"hm_reqPending": "காத்திருக்கிறது",
"hm_reqAccepted": "ஏற்கப்பட்டது",
"hm_reqRejected": "நிராகரிக்கப்பட்டது",
"hm_halfDay": "அரை நாள் (4 மணி)",
"hm_fullDay": "முழு நாள் (8 மணி)",
"hm_rateThisDriver": "இந்த ஓட்டுநரை மதிப்பிடுங்கள்",
"hm_rated": "மதிப்பிட்டீர்கள்",
"hm_reqSent": "கோரிக்கை அனுப்பப்பட்டது",
"hm_reqSentText": "ஓட்டுநர் உங்கள் கோரிக்கையைப் பார்த்து விரைவில் பதில் அளிப்பார்.",
"hm_ratingSent": "மதிப்பீடு அனுப்பப்பட்டது",
"hm_ratingThanks": "நன்றி. இது மற்ற வாடிக்கையாளர்களுக்கு உதவும்.",
"hm_ok": "சரி",
"mc_custRequest": "வாடிக்கையாளர் கோரிக்கை",
"mc_helpLead": "இந்த லீடில் உதவி வேண்டுமா? ஸ்ராமிகாவை அழைக்கவும்",
"ld_stCall": "அழைப்பு செய்யப்பட்டது",
"ld_stAccepted": "ஏற்றுக்கொள்ளப்பட்டது",
"ld_stSuccess": "பயணம் வெற்றி",
"ld_stConfirm": "உறுதிசெய்ய வேண்டும்",
"ld_stNotBooked": "புக் ஆகவில்லை",
"ld_waiting": "காத்திருக்கிறது",
"ld_afterTrip": "பயணத்திற்குப் பிறகு",
"ld_chipDone": "முடிந்தது",
"ld_chipConfirm": "உங்கள் பதில் தேவை",
"ld_chipUpcoming": "வரவிருக்கிறது",
"ld_chipSent": "விசாரணை அனுப்பப்பட்டது",
"ld_title": "விசாரணை விவரங்கள்",
"ld_sub": "உங்கள் விசாரணையைப் பார்த்து, என்ன நடந்தது என்று சொல்லுங்கள்",
"ld_tripEnquiry": "பயண விசாரணை",
"ld_sentTo": "{name}-க்கு அனுப்பப்பட்டது",
"ld_sentPartner": "டிரைவருக்கு அனுப்பப்பட்டது",
"ld_tripDetails": "பயண விவரங்கள்",
"ld_tripDate": "பயண தேதி",
"ld_enquiryDate": "விசாரணை தேதி",
"ld_distance": "தூரம்",
"ld_passengers": "பயணிகள்",
"ld_vehicle": "கேட்ட வாகனம்",
"ld_driverReq": "கேட்ட ஓட்டுநர்",
"ld_refFare": "குறிப்புக் கட்டணம்",
"ld_refNote": "இது உங்களுக்குக் காட்டப்பட்ட விலை. இறுதி விலை டிரைவருடன் நேரடியாக முடிவு செய்யப்படும்.",
"ld_didBook": "இந்தக் காரை புக் செய்தீர்களா?",
"ld_didBookDriver": "இந்த ஓட்டுநரை அமர்த்தினீர்களா?",
"ld_didBookSub": "இந்த விசாரணை என்ன ஆனது என்று சொல்லுங்கள்.",
"ld_yes": "ஆம், புக் செய்தேன்",
"ld_yesSub": "அவர்களுடன் சென்றேன்",
"ld_no": "இல்லை, புக் செய்யவில்லை",
"ld_noSub": "நான் போகவில்லை",
"ld_maybe": "இன்னும் முடிவு செய்யவில்லை",
"ld_maybeSub": "இன்னும் உறுதியில்லை",
"ld_beforeTrip": "பயணத் தேதிக்குப் பிறகு பதில் சொல்லலாம்.",
"ld_rateTitle": "உங்கள் அனுபவம் எப்படி இருந்தது?",
"ld_rateSub": "உங்கள் நட்சத்திரங்கள் மற்ற வாடிக்கையாளர்கள் தேர்வு செய்ய உதவும்.",
"ld_ratePh": "உங்கள் அனுபவத்தைப் பற்றி சொல்லுங்கள் (விருப்பம்)",
"ld_rateSend": "மதிப்பீட்டை அனுப்பு",
"ld_rateThanks": "நன்றி - நீங்கள் {n} ★ கொடுத்தீர்கள்",
"ld_rateErr": "மதிப்பீட்டைச் சேமிக்க முடியவில்லை. மீண்டும் முயலவும்.",
"ld_whyTitle": "புக் செய்யவில்லை என்றால், என்ன நடந்தது?",
"ld_whySub": "உங்களுக்குச் சிறப்பாகச் சேவை செய்ய உதவும் (விருப்பம்)",
"ld_rHigh": "விலை அதிகம்",
"ld_rNotAvail": "கார் கிடைக்கவில்லை",
"ld_rElsewhere": "வேறு இடத்தில் புக் செய்தேன்",
"ld_rNoResp": "பதில் இல்லை",
"ld_rPlans": "திட்டம் மாறியது",
"ld_rOther": "மற்றவை",
"ld_rThanks": "சொன்னதற்கு நன்றி.",
"ld_callPartner": "டிரைவரை அழைக்கவும்",
"ld_callSub": "பார்ட்னருடன் நேரடியாகப் பேசுங்கள்",
"mc_tabLeads": "லீட்கள்",
"mc_tabWallet": "வாலெட்",
"mc_free": "லீட்கள் இப்போது இலவசம்.",
"mc_freeSub": "உங்கள் வாலெட்டிலிருந்து எதுவும் எடுக்கப்படாது.",
"mc_low": "வாலெட் ₹{min}-க்குக் குறைவு - லீட்கள் வர பணம் சேர்க்கவும்.",
"mc_addMoney": "பணம் சேர்க்க - ஸ்ராமிகாவை அழைக்கவும்",
"mc_cars": "கார்கள்",
"mc_available": "கிடைக்கிறது",
"mc_busy": "பிஸி",
"mc_inReview": "பரிசீலனையில்",
"mc_myDrivers": "என் ஓட்டுநர்கள்",
"mc_limit": "வாகன வரம்பு எட்டியது ({n})",
"mc_live": "நேரலை",
"mc_rejected": "ஒப்புதல் இல்லை",
"mc_hidden": "மறைக்கப்பட்டது",
"mc_availability": "கிடைக்கும் நிலை",
"mc_onTrip": "பயணத்தில்",
"mc_maint": "பராமரிப்பில்",
"mc_avHint": "வாடிக்கையாளர்களுக்கு உங்கள் காரில் \"பயணத்தில்\" அல்லது \"பராமரிப்பில்\" என்று தெரியும். 24 மணி நேரத்திற்குப் பிறகு மீண்டும் கிடைக்கும் நிலைக்கு வரும்.",
"mc_addDriver": "ஓட்டுநர் சேர்க்கவும்",
"mc_driver": "ஓட்டுநர்",
"mc_chooseDriver": "ஓட்டுநரைத் தேர்வு செய்யவும்",
"mc_drvPending": "(ஒப்புதலுக்காக)",
"mc_pricesDetails": "விலைகள் & விவரங்கள்",
"mc_reviewText": "ஸ்ராமிகா இந்தக் காரைச் சரிபார்க்கிறது. நேரலைக்கு வந்ததும் சொல்வோம்.",
"mc_editsPending": "உங்கள் சமீபத்திய மாற்றங்கள் ஒப்புதலுக்காகக் காத்திருக்கின்றன.",
"mc_rejectedText": "இந்தக் காருக்கு ஒப்புதல் கிடைக்கவில்லை. காரணம் அறிய ஸ்ராமிகாவை அழைக்கவும்.",
"mc_hiddenText": "வாடிக்கையாளர்கள் இந்தக் காரைப் பார்க்க முடியாது. மீண்டும் காட்ட ஸ்ராமிகாவை அழைக்கவும்.",
"mc_noCars": "இன்னும் கார்கள் இல்லை",
"mc_noCarsSub": "அழைப்புகள் வர உங்கள் காரைச் சேர்க்கவும்.",
"mc_regProgress": "கார் பதிவு நடக்கிறது",
"mc_regProgressSub": "உங்கள் கார் அமைக்கப்படுகிறது. ஒரு நாளுக்கு மேல் ஆனால் ஸ்ராமிகாவை அழைக்கவும்.",
"mc_profileReview": "சுயவிவரம் பரிசீலனையில் உள்ளது",
"mc_profileReviewSub": "உங்கள் ஆவணங்கள் சரிபார்க்கப்படுகின்றன. ஒப்புதலுக்குப் பிறகு உங்கள் கார்கள் நேரலைக்கு வரும்.",
"mc_submitted": "அனுப்பிய தேதி",
"mc_appId": "விண்ணப்ப ஐடி",
"mc_licExpired": "உரிமம் காலாவதியானது",
"mc_licExpiredSub": "உங்கள் ஓட்டுநர் உரிமம் காலாவதியானது. புதுப்பித்து மீண்டும் அனுப்பவும்.",
"mc_licAgain": "உரிமப் படம் மீண்டும் தேவை",
"mc_licAgainSub": "உங்கள் உரிமப் படம் தெளிவாக இல்லை. தெளிவான படம் அனுப்பவும்.",
"mc_loading": "உங்கள் கார்கள் ஏற்றப்படுகின்றன…",
"mc_loadErr": "ஏற்ற முடியவில்லை. மீண்டும் முயலவும்.",
"mc_retry": "மீண்டும் முயலவும்",
"mc_relogin": "மீண்டும் உள்நுழையவும்",
"mc_moveDriver": "{a}-ஐ இந்தக் காருக்கு மாற்றவா? {b}-க்கு மற்ற கார் கிடைக்கும்.",
"mc_replaceDriver": "{a}-ஐ இந்தக் காரில் வைக்கவா? {b} இதிலிருந்து நீக்கப்படுவார்.",
"mc_assignErr": "ஓட்டுநரை மாற்ற முடியவில்லை. மீண்டும் முயலவும்.",
"mc_getMore": "அதிக அழைப்புகள் பெறுங்கள்",
"mc_getMoreSub": "5 எளிய படிகள்",
"mc_leadPrices": "லீட் விலைகள்",
"mc_leadPricesSub": "ஒரு லீட்டின் விலை",
"mc_yourLeads": "உங்கள் லீட்கள்",
"mc_leadsCount": "{n} · புதியவை முதலில்",
"mc_noLeads": "இன்னும் லீட்கள் இல்லை",
"mc_noLeadsSub": "வாடிக்கையாளர்கள் ஸ்ராமிகா வழியாக உங்களை அழைக்கும்போது இங்கே தெரிவார்கள்.",
"mc_new": "புதியது",
"mc_called": "அழைத்தார்",
"mc_booked": "புக் ஆனது",
"mc_custPrice": "வாடிக்கையாளருக்குக் காட்டிய விலை",
"mc_showNumber": "எண்ணைக் காட்டு",
"mc_revealSoon": "வாடிக்கையாளர் எண்ணைக் காட்டுவது விரைவில் வருகிறது.",
"mc_didHappen": "இந்தப் பயணம் நடந்ததா?",
"mc_youMarked": "உங்கள் பதில்: {answer}",
"mc_locked": "மாற்ற முடியாது",
"mc_changesLeft": "பதிலை மாற்றவும் - {n} மீதம்",
"mc_rateCust": "இந்த வாடிக்கையாளருக்கு மதிப்பீடு கொடுங்கள்",
"mc_rated": "நன்றி - மதிப்பீடு கொடுத்தீர்கள்",
"mc_leadDetails": "லீட் விவரங்கள்",
"mc_leadDetailsSub": "வாடிக்கையாளர் விசாரணை, என்ன நடந்தது",
"mc_customer": "வாடிக்கையாளர்",
"mc_quoted": "வாடிக்கையாளருக்குக் காட்டியது",
"mc_freeLine": "லீட்கள் இப்போது இலவசம் - இதிலிருந்து எதுவும் எடுக்கப்படாது.",
"mc_chargeLine": "லீட் கட்டணங்கள் இந்த இருப்பிலிருந்து எடுக்கப்படும்.",
"mc_refer": "ஒரு தொழிலைப் பரிந்துரைக்கவும்",
"mc_referText": "நீங்கள் அழைத்த டிரைவர் ஒப்புதல் பெற்றதும், லீட் கட்டணங்களுக்கு இருவருக்கும் கிரெடிட் கிடைக்கும்.",
"mc_txns": "பரிவர்த்தனைகள்",
"mc_noTxns": "இன்னும் பரிவர்த்தனைகள் இல்லை",
"mc_tip1": "லீட் கட்டணம் இந்த வாலெட்டிலிருந்து",
"mc_tip2": "இருப்பு குறைந்தால் புதிய லீட்கள் நிற்கலாம்",
"mc_tip3": "செயலில் இருக்க எப்போது வேண்டுமானாலும் பணம் சேர்க்கவும்",
"cd_title": "வாகன விவரங்கள்",
"cd_photosNote": "பரிசீலனைக்குப் பிறகு நம்பர் பிளேட்டுகள் தானாக மறைக்கப்படும்.",
"cd_photosMin": "குறைந்தது 3 படங்கள் சேர்க்கவும் (இன்னும் {n} தேவை)",
"cd_photosSent": "பரிசீலனைக்கு அனுப்பப்பட்டது. ஒப்புதலுக்குப் பிறகு புதிய படங்கள் தெரியும்.",
"cd_addPhoto": "படம் சேர்க்கவும்",
"cd_replace": "மாற்று",
"cd_remove": "நீக்கு",
"cd_newTag": "புதியது",
"cd_pendingTag": "பரிசீலனையில்",
"cd_details": "கார் விவரங்கள்",
"cd_detailsNote": "படங்கள், விவரங்களில் மாற்றங்கள் ஸ்ராமிகா சரிபார்த்த பின்னரே தெரியும்.",
"cd_city": "நகரம்",
"cd_category": "விலைக் குழு",
"cd_categoryNote": "உங்கள் மாடல், இருக்கைகளைப் பொறுத்து அமையும். தவறாகத் தெரிந்தால் ஸ்ராமிகாவை அழைக்கவும்.",
"cd_notSet": "இன்னும் அமைக்கப்படவில்லை",
"cd_acSub": "இந்தக் காரில் ஏசி வேலை செய்கிறதா?",
"cd_musicSub": "மியூசிக் அல்லது புளூடூத் வேலை செய்கிறதா?",
"cd_pricesNote": "உடனே சேமிக்கப்படும். காலியான பெட்டிக்கு சாம்பல் நிறத்தில் காட்டிய பரிந்துரை விலை பயன்படும்.",
"cd_rule": "விலையை 24 மணி நேரத்தில் ஒருமுறை மட்டுமே உயர்த்தலாம். குறைப்பது எப்போது வேண்டுமானாலும்.",
"cd_suggestedUsed": "காலி: பரிந்துரை {v} பயன்படும்",
"cd_savePrices": "என் விலைகளைச் சேமி",
"cd_saving": "சேமிக்கப்படுகிறது…",
"cd_saved": "சேமிக்கப்பட்டது",
"cd_savedMsg": "உங்கள் விலைகள் சேமிக்கப்பட்டன.",
"cd_saveErr": "உங்கள் விலைகளைச் சேமிக்க முடியவில்லை. மீண்டும் முயலவும்.",
"cd_noCat": "இந்தக் காருக்கு இன்னும் விலைக் குழு இல்லை. ஸ்ராமிகாவை அழைக்கவும்.",
"cd_submit": "கார் விவரங்களை ஒப்புதலுக்கு அனுப்பவும்",
"cd_sending": "அனுப்பப்படுகிறது…",
"cd_sent": "அனுப்பப்பட்டது",
"cd_sentMsg": "அனுப்பப்பட்டது! ஸ்ராமிகா சரிபார்த்து உங்கள் மாற்றங்களை ஒப்புக்கொள்ளும்.",
"cd_sendErr": "அனுப்ப முடியவில்லை. மீண்டும் முயலவும்.",
"cd_minPhotosErr": "குறைந்தது 3 படங்களை வைத்திருக்கவும்.",
"cd_noChange": "எந்த விலையும் மாறவில்லை",
"hl_phNote": "எ.கா. என் கார் ஆட்டோமேட்டிக், இந்தி பேசும் ஓட்டுநர் வேண்டும்...",
"hl_noteHint": "உங்கள் விசாரணையுடன் ஓட்டுநருக்கு இது தெரியும்.",
"hl_yearFirst": "முதலில் ஆண்டை உள்ளிடவும்",
"lp_headerSub": "உங்கள் பயணத்தைத் திட்டமிட்டு சிறந்த கார்களைப் பாருங்கள்",
"hl_headerSub": "உங்கள் பயணத்தைத் திட்டமிட்டு சிறந்த ஓட்டுநர்களைப் பாருங்கள்",
"lp_whenSub": "பயணத் தேதிகளையும் நேரங்களையும் தேர்ந்தெடுக்கவும்",
"lp_prefSub": "இன்னும் சில விவரங்களைச் சொல்லுங்கள்",
"lp_optional": "(விருப்பம்)",
"lp_clear": "அழி",
"hl_carTitle": "ஓட்டுநர் ஓட்ட வேண்டிய உங்கள் கார்",
"hl_carSub": "உங்கள் காரின் ஆண்டு, மாடல்",
"hl_year": "ஆண்டு",
"hl_model": "மாடல்",
"hl_fuel": "எரிபொருள் வகை",
"hl_phYear": "எ.கா. 2018",
"hl_phModel": "மாடலைத் தேடுங்கள்",
"hl_phFuel": "மாடலில் இருந்து தானாக நிரப்பப்படும்",
"hl_car": "உங்கள் கார்",
"hl_farPickup": "{area} {city}-இலிருந்து 30 கி.மீக்கு மேல் தொலைவில் உள்ளது. 30 கி.மீக்குள் உள்ள இடத்தைத் தேர்ந்தெடுக்கவும், அல்லது நகரத்தை மாற்றவும்.",
"hl_tooFar": "{from} முதல் {to} வரை {km} கி.மீ - ஒரு ஓட்டுநருக்கு வரம்பு {max} கி.மீ. தயவுசெய்து {max} கி.மீக்குள் சேருமிடத்தைத் தேர்ந்தெடுக்கவும்.",
"hl_noPlace": "உங்கள் இருப்பிடத்திலிருந்து இடத்தின் பெயர் கிடைக்கவில்லை - உங்கள் நகரத்தைத் தட்டச்சு செய்யவும்.",
"navDashboard": "டாஷ்போர்டு",
"ac_language_sub": "ஆப் மொழியை மாற்றவும்",
"ac_support": "உதவி",
"ac_support_sub": "உதவி & கேள்விகள்",
"ac_settings": "அமைப்புகள்",
"ac_settings_sub": "சுயவிவரம் & விருப்பங்கள்",
"ac_profileInfo": "சுயவிவரத் தகவல்",
"ac_profileInfo_sub": "பெயர், மின்னஞ்சல், தொலைபேசி திருத்த",
"ac_prefCity": "விருப்ப நகரம்",
"ac_prefCity_sub": "இயல்புநிலை நகரத்தை மாற்றவும்",
"ac_terms": "விதிமுறைகள்",
"ac_terms_sub": "விதிமுறைகள் & நிபந்தனைகள்",
"ac_privacy": "தனியுரிமை",
"ac_privacy_sub": "தனியுரிமைக் கொள்கை",
"ac_history_sub": "உங்கள் விசாரணைகள், கடந்த பயணங்கள்",
"ac_notifications": "அறிவிப்புகள்",
"ac_notif_sub_user": "பயணம் & கணக்கு அறிவிப்புகள்",
"ac_notif_sub": "கணக்கு அறிவிப்புகள்",
"ac_ownerDash": "டிரைவர் டாஷ்போர்டு",
"ac_ownerDash_sub": "லீட்கள், கார்கள், வாலெட்",
"ac_myCars": "என் கார்கள்",
"ac_myCars_sub": "உங்கள் வாகனப் பட்டியல்",
"ac_addVehicle": "வாகனம் சேர்க்கவும்",
"ac_addVehicle_sub": "இன்னொரு காரை ஒப்புதலுக்கு அனுப்பவும்",
"ac_driverDash": "ஓட்டுநர் டாஷ்போர்டு",
"ac_driverDash_sub": "உங்கள் லீட்கள், கட்டணங்கள், நிலை",
"ac_menuUser": "என் கணக்கு",
"ac_menuUser_sub": "உங்கள் பயணங்கள் & கணக்கு",
"ac_menuOwner": "டிரைவர் மெனு",
"ac_menuOwner_sub": "வாகனங்கள் & டிரைவர் பணிகள்",
"ac_menuDriver": "வாடகை ஓட்டுநர் மெனு",
"ac_menuDriver_sub": "உங்கள் லீட்கள் & நிலை",
"ac_menuAgent": "கள முகவர் மெனு",
"ac_menuAgent_sub": "உங்கள் பரிந்துரைக் குறியீடு & கணக்கு",
"ac_menuGeneral": "பொது விருப்பங்கள்",
"ac_menuGeneral_sub": "கணக்கு & ஆப் விருப்பங்கள்",
"ac_account": "கணக்கு",
"ac_editProfile": "சுயவிவரம் திருத்த",
"ac_changePhoto": "சுயவிவரப் படத்தை மாற்றவும்",
"ac_verified": "சரிபார்க்கப்பட்டது",
"ac_back": "பின்செல்",
"ac_pendingTitle": "பிசினஸ் விண்ணப்பம் பரிசீலனையில் உள்ளது",
"ac_pendingText": "நிர்வாகி உங்கள் பிசினஸ் விண்ணப்பத்தைப் பார்க்கிறார். ஒப்புதல் கிடைத்ததும் தெரிவிப்போம்.",
"ac_strength": "சுயவிவர வலிமை",
"ac_strengthDone": "முழுமை - எல்லாம் தயார்!",
"ac_strengthGood": "நல்ல நிலை",
"ac_strengthLow": "முழுமையற்றது - சுயவிவரத்தை முடிக்கவும்",
"ac_searchPh": "அமைப்புகள், டாஷ்போர்டு தேடுக…",
"ac_clearSearch": "தேடலை அழி",
"ac_noMatch": "எதுவும் கிடைக்கவில்லை",
"ac_tryElse": "வேறு ஏதாவது தேடிப் பாருங்கள்",
"ac_inSection": "{section} இல்",
"ac_agentCode": "பரிந்துரைக் குறியீடு",
"ac_agentCodeSub": "நீங்கள் சேர்க்கும் டிரைவருக்கு இதைக் கொடுங்கள்",
"ac_noCode": "இன்னும் குறியீடு இல்லை",
"ac_copy": "நகலெடு",
"ac_copied": "நகலெடுக்கப்பட்டது",
"ac_working": "நடக்கிறது…",
"ac_genNew": "புதிய குறியீடு உருவாக்கவும்",
"ac_gen": "குறியீடு உருவாக்கவும்",
"ac_agentNote": "டிரைவர் சேரும்போது இதை உள்ளிட வேண்டும், அப்போது அது செல்லுபடியாக இருக்க வேண்டும். புதிய குறியீடு உருவாக்கினால் பழையது வேலை செய்யாது.",
"ac_agentConfirm": "புதிய குறியீடு உருவாக்கவா? தற்போதைய குறியீடு உடனே நின்றுவிடும், அதை எழுதி வைத்தவர்கள் பயன்படுத்த முடியாது. ஏற்கனவே சேர்ந்த கணக்குகளின் கிரெடிட் அப்படியே இருக்கும்.",
"ac_agentErr": "குறியீடு உருவாக்க முடியவில்லை. மீண்டும் முயலவும்.",
"ac_refer": "பரிந்துரைத்து சம்பாதியுங்கள்",
"ac_referCustSub": "டிரைவர் அல்லது ஆல்டிங் டிரைவரை அழைக்கவும்",
"ac_referCustSubR": "டிரைவர் அல்லது ஆல்டிங் டிரைவரை அழைத்து, ஒவ்வொருவருக்கும் ₹{amt} பெறுங்கள்",
"ac_referCustText": "கேப் வைத்திருப்பவர் அல்லது வாடகைக்கு ஓட்டுபவர் தெரியுமா? உங்கள் குறியீட்டைப் பகிருங்கள். அவர்களின் கணக்கு ஒப்புதல் பெற்றதும், உங்கள் ஸ்ராமிகா வாலெட்டில் {reward} வரும்.",
"ac_aCredit": "பரிந்துரை கிரெடிட்",
"ac_share": "பகிர்",
"ac_approved": "ஒப்புதல்",
"ac_waiting": "காத்திருப்பு",
"ac_yourWallet": "உங்கள் வாலெட்",
"ac_referBizSub": "இன்னொரு டிரைவர் அல்லது ஆல்டிங் டிரைவரை அழைக்கவும்",
"ac_referBizSubR": "இன்னொரு டிரைவரை அழைக்கவும் - இருவருக்கும் ₹{amt}",
"ac_referSoon": "உங்கள் கணக்கு ஒப்புதல் பெற்றதும் பரிந்துரைக் குறியீடு வரும்.",
"ac_referBizText": "உங்கள் குறியீட்டைப் பகிருங்கள். அவர்களின் கணக்கு ஒப்புதல் பெற்றதும், லீட் கட்டணங்களுக்கு இருவருக்கும் {credit} கிடைக்கும்.",
"ac_creditAmt": "₹{amt} கிரெடிட்",
"ac_credit": "கிரெடிட்",
"ac_pickCar": "பரிந்துரை எந்தக் காருக்குப் பதிவாக வேண்டும் என்று தேர்ந்தெடுக்கவும்.",
"ac_spaces": "இடைவெளிகள், கோடுகள் கணக்கில் இல்லை - எப்படி தட்டச்சு செய்தாலும் வேலை செய்யும்.",
"ac_oneWallet": "உங்கள் எந்தக் குறியீட்டின் கிரெடிட்டும் உங்கள் ஒரே வாலெட்டில் சேரும்.",
"ac_car": "கார் {id}",
"ac_calcTitle": "ஓடோமீட்டர் & கட்டணக் கணிப்பான்",
"ac_calcSub": "ஓடோமீட்டர் அளவீடுகளில் இருந்து கட்டண மதிப்பீடு",
"ac_startOdo": "தொடக்க அளவு (கி.மீ)",
"ac_endOdo": "இறுதி அளவு (கி.மீ)",
"ac_endLess": "இறுதி அளவு தொடக்கத்தை விட அதிகமாக இருக்க வேண்டும்.",
"ac_calcBtn": "கட்டணம் கணக்கிடு",
"ac_calcNone": "இந்த நகரில் இந்தப் பயணம், காருக்கு இன்னும் கட்டணம் இல்லை.",
"ac_pricedAs": "கணக்கிட்ட முறை: {mode}",
"ac_estNote": "நகரின் பரிந்துரைக்கப்பட்ட விலைகளில் மதிப்பீடு - இறுதிக் கட்டணத்தை டிரைவரிடம் உறுதிசெய்யுங்கள். சுங்கம், பார்க்கிங், மாநில அனுமதி தனி.",
"ac_seats": "{n} இருக்கைகள்",
"ac_logout": "வெளியேறு",
"ac_loading": "சுயவிவரம் ஏற்றப்படுகிறது…",
"ac_takePhoto": "படம் எடுக்கவும்",
"ac_gallery": "கேலரியிலிருந்து தேர்வு",
"ac_removePhoto": "படத்தை நீக்கு",
"ac_cancel": "ரத்து",
"ms_title": "மேலும் சேவைகள்",
"ms_sub": "கார் & பயண சேவைகள் அனைத்தும் ஒரே இடத்தில்",
"ms_towing": "வாகனம் இழுக்கும் வேன்",
"ms_towing_sub": "உங்கள் வாகனத்தைப் பாதுகாப்பாக எடுத்துச் செல்லுங்கள்",
"ms_school": "ஓட்டுநர் பள்ளிகள்",
"ms_school_sub": "சான்றிதழ் பெற்ற பயிற்சியாளர்களிடம் கற்றுக்கொள்ளுங்கள்",
"ms_lease": "மாத கார் குத்தகை",
"ms_lease_sub": "ஓட்டுநருடன் கார்கள், மாத ஒப்பந்தம்",
"ms_tours": "சுற்றுலா & தொகுப்புகள்",
"ms_tours_sub": "குழு & தனிப்பட்ட சுற்றுலா விலைகள்",
"ms_wash": "வீட்டில் கார் கழுவுதல்",
"ms_wash_sub": "வீட்டு வாசலில் கழுவுதல்",
"ms_mechanic": "வீட்டில் கார் மெக்கானிக்",
"ms_mechanic_sub": "நம்பகமான மெக்கானிக்குகள் உங்கள் வீட்டுக்கே",
"ms_accessories": "துணைப்பொருள் பொருத்துதல்",
"ms_accessories_sub": "துணைப்பொருட்கள் வீட்டில் கொண்டு வந்து பொருத்துவோம்",
"ms_soon": "விரைவில் வருகிறது",
"ms_noneYet": "உங்கள் நகரில் இன்னும் எந்தச் சேவையும் இல்லை - எங்களை அழைத்து உங்கள் தேவையைச் சொல்லுங்கள்.",
"ms_soonText": "{service} விரைவில் உங்கள் நகருக்கு வருகிறது. முன்பே வேண்டுமா? எங்களை அழைத்து உங்கள் தேவையைச் சொல்லுங்கள்.",
"ms_callUs": "ஸ்ராமிகாவை அழைக்கவும்",
"ms_close": "மூடு",
"ms_footer": "மேலும் சேவைகள் விரைவில் · தொடர்புக்கு: {email}",
"navHireDriver": "ஓட்டுநர்கள்",
"hs_title": "வரலாறு",
"hs_active": "நடப்பில்",
"hs_past": "கடந்தவை",
"hs_loading": "உங்கள் வரலாறு ஏற்றப்படுகிறது…",
"hs_emptyTitle": "இன்னும் எதுவும் இல்லை",
"hs_emptyText": "உங்கள் கார் விசாரணைகளும் பயண வரலாறும் இங்கே தெரியும்.",
"hs_findCar": "காரைத் தேடுங்கள்",
"hs_activeEmpty": "தற்போது எதுவும் இல்லை. நீங்கள் செய்யும் விசாரணைகள் பயணத் தேதி வரை இங்கே இருக்கும்.",
"hs_pastEmpty": "இங்கே இன்னும் எதுவும் இல்லை.",
"hs_filterAll": "அனைத்தும்",
"hs_filterNone": "இந்த வடிகட்டிக்கு எதுவும் இல்லை.",
"hs_signInTitle": "என் வரலாறு",
"hs_signInText": "உங்கள் விசாரணைகளையும் பயணங்களையும் பார்க்க உள்நுழையவும்.",
"hs_signIn": "உள்நுழைக",
"hs_rateTitle": "உங்கள் கடைசி பயணம் எப்படி இருந்தது?",
"hs_rateTap": "மதிப்பிட நட்சத்திரத்தைத் தட்டவும்",
"hs_rateLow": "உங்கள் அனுபவத்தை மேம்படுத்த முயற்சிப்போம்",
"hs_rateMid": "உங்கள் கருத்துக்கு நன்றி!",
"hs_rateHigh": "உங்கள் பயணம் சிறப்பாக இருந்ததில் மகிழ்ச்சி!",
"hs_rateSubmit": "மதிப்பீட்டைச் சமர்ப்பிக்கவும்",
"hs_rateLater": "பிறகு",
"hs_rateHelps": "உங்கள் மதிப்பீடு அடுத்த பயணங்களை மேம்படுத்தும்.",
"hs_rateVerified": "உங்கள் கணக்கு இப்போது ஸ்ராமிகாவால் சரிபார்க்கப்பட்டது!",
"hs_rateDriver": "ஓட்டுநரை மதிப்பிடுங்கள்",
"hs_editRating": "மதிப்பீட்டை மாற்றவும்",
"hs_chatDriver": "ஓட்டுநருடன் அரட்டை",
"hs_paid": "செலுத்தியது: ₹{amt}",
"hs_stBooked": "புக் செய்யப்பட்டது",
"hs_stNotBooked": "புக் செய்யவில்லை",
"hs_stDeciding": "இன்னும் முடிவு செய்யவில்லை",
"hs_stContacted": "ஓட்டுநரைத் தொடர்பு கொண்டீர்கள்",
"hs_stSent": "விசாரணை அனுப்பப்பட்டது",
"hs_oneWay": "ஒரு வழி",
"hs_roundTrip": "சுற்றுப் பயணம்",
"hs_enquiry": "விசாரணை",
"hs_callName": "{name}-ஐ அழைக்கவும்",
"hs_callDriver": "ஓட்டுநரை அழைக்கவும்",
"hs_askBooked": "இந்தப் பயணத்தை புக் செய்தீர்களா?",
"hs_yes": "ஆம்",
"hs_no": "இல்லை",
"hs_notYet": "இன்னும் இல்லை",
"hs_saveFailedRow": "சேமிக்க முடியவில்லை - விசாரணையைத் திறந்து மீண்டும் முயலவும்.",
"hs_saidBooked": "நீங்கள் புக் செய்ததாகச் சொன்னீர்கள்",
"hs_saidNot": "நீங்கள் புக் செய்யவில்லை என்று சொன்னீர்கள்",
"hs_saidDeciding": "நீங்கள் இன்னும் முடிவு செய்யவில்லை என்று சொன்னீர்கள்",
"hs_details": "விவரங்கள்",
"hs_sheetTitle": "பயண விசாரணை",
"hs_pickup": "பிக்கப்",
"hs_drop": "டிராப்",
"hs_tripType": "பயண வகை",
"hs_distTime": "தூரம் / நேரம்",
"hs_vehicle": "வாகனம்",
"hs_partner": "பார்ட்னர்",
"hs_enquiryMade": "விசாரணை செய்த தேதி",
"hs_timesCalled": "அழைத்த முறைகள்",
"hs_quoted": "உங்களுக்குச் சொன்ன விலை",
"hs_quotedNote": "நீங்கள் விசாரித்தபோது காட்டிய விலை. இறுதிக் கட்டணத்தை பார்ட்னரிடம் உறுதிசெய்யுங்கள்.",
"hs_whatHappened": "என்ன நடந்தது",
"hs_tlCreated": "விசாரணை உருவானது",
"hs_tlViewed": "நீங்கள் {car} பார்த்தீர்கள்",
"hs_tlShared": "எண் பகிரப்பட்டது",
"hs_tlSharedNote": "பார்ட்னரின் எண் உங்களுக்குக் காட்டப்பட்டது",
"hs_tlCalled": "நீங்கள் பார்ட்னரை அழைத்தீர்கள்",
"hs_tlCalls": "மொத்தம் {n} அழைப்புகள்",
"hs_tlAnswered": "நீங்கள் பதிலளித்தீர்கள்",
"hs_youBooked": "நீங்கள் இந்தப் பயணத்தை புக் செய்தீர்கள்",
"hs_youNot": "நீங்கள் இந்தப் பயணத்தை புக் செய்யவில்லை",
"hs_youDeciding": "நீங்கள் இன்னும் முடிவு செய்யவில்லை",
"hs_changeAnswer": "பதிலை மாற்றவும்",
"hs_noMoreChanges": "இனி மாற்ற முடியாது",
"hs_changesLeft": "மீதமுள்ள மாற்றங்கள்: {n}",
"hs_changeYour": "உங்கள் பதிலை மாற்றவும்",
"hs_askWhy": "இது உங்களுக்கு நல்ல கேப்களைக் காட்ட உதவும் - டிரைவர்களுக்கும் பயன் தெரியும்.",
"hs_ansYes": "ஆம், புக் செய்தேன்",
"hs_ansNo": "இல்லை, செய்யவில்லை",
"hs_keep": "என் பதிலையே வைத்திருக்கவும்",
"hs_saveErr": "சேமிக்க முடியவில்லை. மீண்டும் முயலவும்.",
"hs_callAgain": "{name}-ஐ மீண்டும் அழைக்கவும்",
"hs_callPartner": "பார்ட்னரை அழைக்கவும்",
"hs_hrs": "{n} மணி",
"hs_close": "மூடு",
"hs_yourRequest": "உங்கள் கோரிக்கை",
"hs_passengers": "பயணிகள்: {n}",
"hs_luggage": "லக்கேஜ்: {n}",
"hs_noLuggage": "லக்கேஜ் இல்லை",
"hs_helpEnquiry": "இந்த விசாரணையில் உதவி வேண்டுமா? ஸ்ராமிகாவை அழைக்கவும்",
"lp_route": "பிக்கப் & டிராப்",
"lp_lblPickup": "பிக்கப் இடம்",
"lp_lblDrop": "டிராப் இடம்",
"lp_cityLine": "நகரம்: {city}",
"lp_change": "மாற்று",
"lp_sameAsDrivers": "ஓட்டுநர்களில் வைத்த அதே பயணமா?",
"lp_sameAsCars": "கார்களில் வைத்த அதே பயணமா?",
"lp_sameYes": "ஆம், அதுவே",
"lp_sameNo": "இல்லை, புதிய பயணம்",
"lp_swap": "பிக்கப்பையும் டிராப்பையும் மாற்று",
"lp_when": "எப்போது",
"lp_pickupWhen": "பிக்கப்",
"lp_returnWhen": "திரும்புதல்",
"lp_today": "இன்று",
"lp_tomorrow": "நாளை",
"lp_sameDay": "அதே நாள்",
"lp_nextDay": "அடுத்த நாள்",
"lp_otherDate": "வேறு தேதி",
"lp_pickTime": "நேரம் தேர்வு",
"lp_distanceLine": "சுமார் {km} கி.மீ · {time}",
"lp_hrMin": "{h} மணி {m} நிமி",
"lp_minOnly": "{m} நிமி",
"lp_stillNeeded": "இன்னும் தேவை: {list}",
"lp_noteLabel": "டிரைவருக்கான குறிப்பு",
"lp_noteHint": "இது உங்கள் விசாரணையுடன் டிரைவருக்குத் தெரியும்.",
"pricesPerCarNote": "ஒவ்வொரு காருக்கும் விலைகள் தனியாக அமைக்கப்படும். பார்க்க அல்லது மாற்ற உங்கள் காரைத் திறக்கவும்.",
"changeMyPrices": "என் விலைகளை மாற்றவும்",
"lp_btnAddStop": "+ ஸ்டாப் சேர்",
"lp_btnDetectLocation": "📍 இருப்பிடம் கண்டறி",
"lp_btnDetecting": "கண்டறிகிறது…",
"lp_btnViewCabs": "கேப்களைப் பார்",
"lp_btnViewDrivers": "ஓட்டுநர்களைப் பார்",
"lp_btnViewDrivers": "ஓட்டுநர்களைப் பார்",
"lp_btnCompleteDetails": "பயண விவரங்களை நிரப்பு",
"lp_tabRoundTrip": "ரவுண்ட் ட்ரிப்",
"lp_tabOneWay": "டிராப்பிங்",
"lp_tripDetails": "பயண விவரங்கள்",
"lp_hireDetails": "பயண விவரங்கள்",
"lp_tripPreferencesOptional": "பயண விருப்பங்கள் (விருப்பத்திற்குரியது)",
"lp_lblPickupCity": "பிக்-அப் நகரம்",
"lp_phTypeCity": "நகரத்தை உள்ளிடு",
"lp_lblExactLocation": "சரியான இருப்பிடம்",
"lp_phPrecisePickup": "சரியான பிக்-அப் இடத்தை உள்ளிடு",
"lp_lblPickupSchedule": "பிக்-அப் நேரம்",
"lp_phStop": "ஸ்டாப் {n}",
"lp_lblFinalDestination": "இறுதி சேருமிடம்",
"lp_phDropLocation": "டிராப் இடத்தை உள்ளிடு",
"lp_lblReturnSchedule": "திரும்பும் நேரம்",
"lp_lblDropSchedule": "இறக்கிவிட வேண்டிய நேரம்",
"lp_hintOneWayReturnCost": "உங்களையும் உங்கள் வாகனத்தையும் இறக்கிவிட்ட பிறகு ஓட்டுநர் தானாகவே திரும்பிச் செல்கிறார். அந்தத் திரும்பும் பயணச் செலவு இந்தக் கட்டணத்தில் அடங்காது - தயவுசெய்து அழைப்பில் ஓட்டுநருடன் நேரடியாக ஒப்புக்கொள்ளுங்கள்.",
"lp_lblPassengers": "உங்கள் குழுவில் பயணிகள்",
"lp_subLblGroupCab": "உங்கள் குழு முழு கேபையும் பதிவு செய்கிறது",
"lp_lblLuggage": "சாமான்",
"lp_lblStops": "ஸ்டாப்கள்",
"lp_errSameLocation": "பிக்-அப் மற்றும் டிராப் ஒரே இடமாக இருக்க முடியாது",
"lp_errReturnTooEarly": "{from} இலிருந்து {to} க்கு சுமார் {hours} மணிநேரம் ஆகும் - தயவுசெய்து பிந்தைய திரும்பும் நேரத்தைத் தேர்ந்தெடுக்கவும்",
"lp_backHomeBy": "வீடு திரும்பும் நேரம்",
"lp_errBackTooEarly": "{from} இலிருந்து {to} சென்று திரும்ப சுமார் {hours} மணிநேரம் ஆகும் - தயவுசெய்து பிந்தைய நேரத்தைத் தேர்ந்தெடுக்கவும்",
"lp_hintCalculatingRoute": "வழி கணக்கிடப்படுகிறது…",
"lp_phNote": "எ.கா. எனக்கு பேபி சீட், பெட் ஃப்ரெண்ட்லி கேப் வேண்டும்...",
"lp_promoRoundTrip": "ரவுண்ட் ட்ரிப் அல்லது மல்டி-ஸ்டாப்?",
"lp_promoMoreStops": "உங்கள் பயணத்தைத் திட்டமிட மேலும் ஸ்டாப்கள் சேர்க்கவும்.",
"lp_toastLocSuccess": "இருப்பிடம் கண்டறியப்பட்டது ✅",
"lp_toastLocDeny": "இந்த அம்சத்தைப் பயன்படுத்த உங்கள் உலாவியில் இருப்பிட அணுகலை அனுமதிக்கவும்",
"lp_errMissingFields": "கட்டாய புலங்கள் இல்லை: {list}",
"lp_errCity": "தயவுசெய்து நகரத்தைத் தேர்ந்தெடுக்கவும்.",
"lp_errPickupDt": "தயவுசெய்து பிக்-அப் தேதி மற்றும் நேரத்தைத் தேர்ந்தெடுக்கவும்.",
"lp_errPickupTimeLimit": "பிக்-அப் நேரம் இப்போதிலிருந்து குறைந்தது 30 நிமிடங்கள் கழித்து இருக்க வேண்டும்.",
"lp_errReturnDt": "தயவுசெய்து திரும்பும்/முடிவு தேதி மற்றும் நேரத்தைத் தேர்ந்தெடுக்கவும்.",
"lp_errReturnTimeLimit": "திரும்பும் நேரம் பிக்-அப் நேரத்திற்குப் பிறகு இருக்க வேண்டும்.",
"lp_errReturnMaxLimit": "திரும்பும் தேதி பிக்-அப்பிலிருந்து 10 நாட்களுக்குள் இருக்க வேண்டும்",
"lp_errPickupLoc": "தயவுசெய்து உங்கள் பிக்-அப் இருப்பிடத்தை உள்ளிடவும்.",
"lp_errPickupRadius": "தயவுசெய்து {city}க்கு {km} கி.மீ.க்குள் இருப்பிடத்தைத் தேர்ந்தெடுக்கவும்.",
"lp_errDestLoc": "தயவுசெய்து உங்கள் சேருமிடத்தை உள்ளிடவும்.",
"lp_errDestRadius": "தயவுசெய்து உங்கள் பிக்-அப்பிலிருந்து 1000 கி.மீ.க்குள் சேருமிடத்தைத் தேர்ந்தெடுக்கவும்.",
"lp_errStopValid": "தயவுசெய்து பரிந்துரைகளில் இருந்து ஸ்டாப் தேர்ந்தெடுக்கவும்.",
"lp_errStopRadius": "தயவுசெய்து உங்கள் பிக்-அப்பிலிருந்து 1000 கி.மீ.க்குள் ஸ்டாப் தேர்ந்தெடுக்கவும்.",
"awaitingDriverResponse": "டிரைவரின் பதிலுக்காகக் காத்திருக்கிறது",
"driverConnected": "டிரைவருடன் இணைக்கப்பட்டது",
"driverAccepted": "டிரைவர் ஏற்றுக்கொண்டார்",
"tripConfirmed": "பயணம் உறுதியானது",
"rideStarted": "பயணம் தொடங்கியது",
"rideCompleted": "பயணம் முடிந்தது",
"connectionFeePaid": "இணைப்புக் கட்டணம் செலுத்தப்பட்டது",
"waitingForPickup": "பிக்அப்புக்காகக் காத்திருக்கிறது",
"manageTrip": "பயணத்தை நிர்வகி",
"tripType": "பயண வகை",
"createdOn": "உருவாக்கிய தேதி",
"currentStatus": "தற்போதைய நிலை",
"connectionFee": "இணைப்புக் கட்டணம்",
"estimatedFare": "மதிப்பிடப்பட்ட கட்டணம்",
"tripId": "பயண ஐடி",
"actualDriverName": "டிரைவரின் உண்மையான பெயர்",
"waitingForDriverAcceptance": "டிரைவர் ஏற்றுக்கொள்வதற்காகக் காத்திருக்கிறது",
"vehicleName": "வாகனப் பெயர்",
"vehicleDetailsAvailableAfter": "டிரைவர் உறுதிசெய்த பிறகு வாகன விவரங்கள் தெரியும்.",
"paidUsingWallet": "வாலெட் மூலம் செலுத்தப்பட்டது",
"paidUsingCredit": "1 இலவச அழைப்பு கிரெடிட் பயன்படுத்தப்பட்டது",
"finalFareConfirmedDirectly": "இறுதிக் கட்டணம் உங்களுக்கும் டிரைவருக்கும் இடையே நேரடியாக முடிவாகும்.",
"tripTimeline": "பயண நிலைகள்",
"contactSupport": "ஸ்ராமிகா உதவியைத் தொடர்பு கொள்ளுங்கள்",
"needHelp": "உதவி வேண்டுமா?",
"upcomingTrips": "வரவிருப்பவை",
"previousTrips": "முந்தையவை",
"connectingIvrCall": "ஸ்ராமிகா ஐவிஆர் மூலம் உங்கள் அழைப்பை இணைக்கிறோம். எங்கள் அமைப்பு உங்களை அழைக்கும் வரை காத்திருக்கவும்.",
"callConnectionFailed": "அழைப்பை இணைக்க முடியவில்லை.",
"callError": "அழைப்பைத் தொடங்க முடியவில்லை.",
"pickupAddress": "??????? ??????",
"destination": "இலக்கு",
"vehicleNumber": "வாகன எண்",
"callHistory": "அழைப்பு வரலாறு",
"callDriverToBook": "???????? ??????????",
"loadingCalls": "அழைப்புகளை ஏற்றுகிறோம்…",
"noCallsMade": "இன்னும் அழைப்புகள் எதுவும் செய்யப்படவில்லை.",
    "completeProfile": "உங்கள் சுயவிவரத்தை முடிக்கவும்",
    "sramikaWallet": "ஸ்ராமிகா வாலெட்",
    "walletBalance": "வாலட் இருப்பு",
    "viewWallet": "வாலட்டைக் காண்க",

    "walletRemaining": "மீதமுள்ளது",
    "walletInfoTitle": "ஸ்ராமிகா உங்களுக்காக இணைக்கும் அழைப்புகளுக்குச் செலுத்த மட்டுமே இந்த வாலெட்.",
    "walletInfo1": "இந்த வாலட்டில் சேர்க்கப்பட்ட பணத்தை எடுக்க முடியாது.",
    "walletInfo2": "ஒவ்வொரு {hours} மணி நேரத்திலும் {free} அழைப்புகள் இலவசம். அதன் பிறகு இணையும் ஒவ்வொரு அழைப்புக்கும் ₹{fee}; அழைப்பு இணையவில்லை என்றால் எதுவும் எடுக்கப்படாது.",
    "walletAddMoney": "பணம் சேர்",
    "walletEnterAmount": "தொகையை உள்ளிடவும்",
    "walletRecharge": "வாலட்டை ரீசார்ஜ் செய்",
    "walletProcessing": "செயலாக்கப்படுகிறது...",
    "walletNoTxns": "இதுவரை வாலட் பரிவர்த்தனைகள் ஏதுமில்லை.",
    "walletNoTxnsSub": "நீங்கள் சேர்த்த பணமும் அழைப்புக் கட்டணங்களும் இங்கே தெரியும்.",
    "walletTxnRecharge": "ரீசார்ஜ்",
    "walletTxnServiceFee": "இணைப்பு கட்டணம்",
    "walletTxnRefund": "பணத்தைத் திரும்பப்பெறுதல்",
    "callDriverToBook": "ஓட்டுநரை அழைத்து முன்பதிவு செய்யுங்கள்","getDriversNumber": "ஓட்டுநர் எண்ணைப் பெறுங்கள்","appName": "ஸ்ராமிகா",
    "appSubtitle": "அருகிலுள்ள கார் பயணங்கள்",
    "onb_skip": "தவிர்",
    "onb_getStarted": "தொடங்கவும்",
    "onb_p1_sign": "அருகிலுள்ள கார்கள்",
    "onb_p1_title": "அருகிலுள்ள டிரைவர்களைக் கண்டறியவும்",
    "onb_p1_sub": "அருகிலுள்ள டிரைவர்களுடன் நேரடியாக இணையுங்கள்.",
    "onb_p1_badge": "கேப் கணக்குகளுக்கு 0% கமிஷன்",
    "onb_p2_sign": "அருகிலுள்ள ஓட்டுநர்",
    "onb_p2_title": "அருகிலுள்ள தனிப்பட்ட ஓட்டுநர்களை அமர்த்தவும்",
    "onb_p2_sub": "அருகிலுள்ள ஓட்டுநர்களுடன் நேரடியாக இணையுங்கள்.",
    "onb_p2_badge": "ஓட்டுநர்களுக்கு 0% கமிஷன்",
    "onb_p3_sign": "நம்பகமான நபர்களுடன் இணைக்கிறோம்",
    "onb_p3_title": "தேர்வு செய்ய உதவி தேவையோ?",
    "onb_p3_sub": "எங்கள் உதவி குழு சரியான டிரைவருடன் உங்களை இணைக்கும்.",
    "onb_p3_badge": "உதவி சேவைக்கு 0% கமிஷன்",
    "onb_p4_sign1": "கேப் வாடகைக்கு",
    "onb_p4_sign2": "ஓட்டுநர் வாடகைக்கு",
    "onb_p4_sign3": "மேலும் சேவைகள்",
    "onb_p4_title": "உங்களுக்கு தேவையான அனைத்தும் ஒரே இடத்தில்",
    "onb_p4_sub": "கேப்கள் மற்றும் ஓட்டுநர்களை அமர்த்தி மேலும் பயண சேவைகளைக் கண்டறியவும்.",
    "onb_p4_badge": "மேலும் சேவைகளுக்கு 0% கமிஷன்",
    "onb_p5_sign": "ஒரே செயலி. பல பயண சேவைகள்.",
    "onb_p5_title": "தொடங்கலாம்",
    "onb_p5_sub": "அருகிலுள்ள சேவைகளுடன் புத்திசாலித்தனமாகப் பயணம் செய்யுங்கள்.",
    "onb_p5_badge": "எப்போதும் 0% கமிஷன்",
    "onb_lang_title": "உங்கள் மொழியில், உங்கள் வசதிக்காக",
    "onb_lang_sub": "தகவல்கள் உங்கள் உள்ளூர் மொழியில் காட்டப்படும்.",
    "onb_footer": "உள்ளூர் ஆதரவு. உள்ளூர் மொழி. சிறந்த அனுபவம்.",
    "onb_language": "மொழி",
    "onb_intentTagline": "அருகிலுள்ள கேப்கள் & ஓட்டுநர்கள்",
    "onb_intentTitle": "ஸ்ராமிகாவை எப்படி பயன்படுத்த விரும்புகிறீர்கள்?",
    "onb_intentSub": "தொடர ஒன்றைத் தேர்ந்தெடுக்கவும்",
    "onb_intentRide": "கேப் & ஓட்டுநர் தேடுங்கள்",
    "onb_intentRideSub": "உள்ளூர், வெளியூர் கேப் அல்லது உங்கள் காருக்கு ஓட்டுநர்.",
    "onb_intentEarn": "ஸ்ராமிகாவுடன் சம்பாதிக்க விரும்புகிறீர்களா?",
    "onb_intentCab": "கேப் கணக்காகச் சேருங்கள்",
    "onb_intentCabSub": "கேபைப் பதிவு செய்து, வாடிக்கையாளர் அழைப்புகளை நேரடியாகப் பெறுங்கள்.",
    "onb_intentDriver": "வாடகை டிரைவராகச் சேருங்கள்",
    "onb_intentDriverSub": "கார் தேவையில்லை. மணி அல்லது நாள் கணக்கில் சம்பாதியுங்கள்.",
    // The /join page for ads (Oct 2026).
    "join_title": "ஸ்ராமிகாவுடன் சம்பாதியுங்கள்",
    "join_subShort": "வாடிக்கையாளர்கள் நேரடியாக உங்களை அழைப்பார்கள்.",
    "join_codeLine": "குறியீடு {code} · ஒப்புதலுக்குப் பின் ₹{amount}",
    "join_codeOnly": "குறியீடு {code}",
    "join_car": "என்னிடம் கார் உள்ளது",
    "join_carNeed": "உரிமம், ஆர்சி, கார் புகைப்படங்கள் · 15 நிமிடங்கள்",
    "join_drv": "ஓட்டத் தெரியும், கார் இல்லை",
    "join_drvNeed": "உரிமம், புகைப்படம், உங்கள் கட்டணங்கள் · 10 நிமிடங்கள்",
    "join_needACar": "கார் வேண்டுமா?",
    "join_seeCarsShort": "கார்களைப் பாருங்கள்",
    "onb_skipForNow": "இப்போது தவிர்",
    "newDriver": "புதிய ஓட்டுநர்",
    "startsFrom": "ஆரம்ப விலை",
    "contactDriver": "ஓட்டுநரை தொடர்பு கொள்ளவும்",
    "hireDriverTitle": "ஓட்டுநரை அமர்த்தவும்",
    "driverWillCome": "ஓட்டுநர் உங்கள் இடத்திற்கு வருவார்",
    "date": "தேதி",
    "time": "நேரம்",
    "duration": "கால அளவு",
    "yourCarType": "உங்கள் கார் வகை",
    "pickupAddress": "பிக்கப் முகவரி",
    "yourPhone": "உங்கள் தொலைபேசி",
    "yourName": "உங்கள் பெயர்",
    "tripPurpose": "பயண நோக்கம் (விருப்பத்திற்குரியது)",
    "youPayDriverDirectly": "நீங்கள் நேரடியாக ஓட்டுநருக்கு பணம் செலுத்துகிறீர்கள். ஸ்ராமிகா எந்த கமிஷனும் வசூலிப்பதில்லை.",
    "rateDriver": "ஓட்டுநரை மதிப்பிடுங்கள்",
    "howWasExperience": "உங்கள் அனுபவம் எப்படி இருந்தது?",
    "shortReview": "குறுகிய விமர்சனம் (விருப்பத்திற்குரியது)",
    "callDriver": "ஓட்டுநரை அழைக்கவும்",
    "filter": "வடிகட்டி",
    "loadingRequests": "கோரிக்கைகள் ஏற்றப்படுகின்றன...",
    "driverWillReview": "ஓட்டுநர் உங்கள் கோரிக்கையை மதிப்பாய்வு செய்து விரைவில் பதிலளிப்பார்.",
    "dismiss": "நிராகரி",
    "thankYouFeedback": "உங்கள் கருத்துக்கு நன்றி. இது மற்ற வாடிக்கையாளர்களுக்கு உதவுகிறது.",
    "selectCityHire": "உங்களுக்கு அருகிலுள்ள ஓட்டுநர்களைக் காண நகரத்தைத் தேர்ந்தெடுக்கவும்",
    "findingDriversIn": "ல் ஓட்டுநர்களை தேடுகிறோம்",
    "clearAll": "அனைத்தையும் அழிக்கவும்",
    "areYouDriver": "நீங்கள் ஓட்டுநரா?",
    "registerAsHireDriver": "பட்டியலிடப்பட ஒரு வாடகை ஓட்டுநராக பதிவு செய்யுங்கள்",
    "join": "சேரவும்",
    "fareCalculatorTitle": "கட்டண கால்குலேட்டர்",
    "distanceLabel": "தூரம்",
    "durationLabel": "கால அளவு",
    "booked": "பதிவு செய்யப்பட்டது",
    "estimatedFareLabel": "மதிப்பிடப்பட்ட கட்டணம்",
    "advanceAlreadyPaid": "முன்பணம் ஏற்கனவே செலுத்தப்பட்டுள்ளது",
    "payToDriverLabel": "ஓட்டுநருக்கு பணம் செலுத்துங்கள்",
    "noTripDetails": "பயண விவரங்கள் எதுவும் கிடைக்கவில்லை.",
    "goHome": "முகப்புக்குச் செல்",
    "earnCommissionBooking": "இந்த முன்பதிவில் கமிஷன் சம்பாதிக்கவும்",
    "customerNameReq": "வாடிக்கையாளர் பெயர் *",
    "customerPhoneReq": "வாடிக்கையாளர் தொலைபேசி *",
    "yourCab": "உங்கள் கேப்",
    "paymentSummary": "கட்டண சுருக்கம்",
    "cabFare": "கேப் கட்டணம்",
    "totalTripCost": "மொத்த பயண செலவு",
    "payNowLabel": "இப்போது செலுத்துங்கள்:",
    "advance10Percent": "முன்பணம் (கேப் கட்டணத்தில் 10%)",
    "balanceToDriver": "ஓட்டுநருக்கு மீதமுள்ள தொகை",
    "selectPaymentMethod": "கட்டண முறையைத் தேர்ந்தெடுக்கவும்",
    "howItWorks": "இது எப்படி செயல்படுகிறது",
    "advanceFullyRefunded": "முன்பணம் முழுமையாக திரும்பப் பெறப்பட்டது",
    "advanceNonRefundable": "முன்பணம் திரும்பப் பெறப்படாது",
    "additionalChargesActuals": "கூடுதல் கட்டணங்கள் உண்மையானவை",
    "profilePhoto": "சுயவிவரப் புகைப்படம்",
    "startTrip": "பயணத்தைத் தொடங்கு",
    "endTrip": "பயணத்தை முடி",
    "finalDistance": "இறுதி தூரம்",
    "fareBreakdown": "கட்டண விவரம்",
    "totalDuration": "மொத்த கால அளவு",
    "withdrawalUnlock": "திரும்பப் பெறுதல் திறப்பு",
    "quickWins": "விரைவான வெற்றிகள்:",
    "yourTrustedCabPartner": "உங்கள் நம்பகமான கேப் கூட்டாளர்",
    "usernameOrMobile": "பயனர்பெயர் அல்லது மொபைல்",
    "password": "கடவுச்சொல்",
    "expired": "காலாவதியானது",
    "withdrawToUpi": "யுபிஐக்கு திரும்பப் பெறுக",
    "minPtsWallet": "குறைந்தபட்சம் 300 புள்ளிகள் பணப்பையில் இருக்க வேண்டும்",
    "availableToWithdraw": "திரும்பப் பெற கிடைக்கும்",
    "upiId": "யுபிஐ ஐடி",
    "amountRupees": "தொகை (₹)",
    "bookingId": "முன்பதிவு ஐடி",
    "lifetimeEarned": "வாழ்நாள் வருமானம்",
    "withdrawable": "திரும்பப் பெறக்கூடியவை",
    "useOnRide": "பயணத்தில் பயன்படுத்தவும்",
    "recentActivity": "சமீபத்திய செயல்பாடு",
    "seeAll": "அனைத்தையும் காண்க",
    "withdrawalLocked": "திரும்பப் பெறுதல் பூட்டப்பட்டுள்ளது",
    "transactionHistory": "பரிவர்த்தனை வரலாறு",
    "noTransactionsYet": "இன்னும் பரிவர்த்தனைகள் இல்லை",
    "loginCta": "உள்நுழை / சேர்",
    "findTaxiBy": "சரியான டாக்ஸியைக் கண்டறியவும்",
    "from": "புறப்படும் இடம்",
    "to": "செல்லும் இடம்",
    "nearbyCars": "அருகிலுள்ள சிறந்த கார்கள்",
    "accountTitle": "எனது சுயவிவரம்",
    "bookings": "வரலாறு",
    "notifications": "அறிவிப்புகள்",
    "support": "உதவி மையம்",
    "settings": "அமைப்புகள்",
    "logout": "வெளியேறு",
    "loginSignup": "உள்நுழை / பதிவு செய்",
    "noBookings": "இதுவரை முன்பதிவுகள் எதுவும் இல்லை.",
    "startBooking": "நம்பகமான உள்ளூர் கேப்களை முன்பதிவு செய்யுங்கள்",
    "faqTitle": "அடிக்கடி கேட்கப்படும் கேள்விகள்",
    "callSupport": "உதவி மையத்தை அழை",
    "language": "மொழி",
    "fareCalculator": "கட்டணக் கணிப்பான்",
    "terms": "விதிமுறைகள் & நிபந்தனைகள்",
    "privacy": "தனியுரிமைக் கொள்கை",
    "manageProfile": "உங்கள் சுயவிவரம் மற்றும் விருப்பங்களை நிர்வகிக்கவும்",
    "mobileNumber": "கைபேசி எண்",
    "username": "பயனர் பெயர்",
    "preferredCity": "விருப்பமான நகரம்",
    "referFriend": "நண்பரை பரிந்துரைக்கவும்",
    "comingSoon": "விரைவில் வருகிறது",
    "cabOwnerProfile": "டிரைவர் சுயவிவரம்",
    "editCabOwnerProfile": "டிரைவர் விவரங்களைத் திருத்து",
    "accountActions": "கணக்கு நடவடிக்கைகள்",
    "save": "மாற்றங்களைச் சேமி",
    "edit": "திருத்து",
    "verified": "சரிபார்க்கப்பட்டது",
    "notEditable": "மாற்ற முடியாது",
    "myRating": "எனது மதிப்பீடு",
    "notSet": "அமைக்கப்படவில்லை",
    "upcoming": "வரவிருக்கும் பயணங்கள்",
    "previous": "முந்தைய பயணங்கள்",
    "noUpcomingTrips": "வரவிருக்கும் பயணங்கள் எதுவும் இல்லை.",
    "noPreviousTrips": "முந்தைய பயணங்கள் எதுவும் இல்லை.",
    "bookRide": "பயணத்தை முன்பதிவு செய்",
    "signIn": "உள்நுழை",
    "viewBookings": "முன்பதிவுகளைப் பார்",
    "personalDetails": "தனிப்பட்ட விவரங்கள்",
    "location": "இடம்",
    "emergencyContact": "அவசரத் தொடர்பு",
    "vehicleOptions": "வாகன விருப்பங்கள்",
    "tripTypesOffered": "வழங்கப்படும் பயண வகைகள்",
    "pricing": "விலை நிர்ணயம்",
    "weeklyAvailability": "வாராந்திர கிடைக்கும் தன்மை",
    "kycLocked": "KYC விவரங்கள் பூட்டப்பட்டுள்ளன",
    "kycLockedDesc": "பெயர், மொபைல், DL மற்றும் வாகன விவரங்களை இங்கு மாற்ற முடியாது. உதவி மையத்தைத் தொடர்பு கொள்ளவும்.",
    "verifiedInfo": "சரிபார்க்கப்பட்ட தகவல்",
    "gender": "பாலினம்",
    "languagesSpoken": "பேசும் மொழிகள்",
    "bio": "சுயவிவரக் குறிப்பு",
    "address": "முகவரி",
    "pincode": "அஞ்சல் குறியீடு",
    "contactName": "தொடர்பு பெயர்",
    "contactPhone": "தொடர்பு எண்",
    "acAvailable": "ஏசி உள்ளது",
    "wallet": "வாலட்",
    "recentSearches": "சமீபத்திய தேடல்கள்",
    "home": "முகப்பு",
    "navCars": "கார்கள்",
    "nearbyHireDrivers": "அருகிலுள்ள வாடகை ஓட்டுநர்கள்",
    "city": "நகரம்",
    "noCabsFoundFor": "கேப்கள் எதுவும் கிடைக்கவில்லை:",
    "tryDifferentSearch": "வேறொரு தேடலை முயலவும் அல்லது பரிந்துரைகளைப் பயன்படுத்தவும்:",
    "sramikaComingTo": "ஸ்ராமிகா விரைவில் வருகிறது:",
    "onboardingDriversIn": "நாங்கள் தற்போது ஓட்டுநர்களை சேர்க்கும் பகுதி:",
    "beTheFirstToKnow": ". சேவை தொடங்கியவுடன் முதலில் தெரிந்து கொள்ளுங்கள்.",
    "expectedLaunch": "எதிர்பார்க்கப்படும் தொடக்கம்",
    "whatsappNumber": "வாட்ஸ்அப் எண் (10 இலக்கங்கள்)",
    "notifyViaWhatsapp": "சேவை தொடங்கியதும் வாட்ஸ்அப் மூலம் அறிவிப்போம்",
    "joining": "இணைகிறது...",
    "onTheList": "நீங்கள் பட்டியலில் இணைந்துவிட்டீர்கள்!",
    "goBackHome": "முகப்புக்கு செல்",
    "noDriversIn": "தற்போது ஓட்டுநர்கள் இல்லை:",
    "driverNetworkExpanding": "எங்கள் சரிபார்க்கப்பட்ட ஓட்டுநர் கட்டமைப்பு வேகமாக விரிவடைகிறது. இந்நகரின் முதல் ஓட்டுநர் கூட்டாளியாக இணைந்து உடனே முன்பதிவுகளைப் பெறுங்கள்.",
    "registerAsDriver": "ஓட்டுநராக பதிவு செய்",
    "learnMore": "மேலும் அறிய",
    "noCabsIn": "தற்போது கேப்கள் இல்லை:",
    "cabNetworkExpanding": "எங்கள் பிரீமியம் கட்டமைப்பு வேகமாக விரிவடைகிறது. இந்நகரில் எங்கள் சிறப்பு சேவைகளை தொடங்கும் முதல் கூட்டாளியாக இணைந்து இன்றே சம்பாதிக்கத் தொடங்குங்கள்.",
    "joinAsPartner": "கூட்டாளியாக இணை",
    "exploreCities": "நகரங்களை ஆராய்",
    "platformDisclaimer": "ஸ்ராமிகா ஒரு தொழில்நுட்ப தளம். போக்குவரத்து சேவைகள் சுதந்திரமான ஆபரேட்டர்களால் வழங்கப்படுகின்றன.",
    "topRated": "சிறந்த மதிப்பீடு",
    "nearby": "அருகில்",
    "luxury": "ஆடம்பரம்",
    "familyTrip": "குடும்ப பயணம்",
    "fastBooking": "விரைவான முன்பதிவு",
    "matched": "பொருந்தியது",
    "estPrice": "மதிப்பிடப்பட்ட விலை",
    "baseRateLabel": "அடிப்படை கட்டணம்",
    "recentSearchesLabel": "சமீபத்திய தேடல்கள்",
    "anyCab": "எந்த கேபும்",
    "trip": "பயணம்",
    "trips": "பயணங்கள்",
    "selectCity": "நகரத்தைத் தேர்ந்தெடுக்கவும்",
    "detecting": "கண்டறியப்படுகிறது...",
    "detectLocation": "இருப்பிடத்தைக் கண்டறி",
    "typeCityName": "நகரத்தின் பெயரை தட்டச்சு செய்க...",
    "filters": "வடிகட்டிகள்",
    "select": "தேர்ந்தெடு",
    "bioHint": "பயணிகளுக்கு உங்களைப் பற்றி சிறிது சொல்லுங்கள்",
    "searchCity": "நகரத்தைத் தேடுங்கள்...",
    "selectCity2": "நகரத்தைத் தேர்ந்தெடுக்கவும்",
    "findRightTaxi": "சரியான டாக்ஸியைக் கண்டறியவும்",
    "lastBooked": "கடைசியாக முன்பதிவு செய்தது:",
    "more": "+ மேலும்",
    "hireDriver": "ஓட்டுநரை அமர்த்தவும்",
    "services": "சேவைகள்",
    "account": "கணக்கு",
    "findRightDriver": "சரியான ஓட்டுநரைக் கண்டறியவும்",
    "searchCabPlaceholder": "கேப், மாடல், பகுதி தேடுங்கள்...",
    "searchDriverPlaceholder": "ஓட்டுநர், பகுதி, மொழி, அனுபவம் தேடுங்கள்...",
    "myHireRequests": "எனது ஓட்டுநர் கோரிக்கைகள்",
    "driverCanSpeakLanguages": "ஓட்டுநர் பேசக்கூடிய மொழிகள்",
    "referenceFare": "பரிந்துரை கட்டணம்",
    "callDriver": "ஓட்டுநரை அழைக்கவும்",

    "driverDiscountLabel": "தள்ளுபடி",
    "connecting": "இணைக்கிறது...",

    "mockCallConnecting": "போலி தொலைபேசி மூலம் ஓட்டுநருக்கு அழைப்பு இணைக்கப்படுகிறது...",
    "mockCallError": "அழைப்பை இணைக்க முடியவில்லை.",
    "callInitiationError": "அழைப்பைத் தொடங்குவதில் பிழை.",


    "callbackInitiationError": "மீண்டும் அழைக்க கோருவதில் பிழை.",
    "bookNowToGetContact": "தொடர்பு எண்ணைப் பெற இப்போதே முன்பதிவு செய்யுங்கள்",
    "regularPrice": "வழக்கமான விலை",
    "typicalFareTooltip": "A typical fare for this route, based on local rates. Partners set their own prices independently.", // TODO: Tamil translation pending.
    "partnersPrice": "டிரைவர் கட்டணம்", // TODO: Tamil translation pending.
    "priceHistory": "விலை வரலாறு", // TODO: Tamil translation pending.
    "increaseAvailableNow": "இப்போது விலைகளை உயர்த்தலாம்", // TODO: Tamil translation pending.
    "nextIncreaseAt": "அடுத்த விலை உயர்வு {{time}} பிறகு", // TODO: Tamil translation pending.
    "noPriceChangesYet": "இன்னும் விலை மாற்றங்கள் இல்லை", // TODO: Tamil translation pending.
    "loadingHistory": "வரலாற்றை ஏற்றுகிறோம்…", // TODO: Tamil translation pending.
    "changeIncrease": "உயர்வு", // TODO: Tamil translation pending.
    "changeDecrease": "குறைவு", // TODO: Tamil translation pending.
    "changeMixed": "சில உயர்வு, சில குறைவு", // TODO: Tamil translation pending.
    "noFieldsChanged": "எந்த விவரமும் மாறவில்லை.", // TODO: Tamil translation pending.
    "typicalFareLabel": "வழக்கமான கட்டணம் ₹{value}",
    "lessThanTypicalFare": "வழக்கமான கட்டணத்தை விட ₹{amount} குறைவு",
    "partnerOfferedPrice": "கூட்டாளர் விலை",
    "partnerPricePrefix": "விலை",
    "estimatedAmount": "மதிப்பிடப்பட்ட தொகை",
    "estimatedAmountCaption": "உண்மையான பயணம், சுங்கச்சாவடிகள், பார்க்கிங் அல்லது வழித்தட மாற்றங்களின் அடிப்படையில் இறுதித் தொகை மாறக்கூடும்.",
    "extrasNote": "Toll, border/state taxes and parking (if any) are extra and paid directly to the driver.", // TODO: pending
    "youSaveComparedToRegular": "வழக்கமான விலையுடன் ஒப்பிடும்போது.",
    "payDirectlyToPartner": "பயண கூட்டாளருடன் உங்கள் பயணத்தை உறுதி செய்த பிறகு மட்டுமே பணம் செலுத்துங்கள்.",
    "chargesDuringTrip": "பயணத்தின் போது கட்டணங்கள்",
    "whyChooseSramika": "வாடிக்கையாளர்கள் ஸ்ராமிகாவை ஏன் தேர்வு செய்கிறார்கள்",
    "verifiedTravelPartners": "Trusted travel partners", // TODO: pending
    "transparentPricing": "வெளிப்படையான விலை",
    "directCommunication": "நேரடி கூட்டாளர் தொடர்பு",
    "noBookingCommission": "முன்பதிவு கமிஷன் இல்லை",
    "secureBookingExperience": "பாதுகாப்பான முன்பதிவு அனுபவம்",
    "youSavePrefix": "நீங்கள் சேமிக்கிறீர்கள்",
    "saveBadge": "சேமி",
    "savingsBasedOnPartnerPrice": "கூட்டாளர் விலை நிர்ணயம் நீங்கள் அதிகம் சேமிக்க உதவுகிறது.",
    "licenseChecked": "Driving License Checked", // TODO: pending
    "bestOffer": "சிறந்த சலுகை",
    "tripPriceDetails": "பயண விலை விவரங்கள்",
    "transparentPartnerPricing": "வெளிப்படையான கூட்டாளர் விலை நிர்ணயம்",
    "noSramikaBookingCommission": "ஸ்ராமிகா முன்பதிவு கமிஷன் இல்லை",
    "driverAllowance": "ஓட்டுநர் படி",
    "nightAllowance": "இரவுப் படி",
    "transparentPricingNoHidden": "வெளிப்படையான விலை - மறைக்கப்பட்ட கட்டணங்கள் இல்லை",
    "promoDiscount": "விளம்பரத் தள்ளுபடி",
    "sramikaDiscount": "ஸ்ராமிகா தள்ளுபடி",
    "couponAppliedMsg": "கூப்பன் பயன்படுத்தப்பட்டது",
    "saveAmount": "சேமி ",
    "removeAction": "அகற்று",
    "applyAction": "பயன்படுத்து",
    "totalFare": "மொத்தக் கட்டணம்",
    "finalPriceLabel": "இறுதி விலை",
    "partnerOfferSuffix": " சலுகை",
    "legacyFareVary": "உண்மையான KM பயணம் அல்லது பயண கால அளவுகளில் ஏதேனும் மாற்றம் ஏற்பட்டால் இறுதி கட்டணம் மாறுபடும்.",
    "legacyTollsExcluded": "⚠️ **குறிப்பு:** சுங்கச்சாவடிகள், வாகன நிறுத்துமிடக் கட்டணங்கள் மற்றும் ஏதேனும் எல்லை/மாநில வரி கட்டணங்கள் இந்தக் கட்டணத்தில் **சேர்க்கப்படவில்லை** மற்றும் தனித்தனியாக வசூலிக்கப்படும்.",
    "estimateFareCalc1": "எங்கள் ",
    "pricingCalculator": "விலை கால்குலேட்டரைப்",
    "estimateFareCalc2": " பயன்படுத்தி எந்த நேரத்திலும் தூரம் அல்லது நேர மாற்றத்திற்கான உங்கள் புதுப்பிக்கப்பட்ட கட்டணத்தை மதிப்பிடலாம்.",
    "pickup": "பிக்கப்",
    "origin": "தோற்றம்",
    "destination": "இலக்கு",
    "oneWay": "ஒரு வழி",
    "inclReturn": "திரும்பப் பெறுதல் உட்பட",
    "hrs": "மணி",
    "estDuration": "மதிப்பிடப்பட்ட காலம்",

    // Rating Modal
    "loadingRating": "ஏற்றுகிறோம்…", // TODO: pending
    "updateRating": "மதிப்பீட்டை மாற்று", // TODO: pending
    "submitRating": "மதிப்பீட்டை அனுப்பு", // TODO: pending
    "tapAStar": "Tap a star", // TODO: pending
    "ratingPoor": "Poor", // TODO: pending
    "ratingFair": "Fair", // TODO: pending
    "ratingGood": "Good", // TODO: pending
    "ratingVeryGood": "Very Good", // TODO: pending
    "ratingExcellent": "Excellent", // TODO: pending
    "loadingRating": "ஏற்றுகிறோம்…",
    "updateRating": "மதிப்பீட்டை மாற்று",
    "submitRating": "மதிப்பீட்டை அனுப்பு",
    "tapAStar": "Tap a star",
    "ratingPoor": "Poor",
    "ratingFair": "Fair",
    "ratingGood": "Good",
    "ratingVeryGood": "Very Good",
    "ratingExcellent": "Excellent",
    "tellUsExperience": "உங்கள் அனுபவத்தைச் சொல்லுங்கள்…",
    "typicalFareBare": "Market Price",
    "totalWithCharges": "Total with trip charges"
  },
  "kn": {
"rm_of": "{n} ರಲ್ಲಿ {yes}",
"rm_driverCame": "ಬುಕ್ ಮಾಡಿದ ಅದೇ ಚಾಲಕರು ಬಂದರು",
"rm_carCame": "ಬುಕ್ ಮಾಡಿದ ಅದೇ ಕಾರು ಬಂತು",
"rm_no": "ಇಲ್ಲ",
"rm_yes": "ಹೌದು",
"rm_sameDriver": "ನೀವು ಬುಕ್ ಮಾಡಿದ ಅದೇ ಚಾಲಕರು ಬಂದರೇ?",
"rm_sameCar": "ನೀವು ಬುಕ್ ಮಾಡಿದ ಅದೇ ಕಾರು ಬಂತೇ?",
"lg_brand": "ಶ್ರಮಿಕ",
"tx_bonus": "ಬೋನಸ್",
"tx_referralBack": "ರೆಫರಲ್ ಬಹುಮಾನ ಹಿಂಪಡೆಯಲಾಗಿದೆ",
"tx_referral": "ರೆಫರಲ್ ಬಹುಮಾನ",
"tx_welcome": "ಸ್ವಾಗತ ಕೊಡುಗೆ",
"tx_failed": "ಪಾವತಿ ವಿಫಲವಾಗಿದೆ",
"lc_offer": "ವಿಶೇಷ ಕೊಡುಗೆ",
"lh_ref": "ಸಂ.",
"cv_mpv": "ಎಂಪಿವಿ",
"updateRating": "ರೇಟಿಂಗ್ ಬದಲಿಸಿ",
"tellUsExperience": "ನಿಮ್ಮ ಅನುಭವ ತಿಳಿಸಿ…",
"submitRating": "ರೇಟಿಂಗ್ ಕಳುಹಿಸಿ",
"loadingRating": "ತರುತ್ತಿದ್ದೇವೆ…",
"ac_roleOwner": "ಡ್ರೈವರ್",
"ac_roleAdmin": "ಅಡ್ಮಿನ್",
"ac_roleSuper": "ಸೂಪರ್ ಅಡ್ಮಿನ್",
"ac_roleDriver": "ಚಾಲಕ",
"ac_roleAgent": "ಫೀಲ್ಡ್ ಏಜೆಂಟ್",
"ac_ownerCarsLeads": "ನನ್ನ ಕಾರುಗಳು, ಲೀಡ್‌ಗಳು",
"od_title": "ನನ್ನ ಚಾಲಕರು",
"od_list": "ನಿಮ್ಮ ಕಾರುಗಳ ಚಾಲಕರು",
"od_add": "ಚಾಲಕರನ್ನು ಸೇರಿಸಿ",
"od_addTitle": "ಹೊಸ ಚಾಲಕ",
"od_name": "ಚಾಲಕರ ಹೆಸರು",
"od_namePh": "ಉದಾ. ರಮೇಶ್ ಕುಮಾರ್",
"od_licencePh": "ಉದಾ. AP09 2024 0012345",
"od_licPhoto": "ಲೈಸೆನ್ಸ್ ಫೋಟೋ",
"od_photo": "ಚಾಲಕರ ಫೋಟೋ",
"od_choose": "ಫೋಟೋ ಆಯ್ಕೆಮಾಡಿ",
"od_checkNote": "ಚಾಲಕರು ಕಾಣುವ ಮೊದಲು ಶ್ರಮಿಕ ಲೈಸೆನ್ಸ್ ಪರಿಶೀಲಿಸುತ್ತದೆ.",
"od_errName": "ಚಾಲಕರ ಹೆಸರು ನಮೂದಿಸಿ.",
"od_errPhone": "10 ಅಂಕಿಯ ಮೊಬೈಲ್ ನಂಬರ್ ನಮೂದಿಸಿ.",
"od_errLicence": "ಲೈಸೆನ್ಸ್ ನಂಬರ್ ನಮೂದಿಸಿ.",
"od_errLicPhoto": "ಲೈಸೆನ್ಸ್ ಫೋಟೋ ಸೇರಿಸಿ.",
"od_errPhoto": "ಚಾಲಕರ ಫೋಟೋ ಸೇರಿಸಿ.",
"od_addFail": "ಚಾಲಕರನ್ನು ಸೇರಿಸಲು ಆಗಲಿಲ್ಲ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
"od_addBtn": "ಈ ಚಾಲಕರನ್ನು ಸೇರಿಸಿ",
"od_adding": "ಸೇರಿಸುತ್ತಿದ್ದೇವೆ…",
"od_loading": "ನಿಮ್ಮ ಚಾಲಕರನ್ನು ತರುತ್ತಿದ್ದೇವೆ…",
"od_loadFail": "ನಿಮ್ಮ ಚಾಲಕರನ್ನು ತರಲು ಆಗಲಿಲ್ಲ.",
"od_pending": "ಅನುಮೋದನೆಗಾಗಿ ಕಾಯುತ್ತಿದೆ",
"od_remove": "ತೆಗೆದುಹಾಕಿ",
"od_removeAsk": "ಈ ಚಾಲಕರನ್ನು ನಿಮ್ಮ ಪಟ್ಟಿಯಿಂದ ತೆಗೆದುಹಾಕಬೇಕೇ?",
"od_removeYes": "ಹೌದು, ತೆಗೆದುಹಾಕಿ",
"od_removeFail": "ಚಾಲಕರನ್ನು ತೆಗೆದುಹಾಕಲು ಆಗಲಿಲ್ಲ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
"od_emptyTitle": "ಇನ್ನೂ ಚಾಲಕರಿಲ್ಲ",
"od_emptyText": "ನಿಮ್ಮ ಕಾರುಗಳನ್ನು ಓಡಿಸುವ ಚಾಲಕರನ್ನು ಸೇರಿಸಿ.",
"ea_title": "ಖಾತೆ ವಿವರಗಳನ್ನು ಬದಲಿಸಿ",
"ea_note": "ಇವು ನೋಂದಣಿ ವೇಳೆ ಪರಿಶೀಲಿಸಿದವು. ಬದಲಾವಣೆ ಶ್ರಮಿಕಕ್ಕೆ ಹೋಗುತ್ತದೆ, ಅನುಮೋದನೆ ಆದ ನಂತರವೇ ಕಾಣುತ್ತದೆ.",
"ea_pendingTitle": "ಒಂದು ಬದಲಾವಣೆ ಅನುಮೋದನೆಗಾಗಿ ಕಾಯುತ್ತಿದೆ",
"ea_pendingText": "ನೀವು ಕಳುಹಿಸಿದ ಬದಲಾವಣೆಯನ್ನು ಶ್ರಮಿಕ ಪರಿಶೀಲಿಸುತ್ತಿದೆ. ಅದು ಮುಗಿದ ನಂತರ ಇನ್ನೊಂದನ್ನು ಕಳುಹಿಸಬಹುದು.",
"ea_sentTitle": "ಅನುಮೋದನೆಗೆ ಕಳುಹಿಸಲಾಗಿದೆ",
"ea_sentText": "ಶ್ರಮಿಕ ಬದಲಾವಣೆಯನ್ನು ಅನುಮೋದಿಸುವವರೆಗೆ ನಿಮ್ಮ ವಿವರಗಳು ಹಾಗೆಯೇ ಇರುತ್ತವೆ.",
"ea_toAccount": "ನನ್ನ ಖಾತೆಗೆ ಹೋಗಿ",
"ea_loadFail": "ನಿಮ್ಮ ಖಾತೆ ವಿವರಗಳನ್ನು ತರಲು ಆಗಲಿಲ್ಲ.",
"ea_sendFail": "ನಿಮ್ಮ ಬದಲಾವಣೆ ಕಳುಹಿಸಲು ಆಗಲಿಲ್ಲ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
"ea_phoneLocked": "ಪರಿಶೀಲಿಸಿದ ನಂಬರ್ ಬದಲಿಸಲು ಶ್ರಮಿಕಕ್ಕೆ ಕರೆ ಮಾಡಿ.",
"ea_blood": "ರಕ್ತದ ಗುಂಪು",
"ea_select": "ಆಯ್ಕೆಮಾಡಿ",
"ea_contact": "ವಿಳಾಸ ಮತ್ತು ತುರ್ತು ಸಂಪರ್ಕ",
"ea_ap": "ಆಂಧ್ರ ಪ್ರದೇಶ",
"ea_tg": "ತೆಲಂಗಾಣ",
"ea_emName": "ತುರ್ತು ಸಂಪರ್ಕದ ಹೆಸರು",
"ea_emPhone": "ತುರ್ತು ಸಂಪರ್ಕ ನಂಬರ್",
"ea_driving": "ಚಾಲನೆ",
"ea_aadhaar": "ಆಧಾರ್ ನಂಬರ್",
"ea_licence": "ಚಾಲನಾ ಲೈಸೆನ್ಸ್ ನಂಬರ್",
"ea_bank": "ಬ್ಯಾಂಕ್ ವಿವರಗಳು",
"ea_accName": "ಖಾತೆದಾರರ ಹೆಸರು",
"ea_accNo": "ಖಾತೆ ನಂಬರ್",
"ea_ifsc": "ಐಎಫ್‌ಎಸ್‌ಸಿ ಕೋಡ್",
"ea_send": "ಅನುಮೋದನೆಗೆ ಕಳುಹಿಸಿ",
"pe_saved": "ನಿಮ್ಮ ವಿವರಗಳನ್ನು ಉಳಿಸಲಾಗಿದೆ.",
"pe_saveFail": "ಉಳಿಸಲು ಆಗಲಿಲ್ಲ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
"pe_loading": "ನಿಮ್ಮ ವಿವರಗಳನ್ನು ತರುತ್ತಿದ್ದೇವೆ…",
"pe_loadFail": "ನಿಮ್ಮ ವಿವರಗಳನ್ನು ತರಲು ಆಗಲಿಲ್ಲ.",
"pe_checked": "ನೋಂದಣಿ ವೇಳೆ ಪರಿಶೀಲಿಸಿದವು",
"pe_car": "ಕಾರು",
"pe_lockedText": "ಇವುಗಳನ್ನು ಬದಲಿಸಲು ಶ್ರಮಿಕಕ್ಕೆ ಕರೆ ಮಾಡಿ - ಮೊದಲು ಮತ್ತೆ ಪರಿಶೀಲಿಸಲಾಗುತ್ತದೆ.",
"pe_about": "ನಿಮ್ಮ ಬಗ್ಗೆ",
"pe_business": "ಬಿಸಿನೆಸ್ ಹೆಸರು (ಇದ್ದರೆ)",
"pe_businessHint": "ಖಾಲಿ ಬಿಟ್ಟರೆ ನಿಮ್ಮ ಹೆಸರೇ ಕಾಣುತ್ತದೆ.",
"pe_businessPh": "ಉದಾ. ಶ್ರೀ ಸಾಯಿ ಟ್ರಾವೆಲ್ಸ್",
"pe_other": "ಇತರ",
"pe_langs": "ನೀವು ಮಾತನಾಡುವ ಭಾಷೆಗಳು",
"pe_bio": "ನಿಮ್ಮ ಬಗ್ಗೆ ಕೆಲವು ಮಾತುಗಳು",
"pe_bioHint": "ಗ್ರಾಹಕರಿಗೆ ನಿಮ್ಮ ಬಗ್ಗೆ ಸ್ವಲ್ಪ ತಿಳಿಸಿ.",
"pe_bioApproval": "ಇಲ್ಲಿ ಬರೆದ ಹೊಸ ಮಾತುಗಳನ್ನು ಗ್ರಾಹಕರಿಗೆ ತೋರಿಸುವ ಮೊದಲು ಶ್ರಮಿಕ ಪರಿಶೀಲಿಸುತ್ತದೆ.",
"pe_bioSent": "ಉಳಿಸಲಾಗಿದೆ. ಶ್ರಮಿಕ ಅನುಮೋದಿಸಿದ ನಂತರ ನಿಮ್ಮ ಹೊಸ ಮಾತುಗಳು ಕಾಣಿಸುತ್ತವೆ.",
"pe_bioWaiting": "ಉಳಿಸಲಾಗಿದೆ. ನಿಮ್ಮ ಹೊಸ ಮಾತುಗಳು ಕಾಯುತ್ತಿವೆ - ನಿಮ್ಮ ಇನ್ನೊಂದು ಬದಲಾವಣೆ ಶ್ರಮಿಕದ ಬಳಿ ಇದೆ.",
"pe_bioPending": "ಅನುಮೋದನೆಗಾಗಿ: “{bio}”",
"pe_bioPh": "ಉದಾ. 8 ವರ್ಷಗಳಿಂದ ಚಾಲನೆ, ವಿಜಯವಾಡ - ಹೈದರಾಬಾದ್ ಮಾರ್ಗ ಚೆನ್ನಾಗಿ ಗೊತ್ತು.",
"pe_pincode": "ಪಿನ್‌ಕೋಡ್",
"pe_phonePh": "10 ಅಂಕಿಯ ಮೊಬೈಲ್ ನಂಬರ್",
"pe_carTrips": "ನಿಮ್ಮ ಕಾರು ಮತ್ತು ಪ್ರಯಾಣಗಳು",
"pe_personalText": "ನಿಮ್ಮ ವಿಳಾಸ, ಭಾಷೆಗಳು, ಲಿಂಗ ಮತ್ತು ತುರ್ತು ಸಂಪರ್ಕವನ್ನು {account} → {edit} ನಲ್ಲಿ ಬದಲಿಸಿ. ಶ್ರಮಿಕ ಮೊದಲು ಬದಲಾವಣೆಯನ್ನು ಪರಿಶೀಲಿಸುತ್ತದೆ.",
"pe_personalBtn": "ನನ್ನ ವಿವರಗಳನ್ನು ಬದಲಿಸಿ",
"pe_acPerCar": "ಎಸಿಯನ್ನು ಪ್ರತಿ ಕಾರಿಗೆ ಪ್ರತ್ಯೇಕವಾಗಿ {myCars} ನಲ್ಲಿ ಹೊಂದಿಸಿ.",
"pe_moreCars": "+{n} ಇನ್ನೂ",
"pe_tripKinds": "ನೀವು ಮಾಡುವ ಪ್ರಯಾಣಗಳು",
"pe_hourly": "ಗಂಟೆ ಲೆಕ್ಕದಲ್ಲಿ",
"pe_dayRent": "ದಿನದ ಬಾಡಿಗೆ",
"pe_prices": "ದರಗಳು",
"pe_week": "ನೀವು ಕೆಲಸ ಮಾಡುವ ದಿನಗಳು, ಸಮಯ",
"pe_from": "ಇಂದ",
"pe_to": "ವರೆಗೆ",
"pe_save": "ಬದಲಾವಣೆಗಳನ್ನು ಉಳಿಸಿ",
"ld_sentDriver": "ಚಾಲಕರಿಗೆ ಕಳುಹಿಸಲಾಗಿದೆ",
"ld_refNoteDriver": "ಇದು ನಿಮಗೆ ತೋರಿಸಿದ ಬೆಲೆ. ಅಂತಿಮ ಬೆಲೆಯನ್ನು ಚಾಲಕರ ಜೊತೆ ನೇರವಾಗಿ ನಿರ್ಧರಿಸಲಾಗುತ್ತದೆ.",
"ld_callDriver": "ಚಾಲಕರಿಗೆ ಕರೆ ಮಾಡಿ",
"dp_theDriver": "ಚಾಲಕರು",
"cv_ownerWord": "ಡ್ರೈವರ್",
"hm_nCars": "{n} ಕಾರುಗಳು",
"hm_oneCar": "1 ಕಾರು",
"newPartner": "ಶ್ರಮಿಕದಲ್ಲಿ ಹೊಸ",
"as_title": "ನಿಮ್ಮ ಬಿಸಿನೆಸ್ ಖಾತೆ ಸ್ಥಗಿತಗೊಂಡಿದೆ",
"as_since": "{date} ರಿಂದ",
"as_whatDriver": "ನಿಮ್ಮ ಡ್ರೈವರ್ ಪ್ರೊಫೈಲ್ ಗ್ರಾಹಕರಿಗೆ ಕಾಣುವುದಿಲ್ಲ, ಹೊಸ ಹೈರ್ ವಿನಂತಿಗಳು ಬರುವುದಿಲ್ಲ.",
"as_whatCars": "ನಿಮ್ಮ ಕಾರುಗಳು ಗ್ರಾಹಕರಿಗೆ ಕಾಣುವುದಿಲ್ಲ, ಹೊಸ ಲೀಡ್‌ಗಳು ಬರುವುದಿಲ್ಲ.",
"as_reason": "ನೀಡಿದ ಕಾರಣ:",
"as_else": "ಉಳಿದೆಲ್ಲವೂ ಕೆಲಸ ಮಾಡುತ್ತದೆ. ಗ್ರಾಹಕರಾಗಿ ಕ್ಯಾಬ್‌ಗಳನ್ನು ನೋಡಬಹುದು, ಡ್ರೈವರ್‌ಗೆ ಕರೆ ಮಾಡಿ ಪ್ರಯಾಣ ಬುಕ್ ಮಾಡಬಹುದು, ನಿಮ್ಮ ಹಳೆಯ ದಾಖಲೆಗಳು ಇಲ್ಲೇ ಇರುತ್ತವೆ.",
"as_lift": "ಸ್ಥಗಿತವನ್ನು ನಮ್ಮ ತಂಡ ಮಾತ್ರ ತೆಗೆಯಬಹುದು.",
"as_liftCall": "ಶ್ರಮಿಕಕ್ಕೆ ಕರೆ ಮಾಡಿ ನಿಮ್ಮ ನೋಂದಾಯಿತ ಮೊಬೈಲ್ ನಂಬರ್ ತಿಳಿಸಿ.",
"as_call": "ಶ್ರಮಿಕಕ್ಕೆ ಕರೆ · {phone}",
"lc_fee": "ಲೀಡ್ ಶುಲ್ಕ",
"lc_free": "ಉಚಿತ",
"lc_noCharges": "ಇನ್ನೂ ಲೀಡ್ ಶುಲ್ಕ ಇಲ್ಲ",
"lc_andAbove": "{min} ಮತ್ತು ಹೆಚ್ಚು",
"lc_ladderCar": "ಕಾರು ಮತ್ತು ಕ್ಯಾಬ್ ಖಾತೆಗಳು",
"lc_ladderHire": "ಹೈರ್ ಡ್ರೈವರ್ ಖಾತೆಗಳು",
"lc_bandCar": "ಗ್ರಾಹಕರಿಗೆ ಹೇಳಿದ ಪ್ರಯಾಣ ದರದ ಪ್ರಕಾರ",
"lc_bandHire": "ಗ್ರಾಹಕರಿಗೆ ಹೇಳಿದ ಡ್ಯೂಟಿ ದರದ ಪ್ರಕಾರ",
"lc_sub": "ಒಬ್ಬ ಗ್ರಾಹಕರ ವಿಚಾರಣೆಗೆ ನಿಮಗೆ ಆಗುವ ವೆಚ್ಚ.",
"lc_loading": "ಈಗಿನ ಶುಲ್ಕಗಳನ್ನು ತರುತ್ತಿದ್ದೇವೆ…",
"lc_loadFail": "ಲೀಡ್ ದರಗಳನ್ನು ತರಲು ಆಗಲಿಲ್ಲ.",
"lc_freeNow": "ಲೀಡ್‌ಗಳು ಈಗ ಉಚಿತ",
"lc_freeText": "ಕೆಳಗಿನ ಪ್ರತಿ ಲೀಡ್ ಇಂದು ನಿಮಗೆ ಉಚಿತ. ನಿಮ್ಮ ವಾಲೆಟ್‌ನಿಂದ ಏನೂ ಕಡಿತವಾಗುವುದಿಲ್ಲ, ಕಡಿಮೆ ಬ್ಯಾಲೆನ್ಸ್‌ಗಾಗಿ ಯಾವ ಲೀಡ್ ಕೂಡ ನಿಲ್ಲುವುದಿಲ್ಲ.",
"lc_validTill": "ಆಫರ್ {date} ವರೆಗೆ.",
"lc_worth": "ಕೆಳಗಿನ ದರಗಳು ಒಂದು ಲೀಡ್‌ನ ಮೌಲ್ಯ - ಶುಲ್ಕ ಆರಂಭವಾಗುವ ದಿನ ಆಶ್ಚರ್ಯ ಆಗದಂತೆ ತೋರಿಸುತ್ತಿದ್ದೇವೆ. ಆ ದಿನಕ್ಕೆ ಮೊದಲೇ ತಿಳಿಸುತ್ತೇವೆ.",
"lc_active": "ಲೀಡ್ ಶುಲ್ಕ ಜಾರಿಯಲ್ಲಿದೆ",
"lc_activeText": "ನಿಮಗೆ ಬರುವ ಪ್ರತಿ ಲೀಡ್‌ಗೆ ಕೆಳಗಿನ ಶುಲ್ಕವನ್ನು ನಿಮ್ಮ ವಾಲೆಟ್‌ನಿಂದ ಕಡಿತಗೊಳಿಸಲಾಗುತ್ತದೆ.",
"lc_tripFare": "ಪ್ರಯಾಣ ದರ",
"lc_good": "ತಿಳಿದುಕೊಳ್ಳಿ",
"lc_g1": "ನೀವು ಪಾವತಿಸುವುದು ಲೀಡ್‌ಗೆ - ಗ್ರಾಹಕರ ವಿಚಾರಣೆಗೆ - ಪ್ರಯಾಣದ ಮೇಲೆ ಕಮಿಷನ್ ಅಲ್ಲ. ಗ್ರಾಹಕರು ನೀಡುವುದು ನಿಮ್ಮದೇ.",
"lc_g2": "ಶುಲ್ಕ ಆ ಗ್ರಾಹಕರಿಗೆ ಹೇಳಿದ ದರವನ್ನು ಅವಲಂಬಿಸಿದೆ, ಆದ್ದರಿಂದ ಸಣ್ಣ ಪ್ರಯಾಣಕ್ಕೆ ದೊಡ್ಡ ಪ್ರಯಾಣದ ಶುಲ್ಕ ಎಂದಿಗೂ ಬರುವುದಿಲ್ಲ.",
"lc_g3": "ಅದೇ ಗ್ರಾಹಕರು ಬೇಗ ಮತ್ತೆ ಕರೆ ಮಾಡಿದರೆ, ಅದು ಹೊಸ ಲೀಡ್ ಅಲ್ಲ.",
"lc_g4": "ಈ ಶುಲ್ಕಗಳು ಬದಲಾಗಬಹುದು. ಪ್ರತಿ ಲೀಡ್ ಬಂದ ದಿನ ಅದಕ್ಕೆ ಎಷ್ಟು ಆಯಿತು ಎಂಬುದು ನಿಮ್ಮ ಲೀಡ್ ಇತಿಹಾಸದಲ್ಲಿ ಯಾವಾಗಲೂ ಕಾಣುತ್ತದೆ.",
"dd_kycTitle": "ಲೀಡ್‌ಗಳು ಬರಲು ಇವುಗಳನ್ನು ಪೂರ್ಣಗೊಳಿಸಿ",
"dd_kycBasic": "ಮೂಲ ವಿವರಗಳು",
"dd_kycEmergency": "ತುರ್ತು ಸಂಪರ್ಕ",
"dd_kycLicence": "ಲೈಸೆನ್ಸ್",
"dd_kycPhoto": "ಫೋಟೋ",
"dd_kycReview": "ನಿಮ್ಮ ವಿವರಗಳನ್ನು ಪರಿಶೀಲಿಸಲಾಗುತ್ತಿದೆ",
"dd_kycReviewSub": "ಶ್ರಮಿಕ ನಿಮ್ಮ ಪ್ರೊಫೈಲ್ ನೋಡುತ್ತಿದೆ.",
"dd_rbNew": "ಹೊಸ ಚಾಲಕ - ಇನ್ನೂ ರೇಟಿಂಗ್ ಇಲ್ಲ",
"dd_rbNewSub": "ಪ್ರಯಾಣಗಳನ್ನು ಮುಗಿಸಿ, ಗ್ರಾಹಕರಿಂದ ರೇಟಿಂಗ್ ಕೇಳಿ - ಉತ್ತಮ ರೇಟಿಂಗ್ ಇದ್ದರೆ ಪಟ್ಟಿಯಲ್ಲಿ ಮೇಲೆ ಬರುತ್ತೀರಿ.",
"dd_rbLine": "ರೇಟಿಂಗ್ {r} · {tier} · {ratings}",
"dd_tSusp": "ನಿಲ್ಲಿಸಲಾಗಿದೆ",
"dd_cSusp": "ನೀವು ಬರಲಿಲ್ಲ ಎಂದು ಗ್ರಾಹಕರು ಒಂದಕ್ಕಿಂತ ಹೆಚ್ಚು ಬಾರಿ ತಿಳಿಸಿದ್ದರಿಂದ ನಿಲ್ಲಿಸಲಾಗಿದೆ.",
"dd_tPriority": "ಆದ್ಯತೆ",
"dd_cPriority": "ಗ್ರಾಹಕರ ಹುಡುಕಾಟದಲ್ಲಿ ನೀವು ಮೇಲೆ ಕಾಣುತ್ತೀರಿ.",
"dd_tStandard": "ಸಾಮಾನ್ಯ",
"dd_cStandard": "ಗ್ರಾಹಕರ ಹುಡುಕಾಟದಲ್ಲಿ ಸಾಮಾನ್ಯ ಸ್ಥಾನ.",
"dd_tWarning": "ಎಚ್ಚರಿಕೆ",
"dd_cWarning": "ನಿಮ್ಮ ಪ್ರೊಫೈಲ್‌ನಲ್ಲಿ ಎಚ್ಚರಿಕೆ ಕಾಣುತ್ತದೆ, ಶ್ರಮಿಕ ಪರಿಶೀಲಿಸುತ್ತದೆ.",
"dd_tCritical": "ಗಂಭೀರ",
"dd_cCritical": "ಶ್ರಮಿಕ ನಿಮ್ಮ ಪ್ರೊಫೈಲ್ ಪರಿಶೀಲಿಸುವವರೆಗೆ ಹೊಸ ಲೀಡ್‌ಗಳನ್ನು ನಿಲ್ಲಿಸಲಾಗಿದೆ.",
"dd_liTotal": "ಬಂದ ಲೀಡ್‌ಗಳು",
"dd_liMonth": "ಈ ತಿಂಗಳು",
"dd_liFees": "ಲೀಡ್ ಶುಲ್ಕ",
"dd_liConv": "{pct}% ಪ್ರಯಾಣಗಳಾದವು · ನೀವು ಗುರುತಿಸಿದ {decided}ರಲ್ಲಿ {won}",
"dd_psTitle": "ಪ್ರೊಫೈಲ್ ಬಲ",
"dd_psFull": "✅ ಪೂರ್ಣ ಪ್ರೊಫೈಲ್ - ಹುಡುಕಾಟದಲ್ಲಿ ಮೇಲೆ ಕಾಣುತ್ತೀರಿ",
"dd_psGood": "ಉತ್ತಮ ಪ್ರೊಫೈಲ್",
"dd_psLow": "⚠️ ಪ್ರೊಫೈಲ್ ಪೂರ್ಣವಾಗಿಲ್ಲ - ಗ್ರಾಹಕರಿಗೆ ಕಡಿಮೆ ಕಾಣುತ್ತೀರಿ",
"dd_psRank": "ಹೈರ್ ಡ್ರೈವರ್ ಪಟ್ಟಿಯಲ್ಲಿ ಮೇಲೆ ಬರಲು",
"dd_psTip1": "ಲಭ್ಯವಿರಿ. ಲಭ್ಯವಿರುವ ಚಾಲಕರು ಮೊದಲು ಕಾಣುತ್ತಾರೆ.",
"dd_psTip2": "100/100 ತಲುಪಿ. ಪೂರ್ಣ ಪ್ರೊಫೈಲ್‌ಗಳು ಉಳಿದವುಗಳಿಗಿಂತ ಮೊದಲು ಬರುತ್ತವೆ.",
"dd_psTip3": "4★ ಅಥವಾ ಹೆಚ್ಚು ಪಡೆಯಿರಿ. ಸಂತೋಷದ ಗ್ರಾಹಕರಿಂದ ರೇಟಿಂಗ್ ಕೇಳಿ.",
"dd_psMissing": "ಸ್ಕೋರ್ ಹೆಚ್ಚಿಸಲು ಇವುಗಳನ್ನು ಸೇರಿಸಿ:",
"dd_fPhoto": "ಪ್ರೊಫೈಲ್ ಫೋಟೋ",
"dd_fLicence": "ಚಾಲನಾ ಲೈಸೆನ್ಸ್",
"dd_fBio": "ನಿಮ್ಮ ಬಗ್ಗೆ",
"dd_fGender": "ಲಿಂಗ",
"dd_fAge": "ವಯಸ್ಸು",
"dd_fCity": "ನಗರ",
"dd_fAddress": "ಪೂರ್ಣ ವಿಳಾಸ",
"dd_fAutomatic": "ಆಟೋಮ್ಯಾಟಿಕ್ ಕಾರು ಚಾಲನೆ",
"dd_fTypes": "ನೀವು ಓಡಿಸುವ ಕಾರು ಪ್ರಕಾರಗಳು",
"dd_fOwnRates": "ನಿಮ್ಮ ಸ್ವಂತ ದರಗಳು",
"dd_fWeekly": "ವಾರದ ಲಭ್ಯತೆ",
"dd_fRating": "ಗ್ರಾಹಕ ರೇಟಿಂಗ್ 4+",
"dd_avTitle": "ನಿಮ್ಮ ಲಭ್ಯತೆ",
"dd_avOffline": "ಆಫ್‌ಲೈನ್",
"dd_avHintAvail": "ಗ್ರಾಹಕರು ನಿಮ್ಮನ್ನು ಹುಡುಕಿ ಕರೆ ಮಾಡಬಹುದು.",
"dd_avHintBusy": "ನೀವು ಪಟ್ಟಿಯಲ್ಲಿ ಇರುತ್ತೀರಿ, ಬ್ಯುಸಿ ಎಂದು ತೋರಿಸಲಾಗುತ್ತದೆ.",
"dd_avHintOff": "ಹೊಸ ಲೀಡ್‌ಗಳಿಗೆ ನೀವು ಕಾಣುವುದಿಲ್ಲ.",
"dd_avHintSusp": "ಖಾತೆ ಸ್ಥಗಿತವಾಗಿರುವವರೆಗೆ ಗ್ರಾಹಕರಿಗೆ ಕಾಣುವುದಿಲ್ಲ - ತೆಗೆದ ನಂತರ ಇದು ಮತ್ತೆ ಅನ್ವಯಿಸುತ್ತದೆ.",
"dd_availFail": "ನಿಮ್ಮ ಲಭ್ಯತೆ ಬದಲಿಸಲು ಆಗಲಿಲ್ಲ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
"dd_leadFail": "ಈ ಲೀಡ್‌ಗೆ ನಿಮ್ಮ ಉತ್ತರ ಉಳಿಸಲು ಆಗಲಿಲ್ಲ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
"dd_rates": "ನಿಮ್ಮ ದರಗಳು",
"dd_gBoth": "ಸ್ಥಳೀಯ ಮತ್ತು ಹೊರ ಊರು",
"dd_nightHalt": "ರಾತ್ರಿ ತಂಗುವಿಕೆ",
"dd_usual": "ಸಾಮಾನ್ಯ ₹{n}",
"dd_max": "ಗರಿಷ್ಠ ₹{n}",
"dd_cityStd": "ನಗರದ ಸಾಮಾನ್ಯ ದರ",
"dd_followsCity": "ನಗರದ ದರ, ಅದರೊಂದಿಗೆ ಬದಲಾಗುತ್ತದೆ",
"dd_above": "ಸಾಮಾನ್ಯಕ್ಕಿಂತ ಹೆಚ್ಚು",
"dd_below": "ಸಾಮಾನ್ಯಕ್ಕಿಂತ ಕಡಿಮೆ",
"dd_nightRides": "ರಾತ್ರಿ ಪ್ರಯಾಣಗಳು ({from}-{to})",
"dd_yesPct": "ಹೌದು, +{pct}%",
"dd_no": "ಇಲ್ಲ",
"dd_raiseOnce": "ದರಗಳನ್ನು ಯಾವಾಗ ಬೇಕಾದರೂ ಕಡಿಮೆ ಮಾಡಬಹುದು. ಹೆಚ್ಚಿಸುವುದು ದಿನಕ್ಕೆ ಒಮ್ಮೆ - ಮುಂದಿನದು {when} ನಂತರ.",
"dd_ratesSaved": "ದರಗಳನ್ನು ಉಳಿಸಲಾಗಿದೆ.",
"dd_ratesSavedMax": "ದರಗಳನ್ನು ಉಳಿಸಲಾಗಿದೆ. ಕೆಲವನ್ನು ನಿಮ್ಮ ನಗರದ ಗರಿಷ್ಠಕ್ಕೆ ಇಳಿಸಲಾಗಿದೆ.",
"dd_ratesFail": "ನಿಮ್ಮ ದರಗಳನ್ನು ಉಳಿಸಲು ಆಗಲಿಲ್ಲ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
"dd_pending": "ಒಂದು ಬದಲಾವಣೆ ಅನುಮೋದನೆಗಾಗಿ ಕಾಯುತ್ತಿದೆ. ಪರಿಶೀಲನೆ ಆಗುವವರೆಗೆ ನಿಮ್ಮ ಈಗಿನ ವಿವರಗಳೇ ಕಾಣುತ್ತವೆ.",
"dd_pickImage": "ದಯವಿಟ್ಟು ಫೋಟೋ ಆಯ್ಕೆಮಾಡಿ.",
"dd_tooBig": "ಆ ಫೋಟೋ ತುಂಬಾ ದೊಡ್ಡದು. 6ಎಂಬಿ ಗಿಂತ ಕಡಿಮೆಯದನ್ನು ಆಯ್ಕೆಮಾಡಿ.",
"dd_sentApproval": "ಅನುಮೋದನೆಗೆ ಕಳುಹಿಸಲಾಗಿದೆ.",
"dd_photoFail": "ನಿಮ್ಮ ಫೋಟೋ ಕಳುಹಿಸಲು ಆಗಲಿಲ್ಲ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
"dd_changePhoto": "ಫೋಟೋ ಬದಲಿಸಿ",
"dd_licExpired": "ಚಾಲನಾ ಲೈಸೆನ್ಸ್ ಅವಧಿ ಮುಗಿದಿದೆ",
"dd_licToday": "ಲೈಸೆನ್ಸ್ ಇಂದು ಅವಧಿ ಮುಗಿಯುತ್ತದೆ",
"dd_licOneDay": "ಲೈಸೆನ್ಸ್ 1 ದಿನದಲ್ಲಿ ಅವಧಿ ಮುಗಿಯುತ್ತದೆ",
"dd_licDays": "ಲೈಸೆನ್ಸ್ {n} ದಿನಗಳಲ್ಲಿ ಅವಧಿ ಮುಗಿಯುತ್ತದೆ",
"dd_licUpdate": "ಲೀಡ್‌ಗಳು ಬರುತ್ತಿರಲು ನಿಮ್ಮ ಲೈಸೆನ್ಸ್ ಅಪ್‌ಡೇಟ್ ಮಾಡಿ.",
"dd_lowFree": "ವಾಲೆಟ್ ₹200 ಕ್ಕಿಂತ ಕಡಿಮೆ (₹{bal})",
"dd_lowFreeText": "ಲೀಡ್‌ಗಳು ಈಗ ಉಚಿತ - ಏನೂ ಕಡಿತವಾಗುವುದಿಲ್ಲ. ಲೀಡ್ ಶುಲ್ಕ ಆರಂಭವಾಗುವ ಮೊದಲು ಹಣ ಸೇರಿಸಿ.",
"dd_lowPaid": "ವಾಲೆಟ್ ಬ್ಯಾಲೆನ್ಸ್ ಕಡಿಮೆ (₹{bal})",
"dd_lowPaidText": "ಲೀಡ್‌ಗಳು ಬರುತ್ತಿರಲು ಹಣ ಸೇರಿಸಿ.",
"dd_leadHistory": "ಲೀಡ್ ಇತಿಹಾಸ",
"dd_leadHistorySub": "ಶ್ರಮಿಕದ ಮೂಲಕ ನಿಮಗೆ ಕರೆ ಮಾಡಿದ ಗ್ರಾಹಕರು",
"dd_noLeads": "ಇನ್ನೂ ಲೀಡ್‌ಗಳಿಲ್ಲ. ಶ್ರಮಿಕದ ಮೂಲಕ ಗ್ರಾಹಕರು ಕರೆ ಮಾಡಿದಾಗ ಇಲ್ಲಿ ಕಾಣುತ್ತದೆ.",
"dd_pendingVer": "ಪರಿಶೀಲನೆಗಾಗಿ ಕಾಯುತ್ತಿದೆ",
"dd_details": "ವಿವರಗಳು",
"dd_exp": "ಅನುಭವ",
"dd_trips": "ಪ್ರಯಾಣದ ಪ್ರಕಾರಗಳು",
"dd_tripsPick": "ಕನಿಷ್ಠ ಒಂದು ರೀತಿಯ ಪ್ರಯಾಣವನ್ನು ಆಯ್ಕೆಮಾಡಿ.",
"dd_tripsFail": "ಉಳಿಸಲಾಗಲಿಲ್ಲ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
"dd_langs": "ಭಾಷೆಗಳು",
"dd_docs": "ನಿಮ್ಮ ದಾಖಲೆಗಳು",
"dd_mobileLocked": "ಪರಿಶೀಲಿಸಲಾಗಿದೆ · ಬದಲಿಸಲಾಗದು",
"dd_licFront": "ಲೈಸೆನ್ಸ್ - ಮುಂಭಾಗ",
"dd_licBack": "ಲೈಸೆನ್ಸ್ - ಹಿಂಭಾಗ",
"dd_notUploaded": "ಅಪ್‌ಲೋಡ್ ಮಾಡಿಲ್ಲ",
"dd_docsNote": "ಲೈಸೆನ್ಸ್ ಅಥವಾ ಮೊಬೈಲ್ ನಂಬರ್ ಬದಲಿಸಲು ಶ್ರಮಿಕಕ್ಕೆ ಕರೆ ಮಾಡಿ - ಬದಲಾಗುವ ಮೊದಲು ಇವುಗಳನ್ನು ಮತ್ತೆ ಪರಿಶೀಲಿಸಲಾಗುತ್ತದೆ.",
"dd_editProfile": "ಪ್ರೊಫೈಲ್ ಮತ್ತು ದಾಖಲೆಗಳನ್ನು ಬದಲಿಸಿ",
"dd_referrals": "ರೆಫರಲ್‌ಗಳು",
"dd_earned": "ಗಳಿಸಿದ್ದು",
"dp_pDriving": "ಚಾಲನಾ ಕೌಶಲ",
"dp_slabLocal": "ಸ್ಥಳೀಯ - {n} ಗಂಟೆವರೆಗೆ",
"dp_slabOut": "ಹೊರ ಊರು - {n} ಗಂಟೆವರೆಗೆ",
"dp_nightRide": "ರಾತ್ರಿ ಪ್ರಯಾಣ +{pct}%",
"dp_nightHalt": "ರಾತ್ರಿ ತಂಗುವಿಕೆ × {n}",
"dp_notFound": "ಚಾಲಕ ಸಿಗಲಿಲ್ಲ",
"dp_notFoundText": "ಈ ಚಾಲಕ ಈಗ ಪಟ್ಟಿಯಲ್ಲಿಲ್ಲ.",
"dp_backDrivers": "ಚಾಲಕರ ಪಟ್ಟಿಗೆ ಹಿಂತಿರುಗಿ",
"dp_available": "ಈಗ ಲಭ್ಯ",
"dp_busy": "ಈಗ ಬ್ಯುಸಿ",
"dp_offline": "ಈಗ ಲಭ್ಯವಿಲ್ಲ",
"dp_canDrive": "ಚಲಾಯಿಸಬಲ್ಲವು",
"dp_moreTypes": "+{n} ಇನ್ನಷ್ಟು",
"dp_new": "ಹೊಸ ಚಾಲಕ",
"dp_tooLong": "ಈ ಪ್ರಯಾಣ ಒಬ್ಬ ಚಾಲಕರಿಗೆ ತುಂಬಾ ದೀರ್ಘ.",
"dp_price": "ಚಾಲಕರ ದರ",
"dp_driverOnly": "ಚಾಲಕರ ಶುಲ್ಕ ಮಾತ್ರ",
"dp_noPrice": "ಈ ಪ್ರಯಾಣಕ್ಕೆ ಇನ್ನೂ ದರವಿಲ್ಲ - ಕರೆ ಮಾಡಿ ಕೇಳಿ.",
"dp_callFail": "ಕರೆ ಸಂಪರ್ಕಿಸಲು ಆಗಲಿಲ್ಲ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
"dp_trustDirect": "ಚಾಲಕರೊಂದಿಗೆ ನೇರವಾಗಿ ಮಾತನಾಡಿ",
"wl_title": "ಶ್ರಮಿಕ ವಾಲೆಟ್",
"wl_balance": "ಬ್ಯಾಲೆನ್ಸ್",
"wl_recent": "ಇತ್ತೀಚಿನ ವಹಿವಾಟುಗಳು",
"wl_needAmt": "ಬ್ಯಾಲೆನ್ಸ್ ಸಾಕಾಗುತ್ತಿಲ್ಲ. ಮುಂದುವರಿಯಲು ₹{amt} ರೀಚಾರ್ಜ್ ಮಾಡಿ.",
"wl_badAmt": "ಸರಿಯಾದ ಮೊತ್ತ ನಮೂದಿಸಿ.",
"wl_done": "ರೀಚಾರ್ಜ್ ಆಯಿತು.",
"wl_payFail": "ಪಾವತಿ ವಿಫಲವಾಗಿದೆ: {reason}",
"wl_payStartFail": "ಪಾವತಿ ಆರಂಭಿಸಲು ಆಗಲಿಲ್ಲ.",
"wl_txnOther": "ವಾಲೆಟ್ ನಮೂದು",
"wl_balAfter": "ಬ್ಯಾಲೆನ್ಸ್ {amt}",
"wg_lowTitle": "ನಿಮ್ಮ ಉಚಿತ ಕರೆಗಳು ಮುಗಿದಿವೆ",
"wg_lowText": "ಈಗ ಸಂಪರ್ಕವಾಗುವ ಪ್ರತಿ ಕರೆಗೆ ₹{fee}. ಕರೆ ಸಂಪರ್ಕವಾದರೆ ಮಾತ್ರ ನಿಮ್ಮ ವಾಲೆಟ್‌ನಿಂದ ತೆಗೆದುಕೊಳ್ಳುತ್ತೇವೆ.",
"wg_balance": "ವಾಲೆಟ್ ಬ್ಯಾಲೆನ್ಸ್: ₹{bal}",
"wg_resets": "ಉಚಿತ ಕರೆಗಳು ಮತ್ತೆ {time} ಕ್ಕೆ ಸಿಗುತ್ತವೆ",
"wg_pick": "ಮೊತ್ತ ಆಯ್ಕೆಮಾಡಿ",
"wg_add": "₹{amt} ಸೇರಿಸಿ",
"wg_paidTitle": "ಈ ಕರೆಗೆ ₹{fee}",
"wg_paidText": "ಕರೆ ಸಂಪರ್ಕವಾದರೆ ಮಾತ್ರ ನಿಮ್ಮ ವಾಲೆಟ್‌ನಿಂದ ತೆಗೆದುಕೊಳ್ಳುತ್ತೇವೆ. ಸಂಪರ್ಕವಾಗದಿದ್ದರೆ ಏನೂ ತೆಗೆದುಕೊಳ್ಳುವುದಿಲ್ಲ.",
"wg_paidCall": "ಕರೆ ಮಾಡಿ · ₹{fee}",
"wg_okTitle": "ನಿಮ್ಮ ವಾಲೆಟ್‌ಗೆ ₹{amt} ಜಮೆಯಾಗಿದೆ",
"wg_okText": "ಹೊಸ ಬ್ಯಾಲೆನ್ಸ್: ₹{bal}",
"wg_callNow": "ಈಗ ಕರೆ ಮಾಡಿ",
"wg_done": "ಸರಿ",
"wg_failTitle": "ಪಾವತಿ ಆಗಲಿಲ್ಲ",
"wg_failText": "ನಿಮ್ಮ ವಾಲೆಟ್‌ಗೆ ಹಣ ಸೇರಿಲ್ಲ. ಬ್ಯಾಂಕ್‌ನಿಂದ ಹಣ ಕಡಿತವಾಗಿದ್ದರೆ, 5–7 ಕೆಲಸದ ದಿನಗಳಲ್ಲಿ ತಾನಾಗಿಯೇ ಹಿಂತಿರುಗುತ್ತದೆ.",
"wg_tryAgain": "ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ",
"wg_pendingTitle": "ನಿಮ್ಮ ಪಾವತಿಯನ್ನು ಖಚಿತಪಡಿಸುತ್ತಿದ್ದೇವೆ",
"wg_pendingText": "ಇದಕ್ಕೆ ಒಂದು ನಿಮಿಷ ಆಗಬಹುದು. ಬ್ಯಾಲೆನ್ಸ್ ತಾನಾಗಿಯೇ ನವೀಕರಣವಾಗುತ್ತದೆ - ದಯವಿಟ್ಟು ಮತ್ತೆ ಪಾವತಿಸಬೇಡಿ.",
"wg_soonTitle": "ಹಣ ಸೇರಿಸುವುದು ಶೀಘ್ರದಲ್ಲೇ",
"wg_soonText": "ಪಾವತಿಗಳು ಇನ್ನೂ ಆರಂಭವಾಗಿಲ್ಲ. ನಿಮ್ಮ ಉಚಿತ ಕರೆಗಳು ಮುಂದುವರಿಯುತ್ತವೆ.",
"wg_startFail": "ಪಾವತಿ ಪುಟ ತೆರೆಯಲಾಗಲಿಲ್ಲ. ಇಂಟರ್ನೆಟ್ ಪರಿಶೀಲಿಸಿ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
"wg_extraTitle": "ಹೆಚ್ಚುವರಿ ಕರೆ - ₹{fee}",
"wg_extraText": "ನಿಜವಾದ ಬುಕಿಂಗ್‌ಗಾಗಿ {h} ಗಂಟೆಗೆ {n} ಉಚಿತ ಕರೆಗಳು.",
"wg_extraTalk": "ಈ ಕರೆಯಲ್ಲಿ ಡ್ರೈವರ್ ಜೊತೆ ನೇರವಾಗಿ ಮಾತನಾಡಿ.",
"wg_balanceAfter": "ಬ್ಯಾಲೆನ್ಸ್ ₹{bal} → ₹{after}",
"wg_payWallet": "ವಾಲೆಟ್‌ನಿಂದ ₹{fee} · ಕರೆ ಮಾಡಿ",
"wg_payUpi": "₹{amt} ಪಾವತಿಸಿ ಕರೆ ಮಾಡಿ",
"wg_freeAfter": "{time} ನಂತರ ಉಚಿತ",
"wg_lastTitle": "ಇದು ನಿಮ್ಮ ಕೊನೆಯ ಉಚಿತ ಕರೆ ({n}/{n})",
"wg_lastText": "{time} ನಂತರ ಮತ್ತೆ {n} ಉಚಿತ ಕರೆಗಳು.",
"wg_call": "ಕರೆ ಮಾಡಿ",
"wg_ownTitle": "ಇದು ನಿಮ್ಮ ಸ್ವಂತ ಕಾರು",
"wg_ownProfile": "ಇದು ನಿಮ್ಮ ಸ್ವಂತ ಪ್ರೊಫೈಲ್",
"wg_ownText": "ನಿಮ್ಮ ಸ್ವಂತ ಖಾತೆಗೆ ನೀವೇ ಲೀಡ್ ಮಾಡಲು ಸಾಧ್ಯವಿಲ್ಲ.",
"ib_title": "ತಕ್ಷಣದ ಬುಕಿಂಗ್",
"ib_text": "8 ಗಂಟೆಯೊಳಗೆ ಆರಂಭವಾಗುವ ಟ್ರಿಪ್‌ಗಳಿಗೆ ಲಭ್ಯತೆಯ ಆಧಾರದ ಮೇಲೆ ಶ್ರಮಿಕ ಕಾರನ್ನು ಸೂಚಿಸುತ್ತದೆ.",
"ib_seats": "ಎಷ್ಟು ಜನ?",
"ib_seat5": "1–4 ಜನ",
"ib_seat7": "5–6 ಜನ",
"ib_seat12": "7–12 ಜನ",
"ib_model": "ಕಾರು ಮಾದರಿ (ಐಚ್ಛಿಕ)",
"ib_modelHint": "ಉದಾ: ಇನ್ನೋವಾ",
"ib_fare": "ಈ ಟ್ರಿಪ್ ದರ: ₹{min} – ₹{max}",
"ib_pickSeats": "ಸೀಟುಗಳನ್ನು ಆಯ್ಕೆಮಾಡಿ",
"ib_book": "ಈಗ ಬುಕ್ ಮಾಡಿ",
"ib_finding": "ನಿಮ್ಮ ಕಾರು ಖಚಿತಪಡಿಸುತ್ತಿದ್ದೇವೆ…",
"ib_confirmed": "ಬುಕಿಂಗ್ ಖಚಿತ",
"ib_callYou": "ಡ್ರೈವರ್ 10 ನಿಮಿಷದಲ್ಲಿ ನಿಮಗೆ ಕರೆ ಮಾಡುತ್ತಾರೆ.",
"ib_team": "ನಮ್ಮ ತಂಡ 10 ನಿಮಿಷಗಳಲ್ಲಿ ನಿಮಗೆ ಕರೆ ಮಾಡುತ್ತದೆ.",
"ib_error": "ಬುಕ್ ಆಗಲಿಲ್ಲ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
"ob_title": "⚡ ತುರ್ತು ಟ್ರಿಪ್?",
"ob_sub": "ಶ್ರಮಿಕ ಸೂಚಿಸಿದ ಕಾರು 2–10 ನಿಮಿಷದಲ್ಲಿ · ₹{min} – ₹{max}",
"ib_textAny": "ಲಭ್ಯತೆಯ ಆಧಾರದ ಮೇಲೆ ಶ್ರಮಿಕ ಕಾರನ್ನು ಸೂಚಿಸುತ್ತದೆ.",
"ib_urgentTitle": "⚡ ಇದು ತುರ್ತು ಟ್ರಿಪ್",
"ib_urgentText": "8 ಗಂಟೆಯೊಳಗಿನ ಪ್ರಯಾಣಕ್ಕೆ ಶ್ರಮಿಕ ಸೂಚಿಸಿದ ಕಾರು - ಸಾಮಾನ್ಯವಾಗಿ 2–10 ನಿಮಿಷಗಳಲ್ಲಿ ಖಚಿತ. ಒಬ್ಬೊಬ್ಬರಿಗೂ ಕರೆ ಮಾಡುವ ಅಗತ್ಯವಿಲ್ಲ.",
"ib_urgentBtn": "⚡ 2–10 ನಿಮಿಷದಲ್ಲಿ ಕಾರು ಬುಕ್ ಮಾಡಿ",
"ib_any": "ಯಾವುದಾದರೂ",
"ib_cars": "{n} ಕಾರುಗಳು",
"ib_wait": "ಸಾಮಾನ್ಯವಾಗಿ 2–10 ನಿಮಿಷ. 10 ನಿಮಿಷದಲ್ಲಿ ಕಾರು ಖಚಿತವಾಗದಿದ್ದರೆ, ನಮ್ಮ ತಂಡ ನಿಮಗೆ ಕರೆ ಮಾಡುತ್ತದೆ.",
"ib_callDriver": "📞 ಡ್ರೈವರ್‌ಗೆ ಕರೆ ಮಾಡಿ",
"ib_private": "ಶ್ರಮಿಕ ನಂಬರ್ ಮೂಲಕ - ನಿಮ್ಮ ನಂಬರ್ ಡ್ರೈವರ್‌ಗೆ ಕಾಣುವುದಿಲ್ಲ",
"ib_calling": "📞 ನಿಮ್ಮ ಫೋನ್ ಈಗ ರಿಂಗ್ ಆಗುತ್ತದೆ - ಎತ್ತಿದ ತಕ್ಷಣ ಡ್ರೈವರ್‌ಗೆ ಜೋಡಿಸುತ್ತೇವೆ.",
"tr_wants": "ಗ್ರಾಹಕರು ಕೇಳಿದ್ದು: {what}",
"wl_txnCall": "ಕರೆ ಶುಲ್ಕ",
"wl_minMax": "₹{min} ರಿಂದ ₹{max} ವರೆಗೆ ಸೇರಿಸಿ.",
"sp_title": "ಸಹಾಯ",
"sp_callTitle": "ಶ್ರಮಿಕದ ಜೊತೆ ಮಾತನಾಡಿ",
"sp_callText": "ಕರೆ, ದರ, ಕಾರು ಅಥವಾ ಚಾಲಕರ ಕುರಿತ ಯಾವುದೇ ಸಮಸ್ಯೆಗೆ.",
"sp_callBtn": "ಶ್ರಮಿಕಕ್ಕೆ ಕರೆ ಮಾಡಿ",
"sp_faqTitle": "ಸಾಮಾನ್ಯ ಪ್ರಶ್ನೆಗಳು",
"sp_q1": "ಕಾರು ಹೇಗೆ ಹುಡುಕುವುದು?",
"sp_a1": "ಪಿಕಪ್, ಡ್ರಾಪ್ ಆಯ್ಕೆಮಾಡಿ. ಕಾರುಗಳು ಮತ್ತು ಅವುಗಳ ದರ ಹೋಲಿಸಿ, ನಂತರ ಕರೆ ಒತ್ತಿ ಡ್ರೈವರ್ ಜೊತೆ ನೇರವಾಗಿ ಮಾತನಾಡಿ.",
"sp_q2": "ಬುಕಿಂಗ್ ಶುಲ್ಕ ಇದೆಯೇ?",
"sp_a2": "ಇಲ್ಲ. ಆಪ್‌ನಲ್ಲಿ ಏನೂ ಬುಕ್ ಆಗುವುದಿಲ್ಲ - ಪ್ರಯಾಣವನ್ನು ಡ್ರೈವರ್ ಜೊತೆ ಮಾತನಾಡಿ ನಿಗದಿಪಡಿಸಿ, ಅವರಿಗೇ ನೇರವಾಗಿ ಪಾವತಿಸಿ.",
"sp_q3": "ಪ್ರಯಾಣ ಹೇಗೆ ರದ್ದು ಮಾಡುವುದು?",
"sp_a3": "ಡ್ರೈವರ್‌ಗೆ ಕರೆ ಮಾಡಿ ತಿಳಿಸಿ. ಪ್ರಯಾಣ ನಿಮ್ಮ ಮತ್ತು ಅವರ ನಡುವೆ ನಿಗದಿಯಾದದ್ದು, ಆದ್ದರಿಂದ ಇಲ್ಲಿ ರದ್ದು ಮಾಡಲು ಯಾವುದೇ ಬುಕಿಂಗ್ ಇಲ್ಲ. ನಿಮ್ಮ ವಿಚಾರಣೆ ಹೇಗಿದ್ದರೂ ಇತಿಹಾಸದಲ್ಲಿ ಇರುತ್ತದೆ.",
"sp_q4": "ಹೇಗೆ ಪಾವತಿಸುವುದು?",
"sp_a4": "ಡ್ರೈವರ್‌ಗೆ ನೇರವಾಗಿ ಪಾವತಿಸಿ - ನಗದು ಅಥವಾ ಯುಪಿಐ, ನೀವು ಒಪ್ಪಿದಂತೆ.",
"sp_q5": "ದರದಲ್ಲಿ ಸೇರದಿರುವುದು ಏನು?",
"sp_a5": "ಟೋಲ್, ಪಾರ್ಕಿಂಗ್, ರಾಜ್ಯ ತೆರಿಗೆ - ಚಾಲಕರಿಗೆ ನೇರವಾಗಿ ಪಾವತಿಸಿ. ಹೆಚ್ಚುವರಿ ಕಿ.ಮೀ ಅಥವಾ ಗಂಟೆಗೆ ಹೆಚ್ಚುವರಿ ದರ.",
"sp_q6": "ಸಮಸ್ಯೆ ಹೇಗೆ ತಿಳಿಸುವುದು?",
"sp_a6": "ಮೇಲಿನ ಬಟನ್‌ನಿಂದ ಶ್ರಮಿಕಕ್ಕೆ ಕರೆ ಮಾಡಿ. ಯಾವ ಪ್ರಯಾಣ ಎಂದು ಹೇಳಲು, ಇತಿಹಾಸದಲ್ಲಿ ಆ ವಿಚಾರಣೆ ತೆರೆದಿಡಿ.",
"sp_footer": "ಶ್ರಮಿಕದ ಸಹಾಯ · support@sramika.com",
"nc_soon": "ಶೀಘ್ರದಲ್ಲೇ",
"nc_title": "ಶ್ರಮಿಕ ಶೀಘ್ರದಲ್ಲೇ {city} ಗೆ ಬರುತ್ತಿದೆ",
"nc_titleNoCity": "ಶ್ರಮಿಕ ಶೀಘ್ರದಲ್ಲೇ ನಿಮ್ಮ ನಗರಕ್ಕೆ ಬರುತ್ತಿದೆ",
"nc_text": "{city} ನಲ್ಲಿ ಕಾರುಗಳು ಮತ್ತು ಚಾಲಕರನ್ನು ಸೇರಿಸುತ್ತಿದ್ದೇವೆ. ನಿಮ್ಮ ಸಂಖ್ಯೆ ನೀಡಿ - ಸಿದ್ಧವಾದಾಗ ವಾಟ್ಸಾಪ್ ನಲ್ಲಿ ತಿಳಿಸುತ್ತೇವೆ.",
"nc_textNoCity": "ನಿಮ್ಮ ನಗರದಲ್ಲಿ ಕಾರುಗಳು ಮತ್ತು ಚಾಲಕರನ್ನು ಸೇರಿಸುತ್ತಿದ್ದೇವೆ. ನಿಮ್ಮ ಸಂಖ್ಯೆ ನೀಡಿ - ಸಿದ್ಧವಾದಾಗ ವಾಟ್ಸಾಪ್ ನಲ್ಲಿ ತಿಳಿಸುತ್ತೇವೆ.",
"nc_expected": "ಆರಂಭದ ನಿರೀಕ್ಷೆ",
"nc_name": "ನಿಮ್ಮ ಹೆಸರು",
"nc_phone": "ವಾಟ್ಸಾಪ್ ಸಂಖ್ಯೆ (10 ಅಂಕಿಗಳು)",
"nc_join": "ಆರಂಭವಾದಾಗ ತಿಳಿಸಿ",
"nc_enterName": "ನಿಮ್ಮ ಹೆಸರು ನಮೂದಿಸಿ.",
"nc_fail": "ಉಳಿಸಲು ಆಗಲಿಲ್ಲ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
"nc_doneTitle": "ನಿಮ್ಮ ಹೆಸರು ನೋಂದಾಯಿತವಾಗಿದೆ",
"nc_doneText": "{city} ನಲ್ಲಿ ಶ್ರಮಿಕ ಆರಂಭವಾದಾಗ ವಾಟ್ಸಾಪ್ ನಲ್ಲಿ ತಿಳಿಸುತ್ತೇವೆ.",
"nc_doneTextNoCity": "ನಿಮ್ಮ ನಗರದಲ್ಲಿ ಶ್ರಮಿಕ ಆರಂಭವಾದಾಗ ವಾಟ್ಸಾಪ್ ನಲ್ಲಿ ತಿಳಿಸುತ್ತೇವೆ.",
"nt_title": "ಅಧಿಸೂಚನೆಗಳು",
"nt_emptyTitle": "ಇನ್ನೂ ಅಧಿಸೂಚನೆಗಳಿಲ್ಲ",
"nt_emptyText": "ನಿಮ್ಮ ವಿಚಾರಣೆಗಳು ಮತ್ತು ಖಾತೆಯ ಸುದ್ದಿಗಳು ಇಲ್ಲಿ ಕಾಣಿಸುತ್ತವೆ.",
"nt_history": "ನನ್ನ ವಿಚಾರಣೆಗಳನ್ನು ನೋಡಿ",
"nt_all": "ಎಲ್ಲಾ",
"nt_ride": "ಪ್ರಯಾಣಗಳು",
"nt_approval": "ಅನುಮೋದನೆಗಳು",
"nt_document": "ದಾಖಲೆಗಳು",
"nt_wallet": "ವಾಲೆಟ್",
"nt_system": "ಅಪ್‌ಡೇಟ್‌ಗಳು",
"nt_unread": "ಹೊಸವು",
"nt_read": "ನೋಡಿದವು",
"nt_important": "ಮುಖ್ಯ",
"nt_noneHere": "{name} ನಲ್ಲಿ ಏನೂ ಇಲ್ಲ.",
"nt_showAll": "ಎಲ್ಲವನ್ನೂ ತೋರಿಸಿ",
"nt_notification": "ಅಧಿಸೂಚನೆ",
"st_confirm": "ದೃಢೀಕರಿಸಿ",
"st_notSignedIn": "ನೀವು ಲಾಗಿನ್ ಆಗಿಲ್ಲ",
"st_signInToManage": "ಪ್ರೊಫೈಲ್ ಮತ್ತು ಸೆಟ್ಟಿಂಗ್‌ಗಳನ್ನು ಬದಲಿಸಲು ಲಾಗಿನ್ ಆಗಿ",
"st_loginSignup": "ಲಾಗಿನ್ / ಸೈನ್ ಅಪ್",
"st_partnerLogin": "ಡ್ರೈವರ್ ಲಾಗಿನ್",
"st_notEditable": "ಬದಲಿಸಲಾಗದು",
"st_usernamePh": "ನಿಮ್ಮ ಬಳಕೆದಾರ ಹೆಸರು",
"st_save": "ಉಳಿಸಿ",
"st_notSet": "ಹೊಂದಿಸಿಲ್ಲ",
"st_edit": "ಬದಲಿಸಿ",
"st_cityPh": "ಉದಾ: ವಿಜಯವಾಡ",
"st_myRating": "ನನ್ನ ರೇಟಿಂಗ್",
"st_footer": "ಶ್ರಮಿಕ 1.0 · ಎಲ್ಲಾ ಡೇಟಾ ಎನ್‌ಕ್ರಿಪ್ಶನ್‌ನಿಂದ ಸುರಕ್ಷಿತ",
"st_nameSaved": "ಬಳಕೆದಾರ ಹೆಸರು ಬದಲಾಗಿದೆ.",
"st_nameFail": "ಬಳಕೆದಾರ ಹೆಸರು ಉಳಿಸಲು ಆಗಲಿಲ್ಲ.",
"st_nfTitle": "ಈ ಪುಟ ಇಲ್ಲ",
"st_nfText": "ಲಿಂಕ್ ಹಳೆಯದಿರಬಹುದು, ಅಥವಾ ವಿಳಾಸದಲ್ಲಿ ತಪ್ಪಿರಬಹುದು. ಎಲ್ಲವೂ ಇಲ್ಲೇ ಇದೆ - ಮುಖಪುಟದಿಂದ ಆರಂಭಿಸಿ.",
"st_nfCar": "ಕಾರು ಹುಡುಕಿ",
"st_nfDriver": "ಚಾಲಕರನ್ನು ಬಾಡಿಗೆಗೆ ಪಡೆಯಿರಿ",
"st_suInvalid": "ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ಪರಿಶೀಲಿಸಿದ ನಂತರವೇ ಈ ಪುಟ ತೆರೆಯುತ್ತದೆ.",
"st_suToLogin": "ಲಾಗಿನ್‌ಗೆ ಹೋಗಿ",
"st_suNameTitle": "ನಿಮ್ಮ ಬಳಕೆದಾರ ಹೆಸರು ಹೊಂದಿಸಿ",
"st_suNameHint": "ಖಾಲಿ ಜಾಗ ಬಳಸಬಹುದು. ನಂತರ ಬದಲಿಸಲು ಆಗುವುದಿಲ್ಲ.",
"st_suNameMissing": "ಮುಂದುವರಿಯಲು ಬಳಕೆದಾರ ಹೆಸರು ನಮೂದಿಸಿ.",
"st_suContinue": "ಮುಂದುವರಿಸಿ",
"st_suPwTitle": "ನಿಮ್ಮ ಪಾಸ್‌ವರ್ಡ್ ಹೊಂದಿಸಿ",
"st_suPwMissing": "ಮುಂದುವರಿಯಲು ಪಾಸ್‌ವರ್ಡ್ ನಮೂದಿಸಿ.",
"st_suPwFail": "ಪಾಸ್‌ವರ್ಡ್ ಹೊಂದಿಸಲು ಆಗಲಿಲ್ಲ.",
"st_suNewPwPh": "ಹೊಸ ಪಾಸ್‌ವರ್ಡ್ ನಮೂದಿಸಿ",
"pl_brand": "ಶ್ರಮಿಕ ಬಿಸಿನೆಸ್",
"pl_portal": "ಡ್ರೈವರ್‌ಗಳಿಗಾಗಿ",
"pl_stepPhone": "ಮೊಬೈಲ್ ನಮೂದಿಸಿ",
"pl_awaiting": "ನಿಮ್ಮ ಖಾತೆ ಇನ್ನೂ ಸಕ್ರಿಯವಾಗಿಲ್ಲ. ಶ್ರಮಿಕವನ್ನು ಸಂಪರ್ಕಿಸಿ.",
"pl_continueFail": "ಮುಂದುವರಿಯಲು ಆಗಲಿಲ್ಲ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
"pl_badPw": "ಪಾಸ್‌ವರ್ಡ್ ತಪ್ಪು. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
"pl_hide": "ಮರೆಮಾಡಿ",
"pl_show": "ತೋರಿಸಿ",
"pl_checking": "ಪರಿಶೀಲಿಸುತ್ತಿದ್ದೇವೆ…",
"pl_continue": "ಮುಂದುವರಿಸಿ →",
"pl_welcomeBack": "ಮರಳಿ ಸ್ವಾಗತ! +91 {phone} ನಿಂದ ಲಾಗಿನ್ ಆಗುತ್ತಿದ್ದೀರಿ",
"pl_otpInstead": "ಬದಲಿಗೆ ಒಟಿಪಿ ಮೂಲಕ ಲಾಗಿನ್",
"pl_otpLabel": "ಒಟಿಪಿ (ಒಮ್ಮೆ ಬಳಸುವ ಪಾಸ್‌ವರ್ಡ್)",
"pl_customerLogin": "← ಗ್ರಾಹಕ ಲಾಗಿನ್",
"pl_secs": "{n} ಸೆ.",
"lg_tenDigit": "10 ಅಂಕಿಯ ಸಂಖ್ಯೆ",
"lg_moreDigits": "ಇನ್ನೂ {n} ಅಂಕಿಗಳು ಬೇಕು",
"lg_oneMoreDigit": "ಇನ್ನೂ 1 ಅಂಕಿ ಬೇಕು",
"lg_startDigit": "6, 7, 8 ಅಥವಾ 9 ರಿಂದ ಆರಂಭವಾಗಬೇಕು",
"lg_enterMobile": "ನಿಮ್ಮ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ನಮೂದಿಸಿ.",
"lg_otpSendFail": "ಒಟಿಪಿ ಕಳುಹಿಸಲು ಆಗಲಿಲ್ಲ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
"lg_enterOtp": "ಒಟಿಪಿ ನಮೂದಿಸಿ.",
"lg_otpInvalid": "ಒಟಿಪಿ ತಪ್ಪು. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
"lg_otpResendFail": "ಒಟಿಪಿ ಮತ್ತೆ ಕಳುಹಿಸಲು ಆಗಲಿಲ್ಲ.",
"lg_pwMin": "ಪಾಸ್‌ವರ್ಡ್ ಕನಿಷ್ಠ 8 ಅಕ್ಷರಗಳಿರಬೇಕು.",
"lg_pwMax": "ಪಾಸ್‌ವರ್ಡ್ 64 ಅಕ್ಷರಗಳನ್ನು ಮೀರಬಾರದು.",
"lg_pwRange": "ಪಾಸ್‌ವರ್ಡ್ 8 ರಿಂದ 64 ಅಕ್ಷರಗಳಿರಬೇಕು.",
"lg_resetFail": "ಪಾಸ್‌ವರ್ಡ್ ಬದಲಿಸಲು ಆಗಲಿಲ್ಲ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
"lg_resetTitle": "ಪಾಸ್‌ವರ್ಡ್ ಮರುಹೊಂದಿಸಿ",
"lg_verifyOtp": "ಒಟಿಪಿ ಪರಿಶೀಲಿಸಿ",
"lg_setNewPw": "ಹೊಸ ಪಾಸ್‌ವರ್ಡ್ ಹೊಂದಿಸಿ",
"lg_forgotIntro": "ನೋಂದಾಯಿತ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ನಮೂದಿಸಿ. ನಾವು ಒಂದು ಕೋಡ್ ಕಳುಹಿಸುತ್ತೇವೆ.",
"lg_mobile": "ಮೊಬೈಲ್ ಸಂಖ್ಯೆ",
"lg_waNotice": "ಈ ಸಂಖ್ಯೆಗೆ ನಿಮ್ಮ ಒಟಿಪಿ ಮತ್ತು ನಿಮ್ಮ ವಿಚಾರಣೆಗಳ ಅಪ್‌ಡೇಟ್‌ಗಳನ್ನು ವಾಟ್ಸಾಪ್ ಮತ್ತು ಎಸ್‌ಎಂಎಸ್ ಮೂಲಕ ಕಳುಹಿಸುತ್ತೇವೆ. ಅಪ್‌ಡೇಟ್‌ಗಳನ್ನು ನಿಲ್ಲಿಸಲು ವಾಟ್ಸಾಪ್‌ನಲ್ಲಿ “ನಿಲ್ಲಿಸಿ” ಎಂದು ಕಳುಹಿಸಿ.",
"lg_sending": "ಕಳುಹಿಸುತ್ತಿದ್ದೇವೆ…",
"lg_sendOtp": "ಒಟಿಪಿ ಕಳುಹಿಸಿ",
"lg_otpSentTo": "+91 {phone} ಗೆ ಒಟಿಪಿ ಕಳುಹಿಸಲಾಗಿದೆ. ಕೆಳಗೆ 6 ಅಂಕಿಯ ಕೋಡ್ ನಮೂದಿಸಿ.",
"lg_otp6": "6 ಅಂಕಿಯ ಒಟಿಪಿ",
"lg_resendIn": "{n} ಸೆ. ನಲ್ಲಿ ಮತ್ತೆ ಕಳುಹಿಸಿ",
"lg_resend": "ಮತ್ತೆ ಕಳುಹಿಸಿ",
"lg_verifying": "ಪರಿಶೀಲಿಸುತ್ತಿದ್ದೇವೆ…",
"lg_otpDone": "ಒಟಿಪಿ ಪರಿಶೀಲಿಸಲಾಗಿದೆ. ನಿಮ್ಮ ಹೊಸ ಪಾಸ್‌ವರ್ಡ್ ಹೊಂದಿಸಿ.",
"lg_newPw": "ಹೊಸ ಪಾಸ್‌ವರ್ಡ್",
"lg_pwHint": "8-64 ಅಕ್ಷರಗಳು",
"lg_saving": "ಉಳಿಸುತ್ತಿದ್ದೇವೆ…",
"lg_tagline": "ನಿಮ್ಮ ನಂಬಿಕೆಯ ಕ್ಯಾಬ್ ಸೇವೆ",
"lg_logIn": "ಲಾಗಿನ್",
"lg_signUp": "ಸೈನ್ ಅಪ್",
"lg_password": "ಪಾಸ್‌ವರ್ಡ್",
"lg_otpLogin": "ಒಟಿಪಿ ಲಾಗಿನ್",
"lg_userOrMobile": "ಬಳಕೆದಾರ ಹೆಸರು ಅಥವಾ ಮೊಬೈಲ್",
"lg_userOrMobilePh": "ಬಳಕೆದಾರ ಹೆಸರು ಅಥವಾ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ",
"lg_enterPw": "ಪಾಸ್‌ವರ್ಡ್ ನಮೂದಿಸಿ",
"lg_forgot": "ಪಾಸ್‌ವರ್ಡ್ ಮರೆತಿರಾ?",
"lg_signingIn": "ಲಾಗಿನ್ ಆಗುತ್ತಿದೆ…",
"lg_signIn": "ಲಾಗಿನ್ ಆಗಿ",
"lg_codeSentTo": "+91 {phone} ಗೆ ಬಂದ 6 ಅಂಕಿಯ ಕೋಡ್ ನಮೂದಿಸಿ",
"lg_verifySignIn": "ಪರಿಶೀಲಿಸಿ ಲಾಗಿನ್ ಆಗಿ",
"lg_userName": "ಬಳಕೆದಾರ ಹೆಸರು",
"lg_nameTaken": "ಈ ಬಳಕೆದಾರ ಹೆಸರು ಈಗಾಗಲೇ ಇದೆ.",
"lg_tryName": "ಇದನ್ನು ಪ್ರಯತ್ನಿಸಿ: {name}",
"lg_numTaken": "ಈ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ಈಗಾಗಲೇ ನೋಂದಾಯಿತವಾಗಿದೆ.",
"lg_signInInstead": "ಲಾಗಿನ್ ಆಗಿ →",
"lg_email": "ಇಮೇಲ್",
"lg_fullName": "ಪೂರ್ಣ ಹೆಸರು",
"lg_enterOtp6": "6 ಅಂಕಿಯ ಒಟಿಪಿ ನಮೂದಿಸಿ",
"lg_setPw": "ಪಾಸ್‌ವರ್ಡ್ ಹೊಂದಿಸಿ",
"lg_confirmPw": "ಪಾಸ್‌ವರ್ಡ್ ದೃಢೀಕರಿಸಿ",
"lg_reenterPw": "ಪಾಸ್‌ವರ್ಡ್ ಮತ್ತೆ ನಮೂದಿಸಿ",
"lg_accept": "ನಾನು {terms} ಮತ್ತು {privacy} ಒಪ್ಪುತ್ತೇನೆ; ವೇದಿಕೆಯ ಕಾರ್ಯಾಚರಣೆಗಾಗಿ ನನ್ನ ವೈಯಕ್ತಿಕ ಮಾಹಿತಿ ಸಂಗ್ರಹಿಸಲು ಸ್ಪಷ್ಟವಾಗಿ ಒಪ್ಪಿಗೆ ನೀಡುತ್ತೇನೆ.",
"lg_terms": "ನಿಯಮಗಳು & ಷರತ್ತುಗಳು",
"lg_privacy": "ಗೌಪ್ಯತಾ ನೀತಿ",
"lg_creating": "ಖಾತೆ ರಚನೆಯಾಗುತ್ತಿದೆ…",
"lg_create": "ಖಾತೆ ರಚಿಸಿ",
"lg_earn": "ಶ್ರಮಿಕದ ಜೊತೆ ಸಂಪಾದಿಸಬೇಕೆ?",
"lg_joinAs": "ಡ್ರೈವರ್ ಅಥವಾ ಆಲ್ಟಿಂಗ್ ಡ್ರೈವರ್ ಆಗಿ ಸೇರಿ",
"lg_cabOwner": "ಡ್ರೈವರ್",
"lg_hireDriver": "ಬಾಡಿಗೆ ಚಾಲಕ",
"lg_enterUsername": "ಬಳಕೆದಾರ ಹೆಸರು ನಮೂದಿಸಿ.",
"lg_otherUsername": "ಬೇರೆ ಬಳಕೆದಾರ ಹೆಸರು ಆಯ್ಕೆಮಾಡಿ.",
"lg_validMobile": "ಸರಿಯಾದ 10 ಅಂಕಿಯ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ನಮೂದಿಸಿ.",
"lg_hasAccount": "ಈ ಸಂಖ್ಯೆಗೆ ಈಗಾಗಲೇ ಖಾತೆ ಇದೆ.",
"lg_otpSentShort": "+91 {phone} ಗೆ ಒಟಿಪಿ ಕಳುಹಿಸಲಾಗಿದೆ",
"lg_noAccount": "ಖಾತೆ ಸಿಗಲಿಲ್ಲ - ಹೊಸ ಖಾತೆ ರಚಿಸೋಣ.",
"lg_autoOtpFail": "ಒಟಿಪಿ ಕಳುಹಿಸಲು ಆಗಲಿಲ್ಲ. ಮತ್ತೆ ಕಳುಹಿಸಿ ಒತ್ತಿ.",
"lg_noPwYet": "ನಿಮ್ಮ ಖಾತೆಗೆ ಇನ್ನೂ ಪಾಸ್‌ವರ್ಡ್ ಇಲ್ಲ - ಈಗಲೇ ಹೊಂದಿಸಿ.",
"lg_enterOtpSent": "ಮೊಬೈಲ್‌ಗೆ ಬಂದ ಒಟಿಪಿ ನಮೂದಿಸಿ.",
"lg_enterUserOrMobile": "ಬಳಕೆದಾರ ಹೆಸರು ಅಥವಾ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ನಮೂದಿಸಿ.",
"lg_enterPwMsg": "ಪಾಸ್‌ವರ್ಡ್ ನಮೂದಿಸಿ.",
"lg_setPwFor": "ನಿಮ್ಮ ಮೊಬೈಲ್ ಸಂಖ್ಯೆಗೆ ಪಾಸ್‌ವರ್ಡ್ ಹೊಂದಿಸಿ.",
"lg_badLogin": "ಬಳಕೆದಾರ ಹೆಸರು/ಮೊಬೈಲ್ ಅಥವಾ ಪಾಸ್‌ವರ್ಡ್ ತಪ್ಪು. ಪರಿಶೀಲಿಸಿ.",
"lg_otpExpired": "ಒಟಿಪಿ ಅವಧಿ ಮುಗಿದಿದೆ. ಮತ್ತೆ ಕಳುಹಿಸಿ.",
"lg_pwMismatch": "ಪಾಸ್‌ವರ್ಡ್‌ಗಳು ಹೊಂದುತ್ತಿಲ್ಲ.",
"lg_enterEmail": "ಇಮೇಲ್ ನಮೂದಿಸಿ.",
"lg_enterFullName": "ನಿಮ್ಮ ಪೂರ್ಣ ಹೆಸರು ನಮೂದಿಸಿ.",
"lg_acceptFirst": "ನಿಯಮಗಳು ಮತ್ತು ಗೌಪ್ಯತಾ ನೀತಿ ಒಪ್ಪಿ.",
"lg_createFail": "ಖಾತೆ ರಚಿಸಲು ಆಗಲಿಲ್ಲ.",
"cv_lExtraOneHr": "ಹೆಚ್ಚುವರಿ 1 ಗಂಟೆ",
"cv_24h": "24 ಗಂಟೆ",
"cv_back": "ಹಿಂದೆ",
"cv_share": "ಹಂಚಿಕೊಳ್ಳಿ",
"cv_linkCopied": "ಲಿಂಕ್ ನಕಲಾಗಿದೆ",
"cv_prevPhoto": "ಹಿಂದಿನ ಫೋಟೋ",
"cv_nextPhoto": "ಮುಂದಿನ ಫೋಟೋ",
"cv_close": "ಮುಚ್ಚಿ",
"cv_nRatings": "{n} ರೇಟಿಂಗ್‌ಗಳು",
"cv_oneRating": "1 ರೇಟಿಂಗ್",
"cv_model": "{year} ಮಾಡೆಲ್",
"cv_manual": "ಮ್ಯಾನುಯಲ್",
"cv_auto": "ಆಟೋಮ್ಯಾಟಿಕ್",
"cv_male": "ಪುರುಷ",
"cv_female": "ಮಹಿಳೆ",
"cv_licence": "ಲೈಸೆನ್ಸ್ ಪರಿಶೀಲಿಸಲಾಗಿದೆ",
"cv_yourTrip": "ನಿಮ್ಮ ಪ್ರಯಾಣ",
"cv_change": "ಬದಲಿಸಿ",
"cv_local": "ಲೋಕಲ್",
"cv_partnerPrice": "ಡ್ರೈವರ್‌ನ ದರ",
"cv_usualFare": "ಸಾಮಾನ್ಯ ದರ",
"cv_extrasShort": "ಟೋಲ್, ಪಾರ್ಕಿಂಗ್ ಹೆಚ್ಚುವರಿ",
"cv_priceDetails": "ದರದ ವಿವರ",
"cv_eta": "{name} {place} ನಿಂದ {n} ನಿಮಿಷ ದೂರದಲ್ಲಿದ್ದಾರೆ",
"cv_seePriceTitle": "ನಿಮ್ಮ ಪ್ರಯಾಣದ ದರ ನೋಡಿ",
"cv_seePriceText": "ಪಿಕಪ್, ಡ್ರಾಪ್ ಆಯ್ಕೆಮಾಡಿ - ದರ ಇಲ್ಲಿ ಕಾಣಿಸುತ್ತದೆ.",
"cv_setTrip": "ಪಿಕಪ್ & ಡ್ರಾಪ್ ಆಯ್ಕೆ",
"cv_allDay": "ಪ್ರತಿದಿನ ಲಭ್ಯ · 24 ಗಂಟೆ",
"cv_everyDay": "ಪ್ರತಿದಿನ ಲಭ್ಯ · {hours}",
"cv_openToday": "ಇಂದು ಲಭ್ಯ · {hours}",
"cv_closedToday": "ಇಂದು ಲಭ್ಯವಿಲ್ಲ",
"cv_daysOpen": "ವಾರದಲ್ಲಿ {n} ದಿನ",
"cv_week": "ವಾರ",
"cv_dayOff": "ರಜೆ",
"cv_dayBusy": "ಬ್ಯುಸಿ",
"cv_dayOpen": "ಲಭ್ಯ",
"cv_notConfirmed": "ಸಾಮಾನ್ಯ ಸಮಯ - ಡ್ರೈವರ್ ಇನ್ನೂ ಖಚಿತಪಡಿಸಿಲ್ಲ",
"cv_rateTitle": "{name} ಜೊತೆ ನಿಮ್ಮ ಪ್ರಯಾಣ ಹೇಗಿತ್ತು?",
"cv_rateNoName": "ನಿಮ್ಮ ಪ್ರಯಾಣ ಹೇಗಿತ್ತು?",
"cv_rateParts": "ಪ್ರತಿ ಅಂಶ - ಬೇಕಾದರೆ ಬದಲಿಸಿ, ಇಲ್ಲವೇ ಹಾಗೆಯೇ ಕಳುಹಿಸಿ",
"cv_noRatings": "ಇನ್ನೂ ರೇಟಿಂಗ್‌ಗಳಿಲ್ಲ",
"cv_rateAfter": "ಈ ಕಾರಿನಲ್ಲಿ ಪ್ರಯಾಣಿಸಿದ್ದೀರಾ? ಪ್ರಯಾಣದ ನಂತರ ರೇಟಿಂಗ್ ನೀಡಿ.",
"cv_partsFrom": "{m} ರೇಟಿಂಗ್‌ಗಳಲ್ಲಿ {n} ರಿಂದ ವಿವರ",
"rl_title": "{name} ಅವರೊಂದಿಗಿನ ಪ್ರಯಾಣಕ್ಕೆ ರೇಟಿಂಗ್ ನೀಡಿ",
"rl_done": "ಧನ್ಯವಾದಗಳು! ನಿಮ್ಮ ರೇಟಿಂಗ್ ಉಳಿಸಲಾಗಿದೆ.",
"rl_gone": "ಈ ಲಿಂಕ್ ಅವಧಿ ಮುಗಿದಿದೆ. ನಿಮ್ಮ ರೇಟಿಂಗ್‌ಗೆ ಧನ್ಯವಾದಗಳು!",
"cv_trustDirect": "ಡ್ರೈವರ್ ಜೊತೆ ನೇರವಾಗಿ ಮಾತನಾಡಿ",
"cv_trustNoFee": "ಬುಕಿಂಗ್ ಶುಲ್ಕವಿಲ್ಲ",
"cv_trustHelp": "ಬೇಕಾದರೆ ಶ್ರಮಿಕದ ಸಹಾಯ",
"cv_help": "ಸಹಾಯ ಬೇಕೇ? ಶ್ರಮಿಕಕ್ಕೆ ಕರೆ ಮಾಡಿ",
"cv_onTripBack": "ಪ್ರಯಾಣದಲ್ಲಿದ್ದಾರೆ · {when} ಕ್ಕೆ ಹಿಂತಿರುಗುತ್ತಾರೆ",
"cv_onTrip": "ಈಗ ಪ್ರಯಾಣದಲ್ಲಿದ್ದಾರೆ",
"cv_notFree": "ಈಗ ಲಭ್ಯವಿಲ್ಲ",
"cv_notifyMe": "ಲಭ್ಯವಾದಾಗ ತಿಳಿಸಿ",
"cv_notified": "ನಿಮಗೆ ತಿಳಿಸುತ್ತೇವೆ",
"cv_similar": "ಇಂಥದೇ ಕಾರುಗಳು",
"cv_setByPartner": "ದರವನ್ನು ಡ್ರೈವರ್ ನಿಗದಿಪಡಿಸಿದ್ದಾರೆ · ಶ್ರಮಿಕ ಕಮಿಷನ್ ಇಲ್ಲ",
"cv_kmBoth": "ಹೋಗಿ-ಬರಲು {km} ಕಿ.ಮೀ",
"cv_nDays": "{n} ದಿನ",
"cv_oneDay": "1 ದಿನ",
"cv_nHrs": "{n} ಗಂಟೆ",
"cv_oneHr": "1 ಗಂಟೆ",
"cv_nNights": "{n} ರಾತ್ರಿ",
"cv_oneNight": "1 ರಾತ್ರಿ",
"cv_nHalfDays": "{n} ಅರ್ಧ ದಿನ",
"cv_oneHalfDay": "1 ಅರ್ಧ ದಿನ",
"cv_lBase": "ಮೂಲ ದರ",
"cv_lDrop": "ಡ್ರಾಪ್ ದರ",
"cv_lDriver": "ಡ್ರೈವರ್ ಬತ್ತಾ ({x})",
"cv_lNight": "ರಾತ್ರಿ ಬತ್ತಾ ({x})",
"cv_lDropUpTo": "ಡ್ರಾಪ್ ({km} ಕಿ.ಮೀ ವರೆಗೆ)",
"cv_lDropFirst": "ಡ್ರಾಪ್ (ಮೊದಲ {km} ಕಿ.ಮೀ)",
"cv_lExtraKmRate": "ಹೆಚ್ಚುವರಿ {km} ಕಿ.ಮೀ × ₹{rate}",
"cv_lPackage": "{n} ಗಂಟೆಗಳ ಪ್ಯಾಕೇಜ್",
"cv_lExtraHr": "ಹೆಚ್ಚುವರಿ {n} ಗಂಟೆ",
"cv_lExtraKm": "ಹೆಚ್ಚುವರಿ {n} ಕಿ.ಮೀ",
"cv_lDayRent": "ದಿನದ ಬಾಡಿಗೆ ({x})",
"cv_lFuel": "ಇಂಧನ ಶುಲ್ಕ",
"cv_youPay": "ನೀವು ಡ್ರೈವರ್‌ಗೆ ಪಾವತಿಸುವುದು",
"cv_notIncl": "ಇದರಲ್ಲಿ ಸೇರಿಲ್ಲ",
"cv_notIncl1": "ಟೋಲ್, ಪಾರ್ಕಿಂಗ್, ರಾಜ್ಯ ತೆರಿಗೆ - ಚಾಲಕರಿಗೆ ನೇರವಾಗಿ ಪಾವತಿಸಿ",
"cv_notIncl2": "ಹೆಚ್ಚುವರಿ ಕಿ.ಮೀ ಅಥವಾ ಗಂಟೆಗೆ ಹೆಚ್ಚುವರಿ ದರ",
"cv_calcLink": "ಹೆಚ್ಚುವರಿ ಕಿ.ಮೀ / ಗಂಟೆಯ ದರ ಲೆಕ್ಕಹಾಕಿ",
"cv_calcTitle": "ದರ ಲೆಕ್ಕಾಚಾರ",
"cv_calcSub": "ಹೆಚ್ಚು ಕಿ.ಮೀ ಅಥವಾ ಗಂಟೆಗಳ ದರ",
"cv_calcHours": "ಪ್ರಯಾಣದ ಗಂಟೆಗಳು",
"cv_calcKm": "ಒಟ್ಟು ಕಿ.ಮೀ",
"cv_calcBtn": "ದರ ಲೆಕ್ಕಹಾಕಿ",
"cv_calcTotal": "ಅಂದಾಜು ದರ",
"cv_calcNote": "ಟೋಲ್, ಪಾರ್ಕಿಂಗ್, ರಾಜ್ಯ ತೆರಿಗೆ ಸೇರಿಲ್ಲ",
"cv_loading": "ಕಾರಿನ ವಿವರಗಳು ಲೋಡ್ ಆಗುತ್ತಿವೆ…",
"cv_goneTitle": "ಈ ಕಾರು ಲಭ್ಯವಿಲ್ಲ",
"cv_goneText": "ಈ ಕಾರು ಈಗ ಪಟ್ಟಿಯಲ್ಲಿಲ್ಲ, ಅಥವಾ ಲಿಂಕ್ ಅವಧಿ ಮುಗಿದಿದೆ.",
"cv_backHome": "ಮುಖಪುಟಕ್ಕೆ ಹೋಗಿ",
"hm_recentEnquiry": "ಇತ್ತೀಚಿನ ವಿಚಾರಣೆ",
"hm_nPartners": "{n} ಪಾರ್ಟ್ನರ್‌ಗಳು",
"hm_onePartner": "1 ಪಾರ್ಟ್ನರ್",
"hm_resAvailIn": "{city} ನಲ್ಲಿ {items} ಲಭ್ಯ",
"hm_resAvailInCars": "{city} ನಲ್ಲಿ {items} ಲಭ್ಯ",
"hm_changeLang": "ಭಾಷೆ ಬದಲಿಸಿ",
"hm_changeCity": "ನಗರ ಬದಲಿಸಿ",
"hm_helpCall": "ಸಹಾಯಕ್ಕೆ ಶ್ರಮಿಕಕ್ಕೆ ಕರೆ ಮಾಡಿ",
"hm_chooseCity": "ನಿಮ್ಮ ನಗರ ಆಯ್ಕೆಮಾಡಿ",
"hm_typeCity": "ನಿಮ್ಮ ನಗರದ ಹೆಸರು ಬರೆಯಿರಿ",
"hm_useMyLocation": "ನನ್ನ ಸ್ಥಳ ಬಳಸಿ",
"hm_finding": "ನಿಮ್ಮ ಸ್ಥಳ ಹುಡುಕುತ್ತಿದೆ…",
"hm_noCities": "ಈ ಹೆಸರಿನ ನಗರ ಇಲ್ಲ",
"hm_locNotSupported": "ಈ ಫೋನ್ ಸ್ಥಳವನ್ನು ಹಂಚಿಕೊಳ್ಳಲು ಆಗುವುದಿಲ್ಲ.",
"hm_locMapsOff": "ನಕ್ಷೆ ಲೋಡ್ ಆಗಲಿಲ್ಲ. ಪುಟವನ್ನು ರಿಫ್ರೆಶ್ ಮಾಡಿ.",
"hm_locNotFound": "ನಿಮ್ಮ ಸ್ಥಳ ಸಿಗಲಿಲ್ಲ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
"hm_locNoCity": "ನಿಮ್ಮ ಸ್ಥಳ ಸಿಕ್ಕಿದೆ, ಆದರೆ ನಗರ ತಿಳಿಯಲಿಲ್ಲ. ಕೆಳಗಿನಿಂದ ಆಯ್ಕೆಮಾಡಿ.",
"hm_locDenied": "ಸ್ಥಳದ ಅನುಮತಿ ನೀಡಿಲ್ಲ. ಫೋನ್ ಸೆಟ್ಟಿಂಗ್‌ನಲ್ಲಿ ಅನುಮತಿಸಿ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
"hm_locUnavailable": "ಸ್ಥಳ ಲಭ್ಯವಿಲ್ಲ. ಜಿಪಿಎಸ್ ಆನ್ ಮಾಡಿ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
"hm_locTimeout": "ಸ್ಥಳ ಹುಡುಕಲು ತುಂಬಾ ಸಮಯ ಆಯಿತು. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
"hm_guestTitle": "ಲಾಗಿನ್ ಆಗಿ ಚಾಲಕರಿಗೆ ನೇರವಾಗಿ ಕರೆ ಮಾಡಿ",
"hm_guestSubCars": "ದರಗಳನ್ನು ಹೋಲಿಸಿ, ಡ್ರೈವರ್ ಜೊತೆ ನೇರವಾಗಿ ಮಾತನಾಡಿ - ಬುಕಿಂಗ್ ಶುಲ್ಕ ಇಲ್ಲ.",
"hm_guestSubDrivers": "ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯಿಂದ ಉಚಿತ. ಒಂದೇ ಸ್ಪರ್ಶದಲ್ಲಿ ಕರೆ ಮಾಡಿ, ನಿಮ್ಮ ವಿಚಾರಣೆಗಳನ್ನು ಇತಿಹಾಸದಲ್ಲಿ ನೋಡಿ. ಬುಕಿಂಗ್ ಶುಲ್ಕ ಇಲ್ಲ.",
"hm_guestTitleCars": "ಲಾಗಿನ್ ಆಗಿ ಡ್ರೈವರ್‌ಗಳಿಗೆ ನೇರವಾಗಿ ಕರೆ ಮಾಡಿ",
"hm_guestSubCarsLogin": "ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯಿಂದ ಉಚಿತ. ಒಂದೇ ಸ್ಪರ್ಶದಲ್ಲಿ ಕರೆ ಮಾಡಿ, ನಿಮ್ಮ ವಿಚಾರಣೆಗಳನ್ನು ಇತಿಹಾಸದಲ್ಲಿ ನೋಡಿ. ಬುಕಿಂಗ್ ಶುಲ್ಕ ಇಲ್ಲ.",
"hm_loginJoin": "ಲಾಗಿನ್ / ಸೇರಿ",
"hm_recent": "ಇತ್ತೀಚಿನ",
"hm_setTrip": "ಪ್ರಯಾಣ ಹೊಂದಿಸಿ",
"hm_km": "{km} ಕಿ.ಮೀ",
"hm_searchCars": "ಕಾರು, ಮಾಡೆಲ್, ಪ್ರದೇಶ ಹುಡುಕಿ",
"hm_searchDrivers": "ಚಾಲಕರ ಹೆಸರು, ಭಾಷೆ ಹುಡುಕಿ",
"hm_filters": "ಫಿಲ್ಟರ್‌ಗಳು",
"hm_clearSearch": "ಹುಡುಕಾಟ ತೆಗೆದುಹಾಕಿ",
"hm_removeFilter": "ಫಿಲ್ಟರ್ ತೆಗೆಯಿರಿ",
"hm_any": "ಯಾವುದಾದರೂ",
"hm_sort": "ಕ್ರಮ",
"hm_sortRec": "ಶಿಫಾರಸು",
"hm_sortPriceLow": "ಕಡಿಮೆ ಬೆಲೆ ಮೊದಲು",
"hm_sortPriceHigh": "ಹೆಚ್ಚು ಬೆಲೆ ಮೊದಲು",
"hm_sortRating": "ಉತ್ತಮ ರೇಟಿಂಗ್ ಮೊದಲು",
"hm_sortEta": "ಹತ್ತಿರದವು ಮೊದಲು",
"hm_sortNewest": "ಹೊಸ ಕಾರುಗಳು ಮೊದಲು",
"hm_seats": "ಸೀಟುಗಳು",
"hm_nSeats": "{n} ಸೀಟುಗಳು",
"hm_carType": "ಕಾರಿನ ಪ್ರಕಾರ",
"hm_price": "ಬೆಲೆ",
"hm_ctHatch": "ಹ್ಯಾಚ್‌ಬ್ಯಾಕ್",
"hm_ctSedan": "ಸೆಡಾನ್",
"hm_ctMiniSuv": "ಮಿನಿ ಎಸ್‌ಯುವಿ",
"hm_ctSuv": "ಎಸ್‌ಯುವಿ",
"hm_ctMpv": "7 ಸೀಟರ್ (ಎಂಪಿವಿ)",
"hm_ctTempo": "ಟೆಂಪೋ ಟ್ರಾವೆಲರ್",
"hm_ctBus": "ಬಸ್",
"hm_fuel": "ಇಂಧನ",
"hm_fuelPetrol": "ಪೆಟ್ರೋಲ್",
"hm_fuelDiesel": "ಡೀಸೆಲ್",
"hm_fuelCng": "ಸಿಎನ್‌ಜಿ",
"hm_fuelEv": "ಎಲೆಕ್ಟ್ರಿಕ್",
"hm_year": "ಕಾರಿನ ವರ್ಷ",
"hm_yr2024": "2024 ಅಥವಾ ಹೊಸದು",
"hm_yr2015": "2015 ಅಥವಾ ಹಳೆಯದು",
"hm_budUnder5": "₹5,000 ಒಳಗೆ",
"hm_budAbove15": "₹15,000 ಮೇಲೆ",
"hm_sortExp": "ಹೆಚ್ಚು ಅನುಭವ ಮೊದಲು",
"hm_sortOnline": "ಈಗ ಆನ್‌ಲೈನ್ ಇರುವವರು ಮೊದಲು",
"hm_sortFareLow": "ಕಡಿಮೆ ಶುಲ್ಕ ಮೊದಲು",
"hm_dBudUnder1": "₹1,000 ಒಳಗೆ",
"hm_dBudAbove3": "₹3,000 ಮೇಲೆ",
"hm_priceNeedsTrip": "ಮೊದಲು ನಿಮ್ಮ ಪ್ರಯಾಣ ಹೊಂದಿಸಿ - ಬೆಲೆ ಅದರ ಮೇಲೆ ಅವಲಂಬಿತ.",
"hm_rating": "ರೇಟಿಂಗ್",
"hm_starsPlus": "{n}+ ಸ್ಟಾರ್",
"hm_experience": "ಚಾಲನಾ ಅನುಭವ",
"hm_expPlus": "{n}+ ವರ್ಷ ಚಾಲನೆ",
"hm_speaks": "ಮಾತನಾಡುವ ಭಾಷೆ",
"hm_goodAt": "ಗ್ರಾಹಕರು ಹೇಳುವುದು",
"hm_tOnTime": "ಸಮಯಕ್ಕೆ ಸರಿ",
"hm_tPolite": "ವಿನಯಶೀಲ",
"hm_tComfort": "ಆರಾಮದಾಯಕ ಪ್ರಯಾಣ",
"hm_tClean": "ಸ್ವಚ್ಛ ಕಾರು",
"hm_tSafe": "ಸುರಕ್ಷಿತ ಚಾಲನೆ",
"hm_driverAge": "ಚಾಲಕರ ವಯಸ್ಸು",
"hm_ageRange": "{range} ವರ್ಷ",
"hm_grpCar": "ಕಾರು",
"hm_grpDriver": "ಚಾಲಕ",
"hm_grpPrice": "ಬೆಲೆ",
"hm_grpTrip": "ಪ್ರಯಾಣ",
"hm_clearAll": "ಎಲ್ಲವನ್ನೂ ತೆಗೆಯಿರಿ",
"hm_close": "ಮುಚ್ಚಿ",
"hm_showCars": "{n} ಕಾರುಗಳನ್ನು ತೋರಿಸಿ",
"hm_showOneCar": "1 ಕಾರು ತೋರಿಸಿ",
"hm_showNoCars": "ಯಾವ ಕಾರೂ ಹೊಂದಿಕೆಯಾಗಿಲ್ಲ",
"hm_showDrivers": "{n} ಚಾಲಕರನ್ನು ತೋರಿಸಿ",
"hm_showOneDriver": "1 ಚಾಲಕರನ್ನು ತೋರಿಸಿ",
"hm_showNoDrivers": "ಯಾವ ಚಾಲಕರೂ ಹೊಂದಿಕೆಯಾಗಿಲ್ಲ",
"hm_tripType": "ಪ್ರಯಾಣದ ಪ್ರಕಾರ",
"hm_ttLocal": "ಸ್ಥಳೀಯ",
"hm_ttOut": "ಹೊರ ಊರು",
"hm_ttDrop": "ಡ್ರಾಪಿಂಗ್",
"hm_availability": "ಲಭ್ಯತೆ",
"hm_availNow": "ಈಗ ಲಭ್ಯ",
"hm_nDrivers": "{n} ಚಾಲಕರು",
"hm_oneDriver": "1 ಚಾಲಕ",
"hm_resRoute": "{route} ಗೆ {items}",
"hm_resNear": "{place} ಹತ್ತಿರ {items}",
"hm_resFound": "ಸಿಕ್ಕಿದವು: {items}",
"hm_showAll": "ಎಲ್ಲಾ ತೋರಿಸಿ",
"hm_shareList": "ಪಟ್ಟಿ ಕಳುಹಿಸಿ",
"dk_trips": "ಪ್ರವಾಸಗಳು",
"dk_heroCars": "{city} ನಲ್ಲಿ ಕಾರುಗಳು",
"dk_subCars": "ನಿಜವಾದ ದರಗಳನ್ನು ನೋಡಿ, ಡ್ರೈವರ್‌ಗೆ ನೇರವಾಗಿ ಕರೆ ಮಾಡಿ - ಬುಕಿಂಗ್ ಶುಲ್ಕ ಇಲ್ಲ, ಮುಂಗಡ ಇಲ್ಲ.",
"dk_heroDrivers": "{city} ನಲ್ಲಿ ಚಾಲಕರನ್ನು ನೇಮಿಸಿ",
"dk_subDrivers": "ನಿಮ್ಮ ಕಾರು, ನಮ್ಮ ಚಾಲಕ - ಎಲ್ಲಾ ದರಗಳನ್ನು ನೋಡಿ, ಚಾಲಕರಿಗೆ ನೇರವಾಗಿ ಕರೆ ಮಾಡಿ.",
"dk_searchCars": "ಕಾರುಗಳನ್ನು ಹುಡುಕಿ",
"dk_searchDrivers": "ಚಾಲಕರನ್ನು ಹುಡುಕಿ",
"dk_when": "ಯಾವಾಗ",
"dk_tripType": "ಪ್ರವಾಸ",
"dk_filters": "ಫಿಲ್ಟರ್‌ಗಳು",
"dk_pickWhen": "ದಿನಾಂಕ ಆರಿಸಿ",
"dk_tagline": "ನಿಮ್ಮ ಹತ್ತಿರ ಕಾರುಗಳು, ಡ್ರೈವರ್‌ಗಳು - ದರ ನೋಡಿ ಡ್ರೈವರ್‌ಗೆ ನೇರವಾಗಿ ಕರೆ ಮಾಡಿ.",
"dk_fCustomers": "ಗ್ರಾಹಕರಿಗೆ",
"dk_fJoin": "ಶ್ರಮಿಕಕ್ಕೆ ಸೇರಿ",
"dk_fAbout": "ನಮ್ಮ ಬಗ್ಗೆ",
"dk_fByCity": "ನಗರವಾರು",
"dk_fCabsByCity": "ನಗರವಾರು ಕಾರುಗಳು",
"dk_fDriversByCity": "ನಗರವಾರು ಚಾಲಕರು",
"dk_fFareChart": "ಟ್ಯಾಕ್ಸಿ ದರ ಪಟ್ಟಿ",
"dk_fAirport": "ವಿಮಾನ ನಿಲ್ದಾಣ ಟ್ಯಾಕ್ಸಿ",
"cbk_button": "🙋 ನಾವೇ ಕರೆ ಮಾಡಿ ಬುಕ್ ಮಾಡುತ್ತೇವೆ",
"cbk_title": "ನಾವು ನಿಮಗೆ ಕರೆ ಮಾಡುತ್ತೇವೆ",
"cbk_sub": "10 ನಿಮಿಷದಲ್ಲಿ ಶ್ರಮಿಕ ತಂಡ ಕರೆ ಮಾಡಿ ನಿಮಗಾಗಿ ಬುಕ್ ಮಾಡುತ್ತದೆ. ಲಾಗಿನ್ ಬೇಕಿಲ್ಲ.",
"cbk_night": "ಈಗ ರಾತ್ರಿ - ಬೆಳಿಗ್ಗೆ 8 ಗಂಟೆಗೆ ಕರೆ ಮಾಡುತ್ತೇವೆ.",
"cbk_name": "ನಿಮ್ಮ ಹೆಸರು",
"cbk_phone": "ಮೊಬೈಲ್ ಸಂಖ್ಯೆ",
"cbk_trip": "ನಿಮ್ಮ ಪ್ರಯಾಣ",
"cbk_note": "ಬೇರೆ ಏನಾದರೂ (ಐಚ್ಛಿಕ)",
"cbk_notePh": "6 ಜನ, 3 ಬ್ಯಾಗ್…",
"cbk_send": "ಕರೆ ಮಾಡಲು ಹೇಳಿ",
"cbk_sending": "ಕಳುಹಿಸುತ್ತಿದ್ದೇವೆ…",
"cbk_done": "ಸಿಕ್ಕಿತು! 10 ನಿಮಿಷದಲ್ಲಿ ಕರೆ ಬರುತ್ತದೆ.",
"cbk_doneNight": "ಸಿಕ್ಕಿತು! ಬೆಳಿಗ್ಗೆ 8 ಗಂಟೆಗೆ ಕರೆ ಮಾಡುತ್ತೇವೆ.",
"cbk_already": "ನಿಮ್ಮ ವಿನಂತಿ ಈಗಾಗಲೇ ಸಿಕ್ಕಿದೆ - ಶೀಘ್ರ ಕರೆ ಮಾಡುತ್ತೇವೆ.",
"cbk_badPhone": "10 ಅಂಕಿಯ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ನೀಡಿ",
"cbk_noName": "ನಿಮ್ಮ ಹೆಸರು ನೀಡಿ",
"cbk_error": "ಕಳುಹಿಸಲು ಆಗಲಿಲ್ಲ. {n} ಗೆ ಕರೆ ಮಾಡಿ.",
"cbk_noLogin": "ಲಾಗಿನ್ ಬೇಡವೇ? ನಾವೇ ಕರೆ ಮಾಡುತ್ತೇವೆ →",
"lcb_title": "ಹೊಸ ಗ್ರಾಹಕರ ಕರೆ",
"lcb_accept": "ತೆಗೆದುಕೊಳ್ಳುತ್ತೇನೆ",
"lcb_reject": "ಈಗ ಆಗಲ್ಲ",
"lcb_ago": "{n} ನಿಮಿಷಗಳ ಹಿಂದೆ",
"lcb_accepted": "ತೆಗೆದುಕೊಂಡಿರಿ — ಲೀಡ್ಸ್‌ನಿಂದ ಗ್ರಾಹಕರಿಗೆ ಕರೆ ಮಾಡಿ",
"lcb_rejected": "ಸರಿ — ಶ್ರಮಿಕ ಈ ಗ್ರಾಹಕರಿಗೆ ಸಹಾಯ ಮಾಡುತ್ತದೆ",
"tr_title": "ಹೊಸ ಟ್ರಿಪ್",
"tr_yourPrice": "ನಿಮ್ಮ ದರ",
"tr_accept": "ಒಪ್ಪುತ್ತೇನೆ",
"tr_decline": "ಆಗಲ್ಲ",
"tr_won": "ಟ್ರಿಪ್ ಖಚಿತ",
"tr_taken": "ಬೇರೆಯವರು ತೆಗೆದುಕೊಂಡರು",
"tr_closed": "ಈ ವಿನಂತಿ ಮುಗಿದಿದೆ",
"tr_missedTip": "ಮೊದಲು ಒಪ್ಪುವ ಡ್ರೈವರ್‌ಗೆ ಟ್ರಿಪ್. ಮುಂದಿನ ಬಾರಿ ಬೇಗ ಒಪ್ಪಿಕೊಳ್ಳಿ.",
"tr_declined": "ಬೇಡ ಎಂದಿರಿ",
"tr_free": "ಇಂದು ಟ್ರಿಪ್‌ಗಳಿಗೆ ಖಾಲಿ",
"tr_call": "ಗ್ರಾಹಕರಿಗೆ ಕರೆ ಮಾಡಿ",
"tr_calling": "ಕರೆ ಜೋಡಿಸುತ್ತಿದ್ದೇವೆ — ಮೊದಲು ನಿಮ್ಮ ಫೋನ್ ರಿಂಗ್ ಆಗುತ್ತದೆ",
"tr_over": "ಟ್ರಿಪ್ ಮುಗಿದಿದೆ",
"tr_callErr": "ಕರೆ ಸಿಗಲಿಲ್ಲ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
"tr_people": "{n} ಜನ",
"cbk_close": "ಮುಚ್ಚಿ",
"dk_fRegisterCar": "ನಿಮ್ಮ ಕಾರು ನೋಂದಾಯಿಸಿ",
"dk_fJoinDriver": "ಚಾಲಕರಾಗಿ ಸೇರಿ",
"dk_fTerms": "ನಿಯಮಗಳು",
"dk_fPrivacy": "ಗೌಪ್ಯತೆ",
"dk_fRefunds": "ಮರುಪಾವತಿ",
"dk_fDelete": "ಖಾತೆ ಅಳಿಸಿ",
"bl_title": "ಇನ್ನೊಂದು ಬಿಸಿನೆಸ್‌ಗೆ ಕರೆ ಮಾಡಲು ಸ್ವಲ್ಪ ಕಾಯಿರಿ",
"bl_body": "ಡ್ರೈವರ್‌ಗಳು 6 ಗಂಟೆಗೆ ಒಂದು ಬಿಸಿನೆಸ್‌ಗೆ ಮಾತ್ರ ಕರೆ ಮಾಡಬಹುದು - ಒಂದೇ ವಿಚಾರಣೆ ಮತ್ತೆ ಮತ್ತೆ ತಲುಪದಂತೆ.",
"bl_next": "ಮುಂದಿನ ಕರೆ: {when} ನಂತರ",
"bl_urgent": "ತುರ್ತೇ? ಶ್ರಮಿಕಗೆ ಕರೆ ಮಾಡಿ",
"bl_ok": "ಸರಿ",
"cb_pill": "ಬುಕಿಂಗ್‌ಗೆ ಕರೆ",
"cb_barTitle": "ಯಾವ ಕಾರು ಎಂದು ಗೊತ್ತಿಲ್ಲವೇ? ನಾವೇ ಬುಕ್ ಮಾಡುತ್ತೇವೆ",
"cb_hours": "ಬೆಳಿಗ್ಗೆ 8 – ರಾತ್ರಿ 9 · ತೆಲುಗು, ಹಿಂದಿ, ಇಂಗ್ಲಿಷ್",
"cb_call": "ಕರೆ ಮಾಡಿ",
"cb_or": "ಅಥವಾ ನಮಗೆ ಕರೆ ಮಾಡಿ, ನಾವೇ ಬುಕ್ ಮಾಡುತ್ತೇವೆ:",
"cb_want": "ನಿಮಗಾಗಿ ನಾವೇ ಬುಕ್ ಮಾಡಬೇಕೇ?",
"cb_quiet": "ಕರೆ ಮಾಡಿ ಬುಕ್ ಮಾಡಬೇಕೇ? ನಾವೇ ಬುಕ್ ಮಾಡುತ್ತೇವೆ",
"cb_callUs": "ಕರೆ ಮಾಡಿ",
"hm_guestCardT": "ಒಮ್ಮೆ ಲಾಗಿನ್ - ಯಾವುದೇ ಡ್ರೈವರ್‌ಗೆ ನೇರ ಕರೆ",
"hm_guestCardD": "ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯೊಂದಿಗೆ ಉಚಿತ. ಬುಕಿಂಗ್ ಶುಲ್ಕ ಇಲ್ಲ.",
"hm_loginShort": "ಲಾಗಿನ್",
"vc_speak": "ಮಾತನಾಡಿ",
"vc_listening": "ಈಗ ಮಾತನಾಡಿ…",
"vc_langs": "ತೆಲುಗು · ಹಿಂದಿ · ಇಂಗ್ಲಿಷ್ - ನಿಮ್ಮ ಭಾಷೆಯಲ್ಲೇ",
"vc_stop": "ನಿಲ್ಲಿಸಿ",
"vc_errMic": "ಮಾತನಾಡಲು ಮೈಕ್ ಅನುಮತಿ ನೀಡಿ",
"vc_errNone": "ಏನೂ ಕೇಳಿಸಲಿಲ್ಲ - ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ",
"vc_errOther": "ಈಗ ಧ್ವನಿ ಕೆಲಸ ಮಾಡುತ್ತಿಲ್ಲ - ಟೈಪ್ ಮಾಡಿ",
"sq_phCars": "ಕಾರು, ಊರು, ಪ್ರವಾಸ - ಏನಾದರೂ ಕೇಳಿ",
"sq_phDrivers": "ಚಾಲಕ, ಭಾಷೆ, ಪ್ರವಾಸ - ಏನಾದರೂ ಕೇಳಿ",
"sq_recent": "ನೀವು ಇತ್ತೀಚೆಗೆ ಹುಡುಕಿದವು",
"sq_clear": "ಎಲ್ಲಾ ತೆಗೆಯಿರಿ",
"sq_remove": "ತೆಗೆಯಿರಿ",
"sq_try": "ಹೀಗೆ ಕೇಳಬಹುದು",
"sq_trips": "ಜನಪ್ರಿಯ ಪ್ರವಾಸಗಳು",
"sq_understood": "ಅರ್ಥವಾಯಿತು:",
"sq_goTrip": "ಈ ಪ್ರವಾಸದ ದರಗಳನ್ನು ನೋಡಿ",
"sq_goCars": "ಈ ಕಾರುಗಳನ್ನು ತೋರಿಸಿ",
"sq_goDrivers": "ಈ ಚಾಲಕರನ್ನು ತೋರಿಸಿ",
"sq_speaks": "{lang} ಮಾತನಾಡುವ ಚಾಲಕ",
"sq_ex1": "ನಾಳೆ ತಿರುಪತಿಗೆ 7 ಸೀಟರ್",
"sq_ex2": "ಏರ್‌ಪೋರ್ಟ್ ಡ್ರಾಪ್",
"sq_ex3": "7 ಸೀಟರ್ ಡೀಸೆಲ್",
"sq_ex4": "ನಾಡಿದ್ದು ಹೈದರಾಬಾದ್ ಹೋಗಿ ಬರಲು",
"sq_dx1": "ನಾಳೆ ಬೆಳಿಗ್ಗೆ ಹೈದರಾಬಾದ್ ಹೋಗಿ ಬರಲು",
"sq_dx2": "ಇಂದು ರಾತ್ರಿ ಏರ್‌ಪೋರ್ಟ್ ಡ್ರಾಪ್",
"sq_dx3": "ನಾಳೆ ಹಿಂದಿ ಮಾತನಾಡುವ ಚಾಲಕ",
"sq_dx4": "ನಾಳೆ ತಿರುಪತಿ",
"sq_inDrivers": "ಈ ಹೆಸರಿನಲ್ಲಿ ಕಾರು ಇಲ್ಲ - ಚಾಲಕರಲ್ಲಿ {n} ಸಿಕ್ಕಿದರು ›",
"sq_inCars": "ಈ ಹೆಸರಿನಲ್ಲಿ ಚಾಲಕ ಇಲ್ಲ - ಕಾರುಗಳಲ್ಲಿ {n} ಸಿಕ್ಕಿವೆ ›",
"vr_titleCars": "ನಿಮ್ಮ ಕಾರುಗಳು ಎಷ್ಟು ದೂರದವರೆಗೆ ಕಾಣಬೇಕು?",
"vr_titleDriver": "ನಿಮ್ಮ ಪ್ರೊಫೈಲ್ ಎಷ್ಟು ದೂರದವರೆಗೆ ಕಾಣಬೇಕು?",
"vr_sub": "ಗ್ರಾಹಕರ ಪಿಕಪ್ ನಿಮ್ಮಿಂದ ಈ ದೂರದೊಳಗೆ ಇದ್ದರೆ ನೀವು ಅವರಿಗೆ ಕಾಣುತ್ತೀರಿ.",
"vr_km": "{n} ಕಿ.ಮೀ",
"vr_sramika": "ಶ್ರಮಿಕ",
"vr_legCity": "ಶ್ರಮಿಕ {n} ಕಿ.ಮೀ",
"vr_legOwn": "ನಿಮ್ಮದು {n} ಕಿ.ಮೀ",
"vr_note": "ದೂರ ಹೆಚ್ಚಿದರೆ ಹೆಚ್ಚು ವಿಚಾರಣೆಗಳು ಬರುತ್ತವೆ - ಆದರೆ ಪಿಕಪ್‌ಗೆ ನೀವೇ ಬರಬೇಕು.",
"vr_save": "ಉಳಿಸಿ",
"vr_reset": "ಶ್ರಮಿಕ ದೂರಕ್ಕೇ ({n} ಕಿ.ಮೀ) ಬದಲಿಸಿ",
"vr_saved": "ಉಳಿಸಲಾಗಿದೆ",
"vr_err": "ಉಳಿಸಲಾಗಲಿಲ್ಲ - ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ",
"vr_later": "ನಂತರ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್‌ನಲ್ಲಿ ಬದಲಾಯಿಸಬಹುದು.",
"dk_bizSub": "ಡ್ರೈವರ್‌ಗಳಿಗಾಗಿ.",
"dk_bizCalls": "ಗ್ರಾಹಕರಿಂದ ನೇರ ಕರೆಗಳು",
"dk_bizPrices": "ನಿಮ್ಮದೇ ದರಗಳು",
"dk_bizHours": "ನಿಮ್ಮದೇ ಸಮಯ",
"dk_bizJoin": "ಹೊಸಬರೇ? ಶ್ರಮಿಕಗೆ ಸೇರಿ",
"dk_step1": "ಫಾರ್ಮ್ ತುಂಬಿ",
"dk_step2": "ಶ್ರಮಿಕ ಪರಿಶೀಲಿಸುತ್ತದೆ",
"dk_step3": "ಗ್ರಾಹಕರು ನಿಮಗೆ ಕರೆ ಮಾಡುತ್ತಾರೆ",
"dk_trustCars": "ಪರಿಶೀಲಿಸಿದ ಕಾರುಗಳು",
"dk_trustDrivers": "ಪರಿಶೀಲಿಸಿದ ಚಾಲಕರು",
"dk_trustPrice": "ಕರೆ ಮಾಡುವ ಮೊದಲೇ ದರ",
"dk_trustCallOwner": "ಡ್ರೈವರ್‌ಗೆ ನೇರ ಕರೆ",
"dk_trustCallDriver": "ಚಾಲಕರಿಗೆ ನೇರ ಕರೆ",
"dk_tripReady": "ಎಲ್ಲಾ ಸಿದ್ಧ - ತೋರಿಸುವ ದರಗಳು ಈ ಪ್ರವಾಸಕ್ಕೇ.",
"dk_tripReadyDrivers": "ಎಲ್ಲಾ ಸಿದ್ಧ - ಪ್ರತಿ ಚಾಲಕರ ದರ ಈ ಪ್ರವಾಸಕ್ಕೇ.",
"dk_route": "ಮಾರ್ಗ",
"dk_group": "ಗುಂಪು",
"dk_people": "{n} ಜನ",
"dk_person": "ಒಬ್ಬರು",
"dk_bags": "{n} ಬ್ಯಾಗ್‌ಗಳು",
"dk_bag": "1 ಬ್ಯಾಗ್",
"dk_kmApprox": "ಸುಮಾರು {km} ಕಿ.ಮೀ.",
"hm_linkCopied": "ಲಿಂಕ್ ನಕಲಾಯಿತು - ವಾಟ್ಸಾಪ್‌ನಲ್ಲಿ ಕಳುಹಿಸಿ",
"hm_setPickup": "ಪಿಕಪ್ ಆಗಿ ಇಡಿ",
"hm_goingTo": "{city} ಗೆ ಹೋಗುತ್ತಿದ್ದೀರಾ?",
"hm_canTake": "{city} ಇಂದ {items} ನಿಮ್ಮನ್ನು ಅಲ್ಲಿಗೆ ಕರೆದೊಯ್ಯುತ್ತವೆ",
"hm_setDrop": "ಡ್ರಾಪ್ ಆಗಿ ಇಡಿ",
"hm_seeBasedIn": "{city} ನಲ್ಲಿರುವ ಕಾರುಗಳನ್ನು ನೋಡಿ",
"hm_bTop": "ಟಾಪ್ ರೇಟಿಂಗ್",
"hm_bNearby": "ಹತ್ತಿರ",
"hm_homeReturn": "{city} ಕಾರು · ವಾಪಸ್ ಹೋಗುವಾಗ ನಿಮ್ಮನ್ನು ಕರೆದೊಯ್ಯುತ್ತದೆ",
"rc_badge": "ಶ್ರಮಿಕ ಶಿಫಾರಸು",
"join_vendor": "ಕಾರ್ ವಾಶ್ ಅಥವಾ ಕಾರ್ ತಪಾಸಣೆ ವ್ಯಾಪಾರವೇ? ನಿಮ್ಮ ವ್ಯಾಪಾರವನ್ನು ಸೇರಿಸಿ →",
"rc_checked": "ಶ್ರಮಿಕ ಪರಿಶೀಲಿಸಿದೆ: ದಾಖಲೆಗಳು, ದರಗಳು, ಕರೆಗಳನ್ನು ಸ್ವೀಕರಿಸುತ್ತಾರೆ, ದೂರುಗಳಿಲ್ಲ",
"rc_why": "ಶಿಫಾರಸು ಇರುವ ಕಾರುಗಳು ಹತ್ತಿರದ ಗ್ರಾಹಕರಿಗೆ ಮೇಲೆ ಕಾಣುತ್ತವೆ.",
"rc_has": "{date} ವರೆಗೆ ನಿಮಗಿದೆ",
"rc_c_verified": "ಪರಿಶೀಲಿಸಲಾಗಿದೆ",
"rc_c_profile": "ಎಲ್ಲಾ ದರಗಳನ್ನು ಹಾಕಿ",
"rc_c_answers": "ಕರೆಗಳನ್ನು ಸ್ವೀಕರಿಸಿ",
"rc_c_rated": "ಉತ್ತಮ ರೇಟಿಂಗ್",
"rc_c_price": "ಸರಿಯಾದ ದರ",
"rc_c_clean": "ದೂರುಗಳಿಲ್ಲ",
"hm_bLuxury": "ಐಷಾರಾಮಿ",
"hm_bFamily": "ಫ್ಯಾಮಿಲಿ ಟ್ರಿಪ್",
"hm_bFast": "ತ್ವರಿತ ಬುಕಿಂಗ್",
"hm_bNew": "ಶ್ರಮಿಕದಲ್ಲಿ ಹೊಸ",
"hm_online": "ಆನ್‌ಲೈನ್",
"hm_newTag": "ಹೊಸಬರು",
"hm_viewFare": "ದರ ನೋಡಿ",
"hm_nReviews": "{n} ವಿಮರ್ಶೆಗಳು",
"hm_onTrip": "ಟ್ರಿಪ್‌ನಲ್ಲಿದೆ",
"hm_repair": "ದುರಸ್ತಿಯಲ್ಲಿದೆ",
"hm_age": "ವಯಸ್ಸು {n}",
"hm_yrs": "{yrs} ವರ್ಷ",
"hm_driving": "ಚಾಲನೆ",
"hm_minAway": "{n} ನಿಮಿಷ ದೂರ",
"hm_kmAway": "{km} ಕಿ.ಮೀ ದೂರ",
"hm_aboutKm": "ಸುಮಾರು {km} ಕಿ.ಮೀ",
"hm_under1km": "1 ಕಿ.ಮೀ ಒಳಗೆ",
"hm_distFrom": "{place} ಇಂದ {dist}",
"hm_matchedBy": "ಹೊಂದಿಕೆ: {what}",
"hm_mModel": "ಕಾರು ಮಾಡೆಲ್",
"hm_mBrand": "ಬ್ರಾಂಡ್",
"hm_mDriver": "ಚಾಲಕರ ಹೆಸರು",
"hm_mLang": "ಭಾಷೆ",
"hm_mDetails": "ಕಾರಿನ ವಿವರ",
"hm_mName": "ಹೆಸರು",
"hm_mCity": "ನಗರ",
"hm_mProfile": "ಪ್ರೊಫೈಲ್",
"hm_seePrice": "ಬೆಲೆ ನೋಡಿ",
"hm_saveAmt": "₹{amt} ಉಳಿತಾಯ",
"hm_call": "ಕರೆ",
"hm_viewCar": "{name} ವಿವರ ನೋಡಿ",
"hm_photoOf": "{name} ಫೋಟೋ {n}",
"hm_tooLong": "ಒಬ್ಬ ಚಾಲಕರಿಗೆ ತುಂಬಾ ದೂರ",
"hm_priceOnReq": "ಕೇಳಿದರೆ ಬೆಲೆ",
"hm_oneHr": "1 ಗಂ",
"hm_busy": "ಬ್ಯುಸಿ",
"hm_offline": "ಆಫ್‌ಲೈನ್",
"hm_confirmTitle": "{name} ಗೆ ಕರೆ ಮಾಡಬೇಕೆ?",
"hm_confirmText": "{car} ಬಗ್ಗೆ. ನಿಮ್ಮ ಪ್ರಯಾಣದ ವಿವರಗಳು ಕರೆಯ ಜೊತೆ ಡ್ರೈವರ್‌ಗೆ ಹೋಗುತ್ತವೆ.",
"hm_thePartner": "ಡ್ರೈವರ್",
"hm_cancel": "ಬೇಡ",
"hm_callConnecting": "ನಿಮ್ಮನ್ನು ಡ್ರೈವರ್‌ಗೆ ಸಂಪರ್ಕಿಸುತ್ತಿದ್ದೇವೆ.",
"hm_callFailed": "ಕರೆ ಸಂಪರ್ಕವಾಗಲಿಲ್ಲ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
"hm_partnerBusy": "ಈ ಡ್ರೈವರ್ ಈಗ ಕರೆ ಸ್ವೀಕರಿಸಲು ಆಗುವುದಿಲ್ಲ. ಬೇರೆ ಕಾರು ಪ್ರಯತ್ನಿಸಿ.",
"hm_cantCall": "ಈ ಖಾತೆಯಿಂದ ಡ್ರೈವರ್‌ಗಳಿಗೆ ಕರೆ ಮಾಡಲು ಆಗುವುದಿಲ್ಲ. ಗ್ರಾಹಕರಾಗಿ ಲಾಗಿನ್ ಆಗಿ.",
"hm_findingCars": "{city} ನಲ್ಲಿ ಕಾರುಗಳನ್ನು ಹುಡುಕುತ್ತಿದೆ…",
"hm_findingDrivers": "{city} ನಲ್ಲಿ ಚಾಲಕರನ್ನು ಹುಡುಕುತ್ತಿದೆ…",
"hm_pickCityCars": "ಕಾರುಗಳನ್ನು ನೋಡಲು ನಿಮ್ಮ ನಗರ ಆಯ್ಕೆಮಾಡಿ",
"hm_pickCityDrivers": "ಚಾಲಕರನ್ನು ನೋಡಲು ನಿಮ್ಮ ನಗರ ಆಯ್ಕೆಮಾಡಿ",
"hm_networkGrowing": "ಶ್ರಮಿಕ ಬೆಳೆಯುತ್ತಿದೆ",
"hm_noCarsIn": "{city} ನಲ್ಲಿ ಇನ್ನೂ ಕಾರುಗಳಿಲ್ಲ",
"hm_noCarsText": "ಇಲ್ಲಿ ಡ್ರೈವರ್‌ಗಳನ್ನು ಸೇರಿಸುತ್ತಿದ್ದೇವೆ. ಬೇರೆ ನಗರ ನೋಡಿ, ಅಥವಾ ನಿಮ್ಮ ಬಳಿ ಕಾರು ಇದ್ದರೆ ಸೇರಿ.",
"hm_noDriversIn": "{city} ನಲ್ಲಿ ಇನ್ನೂ ಚಾಲಕರಿಲ್ಲ",
"hm_noDriversText": "ಇಲ್ಲಿ ಚಾಲಕರನ್ನು ಸೇರಿಸುತ್ತಿದ್ದೇವೆ. ಬೇರೆ ನಗರ ನೋಡಿ, ಅಥವಾ ನೀವು ಚಾಲಕರಾಗಿದ್ದರೆ ಸೇರಿ.",
"hm_joinPartner": "ನಿಮ್ಮ ಕಾರಿನೊಂದಿಗೆ ಸೇರಿ",
"hm_joinDriver": "ಚಾಲಕರಾಗಿ ಸೇರಿ",
"hm_supTitle": "ಶ್ರಮಿಕದ ಸಹಾಯ ಬೇಕೇ?",
"hm_supText": "ನಮಗೆ ಕರೆ ಮಾಡಿ. ಸರಿಯಾದ ಕಾರು ಹುಡುಕಲು ಸಹಾಯ ಮಾಡುತ್ತೇವೆ.",
"hm_ocTitle": "{city} ನಲ್ಲಿ ಕಾರುಗಳು ಬೇಕೇ?",
"hm_ocText": "ನಿಮ್ಮ ನಗರ ಈಗ {current}.",
"hm_switchTo": "{city} ಗೆ ಬದಲಿಸಿ",
"hm_lookingFor": "{city} ಹತ್ತಿರ “{q}” ಹುಡುಕುತ್ತಿದೆ…",
"hm_iAccT": "ನಿಮ್ಮ ಖಾತೆ ಹುಡುಕುತ್ತಿದ್ದೀರಾ?",
"hm_iAccD": "ನಿಮ್ಮ ಪ್ರೊಫೈಲ್, ಸೆಟ್ಟಿಂಗ್‌ಗಳು ಖಾತೆಯಲ್ಲಿವೆ.",
"hm_iAccB": "ಖಾತೆ ತೆರೆಯಿರಿ",
"hm_iPartT": "ನಿಮ್ಮ ಕಾರನ್ನು ಶ್ರಮಿಕಕ್ಕೆ ಸೇರಿಸಬೇಕೆ?",
"hm_iPartD": "ನಿಮ್ಮ ಕಾರಿನೊಂದಿಗೆ ಅಥವಾ ಚಾಲಕರಾಗಿ ಶ್ರಮಿಕದಲ್ಲಿ ಬಿಸಿನೆಸ್ ಆಗಿ ಸೇರಿ ಗ್ರಾಹಕರ ಕರೆಗಳನ್ನು ಪಡೆಯಿರಿ. ಕಮಿಷನ್ ಇಲ್ಲ.",
"hm_iTripsT": "ನಿಮ್ಮ ಪ್ರಯಾಣಗಳನ್ನು ಹುಡುಕುತ್ತಿದ್ದೀರಾ?",
"hm_iTripsD": "ನಿಮ್ಮ ವಿಚಾರಣೆಗಳು, ಪ್ರಯಾಣಗಳು ಇತಿಹಾಸದಲ್ಲಿವೆ.",
"hm_iTripsB": "ಇತಿಹಾಸ ತೆರೆಯಿರಿ",
"hm_iPriceT": "ಬೆಲೆ ನೋಡುತ್ತಿದ್ದೀರಾ?",
"hm_iPriceD": "ಪ್ರತಿ ಕಾರಿನ ಬೆಲೆ ನೋಡಲು ಮೇಲೆ ನಿಮ್ಮ ಪ್ರಯಾಣ ಹೊಂದಿಸಿ.",
"hm_iRouteT": "ಎಲ್ಲಿಗಾದರೂ ಹೋಗುತ್ತಿದ್ದೀರಾ?",
"hm_iRouteD": "ನಿಮ್ಮ ಪ್ರಯಾಣ ಹೊಂದಿಸಲು ಮೇಲೆ “ಪಿಕಪ್ ಸ್ಥಳ” ಒತ್ತಿ.",
"hm_noFound": "“{q}” ಗೆ ಕಾರುಗಳು ಸಿಗಲಿಲ್ಲ",
"hm_noDriversFound": "“{q}” ಗೆ ಚಾಲಕರು ಸಿಗಲಿಲ್ಲ",
"hm_noMatchCars": "ನಿಮ್ಮ ಫಿಲ್ಟರ್‌ಗಳಿಗೆ ಹೊಂದುವ ಕಾರುಗಳಿಲ್ಲ",
"hm_noMatchDrivers": "ನಿಮ್ಮ ಫಿಲ್ಟರ್‌ಗಳಿಗೆ ಹೊಂದುವ ಚಾಲಕರಿಲ್ಲ",
"hm_tryThese": "ಇವುಗಳಲ್ಲಿ ಒಂದನ್ನು ಪ್ರಯತ್ನಿಸಿ:",
"hm_clearFilters": "ಫಿಲ್ಟರ್ ತೆಗೆಯಿರಿ",
"hm_hide": "ಮರೆಮಾಡಿ",
"hm_didBookCar": "{car} ಬುಕ್ ಮಾಡಿದಿರಾ?",
"hm_didBookWith": "{name} ಜೊತೆ {car} ಬುಕ್ ಮಾಡಿದಿರಾ?",
"hm_didHire": "{name} ಅವರನ್ನು ನೇಮಿಸಿಕೊಂಡಿರಾ?",
"hm_thanksSaid": "ಧನ್ಯವಾದ - ನೀವು “{answer}” ಎಂದಿರಿ.",
"hm_askLater": "ನಂತರ ಕೇಳಿ",
"hm_joinDriverT": "ನೀವು ಚಾಲಕರೇ?",
"hm_joinDriverD": "ಶ್ರಮಿಕಕ್ಕೆ ಸೇರಿ ಗ್ರಾಹಕರ ಕರೆಗಳನ್ನು ಪಡೆಯಿರಿ.",
"hm_join": "ಸೇರಿ",
"hm_joinCarT": "ನಿಮ್ಮ ಬಳಿ ಕಾರು ಇದೆಯೇ?",
"hm_joinCarD": "ನಿಮ್ಮ ಕಾರನ್ನು ಶ್ರಮಿಕಕ್ಕೆ ಸೇರಿಸಿ ಗ್ರಾಹಕರ ಕರೆಗಳನ್ನು ಪಡೆಯಿರಿ. ಕಮಿಷನ್ ಇಲ್ಲ.",
"hm_myRequests": "ನನ್ನ ಬಾಡಿಗೆ ವಿನಂತಿಗಳು",
"hm_loading": "ಲೋಡ್ ಆಗುತ್ತಿದೆ…",
"hm_reqPending": "ಕಾಯುತ್ತಿದೆ",
"hm_reqAccepted": "ಒಪ್ಪಿದ್ದಾರೆ",
"hm_reqRejected": "ನಿರಾಕರಿಸಿದ್ದಾರೆ",
"hm_halfDay": "ಅರ್ಧ ದಿನ (4 ಗಂ)",
"hm_fullDay": "ಪೂರ್ಣ ದಿನ (8 ಗಂ)",
"hm_rateThisDriver": "ಈ ಚಾಲಕರಿಗೆ ರೇಟಿಂಗ್ ನೀಡಿ",
"hm_rated": "ರೇಟಿಂಗ್ ನೀಡಿದ್ದೀರಿ",
"hm_reqSent": "ವಿನಂತಿ ಕಳುಹಿಸಲಾಗಿದೆ",
"hm_reqSentText": "ಚಾಲಕರು ನಿಮ್ಮ ವಿನಂತಿ ನೋಡಿ ಬೇಗ ಉತ್ತರಿಸುತ್ತಾರೆ.",
"hm_ratingSent": "ರೇಟಿಂಗ್ ಕಳುಹಿಸಲಾಗಿದೆ",
"hm_ratingThanks": "ಧನ್ಯವಾದ. ಇದು ಇತರ ಗ್ರಾಹಕರಿಗೆ ಸಹಾಯ ಮಾಡುತ್ತದೆ.",
"hm_ok": "ಸರಿ",
"mc_custRequest": "ಗ್ರಾಹಕರ ವಿನಂತಿ",
"mc_helpLead": "ಈ ಲೀಡ್‌ನಲ್ಲಿ ಸಹಾಯ ಬೇಕೇ? ಶ್ರಮಿಕಕ್ಕೆ ಕರೆ ಮಾಡಿ",
"ld_stCall": "ಕರೆ ಮಾಡಲಾಗಿದೆ",
"ld_stAccepted": "ಒಪ್ಪಿಕೊಳ್ಳಲಾಗಿದೆ",
"ld_stSuccess": "ಪ್ರಯಾಣ ಯಶಸ್ವಿ",
"ld_stConfirm": "ಖಚಿತಪಡಿಸಬೇಕು",
"ld_stNotBooked": "ಬುಕ್ ಆಗಲಿಲ್ಲ",
"ld_waiting": "ಕಾಯುತ್ತಿದೆ",
"ld_afterTrip": "ಪ್ರಯಾಣದ ನಂತರ",
"ld_chipDone": "ಪೂರ್ಣಗೊಂಡಿದೆ",
"ld_chipConfirm": "ನಿಮ್ಮ ಉತ್ತರ ಬೇಕು",
"ld_chipUpcoming": "ಮುಂಬರುವ",
"ld_chipSent": "ವಿಚಾರಣೆ ಕಳುಹಿಸಲಾಗಿದೆ",
"ld_title": "ವಿಚಾರಣೆಯ ವಿವರಗಳು",
"ld_sub": "ನಿಮ್ಮ ವಿಚಾರಣೆ ನೋಡಿ, ಏನಾಯಿತು ಎಂದು ತಿಳಿಸಿ",
"ld_tripEnquiry": "ಪ್ರಯಾಣ ವಿಚಾರಣೆ",
"ld_sentTo": "{name} ಗೆ ಕಳುಹಿಸಲಾಗಿದೆ",
"ld_sentPartner": "ಡ್ರೈವರ್‌ಗೆ ಕಳುಹಿಸಲಾಗಿದೆ",
"ld_tripDetails": "ಪ್ರಯಾಣದ ವಿವರಗಳು",
"ld_tripDate": "ಪ್ರಯಾಣದ ದಿನಾಂಕ",
"ld_enquiryDate": "ವಿಚಾರಣೆ ದಿನಾಂಕ",
"ld_distance": "ದೂರ",
"ld_passengers": "ಪ್ರಯಾಣಿಕರು",
"ld_vehicle": "ಕೇಳಿದ ವಾಹನ",
"ld_driverReq": "ಕೇಳಿದ ಚಾಲಕ",
"ld_refFare": "ಉಲ್ಲೇಖ ದರ",
"ld_refNote": "ಇದು ನಿಮಗೆ ತೋರಿಸಿದ ಬೆಲೆ. ಅಂತಿಮ ಬೆಲೆಯನ್ನು ಡ್ರೈವರ್ ಜೊತೆ ನೇರವಾಗಿ ನಿರ್ಧರಿಸಲಾಗುತ್ತದೆ.",
"ld_didBook": "ಈ ಕಾರನ್ನು ಬುಕ್ ಮಾಡಿದಿರಾ?",
"ld_didBookDriver": "ಈ ಚಾಲಕರನ್ನು ನೇಮಿಸಿಕೊಂಡಿರಾ?",
"ld_didBookSub": "ಈ ವಿಚಾರಣೆ ಏನಾಯಿತು ಎಂದು ತಿಳಿಸಿ.",
"ld_yes": "ಹೌದು, ಬುಕ್ ಮಾಡಿದೆ",
"ld_yesSub": "ಅವರ ಜೊತೆ ಹೋದೆ",
"ld_no": "ಇಲ್ಲ, ಬುಕ್ ಮಾಡಲಿಲ್ಲ",
"ld_noSub": "ನಾನು ಹೋಗಲಿಲ್ಲ",
"ld_maybe": "ಇನ್ನೂ ನಿರ್ಧರಿಸಿಲ್ಲ",
"ld_maybeSub": "ಇನ್ನೂ ಖಚಿತವಿಲ್ಲ",
"ld_beforeTrip": "ಪ್ರಯಾಣದ ದಿನಾಂಕದ ನಂತರ ಉತ್ತರಿಸಬಹುದು.",
"ld_rateTitle": "ನಿಮ್ಮ ಅನುಭವ ಹೇಗಿತ್ತು?",
"ld_rateSub": "ನಿಮ್ಮ ಸ್ಟಾರ್‌ಗಳು ಇತರ ಗ್ರಾಹಕರು ಆಯ್ಕೆ ಮಾಡಲು ಸಹಾಯ ಮಾಡುತ್ತವೆ.",
"ld_ratePh": "ನಿಮ್ಮ ಅನುಭವದ ಬಗ್ಗೆ ತಿಳಿಸಿ (ಐಚ್ಛಿಕ)",
"ld_rateSend": "ರೇಟಿಂಗ್ ಕಳುಹಿಸಿ",
"ld_rateThanks": "ಧನ್ಯವಾದ - ನೀವು {n} ★ ನೀಡಿದಿರಿ",
"ld_rateErr": "ರೇಟಿಂಗ್ ಉಳಿಸಲಾಗಲಿಲ್ಲ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
"ld_whyTitle": "ಬುಕ್ ಮಾಡದಿದ್ದರೆ, ಏನಾಯಿತು?",
"ld_whySub": "ನಿಮಗೆ ಉತ್ತಮ ಸೇವೆ ನೀಡಲು ಸಹಾಯ (ಐಚ್ಛಿಕ)",
"ld_rHigh": "ಬೆಲೆ ಹೆಚ್ಚು",
"ld_rNotAvail": "ಕಾರು ಲಭ್ಯವಿಲ್ಲ",
"ld_rElsewhere": "ಬೇರೆ ಕಡೆ ಬುಕ್ ಮಾಡಿದೆ",
"ld_rNoResp": "ಪ್ರತಿಕ್ರಿಯೆ ಇಲ್ಲ",
"ld_rPlans": "ಯೋಜನೆ ಬದಲಾಯಿತು",
"ld_rOther": "ಇತರೆ",
"ld_rThanks": "ತಿಳಿಸಿದ್ದಕ್ಕೆ ಧನ್ಯವಾದ.",
"ld_callPartner": "ಡ್ರೈವರ್‌ಗೆ ಕರೆ ಮಾಡಿ",
"ld_callSub": "ಪಾರ್ಟ್ನರ್ ಜೊತೆ ನೇರವಾಗಿ ಮಾತನಾಡಿ",
"mc_tabLeads": "ಲೀಡ್‌ಗಳು",
"mc_tabWallet": "ವಾಲೆಟ್",
"mc_free": "ಲೀಡ್‌ಗಳು ಈಗ ಉಚಿತ.",
"mc_freeSub": "ನಿಮ್ಮ ವಾಲೆಟ್‌ನಿಂದ ಏನೂ ತೆಗೆಯುವುದಿಲ್ಲ.",
"mc_low": "ವಾಲೆಟ್ ₹{min} ಕ್ಕಿಂತ ಕಡಿಮೆ - ಲೀಡ್ ಬರಲು ಹಣ ಸೇರಿಸಿ.",
"mc_addMoney": "ಹಣ ಸೇರಿಸಿ - ಶ್ರಮಿಕಕ್ಕೆ ಕರೆ",
"mc_cars": "ಕಾರುಗಳು",
"mc_available": "ಲಭ್ಯ",
"mc_busy": "ಬ್ಯುಸಿ",
"mc_inReview": "ಪರಿಶೀಲನೆಯಲ್ಲಿ",
"mc_myDrivers": "ನನ್ನ ಚಾಲಕರು",
"mc_limit": "ವಾಹನ ಮಿತಿ ತಲುಪಿದೆ ({n})",
"mc_live": "ಲೈವ್",
"mc_rejected": "ಅನುಮೋದನೆ ಇಲ್ಲ",
"mc_hidden": "ಮರೆಮಾಡಲಾಗಿದೆ",
"mc_availability": "ಲಭ್ಯತೆ",
"mc_onTrip": "ಪ್ರಯಾಣದಲ್ಲಿ",
"mc_maint": "ದುರಸ್ತಿಯಲ್ಲಿ",
"mc_avHint": "ಗ್ರಾಹಕರಿಗೆ ನಿಮ್ಮ ಕಾರಿನ ಮೇಲೆ \"ಪ್ರಯಾಣದಲ್ಲಿ\" ಅಥವಾ \"ದುರಸ್ತಿಯಲ್ಲಿ\" ಎಂದು ಕಾಣುತ್ತದೆ. 24 ಗಂಟೆಗಳ ನಂತರ ಮತ್ತೆ ಲಭ್ಯವಾಗುತ್ತದೆ.",
"mc_addDriver": "ಚಾಲಕ ಸೇರಿಸಿ",
"mc_driver": "ಚಾಲಕ",
"mc_chooseDriver": "ಚಾಲಕರನ್ನು ಆಯ್ಕೆಮಾಡಿ",
"mc_drvPending": "(ಅನುಮೋದನೆಗಾಗಿ)",
"mc_pricesDetails": "ಬೆಲೆ & ವಿವರಗಳು",
"mc_reviewText": "ಶ್ರಮಿಕ ಈ ಕಾರನ್ನು ಪರಿಶೀಲಿಸುತ್ತಿದೆ. ಲೈವ್ ಆದಾಗ ತಿಳಿಸುತ್ತೇವೆ.",
"mc_editsPending": "ನಿಮ್ಮ ಇತ್ತೀಚಿನ ಬದಲಾವಣೆಗಳು ಅನುಮೋದನೆಗಾಗಿ ಕಾಯುತ್ತಿವೆ.",
"mc_rejectedText": "ಈ ಕಾರಿಗೆ ಅನುಮೋದನೆ ಸಿಗಲಿಲ್ಲ. ಕಾರಣ ತಿಳಿಯಲು ಶ್ರಮಿಕಕ್ಕೆ ಕರೆ ಮಾಡಿ.",
"mc_hiddenText": "ಗ್ರಾಹಕರಿಗೆ ಈ ಕಾರು ಕಾಣುವುದಿಲ್ಲ. ಮತ್ತೆ ತೋರಿಸಲು ಶ್ರಮಿಕಕ್ಕೆ ಕರೆ ಮಾಡಿ.",
"mc_noCars": "ಇನ್ನೂ ಕಾರುಗಳಿಲ್ಲ",
"mc_noCarsSub": "ಕರೆಗಳು ಬರಲು ನಿಮ್ಮ ಕಾರು ಸೇರಿಸಿ.",
"mc_regProgress": "ಕಾರು ನೋಂದಣಿ ನಡೆಯುತ್ತಿದೆ",
"mc_regProgressSub": "ನಿಮ್ಮ ಕಾರು ಸಿದ್ಧವಾಗುತ್ತಿದೆ. ಒಂದು ದಿನಕ್ಕಿಂತ ಹೆಚ್ಚು ತೆಗೆದುಕೊಂಡರೆ ಶ್ರಮಿಕಕ್ಕೆ ಕರೆ ಮಾಡಿ.",
"mc_profileReview": "ಪ್ರೊಫೈಲ್ ಪರಿಶೀಲನೆಯಲ್ಲಿದೆ",
"mc_profileReviewSub": "ನಿಮ್ಮ ದಾಖಲೆಗಳನ್ನು ಪರಿಶೀಲಿಸಲಾಗುತ್ತಿದೆ. ಅನುಮೋದನೆಯ ನಂತರ ನಿಮ್ಮ ಕಾರುಗಳು ಲೈವ್ ಆಗುತ್ತವೆ.",
"mc_submitted": "ಕಳುಹಿಸಿದ ದಿನಾಂಕ",
"mc_appId": "ಅರ್ಜಿ ಐಡಿ",
"mc_licExpired": "ಲೈಸೆನ್ಸ್ ಅವಧಿ ಮುಗಿದಿದೆ",
"mc_licExpiredSub": "ನಿಮ್ಮ ಡ್ರೈವಿಂಗ್ ಲೈಸೆನ್ಸ್ ಅವಧಿ ಮುಗಿದಿದೆ. ನವೀಕರಿಸಿ ಮತ್ತೆ ಕಳುಹಿಸಿ.",
"mc_licAgain": "ಲೈಸೆನ್ಸ್ ಫೋಟೋ ಮತ್ತೆ ಬೇಕು",
"mc_licAgainSub": "ನಿಮ್ಮ ಲೈಸೆನ್ಸ್ ಫೋಟೋ ಸ್ಪಷ್ಟವಾಗಿರಲಿಲ್ಲ. ಸ್ಪಷ್ಟ ಫೋಟೋ ಕಳುಹಿಸಿ.",
"mc_loading": "ನಿಮ್ಮ ಕಾರುಗಳು ಲೋಡ್ ಆಗುತ್ತಿವೆ…",
"mc_loadErr": "ಲೋಡ್ ಆಗಲಿಲ್ಲ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
"mc_retry": "ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ",
"mc_relogin": "ಮತ್ತೆ ಲಾಗಿನ್ ಆಗಿ",
"mc_moveDriver": "{a} ಅವರನ್ನು ಈ ಕಾರಿಗೆ ಬದಲಿಸಬೇಕೇ? {b} ಅವರಿಗೆ ಬೇರೆ ಕಾರು ಸಿಗುತ್ತದೆ.",
"mc_replaceDriver": "{a} ಅವರನ್ನು ಈ ಕಾರಿಗೆ ಹಾಕಬೇಕೇ? {b} ಅವರನ್ನು ಇದರಿಂದ ತೆಗೆಯಲಾಗುತ್ತದೆ.",
"mc_assignErr": "ಚಾಲಕರನ್ನು ಬದಲಿಸಲಾಗಲಿಲ್ಲ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
"mc_getMore": "ಹೆಚ್ಚು ಕರೆಗಳನ್ನು ಪಡೆಯಿರಿ",
"mc_getMoreSub": "5 ಸುಲಭ ಹಂತಗಳು",
"mc_leadPrices": "ಲೀಡ್ ಬೆಲೆಗಳು",
"mc_leadPricesSub": "ಒಂದು ಲೀಡ್‌ನ ಬೆಲೆ",
"mc_yourLeads": "ನಿಮ್ಮ ಲೀಡ್‌ಗಳು",
"mc_leadsCount": "{n} · ಹೊಸದು ಮೊದಲು",
"mc_noLeads": "ಇನ್ನೂ ಲೀಡ್‌ಗಳಿಲ್ಲ",
"mc_noLeadsSub": "ಗ್ರಾಹಕರು ಶ್ರಮಿಕದ ಮೂಲಕ ನಿಮಗೆ ಕರೆ ಮಾಡಿದಾಗ ಇಲ್ಲಿ ಕಾಣುತ್ತಾರೆ.",
"mc_new": "ಹೊಸದು",
"mc_called": "ಕರೆ ಮಾಡಿದ್ದಾರೆ",
"mc_booked": "ಬುಕ್ ಆಗಿದೆ",
"mc_custPrice": "ಗ್ರಾಹಕರಿಗೆ ತೋರಿಸಿದ ಬೆಲೆ",
"mc_showNumber": "ನಂಬರ್ ತೋರಿಸಿ",
"mc_revealSoon": "ಗ್ರಾಹಕರ ನಂಬರ್ ತೋರಿಸುವುದು ಶೀಘ್ರದಲ್ಲೇ ಬರಲಿದೆ.",
"mc_didHappen": "ಈ ಪ್ರಯಾಣ ನಡೆಯಿತೇ?",
"mc_youMarked": "ನಿಮ್ಮ ಉತ್ತರ: {answer}",
"mc_locked": "ಬದಲಿಸಲಾಗದು",
"mc_changesLeft": "ಉತ್ತರ ಬದಲಿಸಿ - {n} ಉಳಿದಿವೆ",
"mc_rateCust": "ಈ ಗ್ರಾಹಕರಿಗೆ ರೇಟಿಂಗ್ ನೀಡಿ",
"mc_rated": "ಧನ್ಯವಾದ - ರೇಟಿಂಗ್ ನೀಡಿದಿರಿ",
"mc_leadDetails": "ಲೀಡ್ ವಿವರಗಳು",
"mc_leadDetailsSub": "ಗ್ರಾಹಕರ ವಿಚಾರಣೆ ಮತ್ತು ಏನಾಯಿತು",
"mc_customer": "ಗ್ರಾಹಕ",
"mc_quoted": "ಗ್ರಾಹಕರಿಗೆ ತೋರಿಸಿದ್ದು",
"mc_freeLine": "ಲೀಡ್‌ಗಳು ಈಗ ಉಚಿತ - ಇದರಿಂದ ಏನೂ ತೆಗೆಯುವುದಿಲ್ಲ.",
"mc_chargeLine": "ಲೀಡ್ ಶುಲ್ಕವನ್ನು ಈ ಬ್ಯಾಲೆನ್ಸ್‌ನಿಂದ ತೆಗೆಯಲಾಗುತ್ತದೆ.",
"mc_refer": "ಒಂದು ವ್ಯಾಪಾರವನ್ನು ರೆಫರ್ ಮಾಡಿ",
"mc_referText": "ನೀವು ಆಹ್ವಾನಿಸಿದ ಡ್ರೈವರ್ ಅನುಮೋದನೆ ಪಡೆದಾಗ, ಲೀಡ್ ಶುಲ್ಕಕ್ಕೆ ನಿಮ್ಮಿಬ್ಬರಿಗೂ ಕ್ರೆಡಿಟ್ ಸಿಗುತ್ತದೆ.",
"mc_txns": "ವಹಿವಾಟುಗಳು",
"mc_noTxns": "ಇನ್ನೂ ವಹಿವಾಟುಗಳಿಲ್ಲ",
"mc_tip1": "ಲೀಡ್ ಶುಲ್ಕ ಈ ವಾಲೆಟ್‌ನಿಂದ",
"mc_tip2": "ಬ್ಯಾಲೆನ್ಸ್ ಕಡಿಮೆಯಾದರೆ ಹೊಸ ಲೀಡ್ ನಿಲ್ಲಬಹುದು",
"mc_tip3": "ಸಕ್ರಿಯವಾಗಿರಲು ಯಾವಾಗ ಬೇಕಾದರೂ ಹಣ ಸೇರಿಸಿ",
"cd_title": "ವಾಹನದ ವಿವರಗಳು",
"cd_photosNote": "ಪರಿಶೀಲನೆಯ ನಂತರ ನಂಬರ್ ಪ್ಲೇಟ್‌ಗಳು ತಾನಾಗಿ ಮರೆಯಾಗುತ್ತವೆ.",
"cd_photosMin": "ಕನಿಷ್ಠ 3 ಫೋಟೋ ಸೇರಿಸಿ (ಇನ್ನೂ {n} ಬೇಕು)",
"cd_photosSent": "ಪರಿಶೀಲನೆಗೆ ಕಳುಹಿಸಲಾಗಿದೆ. ಅನುಮೋದನೆಯ ನಂತರ ಹೊಸ ಫೋಟೋಗಳು ಕಾಣುತ್ತವೆ.",
"cd_addPhoto": "ಫೋಟೋ ಸೇರಿಸಿ",
"cd_replace": "ಬದಲಿಸಿ",
"cd_remove": "ತೆಗೆದುಹಾಕಿ",
"cd_newTag": "ಹೊಸದು",
"cd_pendingTag": "ಪರಿಶೀಲನೆಯಲ್ಲಿ",
"cd_details": "ಕಾರಿನ ವಿವರಗಳು",
"cd_detailsNote": "ಫೋಟೋ ಮತ್ತು ವಿವರಗಳ ಬದಲಾವಣೆಗಳು ಶ್ರಮಿಕ ಪರಿಶೀಲಿಸಿದ ನಂತರವೇ ಕಾಣುತ್ತವೆ.",
"cd_city": "ನಗರ",
"cd_category": "ಬೆಲೆ ಗುಂಪು",
"cd_categoryNote": "ನಿಮ್ಮ ಮಾಡೆಲ್ ಮತ್ತು ಸೀಟುಗಳಿಂದ ನಿರ್ಧಾರವಾಗುತ್ತದೆ. ತಪ್ಪಾಗಿದ್ದರೆ ಶ್ರಮಿಕಕ್ಕೆ ಕರೆ ಮಾಡಿ.",
"cd_notSet": "ಇನ್ನೂ ನಿಗದಿಯಾಗಿಲ್ಲ",
"cd_acSub": "ಈ ಕಾರಿನಲ್ಲಿ ಎಸಿ ಕೆಲಸ ಮಾಡುತ್ತದೆಯೇ?",
"cd_musicSub": "ಮ್ಯೂಸಿಕ್ ಅಥವಾ ಬ್ಲೂಟೂತ್ ಕೆಲಸ ಮಾಡುತ್ತದೆಯೇ?",
"cd_pricesNote": "ತಕ್ಷಣ ಉಳಿಯುತ್ತದೆ. ಖಾಲಿ ಬಾಕ್ಸ್‌ಗೆ ಬೂದು ಬಣ್ಣದಲ್ಲಿ ತೋರಿಸಿದ ಸೂಚಿತ ಬೆಲೆ ಬಳಸಲಾಗುತ್ತದೆ.",
"cd_rule": "ಬೆಲೆಯನ್ನು 24 ಗಂಟೆಗೆ ಒಮ್ಮೆ ಮಾತ್ರ ಹೆಚ್ಚಿಸಬಹುದು. ಕಡಿಮೆ ಮಾಡುವುದು ಯಾವಾಗ ಬೇಕಾದರೂ.",
"cd_suggestedUsed": "ಖಾಲಿ: ಸೂಚಿತ {v} ಬಳಸಲಾಗುತ್ತದೆ",
"cd_savePrices": "ನನ್ನ ಬೆಲೆ ಉಳಿಸಿ",
"cd_saving": "ಉಳಿಸಲಾಗುತ್ತಿದೆ…",
"cd_saved": "ಉಳಿಸಲಾಗಿದೆ",
"cd_savedMsg": "ನಿಮ್ಮ ಬೆಲೆಗಳು ಉಳಿದಿವೆ.",
"cd_saveErr": "ನಿಮ್ಮ ಬೆಲೆ ಉಳಿಸಲಾಗಲಿಲ್ಲ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
"cd_noCat": "ಈ ಕಾರಿಗೆ ಇನ್ನೂ ಬೆಲೆ ಗುಂಪು ಇಲ್ಲ. ದಯವಿಟ್ಟು ಶ್ರಮಿಕಕ್ಕೆ ಕರೆ ಮಾಡಿ.",
"cd_submit": "ಕಾರಿನ ವಿವರಗಳನ್ನು ಅನುಮೋದನೆಗೆ ಕಳುಹಿಸಿ",
"cd_sending": "ಕಳುಹಿಸಲಾಗುತ್ತಿದೆ…",
"cd_sent": "ಕಳುಹಿಸಲಾಗಿದೆ",
"cd_sentMsg": "ಕಳುಹಿಸಲಾಗಿದೆ! ಶ್ರಮಿಕ ಪರಿಶೀಲಿಸಿ ನಿಮ್ಮ ಬದಲಾವಣೆಗಳನ್ನು ಅನುಮೋದಿಸುತ್ತದೆ.",
"cd_sendErr": "ಕಳುಹಿಸಲಾಗಲಿಲ್ಲ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
"cd_minPhotosErr": "ದಯವಿಟ್ಟು ಕನಿಷ್ಠ 3 ಫೋಟೋ ಇರಿಸಿ.",
"cd_noChange": "ಯಾವುದೇ ಬೆಲೆ ಬದಲಾಗಿಲ್ಲ",
"hl_phNote": "ಉದಾ: ನನ್ನ ಕಾರು ಆಟೋಮ್ಯಾಟಿಕ್, ಹಿಂದಿ ಮಾತನಾಡುವ ಚಾಲಕ ಬೇಕು...",
"hl_noteHint": "ನಿಮ್ಮ ವಿಚಾರಣೆಯೊಂದಿಗೆ ಚಾಲಕರಿಗೆ ಇದು ಕಾಣುತ್ತದೆ.",
"hl_yearFirst": "ಮೊದಲು ವರ್ಷ ನಮೂದಿಸಿ",
"lp_headerSub": "ನಿಮ್ಮ ಪ್ರಯಾಣ ಯೋಜಿಸಿ, ಉತ್ತಮ ಕಾರುಗಳನ್ನು ನೋಡಿ",
"hl_headerSub": "ನಿಮ್ಮ ಪ್ರಯಾಣ ಯೋಜಿಸಿ, ಉತ್ತಮ ಚಾಲಕರನ್ನು ನೋಡಿ",
"lp_whenSub": "ಪ್ರಯಾಣದ ದಿನಾಂಕ ಮತ್ತು ಸಮಯ ಆಯ್ಕೆಮಾಡಿ",
"lp_prefSub": "ಇನ್ನಷ್ಟು ವಿವರಗಳನ್ನು ತಿಳಿಸಿ",
"lp_optional": "(ಐಚ್ಛಿಕ)",
"lp_clear": "ತೆರವುಗೊಳಿಸಿ",
"hl_carTitle": "ಚಾಲಕ ಓಡಿಸಬೇಕಾದ ನಿಮ್ಮ ಕಾರು",
"hl_carSub": "ನಿಮ್ಮ ಕಾರಿನ ವರ್ಷ ಮತ್ತು ಮಾಡೆಲ್",
"hl_year": "ವರ್ಷ",
"hl_model": "ಮಾಡೆಲ್",
"hl_fuel": "ಇಂಧನ ಪ್ರಕಾರ",
"hl_phYear": "ಉದಾ: 2018",
"hl_phModel": "ಮಾಡೆಲ್ ಹುಡುಕಿ",
"hl_phFuel": "ಮಾಡೆಲ್‌ನಿಂದ ತಾನಾಗಿ ತುಂಬುತ್ತದೆ",
"hl_car": "ನಿಮ್ಮ ಕಾರು",
"hl_farPickup": "{area} {city} ನಿಂದ 30 ಕಿ.ಮೀ ಗಿಂತ ಹೆಚ್ಚು ದೂರದಲ್ಲಿದೆ. 30 ಕಿ.ಮೀ ಒಳಗಿನ ಸ್ಥಳ ಆಯ್ಕೆಮಾಡಿ, ಅಥವಾ ನಗರ ಬದಲಿಸಿ.",
"hl_tooFar": "{from} ನಿಂದ {to} {km} ಕಿ.ಮೀ - ಒಬ್ಬ ಚಾಲಕನ ಮಿತಿ {max} ಕಿ.ಮೀ. ದಯವಿಟ್ಟು {max} ಕಿ.ಮೀ ಒಳಗಿನ ಗಮ್ಯ ಆಯ್ಕೆಮಾಡಿ.",
"hl_noPlace": "ನಿಮ್ಮ ಸ್ಥಳದಿಂದ ಜಾಗದ ಹೆಸರು ಸಿಗಲಿಲ್ಲ - ದಯವಿಟ್ಟು ನಿಮ್ಮ ನಗರ ಟೈಪ್ ಮಾಡಿ.",
"navDashboard": "ಡ್ಯಾಶ್‌ಬೋರ್ಡ್",
"ac_language_sub": "ಆ್ಯಪ್ ಭಾಷೆ ಬದಲಿಸಿ",
"ac_support": "ಸಹಾಯ",
"ac_support_sub": "ಸಹಾಯ & ಪ್ರಶ್ನೆಗಳು",
"ac_settings": "ಸೆಟ್ಟಿಂಗ್ಸ್",
"ac_settings_sub": "ಪ್ರೊಫೈಲ್ & ಆದ್ಯತೆಗಳು",
"ac_profileInfo": "ಪ್ರೊಫೈಲ್ ಮಾಹಿತಿ",
"ac_profileInfo_sub": "ಹೆಸರು, ಇಮೇಲ್, ಫೋನ್ ಬದಲಿಸಿ",
"ac_prefCity": "ಆದ್ಯತೆಯ ನಗರ",
"ac_prefCity_sub": "ಡೀಫಾಲ್ಟ್ ನಗರ ಬದಲಿಸಿ",
"ac_terms": "ನಿಯಮಗಳು",
"ac_terms_sub": "ನಿಯಮಗಳು & ಷರತ್ತುಗಳು",
"ac_privacy": "ಗೌಪ್ಯತೆ",
"ac_privacy_sub": "ಗೌಪ್ಯತಾ ನೀತಿ",
"ac_history_sub": "ನಿಮ್ಮ ವಿಚಾರಣೆಗಳು, ಹಿಂದಿನ ಪ್ರಯಾಣಗಳು",
"ac_notifications": "ಅಧಿಸೂಚನೆಗಳು",
"ac_notif_sub_user": "ಪ್ರಯಾಣ & ಖಾತೆ ಅಪ್‌ಡೇಟ್‌ಗಳು",
"ac_notif_sub": "ಖಾತೆ ಅಪ್‌ಡೇಟ್‌ಗಳು",
"ac_ownerDash": "ಡ್ರೈವರ್ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್",
"ac_ownerDash_sub": "ಲೀಡ್‌ಗಳು, ಕಾರುಗಳು, ವಾಲೆಟ್",
"ac_myCars": "ನನ್ನ ಕಾರುಗಳು",
"ac_myCars_sub": "ನಿಮ್ಮ ವಾಹನಗಳ ಪಟ್ಟಿ",
"ac_addVehicle": "ವಾಹನ ಸೇರಿಸಿ",
"ac_addVehicle_sub": "ಇನ್ನೊಂದು ಕಾರನ್ನು ಅನುಮೋದನೆಗೆ ಕಳುಹಿಸಿ",
"ac_driverDash": "ಚಾಲಕರ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್",
"ac_driverDash_sub": "ನಿಮ್ಮ ಲೀಡ್‌ಗಳು, ದರಗಳು, ಸ್ಥಿತಿ",
"ac_menuUser": "ನನ್ನ ಖಾತೆ",
"ac_menuUser_sub": "ನಿಮ್ಮ ಪ್ರಯಾಣಗಳು & ಖಾತೆ",
"ac_menuOwner": "ಡ್ರೈವರ್ ಮೆನು",
"ac_menuOwner_sub": "ವಾಹನಗಳು & ಡ್ರೈವರ್ ಕೆಲಸಗಳು",
"ac_menuDriver": "ಬಾಡಿಗೆ ಚಾಲಕ ಮೆನು",
"ac_menuDriver_sub": "ನಿಮ್ಮ ಲೀಡ್‌ಗಳು & ಸ್ಥಿತಿ",
"ac_menuAgent": "ಫೀಲ್ಡ್ ಏಜೆಂಟ್ ಮೆನು",
"ac_menuAgent_sub": "ನಿಮ್ಮ ರೆಫರಲ್ ಕೋಡ್ & ಖಾತೆ",
"ac_menuGeneral": "ಸಾಮಾನ್ಯ ಆಯ್ಕೆಗಳು",
"ac_menuGeneral_sub": "ಖಾತೆ & ಆ್ಯಪ್ ಆದ್ಯತೆಗಳು",
"ac_account": "ಖಾತೆ",
"ac_editProfile": "ಪ್ರೊಫೈಲ್ ಬದಲಿಸಿ",
"ac_changePhoto": "ಪ್ರೊಫೈಲ್ ಫೋಟೋ ಬದಲಿಸಿ",
"ac_verified": "ಪರಿಶೀಲಿಸಲಾಗಿದೆ",
"ac_back": "ಹಿಂದೆ",
"ac_pendingTitle": "ಬಿಸಿನೆಸ್ ಅರ್ಜಿ ಪರಿಶೀಲನೆಯಲ್ಲಿದೆ",
"ac_pendingText": "ನಿಮ್ಮ ಬಿಸಿನೆಸ್ ಅರ್ಜಿಯನ್ನು ಅಡ್ಮಿನ್ ಪರಿಶೀಲಿಸುತ್ತಿದ್ದಾರೆ. ಅನುಮೋದನೆ ಆದ ತಕ್ಷಣ ತಿಳಿಸುತ್ತೇವೆ.",
"ac_strength": "ಪ್ರೊಫೈಲ್ ಬಲ",
"ac_strengthDone": "ಪೂರ್ಣ - ಎಲ್ಲಾ ಸಿದ್ಧ!",
"ac_strengthGood": "ಉತ್ತಮ ಸ್ಥಿತಿ",
"ac_strengthLow": "ಅಪೂರ್ಣ - ಪ್ರೊಫೈಲ್ ಪೂರ್ಣಗೊಳಿಸಿ",
"ac_searchPh": "ಸೆಟ್ಟಿಂಗ್ಸ್, ಡ್ಯಾಶ್‌ಬೋರ್ಡ್ ಹುಡುಕಿ…",
"ac_clearSearch": "ಹುಡುಕಾಟ ತೆರವುಗೊಳಿಸಿ",
"ac_noMatch": "ಏನೂ ಸಿಗಲಿಲ್ಲ",
"ac_tryElse": "ಬೇರೆ ಏನಾದರೂ ಹುಡುಕಿ",
"ac_inSection": "{section} ನಲ್ಲಿ",
"ac_agentCode": "ರೆಫರಲ್ ಕೋಡ್",
"ac_agentCodeSub": "ನೀವು ಸೇರಿಸುತ್ತಿರುವ ಡ್ರೈವರ್‌ಗೆ ಇದನ್ನು ಕೊಡಿ",
"ac_noCode": "ಇನ್ನೂ ಕೋಡ್ ಇಲ್ಲ",
"ac_copy": "ನಕಲಿಸಿ",
"ac_copied": "ನಕಲಾಗಿದೆ",
"ac_working": "ಕೆಲಸ ನಡೆಯುತ್ತಿದೆ…",
"ac_genNew": "ಹೊಸ ಕೋಡ್ ರಚಿಸಿ",
"ac_gen": "ಕೋಡ್ ರಚಿಸಿ",
"ac_agentNote": "ಡ್ರೈವರ್ ಸೇರುವಾಗ ಇದನ್ನು ನಮೂದಿಸಬೇಕು, ಆಗ ಅದು ಮಾನ್ಯವಾಗಿರಬೇಕು. ಹೊಸ ಕೋಡ್ ರಚಿಸಿದರೆ ಹಳೆಯದು ಕೆಲಸ ಮಾಡುವುದಿಲ್ಲ.",
"ac_agentConfirm": "ಹೊಸ ಕೋಡ್ ರಚಿಸಬೇಕೇ? ನಿಮ್ಮ ಈಗಿನ ಕೋಡ್ ತಕ್ಷಣ ನಿಲ್ಲುತ್ತದೆ, ಅದನ್ನು ಬರೆದಿಟ್ಟವರು ಬಳಸಲಾಗುವುದಿಲ್ಲ. ಈಗಾಗಲೇ ಸೇರಿದ ಖಾತೆಗಳ ಕ್ರೆಡಿಟ್ ಹಾಗೇ ಇರುತ್ತದೆ.",
"ac_agentErr": "ಕೋಡ್ ರಚಿಸಲಾಗಲಿಲ್ಲ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
"ac_refer": "ರೆಫರ್ ಮಾಡಿ ಗಳಿಸಿ",
"ac_referCustSub": "ಡ್ರೈವರ್ ಅಥವಾ ಆಲ್ಟಿಂಗ್ ಡ್ರೈವರ್‌ನನ್ನು ಆಹ್ವಾನಿಸಿ",
"ac_referCustSubR": "ಡ್ರೈವರ್ ಅಥವಾ ಆಲ್ಟಿಂಗ್ ಡ್ರೈವರ್‌ನನ್ನು ಆಹ್ವಾನಿಸಿ, ಪ್ರತಿಯೊಬ್ಬರಿಗೆ ₹{amt} ಪಡೆಯಿರಿ",
"ac_referCustText": "ಕ್ಯಾಬ್ ಇರುವವರು ಅಥವಾ ಬಾಡಿಗೆಗೆ ಓಡಿಸುವವರು ಗೊತ್ತೇ? ನಿಮ್ಮ ಕೋಡ್ ಹಂಚಿಕೊಳ್ಳಿ. ಅವರ ಖಾತೆ ಅನುಮೋದನೆ ಆದ ತಕ್ಷಣ ನಿಮ್ಮ ಶ್ರಮಿಕ ವಾಲೆಟ್‌ಗೆ {reward} ಬರುತ್ತದೆ.",
"ac_aCredit": "ರೆಫರಲ್ ಕ್ರೆಡಿಟ್",
"ac_share": "ಹಂಚಿಕೊಳ್ಳಿ",
"ac_approved": "ಅನುಮೋದಿತ",
"ac_waiting": "ಕಾಯುತ್ತಿದೆ",
"ac_yourWallet": "ನಿಮ್ಮ ವಾಲೆಟ್",
"ac_referBizSub": "ಇನ್ನೊಬ್ಬ ಡ್ರೈವರ್ ಅಥವಾ ಆಲ್ಟಿಂಗ್ ಡ್ರೈವರ್‌ನನ್ನು ಆಹ್ವಾನಿಸಿ",
"ac_referBizSubR": "ಇನ್ನೊಬ್ಬ ಡ್ರೈವರ್‌ನನ್ನು ಆಹ್ವಾನಿಸಿ - ಇಬ್ಬರಿಗೂ ₹{amt}",
"ac_referSoon": "ನಿಮ್ಮ ಖಾತೆ ಅನುಮೋದನೆ ಆದ ತಕ್ಷಣ ರೆಫರಲ್ ಕೋಡ್ ಬರುತ್ತದೆ.",
"ac_referBizText": "ನಿಮ್ಮ ಕೋಡ್ ಹಂಚಿಕೊಳ್ಳಿ. ಅವರ ಖಾತೆ ಅನುಮೋದನೆ ಆದಾಗ, ಲೀಡ್ ಶುಲ್ಕಕ್ಕೆ ನಿಮ್ಮಿಬ್ಬರಿಗೂ {credit} ಸಿಗುತ್ತದೆ.",
"ac_creditAmt": "₹{amt} ಕ್ರೆಡಿಟ್",
"ac_credit": "ಕ್ರೆಡಿಟ್",
"ac_pickCar": "ರೆಫರಲ್ ಯಾವ ಕಾರಿಗೆ ದಾಖಲಾಗಬೇಕು ಎಂದು ಆಯ್ಕೆಮಾಡಿ.",
"ac_spaces": "ಖಾಲಿ ಜಾಗ, ಗೆರೆಗಳನ್ನು ಲೆಕ್ಕಿಸುವುದಿಲ್ಲ - ಹೇಗೆ ಟೈಪ್ ಮಾಡಿದರೂ ಕೆಲಸ ಮಾಡುತ್ತದೆ.",
"ac_oneWallet": "ನಿಮ್ಮ ಯಾವುದೇ ಕೋಡ್‌ನ ಕ್ರೆಡಿಟ್ ನಿಮ್ಮ ಒಂದೇ ವಾಲೆಟ್‌ಗೆ ಬರುತ್ತದೆ.",
"ac_car": "ಕಾರು {id}",
"ac_calcTitle": "ಓಡೋಮೀಟರ್ & ದರ ಲೆಕ್ಕಾಚಾರ",
"ac_calcSub": "ಓಡೋಮೀಟರ್ ರೀಡಿಂಗ್‌ನಿಂದ ದರ ಅಂದಾಜು",
"ac_startOdo": "ಆರಂಭದ ರೀಡಿಂಗ್ (ಕಿ.ಮೀ)",
"ac_endOdo": "ಕೊನೆಯ ರೀಡಿಂಗ್ (ಕಿ.ಮೀ)",
"ac_endLess": "ಕೊನೆಯ ರೀಡಿಂಗ್ ಆರಂಭಕ್ಕಿಂತ ಹೆಚ್ಚಿರಬೇಕು.",
"ac_calcBtn": "ದರ ಲೆಕ್ಕಹಾಕಿ",
"ac_calcNone": "ಈ ನಗರದಲ್ಲಿ ಈ ಪ್ರಯಾಣ ಮತ್ತು ಕಾರಿಗೆ ಇನ್ನೂ ದರ ಇಲ್ಲ.",
"ac_pricedAs": "ಲೆಕ್ಕದ ವಿಧಾನ: {mode}",
"ac_estNote": "ನಗರದ ಸೂಚಿತ ದರಗಳಲ್ಲಿ ಅಂದಾಜು - ಅಂತಿಮ ದರವನ್ನು ಡ್ರೈವರ್ ಜೊತೆ ಖಚಿತಪಡಿಸಿ. ಟೋಲ್, ಪಾರ್ಕಿಂಗ್, ರಾಜ್ಯ ಪರ್ಮಿಟ್ ಹೆಚ್ಚುವರಿ.",
"ac_seats": "{n} ಸೀಟುಗಳು",
"ac_logout": "ಲಾಗ್ ಔಟ್",
"ac_loading": "ಪ್ರೊಫೈಲ್ ಲೋಡ್ ಆಗುತ್ತಿದೆ…",
"ac_takePhoto": "ಫೋಟೋ ತೆಗೆಯಿರಿ",
"ac_gallery": "ಗ್ಯಾಲರಿಯಿಂದ ಆಯ್ಕೆಮಾಡಿ",
"ac_removePhoto": "ಫೋಟೋ ತೆಗೆದುಹಾಕಿ",
"ac_cancel": "ರದ್ದುಮಾಡಿ",
"ms_title": "ಇನ್ನಷ್ಟು ಸೇವೆಗಳು",
"ms_sub": "ಕಾರು & ಪ್ರಯಾಣದ ಎಲ್ಲ ಸೇವೆಗಳು ಒಂದೇ ಕಡೆ",
"ms_towing": "ವಾಹನ ಟೋಯಿಂಗ್ ವ್ಯಾನ್",
"ms_towing_sub": "ನಿಮ್ಮ ವಾಹನವನ್ನು ಸುರಕ್ಷಿತವಾಗಿ ಸಾಗಿಸಿ",
"ms_school": "ಡ್ರೈವಿಂಗ್ ಶಾಲೆಗಳು",
"ms_school_sub": "ಪ್ರಮಾಣಿತ ತರಬೇತುದಾರರಿಂದ ಕಲಿಯಿರಿ",
"ms_lease": "ಮಾಸಿಕ ಕಾರು ಲೀಸ್",
"ms_lease_sub": "ಚಾಲಕರೊಂದಿಗೆ ಕಾರುಗಳು, ಮಾಸಿಕ ಒಪ್ಪಂದ",
"ms_tours": "ಪ್ರವಾಸಗಳು & ಪ್ಯಾಕೇಜ್‌ಗಳು",
"ms_tours_sub": "ಗುಂಪು & ವೈಯಕ್ತಿಕ ಪ್ರವಾಸದ ದರಗಳು",
"ms_wash": "ಮನೆಯಲ್ಲೇ ಕಾರು ತೊಳೆಯುವಿಕೆ",
"ms_wash_sub": "ಮನೆ ಬಾಗಿಲಲ್ಲೇ ತೊಳೆಯುವಿಕೆ",
"ms_mechanic": "ಮನೆಯಲ್ಲೇ ಕಾರು ಮೆಕ್ಯಾನಿಕ್",
"ms_mechanic_sub": "ನಂಬಿಕೆಯ ಮೆಕ್ಯಾನಿಕ್‌ಗಳು ನಿಮ್ಮ ಮನೆಗೇ",
"ms_accessories": "ಆಕ್ಸೆಸರಿ ಫಿಟ್ಟಿಂಗ್",
"ms_accessories_sub": "ಆಕ್ಸೆಸರಿಗಳನ್ನು ಮನೆಗೆ ತಂದು ಅಳವಡಿಸುತ್ತೇವೆ",
"ms_soon": "ಶೀಘ್ರದಲ್ಲೇ ಬರಲಿದೆ",
"ms_noneYet": "ನಿಮ್ಮ ನಗರದಲ್ಲಿ ಇನ್ನೂ ಯಾವ ಸೇವೆಯೂ ಇಲ್ಲ - ನಮಗೆ ಕರೆ ಮಾಡಿ ನಿಮ್ಮ ಅಗತ್ಯ ತಿಳಿಸಿ.",
"ms_soonText": "{service} ಶೀಘ್ರದಲ್ಲೇ ನಿಮ್ಮ ನಗರಕ್ಕೆ ಬರಲಿದೆ. ಮೊದಲೇ ಬೇಕೇ? ನಮಗೆ ಕರೆ ಮಾಡಿ ನಿಮ್ಮ ಅಗತ್ಯ ತಿಳಿಸಿ.",
"ms_callUs": "ಶ್ರಮಿಕಕ್ಕೆ ಕರೆ ಮಾಡಿ",
"ms_close": "ಮುಚ್ಚಿ",
"ms_footer": "ಇನ್ನಷ್ಟು ಸೇವೆಗಳು ಶೀಘ್ರದಲ್ಲೇ · ಸಂಪರ್ಕಿಸಿ: {email}",
"navHireDriver": "ಚಾಲಕರು",
"hs_title": "ಇತಿಹಾಸ",
"hs_active": "ಸಕ್ರಿಯ",
"hs_past": "ಹಿಂದಿನವು",
"hs_loading": "ನಿಮ್ಮ ಇತಿಹಾಸ ಲೋಡ್ ಆಗುತ್ತಿದೆ…",
"hs_emptyTitle": "ಇನ್ನೂ ಏನೂ ಇಲ್ಲ",
"hs_emptyText": "ನಿಮ್ಮ ಕಾರು ವಿಚಾರಣೆಗಳು ಮತ್ತು ಪ್ರಯಾಣದ ಇತಿಹಾಸ ಇಲ್ಲಿ ಕಾಣುತ್ತವೆ.",
"hs_findCar": "ಕಾರು ಹುಡುಕಿ",
"hs_activeEmpty": "ಈಗ ಏನೂ ಇಲ್ಲ. ನೀವು ಮಾಡುವ ವಿಚಾರಣೆಗಳು ಪ್ರಯಾಣದ ದಿನಾಂಕದವರೆಗೆ ಇಲ್ಲಿ ಇರುತ್ತವೆ.",
"hs_pastEmpty": "ಇಲ್ಲಿ ಇನ್ನೂ ಏನೂ ಇಲ್ಲ.",
"hs_filterAll": "ಎಲ್ಲಾ",
"hs_filterNone": "ಈ ಆಯ್ಕೆಗೆ ಏನೂ ಇಲ್ಲ.",
"hs_signInTitle": "ನನ್ನ ಇತಿಹಾಸ",
"hs_signInText": "ನಿಮ್ಮ ವಿಚಾರಣೆಗಳು ಮತ್ತು ಪ್ರಯಾಣಗಳನ್ನು ನೋಡಲು ಸೈನ್ ಇನ್ ಮಾಡಿ.",
"hs_signIn": "ಸೈನ್ ಇನ್",
"hs_rateTitle": "ನಿಮ್ಮ ಕೊನೆಯ ಪ್ರಯಾಣ ಹೇಗಿತ್ತು?",
"hs_rateTap": "ರೇಟ್ ಮಾಡಲು ನಕ್ಷತ್ರ ಒತ್ತಿ",
"hs_rateLow": "ನಿಮ್ಮ ಅನುಭವ ಸುಧಾರಿಸಲು ಪ್ರಯತ್ನಿಸುತ್ತೇವೆ",
"hs_rateMid": "ನಿಮ್ಮ ಅಭಿಪ್ರಾಯಕ್ಕೆ ಧನ್ಯವಾದಗಳು!",
"hs_rateHigh": "ನಿಮ್ಮ ಪ್ರಯಾಣ ಚೆನ್ನಾಗಿತ್ತು ಎಂದು ಸಂತೋಷ!",
"hs_rateSubmit": "ರೇಟಿಂಗ್ ಸಲ್ಲಿಸಿ",
"hs_rateLater": "ನಂತರ",
"hs_rateHelps": "ನಿಮ್ಮ ರೇಟಿಂಗ್ ಮುಂದಿನ ಪ್ರಯಾಣಗಳನ್ನು ಸುಧಾರಿಸುತ್ತದೆ.",
"hs_rateVerified": "ನಿಮ್ಮ ಖಾತೆಯನ್ನು ಈಗ ಶ್ರಮಿಕ ಪರಿಶೀಲಿಸಿದೆ!",
"hs_rateDriver": "ಚಾಲಕರಿಗೆ ರೇಟ್ ಮಾಡಿ",
"hs_editRating": "ರೇಟಿಂಗ್ ಬದಲಿಸಿ",
"hs_chatDriver": "ಚಾಲಕರೊಂದಿಗೆ ಚಾಟ್",
"hs_paid": "ಪಾವತಿ: ₹{amt}",
"hs_stBooked": "ಬುಕ್ ಆಗಿದೆ",
"hs_stNotBooked": "ಬುಕ್ ಆಗಿಲ್ಲ",
"hs_stDeciding": "ಇನ್ನೂ ನಿರ್ಧರಿಸಿಲ್ಲ",
"hs_stContacted": "ಚಾಲಕರನ್ನು ಸಂಪರ್ಕಿಸಿದ್ದೀರಿ",
"hs_stSent": "ವಿಚಾರಣೆ ಕಳುಹಿಸಲಾಗಿದೆ",
"hs_oneWay": "ಒಂದು ಕಡೆ",
"hs_roundTrip": "ರೌಂಡ್ ಟ್ರಿಪ್",
"hs_enquiry": "ವಿಚಾರಣೆ",
"hs_callName": "{name}ಗೆ ಕರೆ ಮಾಡಿ",
"hs_callDriver": "ಚಾಲಕರಿಗೆ ಕರೆ ಮಾಡಿ",
"hs_askBooked": "ಈ ಪ್ರಯಾಣವನ್ನು ಬುಕ್ ಮಾಡಿದ್ದೀರಾ?",
"hs_yes": "ಹೌದು",
"hs_no": "ಇಲ್ಲ",
"hs_notYet": "ಇನ್ನೂ ಇಲ್ಲ",
"hs_saveFailedRow": "ಉಳಿಸಲಾಗಲಿಲ್ಲ - ವಿಚಾರಣೆ ತೆರೆದು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
"hs_saidBooked": "ನೀವು ಬುಕ್ ಮಾಡಿದ್ದೀರಿ ಎಂದು ಹೇಳಿದ್ದೀರಿ",
"hs_saidNot": "ನೀವು ಬುಕ್ ಮಾಡಿಲ್ಲ ಎಂದು ಹೇಳಿದ್ದೀರಿ",
"hs_saidDeciding": "ನೀವು ಇನ್ನೂ ನಿರ್ಧರಿಸಿಲ್ಲ ಎಂದು ಹೇಳಿದ್ದೀರಿ",
"hs_details": "ವಿವರಗಳು",
"hs_sheetTitle": "ಪ್ರಯಾಣ ವಿಚಾರಣೆ",
"hs_pickup": "ಪಿಕಪ್",
"hs_drop": "ಡ್ರಾಪ್",
"hs_tripType": "ಪ್ರಯಾಣದ ಪ್ರಕಾರ",
"hs_distTime": "ದೂರ / ಸಮಯ",
"hs_vehicle": "ವಾಹನ",
"hs_partner": "ಪಾರ್ಟ್ನರ್",
"hs_enquiryMade": "ವಿಚಾರಣೆ ಮಾಡಿದ ದಿನಾಂಕ",
"hs_timesCalled": "ಕರೆ ಮಾಡಿದ ಬಾರಿ",
"hs_quoted": "ನಿಮಗೆ ತಿಳಿಸಿದ ದರ",
"hs_quotedNote": "ನೀವು ವಿಚಾರಿಸಿದಾಗ ತೋರಿಸಿದ ದರ. ಅಂತಿಮ ದರವನ್ನು ಪಾರ್ಟ್ನರ್ ಜೊತೆ ಖಚಿತಪಡಿಸಿ.",
"hs_whatHappened": "ಏನಾಯಿತು",
"hs_tlCreated": "ವಿಚಾರಣೆ ಆರಂಭವಾಯಿತು",
"hs_tlViewed": "ನೀವು {car} ನೋಡಿದಿರಿ",
"hs_tlShared": "ಸಂಖ್ಯೆ ಹಂಚಲಾಯಿತು",
"hs_tlSharedNote": "ಪಾರ್ಟ್ನರ್ ಸಂಖ್ಯೆಯನ್ನು ನಿಮಗೆ ತೋರಿಸಲಾಯಿತು",
"hs_tlCalled": "ನೀವು ಪಾರ್ಟ್ನರ್‌ಗೆ ಕರೆ ಮಾಡಿದಿರಿ",
"hs_tlCalls": "ಒಟ್ಟು {n} ಕರೆಗಳು",
"hs_tlAnswered": "ನೀವು ಉತ್ತರಿಸಿದಿರಿ",
"hs_youBooked": "ನೀವು ಈ ಪ್ರಯಾಣ ಬುಕ್ ಮಾಡಿದ್ದೀರಿ",
"hs_youNot": "ನೀವು ಈ ಪ್ರಯಾಣ ಬುಕ್ ಮಾಡಿಲ್ಲ",
"hs_youDeciding": "ನೀವು ಇನ್ನೂ ನಿರ್ಧರಿಸುತ್ತಿದ್ದಿರಿ",
"hs_changeAnswer": "ಉತ್ತರ ಬದಲಿಸಿ",
"hs_noMoreChanges": "ಇನ್ನು ಬದಲಿಸಲು ಆಗುವುದಿಲ್ಲ",
"hs_changesLeft": "ಉಳಿದ ಬದಲಾವಣೆಗಳು: {n}",
"hs_changeYour": "ನಿಮ್ಮ ಉತ್ತರ ಬದಲಿಸಿ",
"hs_askWhy": "ಇದರಿಂದ ನಿಮಗೆ ಉತ್ತಮ ಕ್ಯಾಬ್‌ಗಳನ್ನು ತೋರಿಸಬಹುದು - ಡ್ರೈವರ್‌ಗಳಿಗೂ ಉಪಯೋಗ.",
"hs_ansYes": "ಹೌದು, ಬುಕ್ ಮಾಡಿದೆ",
"hs_ansNo": "ಇಲ್ಲ, ಮಾಡಿಲ್ಲ",
"hs_keep": "ನನ್ನ ಉತ್ತರ ಹಾಗೇ ಇರಲಿ",
"hs_saveErr": "ಉಳಿಸಲಾಗಲಿಲ್ಲ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
"hs_callAgain": "{name}ಗೆ ಮತ್ತೆ ಕರೆ ಮಾಡಿ",
"hs_callPartner": "ಪಾರ್ಟ್ನರ್‌ಗೆ ಕರೆ ಮಾಡಿ",
"hs_hrs": "{n} ಗಂ",
"hs_close": "ಮುಚ್ಚಿ",
"hs_yourRequest": "ನಿಮ್ಮ ಬೇಡಿಕೆ",
"hs_passengers": "ಪ್ರಯಾಣಿಕರು: {n}",
"hs_luggage": "ಲಗೇಜ್: {n}",
"hs_noLuggage": "ಲಗೇಜ್ ಇಲ್ಲ",
"hs_helpEnquiry": "ಈ ವಿಚಾರಣೆಗೆ ಸಹಾಯ ಬೇಕೇ? ಶ್ರಮಿಕಕ್ಕೆ ಕರೆ ಮಾಡಿ",
"lp_route": "ಪಿಕಪ್ & ಡ್ರಾಪ್",
"lp_lblPickup": "ಪಿಕಪ್ ಸ್ಥಳ",
"lp_lblDrop": "ಡ್ರಾಪ್ ಸ್ಥಳ",
"lp_cityLine": "ನಗರ: {city}",
"lp_change": "ಬದಲಿಸಿ",
"lp_sameAsDrivers": "ಚಾಲಕರಲ್ಲಿ ಇಟ್ಟ ಅದೇ ಪ್ರವಾಸವೇ?",
"lp_sameAsCars": "ಕಾರುಗಳಲ್ಲಿ ಇಟ್ಟ ಅದೇ ಪ್ರವಾಸವೇ?",
"lp_sameYes": "ಹೌದು, ಅದೇ",
"lp_sameNo": "ಇಲ್ಲ, ಹೊಸ ಪ್ರವಾಸ",
"lp_swap": "ಪಿಕಪ್ ಮತ್ತು ಡ್ರಾಪ್ ಅದಲುಬದಲು",
"lp_when": "ಯಾವಾಗ",
"lp_pickupWhen": "ಪಿಕಪ್",
"lp_returnWhen": "ಹಿಂದಿರುಗುವಿಕೆ",
"lp_today": "ಇಂದು",
"lp_tomorrow": "ನಾಳೆ",
"lp_sameDay": "ಅದೇ ದಿನ",
"lp_nextDay": "ಮರುದಿನ",
"lp_otherDate": "ಬೇರೆ ದಿನಾಂಕ",
"lp_pickTime": "ಸಮಯ ಆಯ್ಕೆ",
"lp_distanceLine": "ಸುಮಾರು {km} ಕಿ.ಮೀ · {time}",
"lp_hrMin": "{h} ಗಂ {m} ನಿ",
"lp_minOnly": "{m} ನಿ",
"lp_stillNeeded": "ಇನ್ನೂ ಬೇಕು: {list}",
"lp_noteLabel": "ಡ್ರೈವರ್‌ಗೆ ಟಿಪ್ಪಣಿ",
"lp_noteHint": "ಇದು ನಿಮ್ಮ ವಿಚಾರಣೆಯೊಂದಿಗೆ ಡ್ರೈವರ್‌ಗೆ ಕಾಣುತ್ತದೆ.",
"pricesPerCarNote": "ಪ್ರತಿ ಕಾರಿಗೂ ಬೆಲೆಗಳು ಪ್ರತ್ಯೇಕವಾಗಿರುತ್ತವೆ. ನೋಡಲು ಅಥವಾ ಬದಲಿಸಲು ನಿಮ್ಮ ಕಾರನ್ನು ತೆರೆಯಿರಿ.",
"changeMyPrices": "ನನ್ನ ಬೆಲೆಗಳನ್ನು ಬದಲಿಸಿ",
"lp_btnAddStop": "+ ಸ್ಟಾಪ್ ಸೇರಿಸಿ",
"lp_btnDetectLocation": "📍 ಸ್ಥಳ ಪತ್ತೆಮಾಡಿ",
"lp_btnDetecting": "ಪತ್ತೆ ಮಾಡಲಾಗುತ್ತಿದೆ…",
"lp_btnViewCabs": "ಕ್ಯಾಬ್‌ಗಳನ್ನು ನೋಡಿ",
"lp_btnViewDrivers": "ಚಾಲಕರನ್ನು ನೋಡಿ",
"lp_btnViewDrivers": "ಚಾಲಕರನ್ನು ನೋಡಿ",
"lp_btnCompleteDetails": "ಪ್ರಯಾಣ ವಿವರ ಭರ್ತಿಮಾಡಿ",
"lp_tabRoundTrip": "ರೌಂಡ್ ಟ್ರಿಪ್",
"lp_tabOneWay": "ಡ್ರಾಪಿಂಗ್",
"lp_tripDetails": "ಪ್ರಯಾಣ ವಿವರಗಳು",
"lp_hireDetails": "ಪ್ರಯಾಣ ವಿವರಗಳು",
"lp_tripPreferencesOptional": "ಪ್ರಯಾಣ ಆದ್ಯತೆಗಳು (ಐಚ್ಛಿಕ)",
"lp_lblPickupCity": "ಪಿಕ್ಅಪ್ ನಗರ",
"lp_phTypeCity": "ನಗರ ಟೈಪ್ ಮಾಡಿ",
"lp_lblExactLocation": "ನಿಖರ ಸ್ಥಳ",
"lp_phPrecisePickup": "ನಿಖರ ಪಿಕ್ಅಪ್ ಸ್ಥಳ ನಮೂದಿಸಿ",
"lp_lblPickupSchedule": "ಪಿಕ್ಅಪ್ ವೇಳಾಪಟ್ಟಿ",
"lp_phStop": "ಸ್ಟಾಪ್ {n}",
"lp_lblFinalDestination": "ಅಂತಿಮ ಗಮ್ಯಸ್ಥಾನ",
"lp_phDropLocation": "ಡ್ರಾಪ್ ಸ್ಥಳ ನಮೂದಿಸಿ",
"lp_lblReturnSchedule": "ರಿಟರ್ನ್ ವೇಳಾಪಟ್ಟಿ",
"lp_lblDropSchedule": "ಡ್ರಾಪ್ ಆಫ್ ಮಾಡಬೇಕಾದ ಸಮಯ",
"lp_hintOneWayReturnCost": "ನಿಮ್ಮನ್ನು ಮತ್ತು ನಿಮ್ಮ ವಾಹನವನ್ನು ಇಳಿಸಿದ ನಂತರ ಚಾಲಕರು ಸ್ವಂತವಾಗಿ ಹಿಂತಿರುಗುತ್ತಾರೆ. ಆ ಹಿಂತಿರುಗುವ ಪ್ರಯಾಣದ ವೆಚ್ಚ ಈ ದರದಲ್ಲಿ ಸೇರಿಲ್ಲ - ದಯವಿಟ್ಟು ಕರೆಯಲ್ಲಿ ಚಾಲಕರೊಂದಿಗೆ ನೇರವಾಗಿ ಒಪ್ಪಂದ ಮಾಡಿಕೊಳ್ಳಿ.",
"lp_lblPassengers": "ನಿಮ್ಮ ಗುಂಪಿನ ಪ್ರಯಾಣಿಕರು",
"lp_subLblGroupCab": "ನಿಮ್ಮ ಗುಂಪು ಸಂಪೂರ್ಣ ಕ್ಯಾಬ್ ಬುಕ್ ಮಾಡುತ್ತದೆ",
"lp_lblLuggage": "ಲಗೇಜ್",
"lp_lblStops": "ಸ್ಟಾಪ್ಗಳು",
"lp_errSameLocation": "ಪಿಕ್ಅಪ್ ಮತ್ತು ಡ್ರಾಪ್ ಒಂದೇ ಸ್ಥಳವಾಗಿರಬಾರದು",
"lp_errReturnTooEarly": "{from} ನಿಂದ {to} ಗೆ ಸುಮಾರು {hours} ಗಂಟೆಗಳು ಬೇಕಾಗುತ್ತದೆ - ದಯವಿಟ್ಟು ನಂತರದ ರಿಟರ್ನ್ ಸಮಯ ಆಯ್ಕೆಮಾಡಿ",
"lp_backHomeBy": "ಮನೆಗೆ ಮರಳುವ ಸಮಯ",
"lp_errBackTooEarly": "{from} ನಿಂದ {to} ಗೆ ಹೋಗಿ ಬರಲು ಸುಮಾರು {hours} ಗಂಟೆಗಳು ಬೇಕಾಗುತ್ತದೆ - ದಯವಿಟ್ಟು ನಂತರದ ಸಮಯ ಆಯ್ಕೆಮಾಡಿ",
"lp_hintCalculatingRoute": "ಮಾರ್ಗ ಲೆಕ್ಕ ಹಾಕಲಾಗುತ್ತಿದೆ…",
"lp_phNote": "ಉದಾ. ನನಗೆ ಬೇಬಿ ಸೀಟ್, ಪೆಟ್ ಫ್ರೆಂಡ್ಲಿ ಕ್ಯಾಬ್ ಬೇಕು...",
"lp_promoRoundTrip": "ರೌಂಡ್ ಟ್ರಿಪ್ ಅಥವಾ ಮಲ್ಟಿ-ಸ್ಟಾಪ್?",
"lp_promoMoreStops": "ನಿಮ್ಮ ಪ್ರಯಾಣ ಯೋಜಿಸಲು ಹೆಚ್ಚು ಸ್ಟಾಪ್ಗಳನ್ನು ಸೇರಿಸಿ.",
"lp_toastLocSuccess": "ಸ್ಥಳ ಪತ್ತೆಯಾಗಿದೆ ✅",
"lp_toastLocDeny": "ಈ ವೈಶಿಷ್ಟ್ಯ ಬಳಸಲು ನಿಮ್ಮ ಬ್ರೌಸರ್ನಲ್ಲಿ ಸ್ಥಳ ಪ್ರವೇಶ ಅನುಮತಿಸಿ",
"lp_errMissingFields": "ಕಡ್ಡಾಯ ಕ್ಷೇತ್ರಗಳು ಕಾಣೆ: {list}",
"lp_errCity": "ದಯವಿಟ್ಟು ನಗರ ಆಯ್ಕೆಮಾಡಿ.",
"lp_errPickupDt": "ದಯವಿಟ್ಟು ಪಿಕ್ಅಪ್ ದಿನಾಂಕ ಮತ್ತು ಸಮಯ ಆಯ್ಕೆಮಾಡಿ.",
"lp_errPickupTimeLimit": "ಪಿಕ್ಅಪ್ ಸಮಯ ಈಗಿನಿಂದ ಕನಿಷ್ಠ 30 ನಿಮಿಷಗಳ ನಂತರ ಇರಬೇಕು.",
"lp_errReturnDt": "ದಯವಿಟ್ಟು ರಿಟರ್ನ್/ಅಂತ್ಯ ದಿನಾಂಕ ಮತ್ತು ಸಮಯ ಆಯ್ಕೆಮಾಡಿ.",
"lp_errReturnTimeLimit": "ರಿಟರ್ನ್ ಸಮಯ ಪಿಕ್ಅಪ್ ಸಮಯದ ನಂತರ ಇರಬೇಕು.",
"lp_errReturnMaxLimit": "ರಿಟರ್ನ್ ದಿನಾಂಕ ಪಿಕ್ಅಪ್ನಿಂದ 10 ದಿನಗಳ ಒಳಗೆ ಇರಬೇಕು",
"lp_errPickupLoc": "ದಯವಿಟ್ಟು ನಿಮ್ಮ ಪಿಕ್ಅಪ್ ಸ್ಥಳ ನಮೂದಿಸಿ.",
"lp_errPickupRadius": "ದಯವಿಟ್ಟು {city} ಯಿಂದ {km} ಕಿ.ಮೀ ಒಳಗೆ ಸ್ಥಳ ಆಯ್ಕೆಮಾಡಿ.",
"lp_errDestLoc": "ದಯವಿಟ್ಟು ನಿಮ್ಮ ಗಮ್ಯಸ್ಥಾನ ನಮೂದಿಸಿ.",
"lp_errDestRadius": "ದಯವಿಟ್ಟು ನಿಮ್ಮ ಪಿಕ್ಅಪ್ನಿಂದ 1000 ಕಿ.ಮೀ ಒಳಗೆ ಗಮ್ಯಸ್ಥಾನ ಆಯ್ಕೆಮಾಡಿ.",
"lp_errStopValid": "ದಯವಿಟ್ಟು ಸಲಹೆಗಳಿಂದ ಸ್ಟಾಪ್ ಆಯ್ಕೆಮಾಡಿ.",
"lp_errStopRadius": "ದಯವಿಟ್ಟು ನಿಮ್ಮ ಪಿಕ್ಅಪ್ನಿಂದ 1000 ಕಿ.ಮೀ ಒಳಗೆ ಸ್ಟಾಪ್ ಆಯ್ಕೆಮಾಡಿ.",
"awaitingDriverResponse": "ಚಾಲಕನ ಪ್ರತಿಕ್ರಿಯೆಗಾಗಿ ಕಾಯಲಾಗುತ್ತಿದೆ",
"driverConnected": "ಚಾಲಕ ಸಂಪರ್ಕಗೊಂಡಿದ್ದಾರೆ",
"driverAccepted": "ಚಾಲಕ ಒಪ್ಪಿಕೊಂಡಿದ್ದಾರೆ",
"tripConfirmed": "ಪ್ರಯಾಣ ಖಚಿತಪಡಿಸಲಾಗಿದೆ",
"rideStarted": "ಸವಾರಿ ಪ್ರಾರಂಭವಾಗಿದೆ",
"rideCompleted": "ಸವಾರಿ ಪೂರ್ಣಗೊಂಡಿದೆ",
"connectionFeePaid": "ಸಂಪರ್ಕ ಶುಲ್ಕ ಪಾವತಿಸಲಾಗಿದೆ",
"waitingForPickup": "ಪಿಕಪ್‌ಗಾಗಿ ಕಾಯುತ್ತಿದೆ",
"manageTrip": "ಪ್ರಯಾಣ ನಿರ್ವಹಿಸಿ",
"tripType": "ಪ್ರಯಾಣದ ಪ್ರಕಾರ",
"createdOn": "ರಚಿಸಿದ ದಿನಾಂಕ",
"currentStatus": "ಈಗಿನ ಸ್ಥಿತಿ",
"connectionFee": "ಸಂಪರ್ಕ ಶುಲ್ಕ",
"estimatedFare": "ಅಂದಾಜು ದರ",
"tripId": "ಪ್ರಯಾಣ ಐಡಿ",
"actualDriverName": "ಚಾಲಕರ ನಿಜವಾದ ಹೆಸರು",
"waitingForDriverAcceptance": "ಚಾಲಕರ ಒಪ್ಪಿಗೆಗಾಗಿ ಕಾಯುತ್ತಿದೆ",
"vehicleName": "ವಾಹನದ ಹೆಸರು",
"vehicleDetailsAvailableAfter": "ಚಾಲಕರು ಖಚಿತಪಡಿಸಿದ ನಂತರ ವಾಹನದ ವಿವರಗಳು ಕಾಣುತ್ತವೆ.",
"paidUsingWallet": "ವಾಲೆಟ್ ಮೂಲಕ ಪಾವತಿಸಲಾಗಿದೆ",
"paidUsingCredit": "1 ಉಚಿತ ಕರೆ ಕ್ರೆಡಿಟ್ ಬಳಸಲಾಗಿದೆ",
"finalFareConfirmedDirectly": "ಅಂತಿಮ ದರವನ್ನು ನೀವು ಮತ್ತು ಡ್ರೈವರ್ ನಡುವೆ ನೇರವಾಗಿ ನಿರ್ಧರಿಸಲಾಗುತ್ತದೆ.",
"tripTimeline": "ಪ್ರಯಾಣದ ಹಂತಗಳು",
"contactSupport": "ಶ್ರಮಿಕದ ಸಹಾಯವನ್ನು ಸಂಪರ್ಕಿಸಿ",
"needHelp": "ಸಹಾಯ ಬೇಕೇ?",
"upcomingTrips": "ಮುಂಬರುವವು",
"previousTrips": "ಹಿಂದಿನವು",
"connectingIvrCall": "ಶ್ರಮಿಕ ಐವಿಆರ್ ಮೂಲಕ ನಿಮ್ಮ ಕರೆ ಸಂಪರ್ಕಿಸುತ್ತಿದ್ದೇವೆ. ನಮ್ಮ ವ್ಯವಸ್ಥೆ ನಿಮಗೆ ಕರೆ ಮಾಡುವವರೆಗೆ ಕಾಯಿರಿ.",
"callConnectionFailed": "ಕರೆ ಸಂಪರ್ಕಿಸಲು ಆಗಲಿಲ್ಲ.",
"callError": "ಕರೆ ಆರಂಭಿಸಲು ಆಗಲಿಲ್ಲ.",
"pickupAddress": "??????? ?????",
"destination": "ಗಮ್ಯಸ್ಥಾನ",
"vehicleNumber": "ವಾಹನದ ನಂಬರ್",
"callHistory": "ಕರೆ ಇತಿಹಾಸ",
"callDriverToBook": "???????? ??? ????",
"loadingCalls": "ಕರೆಗಳನ್ನು ತರುತ್ತಿದ್ದೇವೆ…",
"noCallsMade": "ಇನ್ನೂ ಯಾವುದೇ ಕರೆ ಮಾಡಿಲ್ಲ.",
    "completeProfile": "ನಿಮ್ಮ ಪ್ರೊಫೈಲ್ ಅನ್ನು ಪೂರ್ಣಗೊಳಿಸಿ",
    "sramikaWallet": "ಶ್ರಮಿಕ ವಾಲೆಟ್",
    "walletBalance": "ವಾಲೆಟ್ ಬ್ಯಾಲೆನ್ಸ್",
    "viewWallet": "ವಾಲೆಟ್ ವೀಕ್ಷಿಸಿ",

    "walletRemaining": "ಬಾಕಿ ಉಳಿದಿದೆ",
    "walletInfoTitle": "ಶ್ರಮಿಕ ನಿಮಗಾಗಿ ಸಂಪರ್ಕಿಸುವ ಕರೆಗಳಿಗೆ ಪಾವತಿಸಲು ಮಾತ್ರ ಈ ವಾಲೆಟ್.",
    "walletInfo1": "ಈ ವಾಲೆಟ್‌ಗೆ ಸೇರಿಸಿದ ಹಣವನ್ನು ಹಿಂತೆಗೆದುಕೊಳ್ಳಲು ಸಾಧ್ಯವಿಲ್ಲ.",
    "walletInfo2": "ಪ್ರತಿ {hours} ಗಂಟೆಗೆ {free} ಕರೆಗಳು ಉಚಿತ. ಅದರ ನಂತರ ಸಂಪರ್ಕವಾಗುವ ಪ್ರತಿ ಕರೆಗೆ ₹{fee}; ಕರೆ ಸಂಪರ್ಕವಾಗದಿದ್ದರೆ ಏನೂ ತೆಗೆದುಕೊಳ್ಳುವುದಿಲ್ಲ.",
    "walletAddMoney": "ಹಣ ಸೇರಿಸಿ",
    "walletEnterAmount": "ಮೊತ್ತ ನಮೂದಿಸಿ",
    "walletRecharge": "ವಾಲೆಟ್ ರೀಚಾರ್ಜ್ ಮಾಡಿ",
    "walletProcessing": "ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಲಾಗುತ್ತಿದೆ...",
    "walletNoTxns": "ಇನ್ನೂ ಯಾವುದೇ ವಾಲೆಟ್ ವಹಿವಾಟುಗಳಿಲ್ಲ.",
    "walletNoTxnsSub": "ನೀವು ಸೇರಿಸಿದ ಹಣ ಮತ್ತು ಕರೆ ಶುಲ್ಕಗಳು ಇಲ್ಲಿ ಕಾಣುತ್ತವೆ.",
    "walletTxnRecharge": "ರೀಚಾರ್ಜ್",
    "walletTxnServiceFee": "ಕನೆಕ್ಷನ್ ಶುಲ್ಕ",
    "walletTxnRefund": "ಮರುಪಾವತಿ",
    "callDriverToBook": "ಚಾಲಕರಿಗೆ ಕರೆ ಮಾಡಿ ಬುಕ್ ಮಾಡಿ","getDriversNumber": "ಚಾಲಕರ ಸಂಖ್ಯೆ ಪಡೆಯಿರಿ","appName": "ಶ್ರಮಿಕ",
    "appSubtitle": "ಹತ್ತಿರದ ಕಾರ್ ಟ್ರಾವೆಲ್ಸ್",
    "onb_skip": "ತಪ್ಪಿಸಿ",
    "onb_getStarted": "ಪ್ರಾರಂಭಿಸಿ",
    "onb_p1_sign": "ಹತ್ತಿರದ ಕಾರುಗಳು",
    "onb_p1_title": "ಹತ್ತಿರದ ಡ್ರೈವರ್‌ಗಳನ್ನು ಹುಡುಕಿ",
    "onb_p1_sub": "ಹತ್ತಿರದ ಡ್ರೈವರ್ ಜೊತೆ ನೇರವಾಗಿ ಸಂಪರ್ಕ ಸಾಧಿಸಿ.",
    "onb_p1_badge": "ಕ್ಯಾಬ್ ಖಾತೆಗಳಿಗೆ 0% ಕಮಿಷನ್",
    "onb_p2_sign": "ಹತ್ತಿರದ ಚಾಲಕರು",
    "onb_p2_title": "ಹತ್ತಿರದ ವೈಯಕ್ತಿಕ ಚಾಲಕರನ್ನು ನೇಮಿಸಿಕೊಳ್ಳಿ",
    "onb_p2_sub": "ಹತ್ತಿರದ ಚಾಲಕರೊಂದಿಗೆ ನೇರವಾಗಿ ಸಂಪರ್ಕ ಸಾಧಿಸಿ.",
    "onb_p2_badge": "ಚಾಲಕರಿಗೆ 0% ಕಮಿಷನ್",
    "onb_p3_sign": "ವಿಶ್ವಾಸಾರ್ಹ ಜನರೊಂದಿಗೆ ನಿಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸುತ್ತೇವೆ",
    "onb_p3_title": "ಆಯ್ಕೆ ಮಾಡಲು ಸಹಾಯ ಬೇಕೇ?",
    "onb_p3_sub": "ನಮ್ಮ ಬೆಂಬಲ ತಂಡವು ಸರಿಯಾದ ಡ್ರೈವರ್ ಜೊತೆ ನಿಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸುತ್ತದೆ.",
    "onb_p3_badge": "ಬೆಂಬಲ ಸಹಾಯಕ್ಕೆ 0% ಕಮಿಷನ್",
    "onb_p4_sign1": "ಕ್ಯಾಬ್ ಬಾಡಿಗೆಗೆ",
    "onb_p4_sign2": "ಚಾಲಕ ಬಾಡಿಗೆಗೆ",
    "onb_p4_sign3": "ಹೆಚ್ಚಿನ ಸೇವೆಗಳು",
    "onb_p4_title": "ನಿಮಗೆ ಬೇಕಾದ ಎಲ್ಲವೂ ಒಂದೇ ಸ್ಥಳದಲ್ಲಿ",
    "onb_p4_sub": "ಕ್ಯಾಬ್‌ಗಳು ಮತ್ತು ಚಾಲಕರನ್ನು ನೇಮಿಸಿಕೊಳ್ಳಿ ಮತ್ತು ಹೆಚ್ಚಿನ ಪ್ರಯಾಣ ಸೇವೆಗಳನ್ನು ಅನ್ವೇಷಿಸಿ.",
    "onb_p4_badge": "ಹೆಚ್ಚಿನ ಸೇವೆಗಳ ಮೇಲೆ 0% ಕಮಿಷನ್",
    "onb_p5_sign": "ಒಂದೇ ಆ್ಯಪ್. ಹಲವು ಪ್ರಯಾಣ ಸೇವೆಗಳು.",
    "onb_p5_title": "ಪ್ರಾರಂಭಿಸೋಣ",
    "onb_p5_sub": "ಹತ್ತಿರದ ಸೇವೆಗಳೊಂದಿಗೆ ಜಾಣತನದಿಂದ ಪ್ರಯಾಣಿಸಿ.",
    "onb_p5_badge": "ಯಾವಾಗಲೂ 0% ಕಮಿಷನ್",
    "onb_lang_title": "ನಿಮ್ಮ ಭಾಷೆಯಲ್ಲಿ, ನಿಮ್ಮ ಅನುಕೂಲಕ್ಕಾಗಿ",
    "onb_lang_sub": "ಮಾಹಿತಿಯನ್ನು ನಿಮ್ಮ ಸ್ಥಳೀಯ ಭಾಷೆಯಲ್ಲಿ ತೋರಿಸಲಾಗುತ್ತದೆ.",
    "onb_footer": "ಸ್ಥಳೀಯ ಬೆಂಬಲ. ಸ್ಥಳೀಯ ಭಾಷೆ. ಉತ್ತಮ ಅನುಭವ.",
    "onb_language": "ಭಾಷೆ",
    "onb_intentTagline": "ಹತ್ತಿರದ ಕ್ಯಾಬ್‌ಗಳು & ಚಾಲಕರು",
    "onb_intentTitle": "ನೀವು ಶ್ರಮಿಕವನ್ನು ಹೇಗೆ ಬಳಸಲು ಬಯಸುತ್ತೀರಿ?",
    "onb_intentSub": "ಮುಂದುವರಿಯಲು ಒಂದು ಆಯ್ಕೆಯನ್ನು ಆರಿಸಿ",
    "onb_intentRide": "ಕ್ಯಾಬ್‌ಗಳು & ಚಾಲಕರನ್ನು ಹುಡುಕಿ",
    "onb_intentRideSub": "ಲೋಕಲ್ ಅಥವಾ ಔಟ್‌ಸ್ಟೇಷನ್ ಕ್ಯಾಬ್ ಬುಕ್ ಮಾಡಿ, ಅಥವಾ ನಿಮ್ಮ ಕಾರಿಗೆ ಚಾಲಕರನ್ನು ನೇಮಿಸಿಕೊಳ್ಳಿ.",
    "onb_intentEarn": "ಶ್ರಮಿಕದ ಜೊತೆ ಗಳಿಸಲು ಬಯಸುವಿರಾ?",
    "onb_intentCab": "ಕ್ಯಾಬ್ ಖಾತೆಯಾಗಿ ಸೇರಿ",
    "onb_intentCabSub": "ನಿಮ್ಮ ಕ್ಯಾಬ್ ನೋಂದಾಯಿಸಿ, ಗ್ರಾಹಕರಿಂದ ನೇರವಾಗಿ ಕರೆಗಳನ್ನು ಪಡೆಯಿರಿ.",
    "onb_intentDriver": "ಬಾಡಿಗೆ ಚಾಲಕರಾಗಿ ಸೇರಿ",
    "onb_intentDriverSub": "ಕಾರು ಅಗತ್ಯವಿಲ್ಲ. ಗ್ರಾಹಕರ ಕಾರುಗಳನ್ನು ಓಡಿಸಿ, ಗಂಟೆ ಅಥವಾ ದಿನದ ಲೆಕ್ಕದಲ್ಲಿ ಗಳಿಸಿ.",
    // The /join page for ads (Oct 2026).
    "join_title": "ಶ್ರಮಿಕದೊಂದಿಗೆ ಗಳಿಸಿ",
    "join_subShort": "ಗ್ರಾಹಕರು ನೇರವಾಗಿ ನಿಮಗೆ ಕರೆ ಮಾಡುತ್ತಾರೆ.",
    "join_codeLine": "ಕೋಡ್ {code} · ಅನುಮೋದನೆಯ ನಂತರ ₹{amount}",
    "join_codeOnly": "ಕೋಡ್ {code}",
    "join_car": "ನನ್ನ ಬಳಿ ಕಾರು ಇದೆ",
    "join_carNeed": "ಲೈಸೆನ್ಸ್, ಆರ್‌ಸಿ, ಕಾರಿನ ಫೋಟೋಗಳು · 15 ನಿಮಿಷ",
    "join_drv": "ಡ್ರೈವಿಂಗ್ ಬರುತ್ತದೆ, ಕಾರು ಇಲ್ಲ",
    "join_drvNeed": "ಲೈಸೆನ್ಸ್, ಫೋಟೋ, ನಿಮ್ಮ ದರಗಳು · 10 ನಿಮಿಷ",
    "join_needACar": "ಕಾರು ಬೇಕೆ?",
    "join_seeCarsShort": "ಕಾರುಗಳನ್ನು ನೋಡಿ",
    "onb_skipForNow": "ಈಗ ಬಿಟ್ಟುಬಿಡಿ",
    "newDriver": "ಹೊಸ ಚಾಲಕ",
    "startsFrom": "ಪ್ರಾರಂಭಿಕ ಬೆಲೆ",
    "contactDriver": "ಚಾಲಕರನ್ನು ಸಂಪರ್ಕಿಸಿ",
    "hireDriverTitle": "ಚಾಲಕರನ್ನು ನೇಮಿಸಿಕೊಳ್ಳಿ",
    "driverWillCome": "ಚಾಲಕ ನಿಮ್ಮ ಸ್ಥಳಕ್ಕೆ ಬರುತ್ತಾರೆ",
    "date": "ದಿನಾಂಕ",
    "time": "ಸಮಯ",
    "duration": "ಅವಧಿ",
    "yourCarType": "ನಿಮ್ಮ ಕಾರಿನ ಪ್ರಕಾರ",
    "pickupAddress": "ಪಿಕಪ್ ವಿಳಾಸ",
    "yourPhone": "ನಿಮ್ಮ ಫೋನ್",
    "yourName": "ನಿಮ್ಮ ಹೆಸರು",
    "tripPurpose": "ಪ್ರಯಾಣದ ಉದ್ದೇಶ (ಐಚ್ಛಿಕ)",
    "youPayDriverDirectly": "ನೀವು ನೇರವಾಗಿ ಚಾಲಕನಿಗೆ ಪಾವತಿಸುತ್ತೀರಿ. ಶ್ರಮಿಕ ಯಾವುದೇ ಕಮಿಷನ್ ವಿಧಿಸುವುದಿಲ್ಲ.",
    "rateDriver": "ಚಾಲಕನಿಗೆ ರೇಟಿಂಗ್ ನೀಡಿ",
    "howWasExperience": "ನಿಮ್ಮ ಅನುಭವ ಹೇಗಿತ್ತು?",
    "shortReview": "ಸಣ್ಣ ವಿಮರ್ಶೆ (ಐಚ್ಛಿಕ)",
    "callDriver": "ಚಾಲಕನಿಗೆ ಕರೆ ಮಾಡಿ",
    "filter": "ಫಿಲ್ಟರ್",
    "loadingRequests": "ವಿನಂತಿಗಳನ್ನು ಲೋಡ್ ಮಾಡಲಾಗುತ್ತಿದೆ...",
    "driverWillReview": "ಚಾಲಕ ನಿಮ್ಮ ವಿನಂತಿಯನ್ನು ಪರಿಶೀಲಿಸಿ ಶೀಘ್ರದಲ್ಲೇ ಪ್ರತಿಕ್ರಿಯಿಸುತ್ತಾರೆ.",
    "dismiss": "ವಜಾಗೊಳಿಸಿ",
    "thankYouFeedback": "ನಿಮ್ಮ ಪ್ರತಿಕ್ರಿಯೆಗೆ ಧನ್ಯವಾದಗಳು. ಇದು ಇತರ ಗ್ರಾಹಕರಿಗೆ ಸಹಾಯ ಮಾಡುತ್ತದೆ.",
    "selectCityHire": "ನಿಮ್ಮ ಹತ್ತಿರದ ಚಾಲಕರನ್ನು ನೋಡಲು ನಗರವನ್ನು ಆಯ್ಕೆಮಾಡಿ",
    "findingDriversIn": "ನಲ್ಲಿ ಚಾಲಕರನ್ನು ಹುಡುಕಲಾಗುತ್ತಿದೆ",
    "clearAll": "ಎಲ್ಲವನ್ನೂ ತೆರವುಗೊಳಿಸಿ",
    "areYouDriver": "ನೀವು ಚಾಲಕರೇ?",
    "registerAsHireDriver": "ಪಟ್ಟಿ ಮಾಡಲು ಬಾಡಿಗೆ ಚಾಲಕರಾಗಿ ನೋಂದಾಯಿಸಿ",
    "join": "ಸೇರಿ",
    "fareCalculatorTitle": "ದರ ಕ್ಯಾಲ್ಕುಲೇಟರ್",
    "distanceLabel": "ದೂರ",
    "durationLabel": "ಅವಧಿ",
    "booked": "ಕಾಯ್ದಿರಿಸಲಾಗಿದೆ",
    "estimatedFareLabel": "ಅಂದಾಜು ದರ",
    "advanceAlreadyPaid": "ಮುಂಗಡವನ್ನು ಈಗಾಗಲೇ ಪಾವತಿಸಲಾಗಿದೆ",
    "payToDriverLabel": "ಚಾಲಕನಿಗೆ ಪಾವತಿಸಿ",
    "noTripDetails": "ಯಾವುದೇ ಪ್ರವಾಸದ ವಿವರಗಳು ಕಂಡುಬಂದಿಲ್ಲ.",
    "goHome": "ಮುಖಪುಟಕ್ಕೆ ಹೋಗಿ",
    "earnCommissionBooking": "ಈ ಬುಕಿಂಗ್‌ನಲ್ಲಿ ಕಮಿಷನ್ ಗಳಿಸಿ",
    "customerNameReq": "ಗ್ರಾಹಕರ ಹೆಸರು *",
    "customerPhoneReq": "ಗ್ರಾಹಕರ ಫೋನ್ *",
    "yourCab": "ನಿಮ್ಮ ಕ್ಯಾಬ್",
    "paymentSummary": "ಪಾವತಿ ಸಾರಾಂಶ",
    "cabFare": "ಕ್ಯಾಬ್ ದರ",
    "totalTripCost": "ಒಟ್ಟು ಪ್ರವಾಸದ ವೆಚ್ಚ",
    "payNowLabel": "ಈಗ ಪಾವತಿಸಿ:",
    "advance10Percent": "ಮುಂಗಡ (ಕ್ಯಾಬ್ ದರದಲ್ಲಿ 10%)",
    "balanceToDriver": "ಚಾಲಕನಿಗೆ ಉಳಿಕೆ",
    "selectPaymentMethod": "ಪಾವತಿ ವಿಧಾನವನ್ನು ಆಯ್ಕೆಮಾಡಿ",
    "howItWorks": "ಇದು ಹೇಗೆ ಕಾರ್ಯನಿರ್ವಹಿಸುತ್ತದೆ",
    "advanceFullyRefunded": "ಮುಂಗಡವನ್ನು ಸಂಪೂರ್ಣವಾಗಿ ಮರುಪಾವತಿಸಲಾಗಿದೆ",
    "advanceNonRefundable": "ಮುಂಗಡ ಮರುಪಾವತಿಸಲಾಗುವುದಿಲ್ಲ",
    "additionalChargesActuals": "ಹೆಚ್ಚುವರಿ ಶುಲ್ಕಗಳು ವಾಸ್ತವದಂತೆ",
    "profilePhoto": "ಪ್ರೊಫೈಲ್ ಫೋಟೋ",
    "startTrip": "ಪ್ರವಾಸ ಪ್ರಾರಂಭಿಸಿ",
    "endTrip": "ಪ್ರವಾಸವನ್ನು ಮುಕ್ತಾಯಗೊಳಿಸಿ",
    "finalDistance": "ಅಂತಿಮ ದೂರ",
    "fareBreakdown": "ದರ ವಿಭಾಗ",
    "totalDuration": "ಒಟ್ಟು ಅವಧಿ",
    "withdrawalUnlock": "ಹಿಂತೆಗೆದುಕೊಳ್ಳುವಿಕೆ ಅನ್ಲಾಕ್",
    "quickWins": "ತ್ವರಿತ ಗೆಲುವುಗಳು:",
    "yourTrustedCabPartner": "ನಿಮ್ಮ ವಿಶ್ವಾಸಾರ್ಹ ಕ್ಯಾಬ್ ಪಾಲುದಾರ",
    "usernameOrMobile": "ಬಳಕೆದಾರರ ಹೆಸರು ಅಥವಾ ಮೊಬೈಲ್",
    "password": "ಪಾಸ್‌ವರ್ಡ್",
    "expired": "ಅವಧಿ ಮುಗಿದಿದೆ",
    "withdrawToUpi": "ಯುಪಿಐ ಗೆ ಹಿಂತೆಗೆದುಕೊಳ್ಳಿ",
    "minPtsWallet": "ಕನಿಷ್ಠ 300 ಅಂಕಗಳು ವ್ಯಾಲೆಟ್‌ನಲ್ಲಿ ಇರಬೇಕು",
    "availableToWithdraw": "ಹಿಂತೆಗೆದುಕೊಳ್ಳಲು ಲಭ್ಯವಿದೆ",
    "upiId": "ಯುಪಿಐ ಐಡಿ",
    "amountRupees": "ಮೊತ್ತ (₹)",
    "bookingId": "ಬುಕಿಂಗ್ ಐಡಿ",
    "lifetimeEarned": "ಜೀವಮಾನದ ಗಳಿಕೆ",
    "withdrawable": "ಹಿಂತೆಗೆದುಕೊಳ್ಳಬಹುದಾದ",
    "useOnRide": "ಸವಾರಿಯಲ್ಲಿ ಬಳಸಿ",
    "recentActivity": "ಇತ್ತೀಚಿನ ಚಟುವಟಿಕೆ",
    "seeAll": "ಎಲ್ಲವನ್ನೂ ನೋಡಿ",
    "withdrawalLocked": "ಹಿಂತೆಗೆದುಕೊಳ್ಳುವಿಕೆ ಲಾಕ್ ಆಗಿದೆ",
    "transactionHistory": "ವಹಿವಾಟು ಇತಿಹಾಸ",
    "noTransactionsYet": "ಇನ್ನೂ ಯಾವುದೇ ವಹಿವಾಟುಗಳಿಲ್ಲ",
    "loginCta": "ಲಾಗಿನ್ / ಸೇರಿ",
    "findTaxiBy": "ಸೂಕ್ತವಾದ ಟ್ಯಾಕ್ಸಿಯನ್ನು ಹುಡುಕಿ",
    "from": "ಇಂದ",
    "to": "ಗೆ",
    "nearbyCars": "ಹತ್ತಿರದ ಅತ್ಯುತ್ತಮ ರೇಟಿಂಗ್ ಹೊಂದಿದ ಕಾರುಗಳು",
    "accountTitle": "ನನ್ನ ಪ್ರೊಫೈಲ್",
    "bookings": "ಇತಿಹಾಸ",
    "notifications": "ಅಧಿಸೂಚನೆಗಳು",
    "support": "ಸಹಾಯ ಕೇಂದ್ರ",
    "settings": "ಸೆಟ್ಟಿಂಗ್‌ಗಳು",
    "logout": "ಲಾಗ್ ಔಟ್",
    "loginSignup": "ಲಾಗಿನ್ / ಸೈನ್ ಅಪ್",
    "noBookings": "ಇನ್ನೂ ಯಾವುದೇ ಬುಕಿಂಗ್‌ಗಳಿಲ್ಲ.",
    "startBooking": "ನಂಬಿಕಸ್ಥ ಸ್ಥಳೀಯ ಕ್ಯಾಬ್‌ಗಳನ್ನು ಬುಕ್ ಮಾಡಲು ಪ್ರಾರಂಭಿಸಿ",
    "faqTitle": "ಸಾಮಾನ್ಯ ಪ್ರಶ್ನೆಗಳು",
    "callSupport": "ಸಹಾಯಕ್ಕೆ ಕರೆ ಮಾಡಿ",
    "language": "ಭಾಷೆ",
    "fareCalculator": "ದರ ಕ್ಯಾಲ್ಕುಲೇಟರ್",
    "terms": "ನಿಯಮಗಳು & ಷರತ್ತುಗಳು",
    "privacy": "ಗೌಪ್ಯತಾ ನೀತಿ",
    "manageProfile": "ನಿಮ್ಮ ಪ್ರೊಫೈಲ್ ಮತ್ತು ಆದ್ಯತೆಗಳನ್ನು ನಿರ್ವಹಿಸಿ",
    "mobileNumber": "ಮೊಬೈಲ್ ಸಂಖ್ಯೆ",
    "username": "ಬಳಕೆದಾರರ ಹೆಸರು",
    "preferredCity": "ಆದ್ಯತೆಯ ನಗರ",
    "referFriend": "ಸ್ನೇಹಿತರಿಗೆ ಶಿಫಾರಸು ಮಾಡಿ",
    "comingSoon": "ಶೀಘ್ರದಲ್ಲೇ ಬರಲಿದೆ",
    "cabOwnerProfile": "ಡ್ರೈವರ್ ಪ್ರೊಫೈಲ್",
    "editCabOwnerProfile": "ಡ್ರೈವರ್ ವಿವರಗಳನ್ನು ಸಂಪಾದಿಸಿ",
    "accountActions": "ಖಾತೆ ಕ್ರಿಯೆಗಳು",
    "save": "ಬದಲಾವಣೆಗಳನ್ನು ಉಳಿಸಿ",
    "edit": "ಸಂಪಾದಿಸಿ",
    "verified": "ಪರಿಶೀಲಿಸಲಾಗಿದೆ",
    "notEditable": "ಬದಲಾಯಿಸಲು ಸಾಧ್ಯವಿಲ್ಲ",
    "myRating": "ನನ್ನ ರೇಟಿಂಗ್",
    "notSet": "ಹೊಂದಿಸಲಾಗಿಲ್ಲ",
    "upcoming": "ಮುಂಬರುವ ಪ್ರಯಾಣಗಳು",
    "previous": "ಹಿಂದಿನ ಪ್ರಯಾಣಗಳು",
    "noUpcomingTrips": "ಮುಂಬರುವ ಪ್ರಯಾಣಗಳಿಲ್ಲ.",
    "noPreviousTrips": "ಹಿಂದಿನ ಪ್ರಯಾಣಗಳಿಲ್ಲ.",
    "bookRide": "ರೈಡ್ ಬುಕ್ ಮಾಡಿ",
    "signIn": "ಸೈನ್ ಇನ್",
    "viewBookings": "ಬುಕಿಂಗ್‌ಗಳನ್ನು ವೀಕ್ಷಿಸಿ",
    "personalDetails": "ವೈಯಕ್ತಿಕ ವಿವರಗಳು",
    "location": "ಸ್ಥಳ",
    "emergencyContact": "ತುರ್ತು ಸಂಪರ್ಕ",
    "vehicleOptions": "ವಾಹನ ಆಯ್ಕೆಗಳು",
    "tripTypesOffered": "ನೀಡುವ ಟ್ರಿಪ್ ಪ್ರಕಾರಗಳು",
    "pricing": "ಬೆಲೆ ನಿಗದಿ",
    "weeklyAvailability": "ಸಾಪ್ತಾಹಿಕ ಲಭ್ಯತೆ",
    "kycLocked": "KYC ವಿವರಗಳನ್ನು ಲಾಕ್ ಮಾಡಲಾಗಿದೆ",
    "kycLockedDesc": "ಹೆಸರು, ಮೊಬೈಲ್, ಡಿಎಲ್ ಮತ್ತು ವಾಹನದ ವಿವರಗಳನ್ನು ಇಲ್ಲಿ ಬದಲಾಯಿಸಲಾಗುವುದಿಲ್ಲ. ಸಹಾಯ ಕೇಂದ್ರವನ್ನು ಸಂಪರ್ಕಿಸಿ.",
    "verifiedInfo": "ಪರಿಶೀಲಿಸಿದ ಮಾಹಿತಿ",
    "gender": "ಲಿಂಗ",
    "languagesSpoken": "ಮಾತನಾಡುವ ಭಾಷೆಗಳು",
    "bio": "ಕಿರು ಪರಿಚಯ",
    "address": "ವಿಳಾಸ",
    "pincode": "ಪಿನ್‌ಕೋಡ್",
    "contactName": "ಸಂಪರ್ಕ ಹೆಸರು",
    "contactPhone": "ಸಂಪರ್ಕ ಸಂಖ್ಯೆ",
    "acAvailable": "ಎಸಿ ಲಭ್ಯವಿದೆ",
    "wallet": "ವಾಲೆಟ್",
    "recentSearches": "ಇತ್ತೀಚಿನ ಹುಡುಕಾಟಗಳು",
    "home": "ಮುಖಪುಟ",
    "navCars": "ಕಾರುಗಳು",
    "nearbyHireDrivers": "ಹತ್ತಿರದ ಬಾಡಿಗೆ ಚಾಲಕರು",
    "city": "ನಗರ",
    "noCabsFoundFor": "ಯಾವುದೇ ಕ್ಯಾಬ್‌ಗಳು ಸಿಗಲಿಲ್ಲ:",
    "tryDifferentSearch": "ಬೇರೆ ಹುಡುಕಾಟವನ್ನು ಪ್ರಯತ್ನಿಸಿ ಅಥವಾ ಸಲಹೆಗಳನ್ನು ಬಳಸಿ:",
    "sramikaComingTo": "ಶ್ರಮಿಕ ಶೀಘ್ರದಲ್ಲೇ ಬರಲಿದೆ:",
    "onboardingDriversIn": "ನಾವು ಪ್ರಸ್ತುತ ಚಾಲಕರನ್ನು ಸೇರಿಸುತ್ತಿರುವ ಪ್ರದೇಶ:",
    "beTheFirstToKnow": ". ಸೇವೆ ಪ್ರಾರಂಭವಾದ ತಕ್ಷಣ ಮೊದಲಿಗರಾಗಿ ತಿಳಿಯಿರಿ.",
    "expectedLaunch": "ನಿರೀಕ್ಷಿತ ಪ್ರಾರಂಭ",
    "whatsappNumber": "ವಾಟ್ಸಾಪ್ ಸಂಖ್ಯೆ (10 ಅಂಕಿಗಳು)",
    "notifyViaWhatsapp": "ಸೇವೆ ಪ್ರಾರಂಭವಾದಾಗ ವಾಟ್ಸಾಪ್ ಮೂಲಕ ತಿಳಿಸುತ್ತೇವೆ",
    "joining": "ಸೇರಿಸಲಾಗುತ್ತಿದೆ...",
    "onTheList": "ನೀವು ಪಟ್ಟಿಯಲ್ಲಿದ್ದೀರಿ!",
    "goBackHome": "ಮುಖಪುಟಕ್ಕೆ ಹಿಂತಿರುಗಿ",
    "noDriversIn": "ಪ್ರಸ್ತುತ ಚಾಲಕರು ಲಭ್ಯವಿಲ್ಲ:",
    "driverNetworkExpanding": "ನಮ್ಮ ಪರಿಶೀಲಿಸಿದ ಚಾಲಕ ಜಾಲ ವೇಗವಾಗಿ ವಿಸ್ತರಿಸುತ್ತಿದೆ. ಈ ನಗರದಲ್ಲಿ ಮೊದಲ ಚಾಲಕ ಪಾಲುದಾರರಾಗಿ ಸೇರಿ ತಕ್ಷಣ ಬುಕಿಂಗ್ ಪಡೆಯಿರಿ.",
    "registerAsDriver": "ಚಾಲಕರಾಗಿ ನೋಂದಾಯಿಸಿ",
    "learnMore": "ಇನ್ನಷ್ಟು ತಿಳಿಯಿರಿ",
    "noCabsIn": "ಪ್ರಸ್ತುತ ಕ್ಯಾಬ್‌ಗಳು ಲಭ್ಯವಿಲ್ಲ:",
    "cabNetworkExpanding": "ನಮ್ಮ ಪ್ರೀಮಿಯಂ ಜಾಲ ವೇಗವಾಗಿ ವಿಸ್ತರಿಸುತ್ತಿದೆ. ಈ ನಗರದಲ್ಲಿ ನಮ್ಮ ವಿಶೇಷ ಸೇವೆಗಳನ್ನು ಪ್ರಾರಂಭಿಸುವ ಮೊದಲ ಪಾಲುದಾರರಾಗಿ ಸೇರಿ ಇಂದೇ ಗಳಿಸಲು ಪ್ರಾರಂಭಿಸಿ.",
    "joinAsPartner": "ಪಾಲುದಾರರಾಗಿ ಸೇರಿ",
    "exploreCities": "ನಗರಗಳನ್ನು ವೀಕ್ಷಿಸಿ",
    "platformDisclaimer": "ಶ್ರಮಿಕ ಒಂದು ತಂತ್ರಜ್ಞಾನ ವೇದಿಕೆ. ಸಾರಿಗೆ ಸೇವೆಗಳನ್ನು ಸ್ವತಂತ್ರ ಆಪರೇಟರ್‌ಗಳು ಒದಗಿಸುತ್ತಾರೆ.",
    "topRated": "ಉನ್ನತ ರೇಟಿಂಗ್",
    "nearby": "ಹತ್ತಿರ",
    "luxury": "ಲಕ್ಷುರಿ",
    "familyTrip": "ಕುಟುಂಬ ಪ್ರವಾಸ",
    "fastBooking": "ವೇಗದ ಬುಕಿಂಗ್",
    "matched": "ಹೊಂದಿಕೆಯಾಗಿದೆ",
    "estPrice": "ಅಂದಾಜು ಬೆಲೆ",
    "baseRateLabel": "ಮೂಲ ದರ",
    "recentSearchesLabel": "ಇತ್ತೀಚಿನ ಹುಡುಕಾಟಗಳು",
    "anyCab": "ಯಾವುದೇ ಕ್ಯಾಬ್",
    "trip": "ಪ್ರವಾಸ",
    "trips": "ಪ್ರವಾಸಗಳು",
    "selectCity": "ನಗರವನ್ನು ಆಯ್ಕೆಮಾಡಿ",
    "detecting": "ಪತ್ತೆ ಮಾಡಲಾಗುತ್ತಿದೆ...",
    "detectLocation": "ಸ್ಥಳವನ್ನು ಪತ್ತೆಮಾಡಿ",
    "typeCityName": "ನಗರದ ಹೆಸರನ್ನು ನಮೂದಿಸಿ...",
    "filters": "ಫಿಲ್ಟರ್‌ಗಳು",
    "select": "ಆಯ್ಕೆಮಾಡಿ",
    "bioHint": "ಪ್ರಯಾಣಿಕರಿಗೆ ನಿಮ್ಮ ಬಗ್ಗೆ ಸ್ವಲ್ಪ ತಿಳಿಸಿ",
    "searchCity": "ನಗರವನ್ನು ಹುಡುಕಿ...",
    "selectCity2": "ನಗರವನ್ನು ಆಯ್ಕೆಮಾಡಿ",
    "findRightTaxi": "ಸೂಕ್ತವಾದ ಟ್ಯಾಕ್ಸಿಯನ್ನು ಹುಡುಕಿ",
    "lastBooked": "ಕೊನೆಯದಾಗಿ ಬುಕ್ ಮಾಡಿದ್ದು:",
    "more": "+ ಇನ್ನಷ್ಟು",
    "hireDriver": "ಚಾಲಕರನ್ನು ನೇಮಿಸಿಕೊಳ್ಳಿ",
    "services": "ಸೇವೆಗಳು",
    "account": "ಖಾತೆ",
    "findRightDriver": "ಸೂಕ್ತವಾದ ಚಾಲಕರನ್ನು ಹುಡುಕಿ",
    "searchCabPlaceholder": "ಕ್ಯಾಬ್, ಮಾದರಿ, ಪ್ರದೇಶ ಹುಡುಕಿ...",
    "searchDriverPlaceholder": "ಚಾಲಕ, ಪ್ರದೇಶ, ಭಾಷೆ, ಅನುಭವ ಹುಡುಕಿ...",
    "myHireRequests": "ನನ್ನ ಚಾಲಕ ವಿನಂತಿಗಳು",
    "driverCanSpeakLanguages": "ಚಾಲಕ ಮಾತನಾಡಬಲ್ಲ ಭಾಷೆಗಳು",
    "referenceFare": "ಉಲ್ಲೇಖ ದರ",
    "callDriver": "ಚಾಲಕರಿಗೆ ಕರೆ ಮಾಡಿ",

    "driverDiscountLabel": "ರಿಯಾಯಿತಿ",
    "connecting": "ಸಂಪರ್ಕಿಸಲಾಗುತ್ತಿದೆ...",

    "mockCallConnecting": "ಮಾಕ್ ಟೆಲಿಫೋನಿ ಮೂಲಕ ಚಾಲಕನಿಗೆ ಕರೆಯನ್ನು ಸಂಪರ್ಕಿಸಲಾಗುತ್ತಿದೆ...",
    "mockCallError": "ಕರೆಯನ್ನು ಸಂಪರ್ಕಿಸಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ.",
    "callInitiationError": "ಕರೆ ಪ್ರಾರಂಭಿಸುವಲ್ಲಿ ದೋಷ.",


    "callbackInitiationError": "ಮರುಕರೆ ವಿನಂತಿಸುವಲ್ಲಿ ದೋಷ.",
    "bookNowToGetContact": "ಸಂಪರ್ಕ ಸಂಖ್ಯೆಯನ್ನು ಪಡೆಯಲು ಈಗಲೇ ಬುಕ್ ಮಾಡಿ",
    "regularPrice": "ಸಾಮಾನ್ಯ ಬೆಲೆ",
    "typicalFareTooltip": "A typical fare for this route, based on local rates. Partners set their own prices independently.", // TODO: Kannada translation pending.
    "partnersPrice": "ಚಾಲಕರ ದರ", // TODO: Kannada translation pending.
    "priceHistory": "ದರಗಳ ಇತಿಹಾಸ", // TODO: Kannada translation pending.
    "increaseAvailableNow": "ಈಗ ದರಗಳನ್ನು ಹೆಚ್ಚಿಸಬಹುದು", // TODO: Kannada translation pending.
    "nextIncreaseAt": "ಮುಂದಿನ ದರ ಏರಿಕೆ {{time}} ನಂತರ", // TODO: Kannada translation pending.
    "noPriceChangesYet": "ಇನ್ನೂ ದರ ಬದಲಾವಣೆಗಳಿಲ್ಲ", // TODO: Kannada translation pending.
    "loadingHistory": "ಇತಿಹಾಸ ತರುತ್ತಿದ್ದೇವೆ…", // TODO: Kannada translation pending.
    "changeIncrease": "ಏರಿಕೆ", // TODO: Kannada translation pending.
    "changeDecrease": "ಇಳಿಕೆ", // TODO: Kannada translation pending.
    "changeMixed": "ಕೆಲವು ಏರಿಕೆ, ಕೆಲವು ಇಳಿಕೆ", // TODO: Kannada translation pending.
    "noFieldsChanged": "ಯಾವುದೇ ವಿವರ ಬದಲಾಗಿಲ್ಲ.", // TODO: Kannada translation pending.
    "typicalFareLabel": "ಸಾಮಾನ್ಯ ದರ ₹{value}",
    "lessThanTypicalFare": "ಸಾಮಾನ್ಯ ದರಕ್ಕಿಂತ ₹{amount} ಕಡಿಮೆ",
    "partnerOfferedPrice": "ಪಾಲುದಾರರ ಬೆಲೆ",
    "partnerPricePrefix": "ಬೆಲೆ",
    "estimatedAmount": "ಅಂದಾಜು ಮೊತ್ತ",
    "estimatedAmountCaption": "ನಿಜವಾದ ಪ್ರಯಾಣ, ಟೋಲ್ ಗಳು, ಪಾರ್ಕಿಂಗ್ ಅಥವಾ ಮಾರ್ಗ ಬದಲಾವಣೆಗಳ ಆಧಾರದ ಮೇಲೆ ಅಂತಿಮ ಮೊತ್ತವು ಬದಲಾಗಬಹುದು.",
    "extrasNote": "Toll, border/state taxes and parking (if any) are extra and paid directly to the driver.", // TODO: pending
    "youSaveComparedToRegular": "ಸಾಮಾನ್ಯ ಬೆಲೆಗೆ ಹೋಲಿಸಿದರೆ.",
    "payDirectlyToPartner": "பயண கூட்டாளருடன் உங்கள் பயணத்தை உறுதி செய்த பிறகு மட்டுமே பணம் செலுத்துங்கள்.",
    "chargesDuringTrip": "ಪ್ರಯಾಣದ ಸಮಯದಲ್ಲಿ ಶುಲ್ಕಗಳು",
    "whyChooseSramika": "வாடிக்கையாளர்கள் ஸ்ராமிகாவை ஏன் தேர்வு செய்கிறார்கள்",
    "verifiedTravelPartners": "Trusted travel partners", // TODO: pending
    "transparentPricing": "ಪಾರದರ್ಶಕ ಬೆಲೆ",
    "directCommunication": "நேரடி கூட்டாளர் தொடர்பு",
    "noBookingCommission": "ಯಾವುದೇ ಬುಕಿಂಗ್ ಆಯೋಗವಿಲ್ಲ",
    "secureBookingExperience": "ಸುರಕ್ಷಿತ ಬುಕಿಂಗ್ ಅನುಭವ",
    "youSavePrefix": "ನೀವು ಉಳಿಸುತ್ತೀರಿ",
    "saveBadge": "ಉಳಿಸಿ",
    "savingsBasedOnPartnerPrice": "கூட்டாளர் விலை நிர்ணயம் நீங்கள் அதிகம் சேமிக்க உதவுகிறது.",
    "licenseChecked": "Driving License Checked", // TODO: pending
    "bestOffer": "ಉತ್ತಮ ಕೊಡುಗೆ"
  },
    "tripPriceDetails": "ಪ್ರಯಾಣದ ಬೆಲೆ ವಿವರಗಳು",
    "transparentPartnerPricing": "ಪಾರದರ್ಶಕ ಪಾಲುದಾರ ಬೆಲೆ",
    "noSramikaBookingCommission": "ಯಾವುದೇ ಶ್ರಮಿಕ ಬುಕಿಂಗ್ ಕಮಿಷನ್ ಇಲ್ಲ",
    "driverAllowance": "ಚಾಲಕ ಭತ್ಯೆ",
    "nightAllowance": "ರಾತ್ರಿ ಭತ್ಯೆ",
    "transparentPricingNoHidden": "ಪಾರದರ್ಶಕ ಬೆಲೆ - ಯಾವುದೇ ಗುಪ್ತ ಶುಲ್ಕಗಳಿಲ್ಲ",
    "promoDiscount": "ಪ್ರೊಮೊ ರಿಯಾಯಿತಿ",
    "sramikaDiscount": "ಶ್ರಮಿಕ ರಿಯಾಯಿತಿ",
    "couponAppliedMsg": "ಕೂಪನ್ ಅನ್ವಯಿಸಲಾಗಿದೆ",
    "saveAmount": "ಉಳಿಸಿ ",
    "removeAction": "ತೆಗೆದುಹಾಕಿ",
    "applyAction": "ಅನ್ವಯಿಸಿ",
    "totalFare": "ಒಟ್ಟು ದರ",
    "finalPriceLabel": "ಅಂತಿಮ ಬೆಲೆ",
    "partnerOfferSuffix": " ಕೊಡುಗೆ",
    "legacyFareVary": "ನೈಜ KM ಪ್ರಯಾಣಿಸಿದ ಅಥವಾ ಪ್ರಯಾಣದ ಅವಧಿಯಲ್ಲಿ ಯಾವುದೇ ಬದಲಾವಣೆ ಇದ್ದರೆ ಅಂತಿಮ ದರವು ಬದಲಾಗಬಹುದು.",
    "legacyTollsExcluded": "⚠️ **ಸೂಚನೆ:** ಟೋಲ್ ಗೇಟ್‌ಗಳು, ಪಾರ್ಕಿಂಗ್ ಶುಲ್ಕಗಳು ಮತ್ತು ಯಾವುದೇ ಗಡಿ/ರಾಜ್ಯ ತೆರಿಗೆ ಶುಲ್ಕಗಳನ್ನು ಈ ದರದಲ್ಲಿ **ಸೇರಿಸಲಾಗಿಲ್ಲ** ಮತ್ತು ಪ್ರತ್ಯೇಕವಾಗಿ ಶುಲ್ಕ ವಿಧಿಸಲಾಗುತ್ತದೆ.",
    "estimateFareCalc1": "ನಮ್ಮ ",
    "pricingCalculator": "ಬೆಲೆ ಕ್ಯಾಲ್ಕುಲೇಟರ್",
    "estimateFareCalc2": " ಅನ್ನು ಬಳಸಿಕೊಂಡು ಯಾವುದೇ ಸಮಯದಲ್ಲಿ ದೂರ ಅಥವಾ ಸಮಯದ ಬದಲಾವಣೆಗಾಗಿ ನಿಮ್ಮ ನವೀಕರಿಸಿದ ದರವನ್ನು ನೀವು ಅಂದಾಜು ಮಾಡಬಹುದು.",
    "pickup": "ಪಿಕಪ್",
    "origin": "ಮೂಲ",
    "destination": "ಗಮ್ಯಸ್ಥಾನ",
    "oneWay": "ಏಕಮುಖ",
    "inclReturn": "ಹಿಂದಿರುಗುವಿಕೆ ಸೇರಿದಂತೆ",
    "hrs": "ಗಂಟೆಗಳು",
    "estDuration": "ಅಂದಾಜು ಅವಧಿ",

    // Rating Modal
    "loadingRating": "ತರುತ್ತಿದ್ದೇವೆ…", // TODO: pending
    "updateRating": "ರೇಟಿಂಗ್ ಬದಲಿಸಿ", // TODO: pending
    "submitRating": "ರೇಟಿಂಗ್ ಕಳುಹಿಸಿ", // TODO: pending
    "tapAStar": "Tap a star", // TODO: pending
    "ratingPoor": "Poor", // TODO: pending
    "ratingFair": "Fair", // TODO: pending
    "ratingGood": "Good", // TODO: pending
    "ratingVeryGood": "Very Good", // TODO: pending
    "ratingExcellent": "Excellent", // TODO: pending
    "tellUsExperience": "ನಿಮ್ಮ ಅನುಭವ ತಿಳಿಸಿ…", // TODO: pending
    "typicalFareBare": "Market Price", // TODO: pending
    "totalWithCharges": "Total with trip charges" // TODO: pending
};

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    return localStorage.getItem('app_lang') || 'en';
  });

  useEffect(() => {
    localStorage.setItem('app_lang', lang);
  }, [lang]);

  /* ── The signed-in user's language, kept on their account ─────────────────────
     Every place that changes the language - the first-open list, the header switch,
     Settings, Terms - calls setLang, so saving here covers all of them at once.

     When they differ, the most recent choice wins. On sign-in the account's saved
     language is compared with this device's by when each was chosen: a choice made
     on another phone yesterday replaces this device's from last week, and a choice
     made here a minute ago, before signing in, is saved to the account. */
  const { user } = useAuth() || {};
  const phone = user?.phone || null;
  const reconciledFor = useRef(null);

  const saveToAccount = (code) => {
    apiRequest("/users/me/language", { method: "PUT", body: JSON.stringify({ language: code }) })
      .then((r) => { if (r?.preferredLanguageUpdatedAt) localStorage.setItem('app_lang_at', r.preferredLanguageUpdatedAt); })
      .catch(() => {}); // the choice still applies on this device; it is saved again next change
  };

  const setLang = (code) => {
    if (!APP_LANGUAGES.includes(code)) return;
    setLangState(code);
    localStorage.setItem('app_lang_at', new Date().toISOString());
    if (phone) saveToAccount(code);
  };

  useEffect(() => {
    if (!phone) { reconciledFor.current = null; return; }
    /* Wait for the account itself. Until /users/me answers, the user is a copy from
       local storage with no language on it, and "nothing saved" would be a guess. */
    if (!user || !("preferredLanguage" in user) || reconciledFor.current === phone) return;
    reconciledFor.current = phone;

    const saved = APP_LANGUAGES.includes(user.preferredLanguage) ? user.preferredLanguage : null;
    const savedAt = user.preferredLanguageUpdatedAt || "";
    const localAt = localStorage.getItem('app_lang_at') || "";

    if (saved && (!localAt || savedAt > localAt)) {
      if (saved !== lang) setLangState(saved);
      localStorage.setItem('app_lang_at', savedAt);
    } else if (saved !== lang) {
      saveToAccount(lang);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [phone, user]);

  const t = useMemo(
    () => (key) => STRINGS[lang]?.[key] || STRINGS.en[key] || key,
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);


